/* Code generated by balancegen from client/src/ui/styles.css.tmpl.
   DO NOT EDIT: edit the .tmpl sibling and run scripts/gen-data.sh.

   Only the wide-pane breakpoint is substituted, because a media query
   cannot read a custom property (R362). Every colour is a token of
   client/src/gen/tokens.css, which is generated from
   data/presentation/presentation.toml and data/identity/identity.toml. */

/* DOM overlay chrome. The game world is canvas; everything textual or
   tabular lives here (ui-map-interface.md §1, §8). Palette and typography
   come from §2 — instrument readouts on deep water. */

@import '../gen/tokens.css';

/* The CASINO panel's own sheet (casino.md). It is chrome, so it arrives
   with the chrome: the panel draws inside the dock's tab body and takes
   the type, the scroll and the release rule from the rules below. It is
   imported here and not from a module, because the dock's stylesheet is
   where every rule of the dock lives, and a CSS @import keeps the order
   of the cascade plain — tokens first, chrome next, panel last. */
@import './casino/casino.css';

/* The two declarations this sheet still owns. A type stack is not a
   colour: no theme turns it. `--mono` is the chrome face (R1797,
   ui-map-interface.md §2.3): the vendored JetBrains Mono at 400 and 500,
   with the system monospace stack behind it for a glyph the subset does
   not hold. `--serif` is the italic Fell face of the historical chart
   reading (ui-map-interface.md §17.1, §17.4, R1694), which the historical
   cartouche and imprint wear. Its family and its fallback are
   `[chart.text]` of `chart.toml`, and the pages that draw a chart declare
   the face with `@font-face`. */
:root {
  --mono: "Aqua Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
  --serif: "Aqua Chart Fell", Georgia, serif;
}

/* The chrome face (R1797). Three faces of one family: the 400 file holds
   the whole chrome alphabet, and two 500 files split it by
   `unicode-range` — the chart file that the map text and the lockup load
   already, and the rest. `scripts/tools/subset-fonts.sh ui` cuts the two
   new files and states the alphabet; the ranges below are the code points
   the files hold. JetBrains Mono is under the SIL Open Font License
   (`OFL-JetBrains-Mono.txt`). `swap`: a DOM text may show the fallback for
   a moment, and it never waits for the face. The game page preloads the
   400 file. */
@font-face {
  font-family: "Aqua Mono";
  src: url(/fonts/jetbrains-mono-400-ui.woff2) format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  unicode-range: U+20-7E, U+A0-FF, U+2013-2014, U+2019, U+201C-201E, U+2022,
    U+2026, U+2032-2033, U+2039-203A, U+2190-2193, U+2197, U+2212, U+221A,
    U+2248, U+2260-2261, U+2264-2265, U+2318, U+25A0, U+25B2, U+25B4, U+25B6,
    U+25B8, U+25BA, U+25BC, U+25BE, U+25C0, U+25C4, U+25C6-25C7, U+25CC,
    U+25CF, U+25EF, U+26A0, U+2715;
}
@font-face {
  font-family: "Aqua Mono";
  src: url(/fonts/jetbrains-mono-500-chart.woff2) format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
  unicode-range: U+20-7E, U+B0, U+B7, U+C4, U+D6, U+DC, U+DF, U+E4, U+F6,
    U+FC, U+2013-2014, U+2019, U+2022, U+2032-2033, U+25C7;
}
@font-face {
  font-family: "Aqua Mono";
  src: url(/fonts/jetbrains-mono-500-ui.woff2) format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
  unicode-range: U+A0-AF, U+B1-B6, U+B8-C3, U+C5-D5, U+D7-DB, U+DD-DE,
    U+E0-E3, U+E5-F5, U+F7-FB, U+FD-FF, U+201C-201E, U+2026, U+2039-203A,
    U+2190-2193, U+2197, U+2212, U+221A, U+2248, U+2260-2261, U+2264-2265,
    U+2318, U+25A0, U+25B2, U+25B4, U+25B6, U+25B8, U+25BA, U+25BC, U+25BE,
    U+25C0, U+25C4, U+25C6, U+25CC, U+25CF, U+25EF, U+26A0, U+2715;
}

/* The face has two weights. A bold or a 600 takes the 500 face as it is
   and is never smeared into a false bold; a light 300 takes the 400 face.
   Every figure is tabular (the Instrument Rule). */
#ui, #hub, #landing {
  font-synthesis-weight: none;
  font-variant-numeric: tabular-nums;
}

/* The face of the header lockup (brand.md §2, R1645). It is the vendored
   JetBrains Mono 500 that the chart's map text already ships
   (scripts/tools/subset-fonts.sh), under a family name of the lockup's
   own, so no other rule takes the face by chance. `unicode-range` is the
   part of the subset a name can need. The hub and the landing read it,
   and `hub.css` declares no face of its own: this sheet is always
   loaded. */
@font-face {
  font-family: "Aqua Lockup";
  src: url(/fonts/jetbrains-mono-500-chart.woff2) format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
  unicode-range: U+20-7E, U+B7;
}

/* The one coloured scrollbar of the game and of every page that loads this
   sheet. It has the lowest specificity, so a rule that hides a scrollbar
   or sizes one still wins. */
* {
  scrollbar-width: thin;
  scrollbar-color: rgb(var(--accent-rgb) / 0.3) transparent;
}
*::-webkit-scrollbar { width: 6px; height: 6px; }
*::-webkit-scrollbar-thumb { background: rgb(var(--accent-rgb) / 0.28); border-radius: 3px; }
*::-webkit-scrollbar-track { background: transparent; }

#ui {
  position: fixed;
  inset: 0;
  pointer-events: none;
  /* The one edge margin of the chrome (R1765, [presentation.layout] pad):
     every piece that stands at a screen edge stands this far off it. A
     piece that stands ON the edge (the readout line, the telephone sheet)
     takes 0. `ui/layout.ts` places the console with the same figure. */
  --pad: 12px;
  /* The anchors of the chrome (§12.0, R1819). `ui/layout.ts` measures the
     readout line, the tab bar and the dock column and writes the three on
     this element; these are their defaults until the first measure, so
     no rule reads a literal of its own. */
  --topbar-h: var(--target-finger);
  --tabs-h: calc(var(--target-finger) + var(--s-3));
  --dock-w: calc(var(--w-dock) + var(--pad));
  /* The safe insets of the screen in chrome px (R1828): `#ui` wears the
     UI scale as a zoom, so an inset written as it is would grow with the
     scale. Every rule of the game chrome reads these four, and
     `ui/layout.ts` measures them through `#safeprobe`. */
  --safe-t: calc(env(safe-area-inset-top, 0px) / var(--ui-scale, 1));
  --safe-r: calc(env(safe-area-inset-right, 0px) / var(--ui-scale, 1));
  --safe-b: calc(env(safe-area-inset-bottom, 0px) / var(--ui-scale, 1));
  --safe-l: calc(env(safe-area-inset-left, 0px) / var(--ui-scale, 1));
  /* The notice lane (round 083 card 16): the notices stand one margin of
     air left of the dock column, from one pad under the readout line.
     `--lane-t` is the one top of the lane: the desktop group bar under
     the readout line adds its height `--gbar-h` here, and nothing else
     moves. The hint line left the lane for the context slot (R2164). */
  --lane-t: calc(var(--topbar-h) + var(--s-3) + var(--gbar-h, 0px));
  --lane-r: calc(var(--dock-w) + var(--pad));
  font-family: var(--mono);
  font-size: var(--t-body-size);
  color: var(--text);
  z-index: 10;
}

#ui .panel {
  background: var(--panel);
  border: 1px solid var(--edge);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border-radius: 8px;
  pointer-events: auto;
}

/* --- pinch containment (§12.0) ---
   The canvas owns the pinch (§8), and iOS ignores `user-scalable=no` from
   version 10 on, so a two-finger gesture that starts on a panel zooms the
   chrome and leaves the map where it was. `touch-action` refuses the
   gesture at the element it starts on. Safari's own `gesturestart` events
   are refused in ui/overlay.ts, because no `touch-action` value reaches
   them.

   `manipulation` is **not** the value for this: it drops the double-tap
   zoom and still allows the pinch. A panel that does not scroll takes
   `none`. A panel that scrolls takes `pan-y`, which keeps the vertical pan
   the panel needs and refuses the pinch exactly as `none` does. Two ids,
   because `#ui .panel` outranks a bare id. */
#ui .panel, #ui #mapbtns, #ui #mapchrome, #ui #rosepress { touch-action: none; }
#ui #tabbody, #ui #chatlog, #ui #queuestrip, #ui #selection, #ui #infocard,
#ui #keys, #ui #settings, #ui #audio, #ui #admin, #ui #viewpanel { touch-action: pan-y; }

/* --- the UI scale (R1556, ui-map-interface.md §13 "The UI scale") ---
   The game page writes the step as `--ui-scale` on <html>, and the three
   chrome roots take it as `zoom`, so the text and the boxes grow together.
   The map canvas stands outside the roots and keeps its size. A page that
   writes no step reads 1.

   The zoom multiplies a `vw` or a `vh` inside a root as well. A length
   that keeps a panel inside the screen — the whole screen less a gutter,
   or a `max-width` or `max-height` share of the screen — therefore
   divides by `--ui-scale`. A share that sets a proportion (a banner's
   width, a film bar, a type size) grows with the chrome. */
#ui, #hub, #landing { zoom: var(--ui-scale, 1); }

/* The chrome is an instrument panel and not a document (R237). A drag on
   it pans the map or moves a control, and a press-and-hold on a telephone
   must raise the peek and never the text callout, so nothing here takes a
   selection. The fields a player types into are the exception, because an
   edit needs a caret and a selection of its own. */
#ui, #hub, #landing {
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}
#ui input, #ui textarea,
#hub input, #hub textarea,
#landing input, #landing textarea {
  user-select: text;
  -webkit-user-select: text;
}
/* The chat window is the one part of the chrome that IS a document (R238):
   a player copies a name, a coordinate or a whole line out of it. The log
   and the entry both take a selection, and the log takes the touch callout
   back, because the callout is what offers COPY on a telephone. */
#ui #chatlog, #ui #chatinput {
  user-select: text;
  -webkit-user-select: text;
  -webkit-touch-callout: default;
}

#ui button {
  font: inherit;
  color: var(--text);
  background: rgb(var(--accent-rgb) / 0.08);
  border: 1px solid var(--edge);
  border-radius: 4px;
  padding: 3px 8px;
  cursor: pointer;
}
/* Every hover look of the chrome stands in a `(hover: hover)` block, in
   its own place in the sheet (R1693, ui-map-interface.md §8). A finger
   makes no hover, and a telephone keeps the hover look on a control after
   a tap until the next tap lands somewhere else. */
@media (hover: hover) {
  #ui button:hover:not(:disabled) { background: rgb(var(--accent-rgb) / 0.18); color: var(--hover-ink); }
}
#ui button:disabled { opacity: 0.35; cursor: not-allowed; }
/* Two kinds of "no" (R45, swapped 2026-08-20): a missing prerequisite is
   struck through — no amount of waiting helps until you build or decrypt
   something; merely being short of resources greys the button out — you
   could press it the moment the alloy lands.

   The strike does NOT ask for :disabled (R701). A locked module tier of the
   draft form stays pressable on purpose, because a disabled button
   dispatches no pointer event and the form could name no gate. It is
   locked all the same, and it must read locked. */
#ui button.locked {
  opacity: 0.55;
  text-decoration: line-through;
  color: var(--dim);
}
#ui button.noafford:disabled {
  opacity: 0.45;
  background: rgb(var(--panel-rgb) / 0.6);
  color: var(--dim);
}
#ui button.primary { border-color: rgb(var(--accent-rgb) / 0.5); color: var(--accent); }
/* The picks of the draft form are the choices of the choice kit (R2011).
   A row of a choice wraps, so an option list takes the line under its
   label. The three typed systems stand on one line, also at 390 px
   (R1922): the pill group takes the room the label leaves, and a long
   name wraps to two lines inside its pill. */
#ui .row.chrow { flex-wrap: wrap; }
#ui .row > .muted:has(+ .ptypes) { flex: 0 0 auto; }
#ui .row > .ptypes { display: flex; flex: 1 1 auto; min-width: 0; max-width: 24em; }
#ui .row > .ptypes > .ch-pg { width: 100%; }
/* INVENT DESIGN stands at the right edge of the draft form. */
#ui .acts.invacts { display: flex; justify-content: flex-end; }
#ui .row > .ptypes button.ch-pl {
  height: auto;
  min-height: var(--ch-pill);
  padding: 3px 4px;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.2;
}
@media (hover: hover) {
  #ui button.danger:hover:not(:disabled) { background: rgb(var(--bad-rgb) / 0.18); color: var(--bad); }
}
/* The armed half of the two-press gate (R696). It wears the danger hover,
   because an armed control is one press from the act. The class survives
   the rebuild the arming causes; `:hover` does not, and a finger never had
   it. A gated control that is not a danger button wears the same mark. */
#ui button.danger.armed, #ui button.armed { background: rgb(var(--bad-rgb) / 0.18); color: var(--bad); }

/* --- the term button (R1557) ---
   A word of a UI sentence that the player glossary marks. It reads as the
   word it is, in the ink and the case of its line, with a dotted line
   under it, and a press opens the definition in the explainer card
   `#bartip`. It is no box: a box in the middle of a line would read as a
   second control of the line's rank. The coarse block below grows its
   target to the 40 px floor with a transparent `::after`, up and down
   only, so the line keeps its height (a pill does the same, R257). */
#ui button.term {
  display: inline;
  position: relative;
  min-height: 0;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  text-transform: inherit;
  text-decoration: underline dotted;
  /* `under` measures from the foot of the text box, so the vendored face's
     own underline metric no longer lifts the line into the letters. */
  text-underline-position: under;
  text-underline-offset: 1px;
  cursor: help;
}
@media (hover: hover) {
  #ui button.term:hover:not(:disabled) { background: none; color: var(--accent); }
}

/* Every place a resource is named wears its colour: the top bar, and each
   term of every cost (state.ts costText). */
#ui .r-alloy, #ui .r-alloy .glyph { color: var(--alloy); }
#ui .r-biomass, #ui .r-biomass .glyph { color: var(--biomass); }
#ui .r-volatiles, #ui .r-volatiles .glyph { color: var(--volatiles); }
#ui .r-isotopes, #ui .r-isotopes .glyph { color: var(--isotopes); }
#ui .r-credits, #ui .r-credits .glyph { color: var(--credits); }
/* The Data Core cell (R1458) stands beside the five. A core is no
   commodity, so its hue is the palette's own `--core`. */
#ui .r-core, #ui .r-core .glyph { color: var(--core); }
#ui .cost .r { opacity: 0.85; }
#ui .cost.short .r { opacity: 1; }
/* The drawn resource icons of `ui/resicon.ts` (R1768): every cost, every
   deposit line and every sentence that names a commodity by its sign
   draws the icon at 1em on the text line, in the ink of its text. The
   rules of `#topbar` size it there. */
svg.ri { display: inline-block; width: 1em; height: 1em; vertical-align: -0.125em; flex: none; }
.r > svg.ri { margin-right: 0.12em; }

/* --- the readout line (R1749, card 01 of mockup round 082) ---
   The top of the screen only reads: the five commodities with their store
   gauges, the Data Core, and the world clock with the most urgent timer.
   Every control stands in the dock. On a desktop the line is a strip that
   hangs from the top edge, centred over the map left of the dock column;
   the sheet block spans it across a telephone. The signals follow round
   080 group C, and none of them is gold. */
#topbar {
  position: absolute;
  top: 0;
  left: calc((100% - var(--dock-w)) / 2);
  /* The dock-in multiplies --rest by --out; see "the chrome dock-in" at the
     end of this file. A panel that states `transform` here instead loses its
     centring at the first frame of the arrival. */
  --rest: translateX(-50%);
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 6px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
/* The strip stands on the top edge (R1764): no top border and no top
   corner, so no line shows over it. Two ids, because `#ui .panel` sets the
   border shorthand and the radius, and a bare id lost to it. */
#ui #topbar {
  border-top: 0;
  border-color: rgb(var(--accent-rgb) / 0.2);
  border-radius: 0 0 14px 14px;
  /* The ground of `.td-ts` of round 082 (R1770): the panel ink, denser at
     the top edge than at the foot. */
  background: linear-gradient(180deg, rgb(var(--panel-rgb) / 0.96), rgb(var(--panel-rgb) / 0.88));
}
/* The drawn icons of `ui/resicon.ts` (R1764, round 080 card 11): 14 px
   on a desktop and 12 px on a telephone, in the cell's ink. */
#topbar .glyph, #topbar .clock .cg { display: inline-flex; flex: none; }
#topbar svg.ri { display: block; width: 14px; height: 14px; }
#topbar .rl-res { display: flex; align-items: center; }
/* The rule between the two groups of commodities, and between the
   commodities and the clock. */
#topbar .rl-dv {
  display: block;
  flex: none;
  width: 1px;
  height: 20px;
  margin: 0 4px;
  background: rgb(var(--accent-rgb) / 0.16);
}
/* The six cells and the clock are controls (R233): each one opens the
   explainer card that names it. They keep the face of a readout, because
   the line is an instrument and a cell drawn as a button reads as one more
   thing to press. The commodity colours come from the `.r-*` rules above,
   so a cell states no colour of its own; its gauge fills in that ink.
   The sizes, the weights and the inks of the line are those it had before
   round 083 (R1843), as the readout figures of `[presentation.chrome]`. */
#ui #topbar button.res, #ui #topbar button.clock {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 10px 3px;
  border: 0;
  border-radius: 0;
  background: none;
  font-size: var(--t-readout-size);
  letter-spacing: inherit;
  text-align: left;
  white-space: nowrap;
}
#ui #topbar button.res { gap: 4px; }
@media (hover: hover) {
  #ui #topbar button.res:hover:not(:disabled),
  #ui #topbar button.clock:not(.on):hover:not(:disabled) { background: none; }
  #topbar button.res:hover .value, #topbar button.clock:hover .tv { text-decoration: underline; }
}
#topbar .res .value { position: relative; color: var(--text); letter-spacing: -0.015em; }
#topbar .res .rate { color: var(--dim); font-size: var(--t-small-size); margin-left: 3px; }
/* The store gauge: a 2 px track under the cell, filled in the commodity's
   ink to the share of the store. Credits are uncapped and draw none. */
#topbar .res .gauge {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 9px;
  height: 2px;
  border-radius: 1px;
  background: rgb(var(--text-rgb) / 0.13);
  overflow: hidden;
}
#topbar .res .gauge b { display: block; height: 100%; background: currentColor; opacity: 0.85; }
/* FULL: the figure turns white and bold, a lid stands over it, and the
   gauge fills thick and white. It reads by shape as well as by ink. */
#topbar .res.full .value { color: var(--readout-white); font-weight: 700; }
#topbar .res.full .value::before {
  content: '';
  position: absolute;
  left: -1px;
  right: -1px;
  top: -4px;
  height: 2px;
  border-radius: 1px;
  background: var(--readout-white);
}
#topbar .res.full .gauge { height: 3px; background: rgb(var(--readout-white-rgb) / 0.3); }
#topbar .res.full .gauge b {
  background: var(--readout-white);
  opacity: 1;
  box-shadow: 0 0 6px rgb(var(--readout-white-rgb) / 0.6);
}
/* The Data Core cell is lit while its card stands (R1458): OPEN. */
#topbar .res.on .value { color: var(--hero-ink); }
/* The world clock, and the most urgent timer beside it: a desktop reads
   them side by side, a telephone stacks the timer under the clock. The
   span of the icon and the time is `rl-ck`, never `ck`: `ck` is the root
   of a card of the card kit, whose rules gave the time a card's ground
   and edge (R1858). */
#ui #topbar button.clock { gap: 10px; color: var(--dim); }
#topbar .clock .rl-ck { display: inline-flex; align-items: center; gap: 6px; }
#topbar .clock .tv { color: var(--hero-ink); letter-spacing: -0.015em; }
#topbar .tline {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding-left: 10px;
  border-left: 1px solid rgb(var(--accent-rgb) / 0.16);
  font-size: var(--t-readout-timer-size);
  letter-spacing: 0.095em;
  color: var(--hero-ink);
}
#topbar .tline .tw { opacity: 0.75; }
#topbar .tline .tg { display: none; opacity: 0.8; }
#topbar .tline b { font-weight: 500; font-size: var(--t-body-size); letter-spacing: 0.04em; }
/* `+N`: the other timers that run. A press opens all of them. */
#topbar .tline .more {
  display: inline-flex;
  align-items: center;
  height: 13px;
  padding: 0 4px;
  border: 1px solid rgb(var(--hero-ink-rgb) / 0.45);
  border-radius: 7px;
  font-size: var(--t-readout-more-size);
  font-weight: 500;
  letter-spacing: 0;
}
/* FAULT: a hatched mark before the timer, the shape of the hatch on the
   drain line under it. */
#topbar .tline .hatch {
  display: block;
  flex: none;
  width: 9px;
  height: 9px;
  border-radius: 2px;
}
/* Every moving red hatch: the box clips a wider ::before that slides one
   horizontal stripe period (6 px × √2) per loop as a transform. A transform
   moves by fractions of a pixel on the compositor and repaints nothing, so
   the stripes roll at an even speed. An animated background-position
   snapped to whole pixels and stepped, and its 8.485 px tile rounded, so
   each loop jumped. The gradient fills the layer with no tile, so the end
   of a loop is its start. */
#topbar .tline .hatch, #alarmlist .alm .hatch, #truce.bad .fill, #link .fill {
  position: relative;
  overflow: hidden;
}
:is(#topbar .tline .hatch, #alarmlist .alm .hatch, #truce.bad .fill, #link .fill)::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: -9px;
  right: 0;
  background-image: repeating-linear-gradient(135deg, var(--bad) 0 2.5px, rgb(var(--bad-rgb) / 0.14) 2.5px 6px);
  animation: fault-hatch 0.9s linear infinite;
  will-change: transform;
}
@keyframes fault-hatch { from { transform: translateX(0); } to { transform: translateX(8.4853px); } }
@media (prefers-reduced-motion: reduce) {
  :is(#topbar .tline .hatch, #alarmlist .alm .hatch, #truce.bad .fill, #link .fill)::before { animation: none; }
}
/* The cup mark beside a clan tag (clan-cup.md §7, card 09 of round 078):
   the dock head of a world, STANDINGS and the clan ranking of the season
   card. It stands at the height of the tag, in gold, and a press names the
   cup beside it (ui/cupmark.ts). */
.cupm { display: inline-flex; align-items: center; margin-left: 4px; vertical-align: -2px; color: var(--gold); cursor: default; }
.cupm.tip::after { content: attr(data-cup); margin-left: 5px; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); white-space: nowrap; }
/* The long and the short form of a word: the sheet block swaps them. */
#topbar .narrow { display: none; }
/* The narrow form of the desktop line (R1868): where the full line is
   wider than the map left of the dock, `ui/readoutfit.ts` writes
   `readout-narrow` on `#ui`. The line then takes the narrow rules of the
   telephone's line: no rates, no rules between the groups, the short word
   of the timer, and the timer stacked under the clock. The sizes stay those
   of the desktop (R1843). Where even the narrow line is too wide,
   `readout-tight` starts the line at the left edge of its room, so its
   first cell stays on the screen. The telephone never carries the two
   classes. */
#ui.readout-narrow #topbar .rl-dv,
#ui.readout-narrow #topbar .wide,
#ui.readout-narrow #topbar .res .rate { display: none; }
#ui.readout-narrow #topbar .narrow { display: inline; }
#ui.readout-narrow #topbar button.clock {
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
}
#ui.readout-narrow #topbar .tline { gap: 4px; padding-left: 0; border-left: 0; line-height: 1; }
#ui.readout-tight #topbar { left: var(--pad); --rest: translateX(0); }

/* --- the sheet (ui-map-interface.md §12): a bottom tab bar whose panel
   rests as a console over the water and expands upward on a telephone.
   On a phone the tab bar is the thumb zone and the sheet goes edge to
   edge — one shell, both form factors. --- */

/* Desktop: the sheet docks as a full-height right column (tab bar at its
   foot), and it opens on intent: it arrives at its bar (R2190). It has no expanded state (R233): a
   full-height column cannot usefully grow, and widening it over the map
   cost the six menus a tab-bar cell. The ⤢ control and `#dock.expanded`
   are the bottom sheet's alone, in the media query below. */
#dock {
  position: absolute;
  /* The column starts at the top of the screen: its head holds the
     commander and the INBOX, OPTIONS and DEV cells (R1749), and the
     readout line stands left of it over the map. It stands one edge
     margin off the top, the right and the bottom edge (R1765). */
  right: var(--pad);
  top: var(--pad);
  bottom: var(--pad);
  width: var(--w-dock);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
/* Collapsing the sheet hides the panel body — but NOT the queue strip
   (R106). §12 is explicit: the queue is the game's one build pipeline and
   never hides, and collapsing the dock was the one thing that hid it. The
   strip is a single line, so the collapsed dock stays a bar. */
#dock.collapsed #tabbody { display: none; }
/* The column at rest sizes to its rows, and it stops at the edge margin
   of the top of the screen, as the open column does (R2740). The open
   queue strip then gives up the height it cannot have and scrolls inside
   itself (the strip rules below). */
#dock.collapsed { top: auto; max-height: calc(100% - 2 * var(--pad)); }
/* The desktop column covers the map labels (R2050, ui-map-interface.md
   §12.0 "The grounds of the chrome"): the peek ground, the panel ink at
   0.94 under the same blur of 6 px, in place of the glass at the panel
   alpha, under which a place name or the legend of a siege window read
   through the rows. The sheet block below sets the ground of a telephone.
   Two ids, because `#ui .panel` sets the glass. */
#ui #dock { background: var(--g-peek); }

/* --- the dock head of a desktop (R1749, card 01 of round 082) ---
   The head of the dock column: the sign and the name, whose press centres
   the map on the hold; the INBOX, OPTIONS and DEV cells in the dark ink of
   LEAVE TO THE HUB; under them the squad chip with its cup mark, the rank
   and the standing-orders tag; and the new-build line of an admin seat.
   Every control here is fixed chrome and acts on the press (§16.8). The
   sheet block hides the head: a telephone stands the commander row in the
   OPTIONS menu. */
#dockhead {
  order: 0;
  flex-shrink: 0;
  padding: 12px 12px 10px;
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.12);
  background: linear-gradient(180deg, rgb(var(--accent-rgb) / 0.08), rgb(var(--accent-rgb) / 0));
}
#dockhead .dh-r1 { display: flex; align-items: center; gap: 8px; }
#ui #dockhead .dh-home {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
  min-height: 48px;
  padding: 0;
  border: 0;
  background: none;
  text-align: left;
}
#dockhead .dh-sign svg { display: block; }
#dockhead .dh-nm { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
#dockhead .dh-nm b {
  font-size: var(--t-title-size);
  line-height: 1;
  font-weight: 500;
  letter-spacing: 0.03em;
  color: var(--hero-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* GO TO THE HOLD is a summary line on the accent ground of the head,
   where Dim falls under 4.5:1, so it takes Text at 70 % (the Dim Read
   Rule, R2050). The line wraps between its words where the cells leave
   it too little room (a dock of 300 px with DEV), and never runs under
   the INBOX cell (R2220). */
#dockhead .dh-nm small { font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); line-height: 1.1; letter-spacing: var(--t-cap-track); color: rgb(var(--text-rgb) / 0.7); overflow-wrap: break-word; }
@media (hover: hover) {
  #ui #dockhead .dh-home:hover:not(:disabled) { background: none; }
  #dockhead .dh-home:hover .dh-nm b { text-decoration: underline; }
}
#dockhead .dh-acts { display: flex; gap: 4px; }
#ui #dockhead .dh-act {
  position: relative;
  width: 58px;
  height: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0;
  border-radius: 10px;
  border-color: rgb(var(--accent-rgb) / 0.24);
  background: transparent;
  color: var(--accent);
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  line-height: 1;
  letter-spacing: var(--t-cap-track);
}
#ui #dockhead .dh-act.on {
  background: rgb(var(--accent-rgb) / 0.22);
  border-color: rgb(var(--accent-rgb) / 0.55);
  color: var(--hero-ink);
}
#dockhead .dh-act.on::after {
  content: '';
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: -1px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--accent);
}
#dockhead .dh-act .lcount { position: absolute; top: -7px; right: -5px; }
#dockhead .dh-act .ctag { position: absolute; top: -8px; left: -4px; margin: 0; }
#dockhead .dh-r2 { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; padding-left: 50px; }
#ui #dockhead .dh-chip, #ui #dockhead button.sq {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  min-height: 0;
  padding: 0 10px;
  border: 1px solid rgb(var(--accent-rgb) / 0.18);
  border-radius: 14px;
  background: rgb(var(--accent-rgb) / 0.05);
  color: var(--text);
  font-size: var(--t-small-size);
  letter-spacing: 0;
  white-space: nowrap;
}
#dockhead .dh-chip b { color: var(--accent); font-weight: 500; }
#ui #dockhead .dh-chip.dh-so { border-style: dashed; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); }
#dockhead .cupm { margin-left: 0; }
/* The squad chip and the rank of card 17 of round 082 (R1767): the squad
   mark, [TAG], SQUAD n and the head count; the rank icon, the title and
   the place. The chip names no full clan name: the roster card names it. */
#ui #dockhead .dh-r2 > .dh-chip { max-width: 100%; min-width: 0; }
#dockhead .dh-chip > svg, #dockhead .dh-chip > img { flex: none; }
#dockhead .dh-cw { display: flex; gap: 6px; min-width: 0; overflow: hidden; }
#dockhead .dh-sn, #dockhead .dh-ct, #dockhead .dh-cw b { flex: none; }
#dockhead .dh-ct { color: rgb(var(--text-rgb) / 0.7); } /* Dim falls to 4.45:1 on the head (R2161). */
/* The new-build line of an admin seat (R89): the light count of new
   commits, the build, and RESTART as the one solid light button. */
#dockhead .dh-dvl {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0 0;
  padding: 6px 6px 6px 10px;
  border: 1px solid rgb(var(--hero-ink-rgb) / 0.2);
  border-radius: 12px;
  background: rgb(var(--hero-ink-rgb) / 0.06);
}
#dockhead .dh-upm {
  display: inline-grid;
  place-items: center;
  width: 18px;
  height: 18px;
  flex: none;
  border-radius: 9px;
  background: var(--hero-ink);
  color: rgb(var(--deep-rgb));
}
#dockhead .dh-dvt { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
#dockhead .dh-dvt b { font-size: var(--t-small-size); letter-spacing: 0.09em; font-weight: 500; color: var(--hero-ink); }
#dockhead .dh-dvt small { font-size: var(--t-small-size); color: var(--dim); white-space: nowrap; }
#ui #dockhead .dh-rst {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  min-height: 0;
  padding: 0 12px;
  border: 0;
  border-radius: 18px;
  background: var(--hero-ink);
  color: rgb(var(--deep-rgb));
  font-size: var(--t-cap-size);
  font-weight: 700;
  letter-spacing: var(--t-cap-track);
}

/* --- the alarm screen (R1753, card 16 of mockup round 082) ---
   **One solid light press at a time.** While an alarm runs (a siege
   warning or a fault), RESTART takes the dark ink of LEAVE TO THE HUB, so
   GO TO is the one solid light press of the screen. `alarm-on` is the
   overlay's one class for it, and the RESTART of the DEV row of the
   telephone menu takes the same rule (R1754). */
#ui.alarm-on #dockhead .dh-rst,
#ui.alarm-on #settings .opt .ch-btn.o-rst {
  border: 1px solid rgb(var(--accent-rgb) / 0.24);
  background: transparent;
  color: var(--accent);
  font-weight: 400;
}
/* The siege row: the flag, SIEGE WARNING over the place, the time of the
   window battle over its countdown, and GO TO, the one solid light press.
   A light row with a light edge, and a light drain along its foot: a
   schedule, never gold. A desktop stands it under the dock head; the sheet
   block stands it in the slot of the peek line. */
#siegerow { order: 0; flex-shrink: 0; position: relative; display: flex; align-items: center; gap: 8px;
  height: 52px; margin: 10px 12px 2px; padding: 0 8px 0 4px; overflow: hidden;
  border: 1px solid rgb(var(--hero-ink-rgb) / 0.5); border-radius: 12px;
  background: rgb(var(--hero-ink-rgb) / 0.08); color: var(--hero-ink); }
#siegerow:empty { display: none; }
#ui #siegerow .sg-open {
  flex: 1; min-width: 0; min-height: 0; height: 100%; display: flex; align-items: center; gap: 9px;
  margin: 0; padding: 0 0 0 4px; border: 0; border-radius: 0; background: none; color: inherit; text-align: left;
}
#siegerow .sg-i {
  width: 30px; height: 30px; flex: none; display: grid; place-items: center;
  border: 1px solid rgb(var(--hero-ink-rgb) / 0.55); border-radius: 8px;
}
#siegerow .sg-t { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
#siegerow .sg-t i, #siegerow .sg-c i {
  font-style: normal; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); line-height: 1; letter-spacing: var(--t-cap-track); white-space: nowrap;
  overflow: hidden; text-overflow: ellipsis;
}
#siegerow .sg-t i { color: var(--text); }
#siegerow .sg-c i { color: var(--dim); letter-spacing: 0.08em; }
#siegerow .sg-t b, #siegerow .sg-c b { font-weight: 500; font-size: var(--t-body-size); line-height: 1; white-space: nowrap; }
#siegerow .sg-t b { overflow: hidden; text-overflow: ellipsis; }
#siegerow .sg-c { flex: none; display: flex; flex-direction: column; align-items: flex-end; gap: 4px; }
#siegerow .sg-c b { font-variant-numeric: tabular-nums; }
/* GO TO and every press of the alarm list share one face: the dark ink of
   LEAVE TO THE HUB, and the solid light face for the one first press. */
#ui :is(#siegerow, #alarmlist) :is(.sg-go, .alb) {
  flex: none; display: inline-flex; align-items: center; justify-content: center; gap: 6px;
  height: 34px; min-height: 0; min-width: 58px; margin: 0; padding: 0 10px;
  border: 1px solid rgb(var(--accent-rgb) / 0.24); border-radius: 8px; background: transparent;
  color: var(--accent); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); line-height: 1; white-space: nowrap;
}
#ui :is(#siegerow, #alarmlist) :is(.sg-go, .alb).light {
  border-color: var(--hero-ink); background: var(--hero-ink); color: rgb(var(--deep-rgb)); font-weight: 700;
}
:is(#siegerow, #alarmlist) .drn {
  position: absolute; left: 0; right: 0; bottom: 0; height: 2px; overflow: hidden;
  background: rgb(var(--hero-ink-rgb) / 0.16);
}
:is(#siegerow, #alarmlist) .drn b {
  position: absolute; left: 0; top: 0; bottom: 0;
  background: var(--hero-ink); box-shadow: 0 0 6px rgb(var(--hero-ink-rgb) / 0.7);
}
/* The alarm list: every running alarm, most urgent first, each with its
   one press. A desktop stands it under the dock head; the sheet block
   stands it over the tab bar. It scrolls inside the room it has. */
#alarmlist { order: 0; flex-shrink: 0; max-height: 60%; overflow-y: auto; overscroll-behavior: contain;
  padding: 0 10px 6px; border-bottom: 1px solid rgb(var(--accent-rgb) / 0.12); }
#alarmlist:empty { display: none; }
#alarmlist .alh { display: flex; align-items: center; gap: 12px; height: 40px; padding: 0 2px; }
#alarmlist .alh b { font-weight: 400; font-size: var(--t-cap-size); letter-spacing: 0.3em; color: var(--accent); }
#alarmlist .alh i { flex: 1; min-width: 0; font-style: normal; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--text);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
#ui #alarmlist .alx {
  flex: none; display: grid; place-items: center; width: 40px; height: 40px; min-height: 0; margin: 0; padding: 0;
  border: 1px solid rgb(var(--accent-rgb) / 0.24); border-radius: 10px; background: transparent; color: var(--accent);
}
#alarmlist .alr {
  position: relative; display: flex; align-items: center; gap: 9px; min-height: 44px;
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.08);
}
#alarmlist .alr.sg { margin: 0 -10px; padding: 0 10px; border-bottom-color: transparent;
  background: rgb(var(--hero-ink-rgb) / 0.06); }
#alarmlist .aln { width: 12px; flex: none; text-align: center; font-size: var(--t-small-size); color: var(--dim);
  font-variant-numeric: tabular-nums; }
#alarmlist .alm { width: 22px; height: 22px; flex: none; display: grid; place-items: center; color: var(--hero-ink); }
#alarmlist .alm .glyph { font-size: var(--t-body-size); line-height: 1; }
#alarmlist .alm .lcount { box-shadow: none; }
#alarmlist .alt { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
/* The head and the line under it wrap: a telephone has no hover, so a
   cut line hides its words for good (R2366). */
#alarmlist .alt { padding: 6px 0; }
#alarmlist .alt b { font-weight: 500; font-size: var(--t-cap-size); line-height: 1.1; letter-spacing: var(--t-cap-track); color: var(--hero-ink);
  overflow-wrap: anywhere; text-transform: uppercase; }
#alarmlist .alt i { font-style: normal; font-size: var(--t-small-size); line-height: 1.2; color: var(--dim);
  overflow-wrap: anywhere; }
#alarmlist .alv { flex: none; font-size: var(--t-small-size); color: var(--hero-ink); font-variant-numeric: tabular-nums; white-space: nowrap; }
/* FAULT: the moving red hatch of the drain line, as a mark. FULL: the lid
   over a thick white gauge, the shape the readout line draws. */
#alarmlist .alm .hatch { display: block; width: 12px; height: 12px; border-radius: 2px; }
#alarmlist .lid { display: flex; flex-direction: column; gap: 2px; width: 14px; }
#alarmlist .lid i { display: block; height: 2px; border-radius: 1px; background: var(--readout-white); }
#alarmlist .lid b { display: block; height: 6px; border-radius: 1px; background: var(--readout-white);
  box-shadow: 0 0 6px rgb(var(--readout-white-rgb) / 0.6); }
/* The time cell is lit while the alarm list stands (OPEN). */
#ui #topbar button.clock.on {
  background: rgb(var(--accent-rgb) / 0.2);
  box-shadow: inset 0 0 0 1px rgb(var(--accent-rgb) / 0.55);
  border-radius: 9px;
}

/* --- the sheet's drag grip (R233) ---
   The top edge of the bottom sheet, and the way a hand takes the sheet
   between its three stops. It is absent on a desktop, where the sheet is a
   full-height column with nothing to resize.

   Small to the eye and large to the finger: the strip itself is 4 px and
   the padding around it makes the target 28 px, which is the same rule the
   three console minimize controls follow (§12.0). The drag drives
   `max-height` through `--sheet-h` and never `transform`, which the chrome
   dock-in owns for this panel. */
#dockgrip {
  order: 0;
  display: none;
  flex: 0 0 auto;
  padding: 12px 0;
  cursor: grab;
  /* The grip is the one place in the chrome where a vertical drag is the
     control itself, so the browser must not read it as a scroll. */
  touch-action: none;
}
#dockgrip .grab {
  display: block;
  width: 42px;
  height: 4px;
  margin: 0 auto;
  border-radius: 2px;
  background: var(--edge);
}
#dockgrip:active { cursor: grabbing; }
#dockgrip:active .grab { background: var(--accent); }

/* The tab bar never shrinks: it is the one row that must stay on the glass
   whatever the queue strip above it holds (R1202). The rows of the dock
   stand in one order on a desktop: the body, the peek line, the queue
   strip and the tab bar; the sheet block moves the peek line under the
   queue strip (R1749). */
/* The bar keeps one inset of 6 px to the left, the right and the foot of
   the column (R1772). */
#tabs { display: flex; gap: 2px; padding: 2px 6px 6px; order: 4; flex-shrink: 0; }
#tabs button { flex: 1; padding: 6px 3px; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); }
#tabs button.active { background: rgb(var(--accent-rgb) / 0.22); color: var(--accent); }
/* **The tab glyphs** (R2214, round 102 cards 14 and 18, round 103 cards
   02 and 07): each game tab `.gt` holds its glyph `.tgl` and its word
   `.tw`. On a desktop the glyph stands beside the word; `fitTabs`
   measures the six words in the dock and gives a tab its short word, or
   the class `g`, while the bar does not fit. A tab of `g` shows its glyph
   alone and a little larger, and its full word stays its title. The
   desktop word takes no tracking, as the page of round 102 drew it; the
   sheet block keeps the tracking of the telephone bar. */
#tabs button.gt {
  position: relative;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: max-content;
  white-space: nowrap;
}
#tabs button.gt.g { min-width: 0; }
#tabs .tgl { display: block; flex: none; width: 14px; height: 14px; }
#tabs button.g .tgl { width: 16px; height: 16px; }
#tabs button.g .tw { display: none; }
/* **The hold bubble** (R2214, round 102 card 15): a touch that rests on
   a tab for `tab_hold_ms` names it over the bar (`ui/tabhold.ts` writes
   `bub`), and on a telephone a keyboard focus names it the same way. The
   bubble reads the full word of the tab off its name. A desktop keeps the
   `title` of the tab. */
#tabs button.gt.bub::after,
#ui.sheet #tabs button.gt:focus-visible::after {
  content: attr(aria-label);
  position: absolute;
  bottom: calc(100% + 9px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  padding: 6px 9px;
  border-radius: 6px;
  background: var(--hero-ink);
  color: rgb(var(--deep-rgb));
  font-size: var(--t-small-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: 0.08em;
  line-height: 1;
  white-space: nowrap;
  pointer-events: none;
}
#tabs button.gt.bub::before,
#ui.sheet #tabs button.gt:focus-visible::before {
  content: '';
  position: absolute;
  bottom: calc(100% - 1px);
  left: 50%;
  margin-left: -5px;
  z-index: 3;
  border: 5px solid transparent;
  border-top-color: var(--hero-ink);
  pointer-events: none;
}
/* The caps stand in the telephone tab bar alone (R1749); the sheet block
   draws them. */
#tabs button.cap { display: none; }

/* --- the signal grammar of the thumb dock (R1749, round 080 group C) ---
   No gold as a signal. ATTENTION is a solid light count, the hero ink with
   a dark figure, or a light dot where no count fits (a new build). A dark
   ring cuts each one from the control under it, so it reads by shape as
   well as by ink. `.dic` is a line icon of the dock. */
#ui .lcount {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  box-sizing: border-box;
  border-radius: 9px;
  background: var(--hero-ink);
  color: rgb(var(--deep-rgb));
  font-size: var(--t-cap-size);
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
  box-shadow: 0 0 0 2px rgb(var(--deep-rgb) / 0.92);
}
#ui .ldot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: var(--hero-ink);
  box-shadow: 0 0 0 2px rgb(var(--deep-rgb));
}
#ui .dic { display: block; flex: none; }

#tabbody { order: 1; flex: 1; min-height: 0; }

/* The open strip takes at most 0.5 of the dock and scrolls
   inside it (R1202). It does not shrink under that cap (R1221): the panel
   body above it gives up the room. A strip that shrank took its share of
   the overflow in proportion to its own content, so on the sheet a long
   build list squeezed it far under half the dock. The desktop column has
   a definite height, so a percentage works here; the sheet has none, and
   its block below states the cap in vh. */
#queuestrip {
  order: 3;
  cursor: pointer;
  max-height: calc(100% * 0.5);
  overflow-y: auto;
  flex-shrink: 0;
}
#queuestrip .qline { display: flex; gap: 10px; align-items: center; padding: 6px 10px; overflow: hidden; white-space: nowrap; }
#queuestrip .qhead { color: var(--accent); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); flex-shrink: 0; }
#queuestrip .qjob { color: var(--text); font-size: var(--t-small-size); overflow: hidden; text-overflow: ellipsis; }
#queuestrip .qjob.waiting { color: var(--dim); }
#queuestrip .qcaret { margin-left: auto; display: flex; }
/* The caret's square press stands 3 px into the pad of the line, so the
   line keeps its height (R1856). */
#queuestrip .qcaret .sqp { margin: -3px 0; }
#queuestrip .job { margin: 4px 10px; cursor: default; }
/* **The desktop strip has three states** (R2740): minimized to its line,
   SMALL and LARGE. The line of the open strip ends in the size press and
   the minimize press of the chat box head; the minimized line ends in the
   restore glyph of the chat box and the legend card. SMALL writes one
   line per job (`.compact`: the name, the clock and a thin bar, no
   presses) and takes at most 0.25 of the column. A
   telephone keeps the caret and has no SMALL strip. */
#queuestrip .qcaret { gap: var(--s-2); }
#queuestrip.small { max-height: calc(100% * 0.25); }
#queuestrip .job.compact { margin: 2px 10px; padding: 3px 0; }
#queuestrip .job.compact .bar { height: 2px; margin-top: 2px; }
/* The column at rest has no height of its own, so a share of it resolves
   to nothing. The LARGE strip there takes the height up to the edge
   margin and shrinks under it (R2740); the SMALL strip states its share of
   the column in vh, as the sheet block states its caps. */
#dock.collapsed #queuestrip { max-height: none; flex-shrink: 1; }
#dock.collapsed #queuestrip.small { max-height: calc((100vh / var(--ui-scale, 1) - 2 * var(--pad)) * 0.25); }
/* The strip has square corners on both shells (R1767, the owner's eye test
   of 2026-10-07): it is a band of the dock, not a card. `#ui .panel`
   rounds every panel, so two ids state the corner. The strip draws its
   top rule alone (R1769, card 17 of round 082): the panel rim on four
   sides doubled the rim of the dock column and drew a rule over the tab
   bar. Under the advisor line the dashed rule of the line stands in its
   place (the rule below). */
#ui #queuestrip { border-radius: 0; border-width: 1px 0 0; border-color: var(--edge); }
/* The peek line (R1749): the advisor line and the sea trials, in an
   element of their own. On a desktop it stands over the queue head with
   the strip's rule over it, and the strip under it gives up its own. */
#peekline { order: 2; flex-shrink: 0; border-top: 1px solid var(--edge); }
#peekline:empty { display: none; }
#peekline:not(:empty) + #queuestrip { border-top: 0; }
/* The advisor line (player-reach.md §4.1, R1305): one button above the
   queue head. The tag takes the head's accent, and the sentence takes the
   body ink. The sentence wraps to two rows and no ellipsis cuts it
   (R2131); a sentence that needs a third row carries a fold caret at the
   end of the line, and the caret opens the line to the whole sentence
   (R1423). A line that fits carries no caret. */
#peekline .advrow { display: flex; align-items: stretch; border-bottom: 1px dashed var(--edge); }
#peekline .advice {
  display: block; flex: 1; min-width: 0; margin: 0; padding: 8px 10px; text-align: left;
  border: 0; border-radius: 0;
  background: transparent; color: var(--text); font-size: var(--t-small-size);
  white-space: normal;
}
#peekline .advice .al {
  display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; line-clamp: 2;
  overflow: hidden; overflow-wrap: anywhere;
}
#peekline .advrow.open .advice .al { display: block; -webkit-line-clamp: none; line-clamp: none; }
/* The count of the sea trials on the advisor line (R2131): a quiet press
   in the secondary ink, `TRIALS 3/8`, that folds the rows open; the ink of
   an "on" state while they stand open (R1798). */
#peekline .tcount {
  flex-shrink: 0; margin: 0; padding: 0 var(--s-2); border: 0; border-radius: 0;
  background: transparent; color: var(--dim);
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track);
  font-variant-numeric: tabular-nums; white-space: nowrap;
}
#peekline .tcount.on { color: var(--accent); }
/* The tag is the small pill of `.td-advl` of round 082 (R1767), on both
   shells; the sea trials line wears the same pill. */
#peekline .advice .atag {
  display: inline-block; margin-right: 4px; padding: 2px 6px; vertical-align: 1px;
  border: 1px solid rgb(var(--accent-rgb) / 0.3); border-radius: 4px;
  color: var(--accent); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); line-height: 1; letter-spacing: var(--t-cap-track);
}
#peekline .afold {
  flex-shrink: 0; margin: 0; padding: 0 var(--s-2); border: 0; border-radius: 0;
  display: grid; place-items: center;
  background: transparent; color: var(--dim);
}
#peekline .advrow.fits .afold { display: none; }
/* The row a press on the advisor line opened, marked for a moment. */
#ui .row.advised { animation: advised 1.6s ease-out; }
@keyframes advised {
  0% { background: rgb(var(--accent-rgb) / 0.35); }
  100% { background: transparent; }
}
@media (prefers-reduced-motion: reduce) {
  #ui .row.advised { animation: none; outline: 1px solid var(--accent); }
}
/* The sea trials (player-reach.md §8.1, R1572): card 06 of mockup round
   075. The line under the advisor line takes the advisor line's idiom, and
   the caret opens the six rows and the drill row under it. The check box
   reads by shape: a hollow box is open, a box with a dot is the next act,
   a filled box with a tick is done. A done row keeps its words and takes
   no strike, because a strike says "locked" in this chrome (R45). The
   next act takes the ink of a hovered button. */
#peekline .tr { font-size: var(--t-small-size); border-bottom: 1px dashed var(--edge); }
#peekline .trow {
  display: flex; align-items: center; gap: 8px; padding: 5px 10px;
  border-top: 1px solid rgb(var(--accent-rgb) / 0.08);
}
#peekline .bx {
  flex: none; position: relative; box-sizing: border-box; width: 12px; height: 12px;
  border: 1px solid var(--dim); border-radius: 2px;
}
#peekline .bx.d { background: var(--accent); border-color: var(--accent); }
#peekline .bx.d::after {
  content: ""; position: absolute; left: 3.5px; top: 0.5px; width: 3px; height: 7px;
  border: solid rgb(var(--ink-rgb)); border-width: 0 1.6px 1.6px 0; transform: rotate(45deg);
}
#peekline .bx.n { border-color: var(--text); }
#peekline .bx.n::after {
  content: ""; position: absolute; left: 3px; top: 3px; width: 4px; height: 4px;
  background: var(--text); border-radius: 50%;
}
#peekline .trow .tt { flex: 1; min-width: 0; color: var(--text); }
#peekline .trow.d .tt { color: var(--dim); }
#peekline .trow.n .tt { color: var(--hover-ink); }
#peekline .trow .show { margin: 0; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); padding: 2px 7px; }
#peekline .trow.d .show { opacity: 0.55; }
#peekline .trow.drill { border-top: 1px dashed var(--edge); }
/* While no act is done, the drill row heads the rows (R2131). */
#peekline .trow.drill.lead { border-top: 0; border-bottom: 1px dashed var(--edge); }
#peekline .trow.drill .tt b { color: var(--amber); font-weight: 400; letter-spacing: 0.08em; }
#peekline .trow.drill .show {
  color: var(--amber); border-color: rgb(var(--amber-rgb) / 0.45); background: rgb(var(--amber-rgb) / 0.06);
}
/* The closing line: the sixth act is done, and the bar drains before the
   card goes for good. A phone states the count instead of the sentence. */
#peekline .closing {
  flex: 1; display: flex; gap: 8px; align-items: center; padding: 8px 10px 9px;
  color: var(--text); font-size: var(--t-small-size);
}
#peekline .closing b { color: var(--accent); font-weight: 400; letter-spacing: 0.08em; }
#peekline .closing .short { display: none; }
#peekline .closing .fadebar {
  flex: none; margin-left: auto; width: 46px; height: 3px; border-radius: 2px;
  background: rgb(var(--accent-rgb) / 0.15); overflow: hidden;
}
#peekline .closing .fadebar i { display: block; height: 100%; background: var(--accent); }

/* The welcome card (player-reach.md §8.5, R1572): card 10 of mockup round
   075. It stands over the map at the top left, the map under it takes a
   shade, and two numbered tags mark the places it points at: the advisor
   line (1) and the ☸ OPTIONS button (2). The shade takes no pointer. The
   kicker takes the cap step, and every sentence and row the body step
   (DESIGN.md "The Sentence Rule", critique of 2026-10-13). */
#welcomedim {
  position: fixed; inset: 0; display: none; pointer-events: none;
  background: rgb(var(--deep-rgb) / 0.35);
}
#welcomedim.on { display: block; }
#welcome {
  position: absolute; left: 22px; top: 54px; z-index: 41; display: none;
  width: min(466px, calc(100vw / var(--ui-scale, 1) - 44px));
  max-height: calc(100vh / var(--ui-scale, 1) - 96px); overflow-y: auto;
  padding: 14px 16px 12px;
}
#welcome.on { display: block; }
#welcome .k { font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }
#welcome h4 { margin: 3px 0 6px; font-size: var(--t-title-size); letter-spacing: 0.21em; color: var(--accent); font-weight: 500; }
#welcome p { margin: 0 0 8px; font: var(--t-body); color: var(--text); }
#welcome p.dim { color: var(--dim); }
/* The situation leads (R2120): the truce, the nearest hostile hold and
   the neighbours, under a hairline. The neighbour's name may wrap, so its
   note keeps the right edge on a narrow card. */
#welcome .sit { margin: 10px 0 0; padding: 9px 0 1px; border-top: 1px solid rgb(var(--accent-rgb) / 0.14); }
#welcome .sit li > span:first-child { min-width: 0; overflow-wrap: anywhere; }
/* The handover inventory folds behind one press (R2120), in the look of
   the HOW IT WORKS fold: one row of the cap step in Dim, a hairline over
   it, and a chevron at its right that points down while it is open. */
#ui #welcome .fold {
  display: flex; align-items: center; gap: var(--s-3);
  width: 100%; min-height: 36px; margin: 9px 0 0; padding: 0;
  background: none; border: 0; border-top: 1px solid rgb(var(--accent-rgb) / 0.14); border-radius: 0;
  color: var(--dim); font: var(--t-cap); letter-spacing: var(--t-cap-track); text-align: left;
}
#ui #welcome .fold::after {
  content: ''; flex: none; width: 6px; height: 6px; margin: 0 4px 0 auto;
  border-right: 1px solid currentColor; border-bottom: 1px solid currentColor;
  transform: rotate(-45deg);
}
#ui #welcome .fold[aria-expanded="true"] { color: var(--text); }
#ui #welcome .fold[aria-expanded="true"]::after { transform: rotate(45deg); }
@media (hover: hover) {
  #ui #welcome .fold:hover { background: rgb(var(--accent-rgb) / 0.06); color: var(--text); }
}
@media (pointer: coarse) {
  #ui #welcome .fold { min-height: var(--target-finger); }
  #welcome .foot button { min-height: var(--target-finger); }
}
/* THE SEASON block under the situation (R2447): a hairline over it, the
   head in the cap step, the sentences in the body step and two quiet
   presses under them. On a telephone the head is the fold press above,
   and the block starts folded. */
#welcome .season { margin: 10px 0 0; padding: 0; border-top: 1px solid rgb(var(--accent-rgb) / 0.14); }
#welcome .season > .st { margin-top: 9px; }
#ui #welcome .season .fold { margin-top: 0; border-top: 0; }
#welcome .season [hidden] { display: none; }
#welcome .season .presses { display: flex; flex-wrap: wrap; gap: 8px; margin: 2px 0 0; }
@media (pointer: coarse) {
  #welcome .season .presses button { min-height: var(--target-finger); }
}
#welcome .lists { display: grid; grid-template-columns: 1fr 1fr; gap: 0 18px; }
#welcome .lists[hidden] { display: none; }
#welcome .st { margin: 9px 0 3px; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }
#welcome ul { margin: 0; padding: 0; list-style: none; font-size: var(--t-body-size); }
#welcome li { display: flex; gap: 8px; padding: 2px 0; border-bottom: 1px solid rgb(var(--accent-rgb) / 0.06); }
#welcome li .q { margin-left: auto; color: var(--dim); text-align: right; white-space: nowrap; }
#welcome .where { display: flex; flex-direction: column; gap: 4px; margin-top: 9px; font-size: var(--t-body-size); }
#welcome .foot { display: flex; gap: 8px; justify-content: flex-end; margin-top: 12px; }
#ui .callout { outline: 1px solid var(--accent); outline-offset: -1px; box-shadow: 0 0 0 3px rgb(var(--accent-rgb) / 0.18); }
#ui .ctag {
  display: inline-block; min-width: 15px; padding: 0 4px; margin-right: 6px; border-radius: 3px;
  background: var(--accent); color: rgb(var(--ink-rgb)); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); text-align: center; line-height: 15px;
}

/* --- the sub-menu row (R258) ---
   The tab bar picks the menu and this row picks the page of that menu.
   The two do the same job, so they are one control and not two: the row
   states exactly what `#tabs button` states above, and everything else
   comes from `#ui button`, which both of them already sit on. The row
   used to wear a 10 px rounded outline pill with no ground, which read as
   a different rank of control. A press of the row is a sub-menu button
   (`.sub`), and the row is `.subrow`: the word "pill" names a press that
   sets a saved value alone (R2011).

   `flex: 1` is what gives the button its width, the same way the tab bar
   gets its width, so no button states a horizontal padding of its own. A
   row therefore fits the narrowest dock it is drawn in, and it wraps only
   when the labels together are wider than the sheet.

   **The `#ui` in the selector is load-bearing.** `#ui button` above states
   the ground, the ink, the padding and the corner of every button in the
   shell, and an id beats any number of classes. A rule that says
   `.subrow .sub` therefore reaches the button for a property that rule
   does not state, and for no other. That is what the old block did: only
   its letter-spacing ever applied, and `.on` painted nothing at all, so
   the row named its active page with no mark on the glass (R258). */
.subrow { display: flex; gap: 2px; flex-wrap: wrap; margin: 2px 0 8px; container-type: inline-size; }
#ui .subrow .sub { flex: 1; padding: 6px var(--s-3); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); }
/* A narrow sub-menu row takes 4 px of side padding on a button in place
   of 8 px (R1811, round 088 card 14): a v2 flag adds a fifth BUILD button,
   and five buttons must fit one line at UI scale 140. The row is its own query
   container, so the rule reads the row and not the screen. */
@container (max-width: 290px) {
  #ui .subrow .sub { padding-left: var(--s-2); padding-right: var(--s-2); }
}
#ui .subrow .sub.on { background: rgb(var(--accent-rgb) / 0.22); color: var(--accent); }

/* --- the anchored sub-menu row (§12) ---
   The sub-menu row stays at the top of the sheet body while the body
   scrolls. A commander who reads down the tech tree or a long building
   list keeps the way to the other pages of the same menu. The primary tab
   bar needs no rule of its own: `#tabs` is a flex sibling of the scroller
   and was never inside it.

   `position: sticky` is the whole mechanism. §10 refuses a scroll listener
   that moves an element per frame, and CSS does this work with no script
   at all.

   The row must be OPAQUE, and `--panel` is not: its 0.82 alpha would let
   the list read through the buttons, which looks like a fault in the
   renderer. The panel ink at full alpha is the same colour the sheet is
   already painted in.

   z-index 2 stands the row over the list. It stays far below the numbers
   that already carry a meaning in this sheet — the panels at 20, the chat
   at 30, the season banner at 45 and `#fatal` on the cover rung — so nothing that
   must cover the dock stops covering it.

   The scroller's top padding moves INTO the row, and that is not a tidy-up
   (this is the part that is easy to get wrong). A sticky box may not leave
   its containing block, which is the content box of `#tabbody` — so with
   `padding-top: 8px` on the scroller the row parks 8 px down and the list
   runs through the band above it. Every browser does that, and no offset
   fixes it, because a negative `top` is clamped by the same containing
   block. The scroller therefore gives up its top padding when it holds an
   anchored row, and the row states 10 px of its own: the 8 px the scroller
   used to give it, plus the 2 px that used to be the row's margin. The
   layout at rest does not move.

   The 8 px under the buttons is padding for the same reason. It has to be
   inside the opaque box, or a row of the list shows through a transparent
   band while it passes under.

   `:first-child` is the whole scope of the rule, and it is the row
   `subRow()` writes for the six game menus. ECONOMY · AUCTION writes a
   second `.subrow` row for its two subpages (§12.2). That row is a page
   control inside a body and not a menu, and two sticky rows at `top: 0`
   would stand on each other. */
#tabbody:has(> .subrow:first-child) { padding-top: 0; }
#tabbody:has(> .tabhead:first-child) { padding-top: 0; }
#tabbody > .subrow:first-child {
  position: sticky;
  top: 0;
  z-index: 2;
  margin: 0;
  padding: 10px 0 8px;
  background: rgb(var(--panel-rgb));
}

#tabbody { overflow-y: auto; padding: 8px 10px 12px; scrollbar-width: thin; }
/* **The sheet head** (R2214, round 102 card 16): an open game menu starts
   with its name, the glyph in the accent and the full word in the hero
   ink, over its pills. It names the menu on the telephone sheet, beside
   the rail and in the desktop dock body, where a glyph tab carries no
   word. The head takes the 8 px the scroller gives up, and the pill row
   under it stays anchored. */
#tabbody > .tabhead {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 30px;
  padding-top: 8px;
  color: var(--hero-ink);
  font: var(--t-title);
  letter-spacing: 0.16em;
  white-space: nowrap;
  overflow: hidden;
}
#tabbody > .tabhead .tgl { flex: none; width: 20px; height: 20px; color: var(--accent); }
/* The pill row under the sheet head is the anchored row of its menu: it
   stays at the top of the body while the head scrolls away. The head
   stands over it, so the row takes 4 px at its top in place of 10 px. */
#tabbody > .tabhead:first-child + .subrow {
  position: sticky;
  top: 0;
  z-index: 2;
  margin: 0;
  padding: 4px 0 8px;
  background: rgb(var(--panel-rgb));
}
#tabbody::-webkit-scrollbar { width: 6px; }
#tabbody::-webkit-scrollbar-thumb { background: var(--edge); border-radius: 3px; }

#ui h3 {
  margin: 12px 0 6px;
  font-size: var(--t-cap-size);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
  font-weight: normal;
  text-transform: uppercase;
}
#ui h3:first-child { margin-top: 2px; }
/* A second line of a head: the limits of the DEPOT deployables (R3190). */
#ui h3 .lim { display: block; margin-top: 2px; }

#ui .row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.07);
}
#ui .row:last-child { border-bottom: 0; }

/* The specification row (R1813, R1847; mockup round 085 card 01 and round
   087 card 04 B, amended by the owner on 2026-10-09): every list of the
   dock that buys a thing draws its rows with `ui/overlay/buildrow.ts`. A
   row is 44 px high on both form factors, with four columns: the icon; the
   name over line 2; the cost column, the cost over the time, right-aligned;
   the press of the verb alone. The cost column and the press have one
   minimum width, so the cost and the press align down every list. Line 2
   runs under the name: a building row opens it with the level prefix
   "05:" (R1874), then the condensed effect "key now → after" of the
   next level (R1081), cut with an ellipsis. The detail (formulas, gates,
   the rest of the figures) lives on the build card (R1826). */
#ui .row.spec {
  display: grid;
  grid-template-columns: calc(var(--s-5) + var(--s-2)) minmax(0, 1fr)
    minmax(var(--w-cost), max-content) minmax(var(--w-press), max-content);
  grid-template-rows: auto auto;
  column-gap: var(--s-2);
  row-gap: var(--s-1);
  align-content: center;
  align-items: center;
  /* A fixed height, not a minimum: every row marches down the panel on
     one rhythm, with or without a line 2. */
  height: var(--target-finger);
  padding: 0;
  overflow: hidden;
}
/* The icon of the item (R1855, `ui/buildicons.ts`): a building or a tech
   step has its own, in the hero ink of a catalogue item (R1798). */
#ui .row.spec .ric { grid-column: 1; grid-row: 1 / 3; display: inline-flex; justify-content: flex-start; color: var(--hero-ink); }
#ui .row.spec .bic { width: var(--s-5); height: var(--s-5); flex: none; }
/* A hull row draws the hull mark of its class in the reader's ship icon
   set, at the size of the fleet row's mark (R1844, R1872). */
#ui .row.spec .ric .ck-ship { width: var(--s-5); height: var(--s-6); flex: none; }
#ui .row.spec .ident {
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--t-body-size);
}
/* The rounds held after the name of a round (R1847): ×N in the dim ink. */
#ui .row.spec .ident .held { color: var(--dim); }
/* The levels already in the queue after the name of a building (R1874):
   +N in the dim ink. */
#ui .row.spec .ident .lvq { margin-left: var(--s-2); color: var(--dim); }
/* The depth of a dive row after its name (R1893): DEPTH n in the cap step. */
#ui .row.spec .ident .dep {
  margin-left: var(--s-2);
  color: var(--dim);
  font-size: var(--t-cap-size);
  letter-spacing: var(--t-cap-track);
}
/* The row of the depth whose start sheet stands (R1893): the plate of the
   lit row of the build card. */
#ui #tabbody .row.spec.picked {
  background: rgb(var(--accent-rgb) / 0.1);
  box-shadow: inset 2px 0 0 var(--accent);
}
/* The separator head of a page of two parts (round 091, R1893): a rule
   over the head, a dot before the title, and the aside at the right. The
   dot is solid over what runs and hollow over what starts a thing. */
#ui h3.sep {
  display: flex;
  align-items: baseline;
  gap: var(--s-2);
  margin-top: var(--s-3);
  padding-top: var(--s-3);
  border-top: 1px solid rgb(var(--accent-rgb) / 0.28);
}
#ui h3.sep:first-child { margin-top: 2px; }
#ui h3.sep > span { color: var(--text); }
#ui h3.sep .sep-dot {
  display: inline-block;
  width: var(--s-2);
  height: var(--s-2);
  margin-right: var(--s-2);
  border-radius: 50%;
  background: var(--accent);
}
#ui h3.sep .sep-dot.o { background: transparent; box-shadow: inset 0 0 0 1px var(--dim); }
#ui h3.sep .sep-aside { margin-left: auto; font-style: normal; text-transform: none; letter-spacing: 0.06em; }
#ui h3.sep .sep-aside b { font-weight: 500; color: var(--text); }
#ui .row.spec .sub {
  grid-column: 2;
  grid-row: 2;
  display: flex;
  align-items: baseline;
  min-width: 0;
  white-space: nowrap;
}
#ui .row.spec .sub .eff { min-width: 0; overflow: hidden; text-overflow: ellipsis; }
/* A reason never cuts (R2061): the reason of a LOCKED row and the source
   sentence of a store row take a second line, and the row grows past its
   44 px. The name on line 1 is free text and keeps its ellipsis. */
#ui .row.spec.rwrap { height: auto; min-height: var(--target-finger); padding: var(--s-1) 0; }
#ui .row.spec.rwrap .sub { white-space: normal; }
#ui .row.spec.rwrap .sub .eff { overflow: visible; text-overflow: clip; }
/* The name of a keystone card never cuts (R2160): it takes a second
   line, and the row grows past its 44 px. Every other name keeps one line
   and its ellipsis (the owner, 2026-10-14). */
#ui .row.spec.nwrap { height: auto; min-height: var(--target-finger); padding: var(--s-1) 0; }
#ui .row.spec.nwrap .ident { white-space: normal; overflow: visible; text-overflow: clip; }
/* The level of a building row (R1874): after the name on line 1, in the
   dim ink and the same step as the name, never the accent, because the
   accent marks a control. */
#ui .row.spec .ident .lvpre { margin-left: var(--s-2); color: var(--dim); font-variant-numeric: tabular-nums; }
#ui .row.spec .sub .eff em { font-style: normal; color: var(--hero-ink); }
#ui .row.spec .sub .fit { display: inline; font-size: inherit; }
/* The cost column: the cost over the time, right-aligned. A part the
   stores cannot pay stands in the bad ink (R45); a locked row states its
   cost in the faint ink. */
#ui .row.spec .costcol {
  grid-column: 3;
  grid-row: 1 / 3;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: var(--s-1);
  white-space: nowrap;
  font-size: var(--t-small-size);
}
#ui .row.spec .costcol .cost { color: var(--text); }
#ui .row.spec .costcol .cost.faint .r { color: var(--faint); }
#ui .row.spec .costcol .r.short { color: var(--bad); opacity: 1; }
#ui .row.spec .costcol .time { color: var(--dim); font-size: var(--t-small-size); }
/* The press: the verb alone, one narrow width on every row, the verb at
   the body step. It never states a time or a cost. A state reads by shape
   (R45): LOCKED has a dashed edge, a press short of stores is faint, and
   MAX and DONE are a solid word. The 44 px row gives the press its finger
   height (review §4.2). */
#ui .row.spec .bp {
  grid-column: 4;
  grid-row: 1 / 3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--s-2);
  width: 100%;
  height: calc(var(--target-finger) - var(--s-4));
  min-width: 0;
  padding: 0 var(--s-2);
  border-radius: var(--r-button);
  border: 1px solid rgb(var(--accent-rgb) / 0.3);
  background: rgb(var(--deep-rgb) / 0.7);
  color: var(--accent);
  font-size: var(--t-body-size);
  white-space: nowrap;
  overflow: hidden;
}
#ui .row.spec .bp .w { flex: none; font-weight: var(--t-title-weight); letter-spacing: 0.06em; }
/* A press that shows a word of its state keeps the room of its verb
   (R1860): the verb stands hidden in the same cell of the press, so the
   German DECRYPT, which is wider than the press, gives every press of the
   TECH list one width and the cost columns align. */
#ui .row.spec .bp[data-verb] { display: grid; justify-items: center; }
#ui .row.spec .bp[data-verb] > .w, #ui .row.spec .bp[data-verb]::before { grid-area: 1 / 1; }
#ui .row.spec .bp[data-verb]::before {
  content: attr(data-verb);
  visibility: hidden;
  font-weight: var(--t-title-weight);
  letter-spacing: 0.06em;
}
#ui .row.spec .bp .bic { width: var(--s-4); height: var(--s-4); }
#ui .row.spec .bp:disabled { opacity: 1; cursor: default; }
#ui .row.spec .bp.short, #ui .row.spec .bp.held {
  border-color: rgb(var(--text-rgb) / 0.16);
  background: rgb(var(--deep-rgb) / 0.4);
  color: var(--faint);
}
#ui .row.spec .bp.lock {
  border-style: dashed;
  border-color: rgb(var(--text-rgb) / 0.3);
  background: transparent;
  color: var(--faint);
}
#ui .row.spec .bp.max, #ui .row.spec .bp.done {
  border-color: rgb(var(--good-rgb) / 0.45);
  background: transparent;
  color: var(--good);
}
/* PENDING of FLEET · COMMISSIONS (R2715): a done offer whose ship waits
   for room in the Dock takes the amber ink, the ink of a state that asks
   for the player. */
#ui .row.spec .bp.pending {
  border-color: rgb(var(--amber-rgb) / 0.5);
  background: rgb(var(--amber-rgb) / 0.08);
  color: var(--amber);
}
/* A library row of DRAFT (R1888, `overlay/library.ts`): IN USE and SPENT
   are a dim word with the width of a press; a REDRAFT row under an open ⋯
   stands indented. */
/* The press and ⋯ take the press column and the column at the right edge
   as they do in every other row, so INSTALL and PRINT keep the full
   width of a press: a percentage width of a shrink-to-fit wrapper
   collapsed it. */
#ui .row.spec .lp { display: contents; }
/* A library row has three lines: the third, the typed systems, runs on
   under the cost column and the press up to the right edge, and the
   rest of the row keeps the two upper lines. */
#ui .row.spec.lib { grid-template-rows: auto auto auto; height: auto; min-height: var(--target-finger); padding: var(--s-1) 0; }
#ui .row.spec.lib .ric { grid-row: 1 / 4; }
#ui .row.spec .sub.l3 { grid-column: 2 / -1; grid-row: 3; }
#ui .row.spec .sub.l3 .fit { min-width: 0; white-space: normal; }
#ui .row.spec .bp.tag {
  box-sizing: border-box;
  border-color: rgb(var(--text-rgb) / 0.16);
  background: transparent;
  color: var(--dim);
}
#ui .row.spec.redraft { padding-left: var(--s-5); }
#ui .fl-grid .lib-price { min-width: 0; margin: 0; }
/* The auto-rebuild switch (R1813) keeps the width of a press. */
#ui .row.spec .bp.switch { justify-content: center; }
#ui .row.spec .bp.switch:not(.primary) { color: var(--dim); }
/* ECONOMY and WAR take the spec row (round 091 card 09, R1892). The section
   head states its title at the left and a count or a unit at the right, in
   the cap step and the dim ink. */
#ui h3.sechd { display: flex; align-items: baseline; justify-content: space-between; gap: var(--s-3); }
#ui h3.sechd .aside { color: var(--dim); font-variant-numeric: tabular-nums; }
/* The kind word after the name: the kind of an object, the runs of a
   print, in the cap step and the dim ink. */
#ui .row.spec .ident .kind {
  margin-left: var(--s-3);
  color: var(--dim);
  font-size: var(--t-cap-size);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
}
/* The icon of a store: the resource icon in its resource ink. */
#ui .row.spec .ric svg.ri { width: var(--s-5); height: var(--s-5); }
/* A rate is no confirmation, so it takes the text ink (R1798). */
#ui .row.spec .sub .rate { color: var(--text); }
/* The figure column: the stock over its cap with a store bar in the
   resource ink, a price, or a window clock. A price field of ADD OFFER
   stands in it too. */
#ui .row.spec .costcol .cost small { color: var(--dim); font-size: inherit; }
#ui .row.spec .costcol .sbar {
  display: block;
  width: 100%;
  height: var(--s-1);
  border-radius: var(--r-bar);
  background: rgb(var(--text-rgb) / 0.14);
  overflow: hidden;
}
#ui .row.spec .costcol .sbar > b { display: block; height: 100%; width: var(--fill, 0%); background: currentColor; }
#ui .row.spec .costcol input { width: var(--w-cost); box-sizing: border-box; }
/* A row with a fold takes a fifth column for its ⋯, in the look of the ⋯
   of a fleet row. */
#ui .row.spec.withmore {
  grid-template-columns: calc(var(--s-5) + var(--s-2)) minmax(0, 1fr)
    minmax(var(--w-cost), max-content) minmax(var(--w-press), max-content) var(--target-mouse);
}
#ui .row.spec .rmore {
  grid-column: 5;
  grid-row: 1 / 3;
  width: var(--target-mouse);
  height: var(--target-mouse);
  margin: 0;
  padding: 0;
  border: 1px solid rgb(var(--accent-rgb) / 0.2);
  border-radius: var(--r-button);
  background: transparent;
  color: var(--accent);
}
#ui .row.spec .rmore.on { background: rgb(var(--accent-rgb) / 0.18); border-color: rgb(var(--accent-rgb) / 0.6); }
@media (pointer: coarse) {
  #ui .row.spec.withmore {
    grid-template-columns: calc(var(--s-5) + var(--s-2)) minmax(0, 1fr)
      minmax(var(--w-cost), max-content) minmax(var(--w-press), max-content) var(--target-finger);
  }
  #ui .row.spec .rmore { width: var(--target-finger); height: var(--target-finger); }
}
/* An object row of WAR · STRUCTURES states the holder, the pledges and
   the benefit with no fold (R1892), so its two lines wrap in place of
   a cut, and the row grows to fit them. */
#ui .row.spec.obj { height: auto; min-height: var(--target-finger); padding: var(--s-1) 0; }
#ui .row.spec.obj .ident, #ui .row.spec.obj .sub { white-space: normal; overflow: visible; }
#ui .row.spec.obj .sub { flex-wrap: wrap; }
#ui .row.spec.obj .sub .eff { overflow: visible; text-overflow: clip; }
/* The icon of an object row is the glyph the map draws for the object, in
   its own inks (R1987). The structure marks carry detail inside the core,
   so the icon takes the 24 px step, and the icon column widens to match
   (the column rule below). */
#ui .row.spec.obj .ric .ck-obj { width: var(--s-6); height: var(--s-6); flex: none; }
/* The row has three lines and three columns (R1993): the window stands
   beside the name, the time to it beside the holder, and SHOW beside the
   benefit, so the text column keeps the width of the cost column. */
#ui .row.spec.obj {
  grid-template-columns: calc(var(--s-6) + var(--s-2)) minmax(0, 1fr) minmax(var(--w-press), max-content);
  grid-template-rows: auto auto auto;
}
#ui .row.spec.obj .ric { grid-row: 1 / 4; }
#ui .row.spec.obj .sub.l3 { grid-column: 2; grid-row: 3; }
#ui .row.spec.obj .costcol { display: contents; }
#ui .row.spec.obj .costcol .cost { grid-column: 3; grid-row: 1; justify-self: end; }
#ui .row.spec.obj .costcol .time { grid-column: 3; grid-row: 2; justify-self: end; }
#ui .row.spec.obj .bp { grid-column: 3; grid-row: 3; }
/* The name is the way into the detail panel, so it has to look pressable
   without becoming another button in a row that already has one. The rule
   holds for every row, not for a specification row alone: the module name
   in the invention form opens the same kind of card, and it must read the
   same as the installation, hull, magazine and doctrine names do (R706).
   A captain card is a `.job`, and its name opens the captain card (R1118).
   The name draws no underline on any device (R2875). */
#ui .row button.info, #ui .job button.info {
  background: none;
  border: 0;
  padding: 0;
  color: var(--text);
  text-align: left;
}
@media (hover: hover) {
  #ui .row button.info:hover, #ui .job button.info:hover { color: var(--accent); }
}
#ui .row button.info.done { color: var(--good); }
#ui .row .name { color: var(--text); }
/* The fit strip (R1468, R1477) stays one line and ends in an ellipsis
   when the row is narrow. The strip is colour-coded: the weapon type in amber, the shield
   type in the shield colour, and a module in the colour of its grade, from
   the refusal colour for Flawed up to gold for Perfect. The grade glyph
   stays, so the strip reads without the colour too. All the colours are
   frozen tokens, so a mark reads the same under every banner. The mark
   colours take no `.row`, because the arcade corner draws the strip in
   its own `.srow` (R1504). */
#ui .row .fit { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
#ui .row .fit { color: var(--dim); font-size: var(--t-small-size); }
#ui .fit .fw { color: var(--amber); }
#ui .fit .fs { color: var(--shield); }
#ui .fit .g-flawed, #ui .gmod.g-flawed { color: var(--bad); }
#ui .fit .g-standard, #ui .gmod.g-standard { color: var(--text); }
#ui .fit .g-fine, #ui .gmod.g-fine { color: var(--good); }
#ui .fit .g-superb, #ui .gmod.g-superb { color: var(--violet); }
#ui .fit .g-perfect, #ui .gmod.g-perfect { color: var(--gold); }
#ui .row .sub { color: var(--dim); font-size: var(--t-small-size); display: block; }
/* A warning under a row: the Data Core waste warning (R1458). It takes
   the refusal colour, the colour of a price the player cannot pay. */
#ui .row .sub.bad { color: var(--bad); }
/* An inbox body keeps the line breaks a report carries (R527): one damage
   record per line, never one paragraph. */
#ui .job .sub.mail { white-space: pre-line; }
#ui .row .cost { color: var(--dim); font-size: var(--t-small-size); }
#ui .row .cost.short { color: var(--bad); }
#ui .lvl { color: var(--accent); }
/* Muted text carries information (a rank, a rate, an idle line), so it
   takes Dim and never Faint: Faint is for a state out of play (R2161). */
#ui .muted { color: var(--dim); }
/* The static looks of the dock lists, as classes in place of inline
   styles (R1813, review §2.3): the column of a row that takes the room,
   and one ink a state. An ink outranks the text ink of a name and of an
   info button in a row or a job card. */
#ui .grow { flex: 1; min-width: 0; }
#ui .ink-good, #ui :is(.row, .job) .ink-good, #ui :is(.row, .job) button.info.ink-good { color: var(--good); }
#ui .ink-bad, #ui :is(.row, .job) .ink-bad, #ui :is(.row, .job) button.info.ink-bad { color: var(--bad); }
#ui .ink-accent, #ui :is(.row, .job) .ink-accent { color: var(--accent); }
#ui .ink-amber, #ui :is(.row, .job) .ink-amber { color: var(--amber); }
/* A season journey that is complete is a prize, so it takes the gold. */
#ui .jdone { color: var(--gold); }
/* The two hairlines and the top figure of an income graph. */
#ui .prodgraph .pgtop { fill: var(--dim); font-size: var(--t-small-size); } /* viewBox units; the plot is 320 wide or more (R2161) */
#ui .sovline .sltop { fill: var(--dim); font-size: var(--t-small-size); } /* the WAR series top figure, as .pgtop (R2161) */
#ui .prodgraph .pgbase { stroke: rgb(var(--accent-rgb) / 0.18); }
#ui .prodgraph .pgceil { stroke: rgb(var(--accent-rgb) / 0.08); }
/* A line that is 0 all along (R2162): a thin rule at a third of its ink. */
#ui .prodgraph .pgzero { stroke-opacity: 0.35; }
#ui .empty { color: var(--dim); padding: 6px 0; }
/* STANDINGS: the reader's own row wears the plate and the accent edge of a
   lit row, and the key under the board names the ⚑ of a row. */
#ui .row.stme { background: rgb(var(--accent-rgb) / 0.1); box-shadow: -2px 0 0 var(--accent); }
#ui .stkey { padding: var(--s-2) 0; color: var(--dim); font-size: var(--t-small-size); }
/* A GO TO line (R1895): the state in one short line, and a quiet press at
   the right that opens the pill where the thing is made. The press wears
   the quiet face of the fleet row press. */
#ui .empty.go { display: flex; align-items: center; gap: var(--s-3); }
#ui .empty.go > span { flex: 1; min-width: 0; }
#ui .empty.go .ck-b { flex: none; }
/* The HOW IT WORKS fold at the foot of a game menu (round 091 card 07,
   R1895): one 36 px row, closed by default, with the fact count at the
   right; open, the fact rows of the card kit, the key over a fixed column
   and the value free to wrap. */
#ui .hw { margin-top: var(--s-4); border-top: 1px solid rgb(var(--accent-rgb) / 0.14); }
#ui .hw-row {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  width: 100%;
  min-height: 36px;
  margin: 0;
  padding: 0;
  background: none;
  border: 0;
  color: var(--dim);
  font: var(--t-cap);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;
}
#ui .hw-row b { font-weight: 500; color: var(--text); }
#ui .hw-row .hw-n { margin-left: auto; font-style: normal; font-size: var(--t-small-size); font-weight: var(--t-small-weight); letter-spacing: 0.04em; text-transform: none; }
#ui .hw-facts { padding-bottom: var(--s-3); }
#ui .hw-facts .ck-fact {
  display: grid;
  grid-template-columns: 104px minmax(0, 1fr);
  column-gap: var(--s-3);
  padding: var(--s-2) 0;
  border-top: 1px solid rgb(var(--accent-rgb) / 0.07);
}
#ui .hw-facts .ck-cap { color: var(--dim); font: var(--t-cap); letter-spacing: var(--t-cap-track); text-transform: uppercase; }
#ui .hw-facts .ck-fv { color: var(--text); font: var(--t-small); }
/* Under a finger the row keeps its 36 px and its target grows to the
   finger target by 4 px over and under it. */
@media (pointer: coarse) {
  #ui .hw-row { position: relative; }
  #ui .hw-row::after { content: ""; position: absolute; inset: calc(-1 * var(--s-2)) 0; }
}

/* queue */
#ui .job { padding: 5px 0; border-bottom: 1px solid rgb(var(--accent-rgb) / 0.07); }
#ui .job .head { display: flex; justify-content: space-between; gap: 6px; }
#ui .job .bar { height: 3px; background: rgb(var(--accent-rgb) / 0.12); border-radius: 2px; margin-top: 4px; }
#ui .job .bar span { display: block; height: 100%; background: var(--accent); border-radius: 2px; }
#ui .job.idle .bar span { background: var(--faint); }
#ui .job .acts { display: flex; gap: 4px; margin-top: 4px; }
#ui .job .acts button { padding: 1px 6px; font-size: var(--t-body-size); }
/* bars */
#ui .meter { display: block; margin-top: 3px; height: 4px; background: rgb(var(--text-rgb) / 0.15); border-radius: 2px; overflow: hidden; }
#ui .meter span { display: block; height: 100%; }
#ui .meter .hull { background: var(--good); }
#ui .meter .shield { background: var(--accent); }

/* --- the stacking ladder (ui-map-interface.md §2.3, R1822) ---
   Each surface of the map chrome stands on the rung of its role, on both
   form factors: the furniture (the chart cards), the console (the round
   unit, VIEW and its panel, the legend, the recall row), the dock (the
   readout line and the dock column or sheet), the card (the context slot
   and sheet, the peek, the explainer cards), the lane (the hint and the
   notices), the wheel, the scrim and the modal. A surface over another
   surface is opaque, so text never shows through text. */
#mapbtns, #mapchrome, #heatchip, #rosepress, #rosepeek, #scalebar, #heatramp { z-index: 20; }
#topbar, #dock { z-index: 30; }
#tooltip, #peeklead { z-index: 41; }
#hint, #notices { z-index: 50; }
#unlock { z-index: 51; }

/* --- the context slot (ui-map-interface.md §12.0, R1818) --- */

/* Every card that explains a thing stands in ONE place (round 083 card
   10): the selected object or a probe scan report (`#selection`), the
   commit card and the rename card, and the hosts a later lane adds. On a
   desktop the slot is the bottom-left of the map, one gap over the
   console, `--w-card` wide; `ui/layout.ts` publishes it as `--ctx-l`,
   `--ctx-b` and `--ctx-w`, so no rule states a literal. One card stands
   at a time (`ui/ctxslot.ts`): a host that waits takes `ctx-wait`. The
   card brings its own ground, edge and radius (`ui/cards/cardkit.css`),
   so the host is a bare box; the card scrolls inside `--ctx-maxh`, which
   keeps one pad free under `--top-foot`, the foot of the chrome on the top
   edge. The card may stand over the round unit at the top left of a
   desktop (R2879) rather than scale down: the card rung stands over the
   console rung of the rose press, and the canvas stands under `#ui`
   (R2904). Its
   action row is pinned to its foot, so an action never scrolls away (084
   open point 7). The ground of the pinned row is the sheet ink at full
   cover, because text never shows through text (§2.3). */
#ui .ctxcard {
  position: absolute;
  left: var(--ctx-l);
  bottom: var(--ctx-b);
  width: var(--ctx-w);
  box-sizing: border-box;
  --ctx-maxh: calc(100vh / var(--ui-scale, 1) - var(--ctx-b) - var(--top-foot, 0px) - var(--pad));
  pointer-events: auto;
  z-index: 40;
}
#ui .ctxcard[hidden], #ui .ctxcard.ctx-wait { display: none; }
#selection, #infocard { display: none; }
#selection.on, #infocard.on { display: block; }
/* The row of the open build card stays lit while the card stands in the
   slot (R1826, round 084 card 13): the plate of a lit press, no solid
   light ground (R1753). */
#ui #tabbody .lit {
  background: rgb(var(--accent-rgb) / 0.1);
  box-shadow: inset 2px 0 0 var(--accent);
}
/* The name of the hull that COMPARE holds (R1829, round 084 card 17): a
   small tag after the name until the second hull is pressed. */
#ui #tabbody button.info.cmp::after {
  content: attr(data-tag);
  display: inline-block;
  margin-left: var(--s-2);
  padding: 0 var(--s-1);
  border: 1px solid rgb(var(--accent-rgb) / 0.5);
  border-radius: var(--r-bar);
  color: var(--accent);
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
}
/* The page of the build card on a telephone (R1826, round 087 card 02):
   the back bar with the back chip, the place in the list and the stepper
   ‹ ›, which costs no row of its own; then the card at the full width of
   the sheet, with its action row pinned to the foot of the sheet. */
#ui #tabbody .ibar {
  display: flex;
  align-items: center;
  gap: var(--s-2);
  min-height: var(--target-finger);
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.12);
}
#ui #tabbody .ibar > button {
  min-height: var(--target-finger);
  margin: 0;
  padding: 0 var(--s-2);
  background: transparent;
  border: 0;
  color: var(--accent);
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
}
#ui #tabbody .ib-back {
  flex: 1;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--s-2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#ui #tabbody .ibar > button > i { font-style: normal; font-size: var(--t-title-size); }
#ui #tabbody .ib-pos { flex: none; color: var(--dim); font-size: var(--t-cap-size); letter-spacing: 0.04em; white-space: nowrap; }
#ui #tabbody .ibar > .ib-st { flex: none; width: var(--target-finger); font-size: var(--t-title-size); }
#ui #tabbody .ck-sz-page > .ck-acts { position: sticky; bottom: 0; background: rgb(var(--sheet-rgb)); }
#ui .ctxcard > .ck { max-height: var(--ctx-maxh); overflow-y: auto; overscroll-behavior: contain; }
#ui .ctxcard > .ck > * { flex-shrink: 0; }
#ui .ctxcard > .ck > .ck-acts { position: sticky; bottom: 0; background: rgb(var(--sheet-rgb)); }
/* A confirm asks: its edge is the accent at the dark face's strength. */
#commitcard > .ck { border-color: rgb(var(--accent-rgb) / 0.34); }
/* The box of the rename card (R1250): one line, in the figure step. */
#ui #renamecard input.renin {
  width: 100%;
  box-sizing: border-box;
  min-height: var(--target-finger);
  font-size: var(--t-figure-size);
}

/* The head of a menu sheet (087 card 01). A desktop draws no menu sheet,
   so it stays empty there. The selection chip names the fleet that the
   menu covers; a press closes the menu. */
#selhead { display: none; }
#ui .selchip {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: var(--s-3);
  max-width: 100%;
  height: 32px;
  min-height: 32px;
  margin: 0;
  padding: 0 10px 0 6px;
  border: 1px solid rgb(var(--accent-rgb) / 0.34);
  border-radius: 16px;
  background: rgb(var(--deep-rgb) / 0.7);
  font: var(--t-cap);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
}
#ui .selchip::after { content: ""; position: absolute; inset: -6px 0; }
#ui .selchip > b { font-weight: 500; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
#ui .selchip > i { font-style: normal; color: var(--dim); }
#ui .selchip .ck-mk { display: inline-grid; place-items: center; width: 16px; height: 16px; flex: none; }

/* --- the context sheet of a telephone (§12.0, R1818, round 087 card 01) ---
   The markup is `ui/ctxsheet.ts`; only a telephone draws it. CLOSED is
   the peek: one line of 44 px (the mark, the name in the owner ink, the
   class or the worst condition, the hull, the order and ✕) and one row of
   44 px (the action row with ⋯ at its right edge, R2008). */
#ui .ck.cs { padding: 0 var(--s-2) var(--s-2); }
#ui .ck.cs > :last-child { margin-bottom: 0; }
#ui .ck .cs-line {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  height: var(--target-finger);
  padding-left: var(--s-2);
}
#ui .ck .cs-nw { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: var(--s-1); }
#ui .ck .cs-nw > b {
  font: var(--t-title);
  letter-spacing: var(--t-title-track);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#ui .ck .cs-nw > b.i-cat { color: var(--hero-ink); }
#ui .ck .cs-nw > b.i-neu { color: var(--text); }
#ui .ck .cs-nw > b.i-npc { color: var(--npc); text-shadow: 0 0 1px var(--npc-edge), 0 0 2px var(--npc-edge); }
#ui .ck .cs-k {
  font: var(--t-cap);
  font-style: normal;
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
  color: var(--dim);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#ui .ck .cs-k.cs-cond { color: var(--bad); }
#ui .ck .cs-k em { font-style: normal; color: var(--dim); }
#ui .ck .cs-hull { flex: none; display: flex; flex-direction: column; gap: 3px; width: 56px; }
#ui .ck .cs-hull > span {
  font: var(--t-small);
  line-height: 1;
  text-align: right;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}
#ui .ck .cs-hull > span small { font: var(--t-cap); color: var(--dim); }
#ui .ck .cs-row { display: flex; gap: var(--s-2); margin-top: var(--s-2); }
/* The armed order under the line of the closed sheet (R2164). */
#ui .ck.cs > .ck-arm { margin: 0 var(--s-2); }
#ui .ck .cs-row .ck-b { padding: 0 var(--s-1); }
/* The signature order of an own hull on the closed sheet (R2415): the
   order row of the card body, at the edges of the action row, and its
   press keeps the 44 px finger target with the padding of a row press. */
#ui .ck.cs > .ck-sigr > .ck-b { padding: 0 var(--s-1); }
/* ✕ of the context sheet and ▴ and ▾ of a drill step card are 44 px
   presses already; the glyph is the solid triangle of the square press in
   its 12 px box (`ui/arrowpress.ts` `arrowGlyph`, R1857), and ✕ draws its
   cross in the same box (`crossGlyph`). The sheet itself has no ▴ and no
   ▾ (R2008). */
#ui .ck .ck-b.cs-up, #ui .ck .ck-b.cs-down, #ui .ck .ck-b.cs-x {
  flex: 0 0 var(--target-finger); padding: 0; line-height: 1;
}
#ui .ck .ck-head .cs-down, #ui .ck .ck-head .cs-x { min-height: var(--target-finger); }
/* EDIT and ⋯ stand at the right edge of the row of the closed sheet (R2008). */
#ui .ck .cs-row > .ck-edit, #ui .ck .cs-row > .ck-more { margin-left: auto; }
#ui .ck .cs-row > .ck-edit + .ck-more { margin-left: 0; }

/* The grab handle of the context sheet (R2008). The bar is the `::before`
   of the card (the sheet block below); the handle is a bare button over
   it, 88 px wide and 44 px high, centred on the bar, so a finger takes it
   and a keyboard reaches it. A drag on it, on the line or on the card head
   moves the sheet (`ui/ctxdrag.ts`): `.cs-drag` gives the card the height
   `--cs-h` that the drag writes once a frame, and `.cs-armed` lights the
   bar in the accent while the release will hold the other state.
   `.cs-snap` eases the release with the sheet ease; reduced motion snaps
   with no class. */
#ui .ctxcard > .cs-grab {
  position: absolute;
  z-index: 41;
  top: -14px;
  left: 50%;
  width: 88px;
  height: var(--target-finger);
  min-height: 0;
  margin: 0 0 0 -44px;
  padding: 0;
  border: 0;
  border-radius: var(--r-button);
  background: transparent;
  cursor: grab;
  touch-action: none;
}
#ui .ctxcard > .cs-grab:active { cursor: grabbing; }
/* The line and the head take the drag, so the browser must not read it
   as a scroll; the body of a raised card still scrolls. */
#ui .ctxcard.closed .cs-line, #ui .ctxcard.raised .cs-line,
#ui .ctxcard.raised > .ck > .ck-head { touch-action: none; }
#ui .ctxcard > .cs-grab:focus-visible { outline: 2px solid var(--accent); outline-offset: -12px; }
#ui .ctxcard.cs-drag > .ck::before { background: rgb(var(--text-rgb) / 0.6); }
#ui .ctxcard.cs-armed > .ck::before, #ui .ctxcard > .cs-grab:active + .ck::before { background: var(--accent); }
#ui .ctxcard.cs-drag > .ck {
  height: var(--cs-h);
  max-height: none;
  overflow: hidden;
}
#ui .ctxcard.cs-drag > .ck > * { flex-shrink: 0; }
#ui .ctxcard.cs-drag.closed > .ck { justify-content: flex-end; }
#ui .ctxcard.cs-snap > .ck { transition: height var(--dock-ms) var(--dock-ease); }
/* The fold has no bar: its handle lies under the whole line, so a tap on
   the line raises the card, and only the presses of the line stand over
   it. */
#ui #selhead > .ck.cs-fold { position: relative; }
#ui #selhead > .ck.cs-fold > .cs-grab {
  position: absolute;
  inset: 0;
  min-height: 0;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
}
#ui #selhead > .ck.cs-fold > .cs-line { position: relative; pointer-events: none; }
#ui #selhead > .ck.cs-fold > .cs-line button { pointer-events: auto; }

/* --- the plot line (v2 slot 3, §12.0 "The plot line", R1823, round 088
   card 08) ---
   Under the flag `routes` only. The plot line takes the place of the peek
   line: the route mark, PLOT · n LEGS over the fleet and the length, the
   hint and ✕. The legs are 44 px rows with a grip, the number, the length
   and ✕; a desktop card lists them in 28 px rows. */
#ui .ck .cs-route { color: var(--accent); font: var(--t-title); }
#ui .ck .cs-pl .cs-nw > b { color: var(--accent); letter-spacing: var(--t-cap-track); }
#ui .ck .cs-tap { flex: none; max-width: 92px; font: var(--t-small); line-height: 1.2; color: var(--dim); text-align: right; }
#ui .ck .cs-hint { font: var(--t-small); font-style: normal; color: var(--dim); margin-left: var(--s-3); }
#ui .ck .cs-legs { display: flex; flex-direction: column; padding: 0 var(--s-4); }
#ui .ck .cs-leg {
  display: grid;
  grid-template-columns: 28px 22px minmax(0, 1fr) var(--target-finger);
  align-items: center;
  column-gap: var(--s-3);
  min-height: var(--target-finger);
  border-top: 1px solid rgb(var(--accent-rgb) / 0.09);
}
#ui .ck .cs-leg.d { grid-template-columns: 18px 18px minmax(0, 1fr) var(--target-mouse); min-height: var(--target-mouse); }
#ui .ck .cs-grip { color: var(--dim); text-align: center; cursor: grab; touch-action: none; }
#ui .ck .cs-num {
  display: inline-grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border: 1px solid var(--accent);
  border-radius: 50%;
  font: var(--t-cap);
  color: var(--accent);
}
#ui .ck .cs-ln { display: flex; flex-direction: column; gap: var(--s-1); min-width: 0; }
#ui .ck .cs-ln > b { font-weight: 500; text-transform: uppercase; letter-spacing: var(--t-cap-track); font-size: var(--t-cap-size); }
#ui .ck .cs-ln > i { font: var(--t-small); font-style: normal; color: var(--dim); }
#ui .ck .cs-leg .ck-x { margin: 0 auto; }
#ui .ck .cs-lpk { font: var(--t-cap); letter-spacing: var(--t-cap-track); color: var(--accent); text-align: center; }
/* A leg of a loop part, and the leg back to its opening point, carry a
   bar at the left edge (v2 §7, R2589). The pass count of a closed part
   is a press of one finger target that steps the count. */
#ui .ck .cs-leg.inl { box-shadow: inset 3px 0 0 var(--accent); }
#ui .ck .cs-pass {
  min-width: var(--target-finger);
  min-height: var(--target-finger);
  border: 0;
  background: transparent;
  font: var(--t-cap);
  letter-spacing: var(--t-cap-track);
  color: var(--accent);
  cursor: pointer;
}
#ui .ck .cs-leg.d .cs-pass { min-width: var(--target-mouse); min-height: var(--target-mouse); }

/* --- the fleet rows of FLEET · MISSIONS (R1816) ---------------------- */
/* One row of 44 px and two lines for every hull, at sea or in the pens,
   with one column set (round 085 card 07 as the owner amended it): the
   class mark; line 1 with the CLASS in the cap step and the text ink and
   the name in the owner ink; line 2 with the order, the hull and the load;
   the group digit; the press of a hull in the pens; and ⋯. A thin hull
   bar runs at the foot of the text column, hatched for a hull in the
   pens. The owner ink and the hull fraction are the two data figures of a
   row: `--fl-ink` and `--fl-hull`. */
#ui .fl-row {
  display: flex;
  align-items: center;
  gap: var(--s-2);
  height: var(--target-finger);
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.07);
}
#ui .fl-row.sel { background: rgb(var(--accent-rgb) / 0.1); box-shadow: inset 2px 0 0 var(--accent); }
#ui .fl-main {
  position: relative;
  display: grid;
  grid-template-columns: var(--s-5) minmax(0, 1fr);
  grid-template-rows: auto auto;
  column-gap: var(--s-3);
  row-gap: var(--s-1);
  align-content: center;
  flex: 1;
  min-width: 0;
  height: 100%;
  margin: 0;
  padding: 0 var(--s-2);
  border: 0;
  border-radius: 0;
  background: none;
  color: var(--text);
  font: var(--t-body);
  text-align: left;
}
#ui button.fl-main { cursor: pointer; }
@media (hover: hover) {
  #ui button.fl-main:hover { background: rgb(var(--accent-rgb) / 0.06); color: var(--text); }
}
/* The hull mark of the class (R1844), in the owner ink. */
#ui .fl-mk { grid-column: 1; grid-row: 1 / 3; display: inline-flex; justify-content: center; color: var(--fl-ink, var(--dim)); }
#ui .fl-mk .ck-ship { width: var(--s-5); height: var(--s-6); }
#ui .fl-l1, #ui .fl-l2 { grid-column: 2; display: flex; align-items: baseline; gap: var(--s-3); min-width: 0; white-space: nowrap; overflow: hidden; }
#ui .fl-l1 { grid-row: 1; }
#ui .fl-l2 { grid-row: 2; color: var(--dim); font-size: var(--t-small-size); gap: var(--s-2); }
/* The class word in the cap step and the dim ink, the name in the body
   step and the owner ink, at sea and in the pens: two steps and two inks
   part the two words, with no plate (R1844, the owner's ruling). */
#ui .fl-cls {
  flex: none;
  color: var(--dim);
  font: var(--t-cap);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
}
#ui .fl-cg { flex: none; color: var(--dim); }
#ui .fl-nm { min-width: 0; overflow: hidden; text-overflow: ellipsis; color: var(--fl-ink, var(--text)); }
/* The group digit (R1844, R1845) takes the look of the group badge of the
   map: the owner ink on the dark ground, with an outline of the same ink.
   It is not the accent, because it is no control. */
#ui .fl-grp.on {
  padding: 0 var(--s-2);
  border: 1px solid color-mix(in srgb, var(--fl-ink, var(--text)) 55%, transparent);
  border-radius: var(--r-bar);
  background: rgb(var(--deep-rgb) / 0.88);
}
#ui .fl-l2 .ord { color: var(--text); text-transform: uppercase; letter-spacing: 0.06em; }
#ui .fl-l2 .fl-sep { font-style: normal; color: var(--dim); }
#ui .fl-l2 small { font-size: inherit; color: var(--dim); }
/* HULL and SHIELD of line 2: the label, a short bar and the percent. */
#ui .fl-v { display: inline-flex; align-items: center; gap: var(--s-2); flex: none; }
#ui .fl-vb {
  display: inline-block;
  width: var(--s-6);
  height: var(--s-2);
  border-radius: var(--r-bar);
  background: rgb(var(--text-rgb) / 0.14);
  overflow: hidden;
}
#ui .fl-vb > b { display: block; height: 100%; width: var(--fl-hull, 0%); background: var(--hero-ink); }
#ui .fl-v.shield .fl-vb > b { width: var(--fl-shield, 0%); background: var(--shield); }
#ui .fl-v.low .fl-vb > b { background: var(--bad); }
#ui .fl-v.mid .fl-vb > b { background: var(--amber); }
#ui .fl-v.hull.low { color: var(--bad); }
#ui .fl-v.hull.mid { color: var(--amber); }
#ui .fl-v small { font-size: inherit; color: var(--dim); }
/* The fit strip of a hull in the pens (R1468, R1477). */
#ui .fl-l2 .fit { flex: none; }
/* A hull in the pens is not on the map: its mark and its hull bar take
   the dim ink, its name keeps the owner ink, and the row presses nothing
   but its press. */
#ui .fl-row.dock .fl-mk { color: var(--dim); }
#ui .fl-row.dock .fl-v.hull:not(.low):not(.mid) .fl-vb > b { background: var(--dim); }
#ui .fl-row.note .fl-cls { color: var(--dim); }
/* A row of FLEET · ROUTES (R2709): the presses stand on a line of their
   own under the name, in line with the text column, so the name takes the
   whole width and wraps where it is longer, and is never cut. */
#ui .fl-row.rt { flex-wrap: wrap; height: auto; min-height: var(--target-finger); row-gap: var(--s-1); padding-bottom: var(--s-2); }
#ui .fl-row.rt .fl-main { flex: 1 0 100%; height: auto; min-height: var(--target-finger); }
#ui .fl-row.rt .fl-l1 { white-space: normal; }
#ui .fl-row.rt .fl-nm { overflow: visible; overflow-wrap: anywhere; }
#ui .fl-row.rt .fl-grp, #ui .fl-row.rt .fl-more { display: none; }
#ui .fl-row.rt .fl-press { flex-wrap: wrap; padding-left: calc(var(--s-5) + var(--s-3) + var(--s-2)); }
#ui .fl-grp {
  flex: none;
  min-width: var(--s-5);
  box-sizing: border-box;
  text-align: center;
  color: var(--fl-ink, var(--dim));
  font: var(--t-cap);
}
#ui .fl-grp.on { height: var(--s-5); line-height: calc(var(--s-5) - 2px); }
#ui .fl-press { flex: none; display: flex; gap: var(--s-2); }
/* The wrench beside DEPLOY (R1906): a square press with the icon alone. */
#ui .fl-press .ck-b.fl-quick { padding: 0; width: var(--target-mouse); }
#ui .fl-press .ck-b.fl-quick .bic { width: var(--s-4); height: var(--s-4); }
@media (pointer: coarse) { #ui .fl-press .ck-b.fl-quick { width: var(--target-finger); } }
#ui .fl-more {
  flex: none;
  width: var(--target-mouse);
  height: var(--target-mouse);
  margin: 0;
  padding: 0;
  border: 1px solid rgb(var(--accent-rgb) / 0.2);
  border-radius: var(--r-button);
  background: transparent;
  color: var(--accent);
}
#ui span.fl-more { border: 0; }
#ui .fl-more.on { background: rgb(var(--accent-rgb) / 0.18); border-color: rgb(var(--accent-rgb) / 0.6); }
@media (pointer: coarse) {
  #ui .fl-more { width: var(--target-finger); height: var(--target-finger); }
}
/* The ⋯ of a row opens the grid of its orders under the row, in the two
   faces of the card (087 card 03): the action press dark, every other
   press quiet. */
#ui .fl-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--s-2);
  padding: var(--s-2) 0 var(--s-3);
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.07);
}
#ui .fl-grid .ck-b, #ui .fl-press .ck-b, #ui .empty.go .ck-b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--s-2);
  min-width: 0;
  min-height: var(--target-mouse);
  margin: 0;
  padding: 0 var(--s-3);
  border-radius: var(--r-button);
  color: var(--accent);
  font: var(--t-body);
  white-space: nowrap;
}
#ui .fl-grid .ck-b > span, #ui .fl-press .ck-b > span, #ui .empty.go .ck-b > span { overflow: hidden; text-overflow: ellipsis; }
#ui .fl-grid .ck-b.dk, #ui .fl-press .ck-b.dk {
  background: rgb(var(--deep-rgb) / 0.88);
  border: 1px solid rgb(var(--accent-rgb) / 0.34);
  font-weight: 500;
  letter-spacing: 0.1em;
}
#ui .fl-grid .ck-b.qt { background: transparent; border: 1px solid rgb(var(--accent-rgb) / 0.2); }
#ui .fl-grid .ck-b.on, #ui .fl-press .ck-b.on {
  background: rgb(var(--accent-rgb) / 0.18);
  border-color: rgb(var(--accent-rgb) / 0.6);
  box-shadow: inset 0 -2px 0 var(--accent);
}
#ui .fl-grid .ck-b:disabled { opacity: 1; color: var(--faint); border-color: rgb(var(--text-rgb) / 0.16); }
/* A press that destroys something (BREAK, SCRAP) wears the bad ink, and
   its armed state the armed ground (R696, R1888). */
#ui .fl-grid .ck-b.dg { color: var(--bad); border-color: rgb(var(--bad-rgb) / 0.35); }
#ui .fl-grid .ck-b.dg.armed { background: rgb(var(--bad-rgb) / 0.18); }
/* The cost on REPAIR in ⋯ of a hull in the pens (R1888). */
#ui .fl-grid .ck-b .ck-bc { font-size: var(--t-small-size); color: var(--dim); }
/* UNDER REPAIR in place of DEPLOY (R1888): a dim word that acts on
   nothing. */
#ui .fl-press .ck-b.qt, #ui .empty.go .ck-b.qt { background: transparent; border: 1px solid rgb(var(--accent-rgb) / 0.2); }
#ui .fl-press .ck-b:disabled { opacity: 1; color: var(--dim); border-color: rgb(var(--text-rgb) / 0.16); cursor: default; }
#ui .fl-grid .ck-key {
  min-width: var(--s-4);
  padding: 0 var(--s-1);
  border: 1px solid rgb(var(--accent-rgb) / 0.4);
  border-radius: var(--r-bar);
  font: var(--t-cap);
  text-transform: uppercase;
}
@media (pointer: coarse) {
  #ui .fl-grid .ck-b, #ui .fl-press .ck-b, #ui .empty.go .ck-b { min-height: var(--target-finger); }
  #ui .fl-grid .ck-key { display: none; }
}
/* --- the captain rows of CAPTAIN · WARDROOM and RECRUITMENT (R1889) --- */
/* Round 091 card 05 as the owner amended it: the portrait over three
   lines (the name, the state word with the phase and the age, the place),
   the ability strip of six fixed cells, the press of a cadet and ⋯ (the
   press and ⋯ of the fleet row). Every column but the text has a fixed
   width, so the strip stands in one column under its head down the list.
   The row height, the portrait and the cell are `[presentation.caprow]`. */
#ui .cr-row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto auto auto;
  grid-template-rows: auto auto auto;
  align-items: center;
  min-height: 56px;
  padding: var(--s-1) var(--s-2);
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.07);
}
#ui.sheet .cr-row { min-height: 64px; }
/* The text block gives its three lines to the grid of the row: the name
   and the state stand beside the ability strip, and line 3, the place or
   the job, runs on under the strip, the press and ⋯ up to the right edge,
   so a captain with a queued skill still shows where he is. The gap of
   a column is the margin of its item, so a row with no press and no ⋯
   keeps the strip at the right edge. */
#ui .cr-tx { display: contents; }
#ui .cr-pt { grid-column: 1; grid-row: 1 / 4; }
#ui .cr-l1, #ui .cr-l2 { grid-column: 2; margin-left: var(--s-3); }
#ui .cr-l3 { grid-column: 2 / -1; grid-row: 3; margin-left: var(--s-3); margin-top: var(--s-1); }
#ui .cr-l1 { grid-row: 1; }
#ui .cr-l2 { grid-row: 2; margin-top: var(--s-1); }
#ui .cr-ab { grid-column: 3; grid-row: 1 / 3; margin-left: var(--s-3); }
#ui .cr-press { grid-column: 4; grid-row: 1 / 3; margin-left: var(--s-3); }
#ui .cr-more { grid-column: 5; grid-row: 1 / 3; margin-left: var(--s-3); }
/* A cadet row of RECRUITMENT (owner, 2026-11-02): the full name takes
   all of row 1, and the strip, RECRUIT and ⋯ stand on row 2, level
   with CADET. */
#ui .cr-row.cr-cad .cr-l1 { grid-column: 2 / -1; }
#ui .cr-row.cr-cad .cr-ab, #ui .cr-row.cr-cad .cr-press, #ui .cr-row.cr-cad .cr-more { grid-row: 2; }
#ui .cr-row.sel, #ui .cr-row.lit { background: rgb(var(--accent-rgb) / 0.1); box-shadow: inset 2px 0 0 var(--accent); }
/* The column head names GUN to PRO once, over the strip. */
#ui .cr-row.cr-head { min-height: 0; padding-top: var(--s-2); border-bottom: 0; }
#ui .cr-head .cr-ab, #ui .cr-head .cr-press, #ui .cr-head .cr-more { grid-row: 1; }
#ui .cr-pt { flex: none; width: 28px; }
#ui .cr-pt .face {
  width: 28px;
  height: 28px;
  border: 1px solid var(--edge);
  border-radius: 50%;
  overflow: hidden;
  background: radial-gradient(circle at 40% 35%, rgb(var(--accent-rgb) / 0.35), rgb(var(--panel-rgb) / 0.9));
}
#ui .cr-pt .face img { display: block; width: 100%; height: 100%; }
#ui .cr-l1, #ui .cr-l2, #ui .cr-l3 { min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
/* Line 1: the full name alone, in the hero ink. It opens the captain card. */
#ui .cr-l1 button.info {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
  border: 0;
  background: none;
  color: var(--hero-ink);
  font: var(--t-body);
  font-weight: 500;
  text-align: left;
}
@media (hover: hover) {
  #ui .cr-l1 button.info:hover { color: var(--accent); }
}
#ui .cr-l2, #ui .cr-l3 { font: var(--t-small); color: var(--dim); }
#ui .cr-l2 .ord { color: var(--text); font: var(--t-cap); letter-spacing: var(--t-cap-track); text-transform: uppercase; }
#ui .cr-l3 button.info { padding: 0; border: 0; background: none; color: var(--text); font: inherit; }
/* The ability strip: one cell per attribute. A talent is the hero ink
   and an underline, a shape and not a colour; the attribute in training
   draws its progress as an underline in the accent; a picker lights its
   column in the accent. Gold is never a signal (R1798). */
#ui .cr-ab { flex: none; display: grid; grid-template-columns: repeat(6, 20px); gap: var(--s-1); }
#ui .cr-ab > span {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(var(--s-5) + var(--s-2));
  border-radius: var(--r-bar);
  background: rgb(var(--accent-rgb) / 0.05);
}
#ui .cr-ab > span > b { font: var(--t-body); font-weight: 500; color: var(--text); font-variant-numeric: tabular-nums; }
#ui .cr-ab > span.t { box-shadow: inset 0 -2px 0 var(--hero-ink); }
#ui .cr-ab > span.t > b { color: var(--hero-ink); }
#ui .cr-ab > span.hi > b { color: var(--accent); }
#ui .cr-ab > span > i { position: absolute; left: 0; bottom: 0; height: 2px; background: var(--accent); }
#ui .cr-head .cr-ab > span { height: auto; background: none; }
#ui .cr-head .cr-ab > span > em { font: var(--t-cap); font-style: normal; letter-spacing: 0; color: var(--dim); }
#ui .cr-head .cr-ab > span.hi > em { color: var(--accent); }
/* The strip of codes is one press (R2176): no frame of its own, a dotted
   line under each code as a term button has, and the finger floor as a
   transparent box over and under it. A press, or a keyboard focus, shows
   the names line under the head. */
#ui button.cr-codes {
  position: relative;
  min-height: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
  color: inherit;
  cursor: help;
}
#ui button.cr-codes > span > em { text-decoration: underline dotted; text-underline-position: under; }
#ui button.cr-codes::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: var(--target-finger);
  transform: translateY(-50%);
}
@media (hover: hover) {
  #ui button.cr-codes:hover:not(:disabled) { background: none; }
  #ui button.cr-codes:hover > span > em { color: var(--accent); }
}
#ui .cr-names { display: none; padding: var(--s-1) var(--s-2) 0; font: var(--t-small); color: var(--dim); }
#ui .cr-names.on, #ui .cr-head:has(.cr-codes:focus-visible) + .cr-names { display: flex; flex-wrap: wrap; gap: var(--s-1) var(--s-3); }
#ui .cr-names b { font: var(--t-cap); letter-spacing: 0; color: var(--text); }
#ui .cr-legend { padding: var(--s-1) var(--s-2) var(--s-2); font: var(--t-small); color: var(--dim); }
/* The press column keeps one width in every row and in the head. */
#ui .cr-press { width: calc(var(--s-6) * 4); justify-content: flex-end; }
/* A row of a captain picker is one press that selects the captain
   (R1893): the row as a button, with no frame of its own. */
#ui button.cr-row.pick {
  width: 100%;
  border-width: 0 0 1px;
  border-radius: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
#ui button.cr-row.pick.sel { background: rgb(var(--accent-rgb) / 0.1); }
#ui .cr-nm { color: var(--hero-ink); font: var(--t-body); font-weight: 500; }
/* The progress bar of a running dive in a note row (R1893). */
#ui .fl-v.prog .fl-vb > b { background: var(--accent); }
/* Line 3 of a row of the dive start sheet (R1986): the risk and the yield
   cut with an ellipsis, and the Prospecting practice, PRO and its bar,
   keeps its whole width at the right end of the row at every width. */
#ui .cr-l3 > .xp-l3 { display: flex; align-items: center; gap: var(--s-3); min-width: 0; }
#ui .xp-l3 > .xp-l3t { flex: 0 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; }
#ui .xp-l3 > .fl-v { margin-left: auto; }
/* --- the peek, hint, notices --- */

/* The peek (R1810; round 084 cards 01 and 02): the card builder writes it
   into this host, and `Overlay.showPeek` places the host beside the object
   with `ui/cards/peek.ts`. The peek takes no pointer, so a hover over it
   never ends the hover of the map; the one action of a pinned peek (MARK,
   or REMOVE over an own marker, R1294) takes the pointer back. */
#tooltip {
  position: absolute;
  width: min(var(--w-peek), 100vw / var(--ui-scale, 1) - 24px);
  display: none;
  pointer-events: none;
}
#tooltip.on { display: block; }
#ui #tooltip .ck { pointer-events: none; }
#ui #tooltip .ck-acts button { pointer-events: auto; touch-action: none; }
/* A row of the cell list, the press back to the list and the pager take a
   press (R2708, R2851). */
#ui #tooltip :is(.ck-sor, .ck-solback, .ck-clpg) { pointer-events: auto; touch-action: none; }
/* The ⚑ of a seamount name on the ridge peek takes a press (R2633). */
#ui #tooltip .ck-smrep .rep { pointer-events: auto; touch-action: none; }
/* The dashed leader from the mark to the peek (084 card 02): one line,
   rotated from its left end. */
#peeklead {
  position: absolute;
  display: none;
  height: 0;
  border-top: 1px dashed rgb(var(--text-rgb) / 0.55);
  transform-origin: 0 0;
  pointer-events: none;
}
#peeklead.on { display: block; }

/* The marker menu (R1294, §8): four round targets at N, E, S and W round
   the pressed point, and the audience toggle in the middle. The script
   sets every size from `chart.toml` [chart.piece.map_markers]; the sheet
   sets the inks of round 062: a water black disc with a faint accent rim,
   and the kind's name under its picture. */
#markermenu {
  position: absolute;
  width: 0;
  height: 0;
  pointer-events: none;
  z-index: 60;
}
#markermenu .reach {
  position: absolute;
  transform: translate(-50%, -50%);
  border: 1px dashed rgb(var(--accent-rgb) / 0.2);
  border-radius: 50%;
  pointer-events: none;
}
#ui #markermenu button {
  position: absolute;
  padding: 0;
  border: none;
  border-radius: 50%;
  pointer-events: auto;
  touch-action: none;
  background: rgb(var(--ink-rgb) / 0.92);
}
#ui #markermenu button.kind { box-shadow: inset 0 0 0 1px rgb(var(--accent-rgb) / 0.35); }
@media (hover: hover) {
  #ui #markermenu button.kind:hover { box-shadow: inset 0 0 0 1.6px rgb(var(--accent-rgb) / 0.9); }
}
#ui #markermenu button.kind:focus-visible { box-shadow: inset 0 0 0 1.6px rgb(var(--accent-rgb) / 0.9); }
#markermenu .kind canvas { position: absolute; left: 0; top: 0; pointer-events: none; }
#markermenu .kind .name {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 3px;
  font-size: var(--t-cap-size);
  font-weight: 500;
  text-align: center;
  color: var(--text);
  opacity: 0.85;
  pointer-events: none;
}
#ui #markermenu button.aud {
  font-size: var(--t-cap-size);
  font-weight: 500;
  letter-spacing: 0.06em;
  color: var(--accent);
  box-shadow: inset 0 0 0 1px rgb(var(--accent-rgb) / 0.9);
}
#ui #markermenu button.aud[data-aud="faction"] { color: var(--text); }

/* --- the quick wheel (ui/quickwheel.ts, ui-map-interface.md §8 "Quick
   chat", R1607; mockup round 077, card 01) ---
   Twelve sectors round a hub that is the channel switch: SQUAD on top,
   FACTION under it. The script draws the SVG and sets every size from
   `presentation.toml` [presentation.quick_wheel]; the sheet sets the inks
   of the card. The wheel takes no pointer: the comma and the finger on the
   VIEW button drive it through window listeners, so a slide never lands on
   a control under it. */
#quickwheel {
  position: absolute;
  z-index: 60;
  pointer-events: none;
}
#quickwheel svg { display: block; overflow: visible; }
#quickwheel .sec { fill: rgb(var(--panel-rgb) / 0.9); stroke: rgb(var(--accent-rgb) / 0.32); stroke-width: 1; }
#quickwheel .sec.on { fill: rgb(var(--accent-rgb) / 0.3); stroke: var(--accent); stroke-width: 1.6; }
#quickwheel .sec.off { stroke: rgb(var(--accent-rgb) / 0.14); }
#quickwheel .sec.off.on { fill: rgb(var(--panel-rgb) / 0.9); stroke: rgb(var(--accent-rgb) / 0.4); stroke-width: 1; }
#quickwheel text { font-family: inherit; }
#quickwheel text.w { fill: var(--text); letter-spacing: 0.04em; }
#quickwheel text.w.on { fill: var(--hero-ink); }
#quickwheel text.key { fill: var(--faint); }
#quickwheel text.w.off, #quickwheel text.key.off { fill: var(--faint); opacity: 0.55; }
#quickwheel .hubbg { fill: rgb(var(--panel-rgb) / 0.97); }
#quickwheel .half { fill: rgb(var(--panel-rgb) / 0.92); stroke: rgb(var(--accent-rgb) / 0.32); stroke-width: 1; }
#quickwheel .half.on { fill: rgb(var(--accent-rgb) / 0.2); stroke: var(--accent); stroke-width: 1.2; }
#quickwheel text.hw { fill: var(--dim); letter-spacing: 0.12em; }
#quickwheel text.hw.on { fill: var(--accent); }
#quickwheel text.hw.off { opacity: 0.45; }
#quickwheel text.ln { fill: var(--hero-ink); }

/* --- the top bar's explainer card (R233) ---
   Its own panel, and not `#tooltip`: that one belongs to the canvas hit
   test and takes no pointer at all, so it can be neither hovered nor tapped
   away. This card takes the pointer, because a finger has to be able to
   read it and then put it away. Like the other explainer cards it is
   `display: none` until it is asked for, so it takes no part in the chrome
   dock-in and carries no `--out`. */
#bartip {
  position: absolute;
  max-width: 260px;
  padding: 7px 10px 8px;
  display: none;
  font-size: var(--t-small-size);
  line-height: 1.45;
  z-index: 42;
}
#bartip.on { display: block; }
#bartip .title { color: var(--hero-ink); letter-spacing: 0.08em; text-transform: uppercase; }
#bartip .line { color: var(--dim); margin-top: 3px; }
#bartip .line.full { color: var(--readout-white); letter-spacing: 0.08em; }
/* A free card (R1555) opens on its first line, in the body ink: the title
   a finger held on, or the definition under a word. */
#bartip .line.lead { color: var(--text); }
#bartip > .line.lead:first-child { margin-top: 0; }

/* The hint host (R2164): the armed order as a card strip at the context
   slot, while no card there names the armed hull (a deploy from the pens,
   a pick armed from the fleet list). It holds the arm line of the card kit,
   the words in the text ink and CANCEL, so it reads as the armed line of a
   card. While another card stands in the slot, the overlay lifts it over
   that card (`--hint-lift`). At rest it is empty and stands nowhere. On a
   telephone the slot is the place of the closed context sheet, over the
   sheet's bar. */
#hint:empty { display: none; }
#hint {
  position: absolute;
  left: var(--ctx-l);
  bottom: calc(var(--ctx-b) + var(--hint-lift, 0px));
  width: var(--ctx-w);
  box-sizing: border-box;
}
#ui #hint .ck > .ck-arm { margin: 0; padding: var(--s-2) var(--s-2) var(--s-2) var(--s-4); border-top: 0; }

/* --- the six group slots (R1817) --------------------------------------- */
/* One slot shows what its control group holds (round 085 card 10): the
   digit, the class mark, the name, the state glyph and a hull bar. The
   state reads by shape: the order glyph while all is well, a triangle in
   the bad ink for a weak hull, an anchor and a hatched bar in the pens
   (the slot stays, R839), a dashed edge for an empty slot, and a lit plate
   with an accent bar for the selected fleet. `--gs-ink` is the owner ink
   of the hull mark, which the overlay writes on the host, and `--gs-hull`
   the hull of one slot. The hull bar takes the health colours of the fleet
   list and never the owner ink (R2213).
   A slot stops the callout and the selection of a long press. */
#ui .gs {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--s-1);
  min-width: 0;
  margin: 0;
  padding: var(--s-1) var(--s-2) var(--s-2);
  border: 1px solid rgb(var(--accent-rgb) / 0.28);
  border-radius: var(--r-button);
  background: var(--g-card);
  color: var(--text);
  font: var(--t-cap);
  text-align: left;
  touch-action: manipulation;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
/* A host shows the held slots and one empty slot (R1865): a slot outside
   that set is hidden and takes no room, so the row shares its width among
   the shown slots and the bar shrinks to them. */
#ui .gs[hidden] { display: none; }
#ui .gs .gs-l1 { display: flex; align-items: center; gap: var(--s-2); min-width: 0; }
#ui .gs .gs-dg { flex: none; color: var(--hero-ink); font-weight: 700; }
#ui .gs .gs-mk { display: inline-flex; flex: none; color: var(--gs-ink, var(--hero-ink)); }
/* The hull mark of the class (R1859): the fleet row's mark at half its
   size, as tall as the role mark it replaced. */
#ui .gs .gs-mk .ck-ship { width: var(--s-3); height: var(--s-4); }
#ui .gs .gs-sg { display: block; flex: none; width: var(--s-4); height: var(--s-4); color: var(--dim); }
#ui .gs .gs-l1 .gs-sg { margin-left: auto; }
#ui .gs .gs-sn { min-width: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; letter-spacing: var(--t-cap-track); }
#ui .gs .gs-bar { display: block; height: 3px; border-radius: var(--r-bar); background: rgb(var(--text-rgb) / 0.14); overflow: hidden; }
#ui .gs .gs-bar > b { display: block; width: var(--gs-hull, 0%); height: 100%; background: var(--hero-ink); }
#ui .gs .gs-bar.mid > b { background: var(--amber); }
#ui .gs .gs-bar.low > b { background: var(--bad); }
#ui .gs .gs-bar.hatch > b { background: repeating-linear-gradient(135deg, rgb(var(--text-rgb) / 0.45) 0 2px, rgb(var(--text-rgb) / 0.1) 2px 5px); }
#ui .gs.empty { border-style: dashed; border-color: rgb(var(--text-rgb) / 0.28); background: rgb(var(--deep-rgb) / 0.55); }
#ui .gs.empty .gs-dg, #ui .gs.empty .gs-sn { color: var(--dim); }
#ui .gs.empty .gs-bar > b { width: 0; }
#ui .gs.dock { background: rgb(var(--sheet-rgb) / 0.9); }
#ui .gs.dock .gs-dg, #ui .gs.dock .gs-sn, #ui .gs.dock .gs-mk { color: var(--dim); }
#ui .gs.weak .gs-sg { color: var(--bad); }
#ui .gs.sel {
  background: linear-gradient(rgb(var(--accent-rgb) / 0.2), rgb(var(--accent-rgb) / 0.2)), var(--g-card);
  border-color: var(--accent);
  box-shadow: inset 0 -2px 0 var(--accent);
}
#ui .gs.sel .gs-sn { color: var(--accent); }
/* The slot under a dragged card head (085 card 13, the desktop frame). */
#ui .gs.drop { border-color: var(--hero-ink); box-shadow: 0 0 0 3px rgb(var(--hero-ink-rgb) / 0.25); }
@media (hover: hover) {
  #ui .gs:hover { border-color: rgb(var(--accent-rgb) / 0.6); color: var(--text); }
}

/* The group row of a telephone (round 085 card 12 A): one row of
   44 px in the closed dock, directly over the tab bar, where the
   thumb rests. It stands only while a slot holds a fleet (085 open point
   4), so a player with no group keeps the dock at its height. The shown
   slots share the width of the row (R1865). It is part
   of the dock's bar: `sheetBarH` counts it, so the console, VIEW and the
   context sheet stand over it. The flex order is the queue strip's, and
   the DOM order puts it between the strip and the tab bar. */
#grouprow { display: none; order: 3; flex-shrink: 0; gap: var(--s-2); padding: var(--s-2) var(--s-3) 0; }
#ui.sheet #grouprow.on { display: flex; }
:is(#grouprow, #arc-grouprow) .gs { flex: 1 1 0; height: 44px; }

/* The group bar of a desktop (round 085 card 14): the shown slots under
   the readout line, centred on the map left of the dock, as the line is,
   for the mouse player too. The bar states no width: it shrinks to the
   slots it shows and stays centred (R1865). The arcade's group bar
   `#arc-groupbar` and group row `#arc-grouprow` take the slot rules of
   both hosts; `arcade/selection.css` places them (arcade.md §7.2). A slot shows the digit as a key cap, the class mark, the
   first word of the name (the whole name on a wide screen, `.wide`), the
   state glyph and the hull bar; an empty slot names its assign chord. The
   notices stand under the bar: `--gbar-h` is the room
   the bar takes, and it is 0 in the sheet form factor. */
#ui:not(.sheet) { --gbar-h: calc(32px + var(--s-3)); }
#groupbar {
  position: absolute;
  top: calc(var(--topbar-h) + var(--s-3));
  left: calc((100% - var(--dock-w)) / 2);
  --rest: translateX(-50%);
  display: flex;
  gap: var(--s-2);
  pointer-events: auto;
  z-index: 31;
}
/* Where even the narrow bar is wider than its room, the bar starts at the
   left edge of its room, as the readout line's `readout-tight` form does
   (R1868); its right end then stands under the dock column (R1865). */
#groupbar.tight { left: var(--pad); --rest: translateX(0); }
/* The bar stands always: with no group it shows the empty slot 1 alone
   (the owner, 2026-10-13: "always one empty slot", R2057). */
#ui.sheet #groupbar { display: none; }
:is(#groupbar, #arc-groupbar) .gs {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto;
  align-items: center;
  column-gap: var(--s-2);
  row-gap: var(--s-1);
  width: 112px;
  height: 32px;
  padding: var(--s-1) var(--s-3) var(--s-1) var(--s-2);
}
:is(#groupbar, #arc-groupbar).wide .gs { width: 168px; }
:is(#groupbar, #arc-groupbar) .gs .gs-bar { grid-column: 2 / -1; }
:is(#groupbar, #arc-groupbar) .gs .gs-sn { font: var(--t-small); letter-spacing: 0; }
:is(#groupbar, #arc-groupbar) .gs .gs-st { display: inline-flex; }
:is(#groupbar, #arc-groupbar) .gs-key {
  display: inline-grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  border: 1px solid rgb(var(--accent-rgb) / 0.4);
  border-bottom-width: 2px;
  border-radius: var(--r-bar);
  color: var(--accent);
  font: var(--t-cap);
}

/* The toast of an assign (085 card 13): one line that names the fleet,
   and UNDO while a replace can be turned back. It stands at the left
   under the readout line and the group bar, and under the round unit of a
   desktop (`--unit-t`, R2879). */
/* The mirrored desktop stands the round unit at the top right (R2883), so
   the toast and the marks key at the left keep their own tops. */
#ui.mirror #grptoast { top: var(--lane-t); }
#ui.mirror #squadkey { top: calc(64px + var(--safe-t)); }
#grptoast {
  position: absolute;
  left: var(--pad);
  top: max(var(--lane-t), var(--unit-t, 0px));
  display: none;
  align-items: center;
  gap: var(--s-3);
  max-width: calc(100vw / var(--ui-scale, 1) - 2 * var(--pad));
  padding: var(--s-2) var(--s-2) var(--s-2) var(--s-4);
  border: 1px solid var(--edge);
  border-radius: var(--r-card);
  background: var(--g-card);
  font: var(--t-small);
  pointer-events: auto;
  z-index: 52;
}
#grptoast.on { display: flex; }
#grptoast .undo { flex: none; min-height: var(--target-mouse); padding: 0 var(--s-3); color: var(--accent); letter-spacing: 0.1em; }
@media (pointer: coarse) {
  #grptoast .undo { min-height: var(--target-finger); }
}

/* The ring that fills round the finger for the length of a long press on
   a slot (085 card 13). `--hold` is the long press of the map. */
#ui .gs-ring { position: absolute; width: 68px; height: 68px; margin: -34px 0 0 -34px; pointer-events: none; z-index: 60; }
#ui .gs-ring svg { display: block; width: 100%; height: 100%; }
#ui .gs-ring circle { fill: none; stroke-width: 4; }
#ui .gs-ring .t { stroke: rgb(var(--hero-ink-rgb) / 0.2); }
#ui .gs-ring .f {
  stroke: var(--hero-ink);
  stroke-linecap: round;
  stroke-dasharray: 188.5;
  stroke-dashoffset: 188.5;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  animation: gs-fill var(--hold) linear forwards;
}
@keyframes gs-fill { to { stroke-dashoffset: 0; } }
@media (prefers-reduced-motion: reduce) {
  #ui .gs-ring .f { animation: none; stroke-dashoffset: 0; }
}
/* The ghost of a dragged card head. */
#ui .gs-ghost {
  position: absolute;
  transform: translate(var(--s-4), var(--s-4));
  padding: var(--s-2) var(--s-3);
  border: 1px solid var(--accent);
  border-radius: var(--r-button);
  background: var(--g-card);
  color: var(--hero-ink);
  font: var(--t-small);
  white-space: nowrap;
  pointer-events: none;
  z-index: 61;
}

/* The drain line (R430, mockup round twenty-four, card 02 "Drain Line").

   A countdown is a quantity as well as a number, so the bar's bottom edge
   is the gauge: a 2 px line whose ink retreats from the right end as the schedule
   runs out, and a small tab under its right end that names the clock. The
   founding truce (plan §5.2) and the seaquake (R218) share it in the order
   they always did — link down > seaquake > truce — and `#link` (R108) is
   the same line in the fault tone.

   Both elements are children of `#topbar` now. They travel home with the
   bar, they leave the map's centre line to the map, and they take no
   pointer. `--frac` is how much of the schedule is still to run, written by
   overlay.ts; 1 is a full line.

   The 18 px inset is the bar's own horizontal padding, so the line runs
   under the bar's content and clears the 10 px corner radii. */
#truce, #link {
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: -1px;
  height: 2px;
  display: none;
  border-radius: 1px;
  background-color: rgb(var(--hero-ink-rgb) / 0.16);
  pointer-events: none;
}
#truce.on, #link.on { display: block; }
#truce .fill, #link .fill {
  display: block;
  height: 100%;
  background: var(--hero-ink);
  box-shadow: 0 0 6px rgb(var(--hero-ink-rgb) / 0.7);
  transform-origin: left;
  transform: scaleX(var(--frac, 1));
}
/* The tab hangs under the line's right end. The shadow is what keeps 10 px
   of type readable over a map that can be any colour under it. The bar is
   33 px tall and the dock's glass starts at 46 px, so the tab has 12 px of
   air: 1 px of margin and a line-height of 1 keep its foot off the dock. */
#truce .tab, #link .tab {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 1px;
  line-height: 1;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--hero-ink);
  white-space: nowrap;
  text-shadow: 0 1px 3px rgb(var(--deep-rgb));
}
#truce .tab .mark, #link .tab .mark { font-weight: 600; }
/* A schedule is a light line that drains, and a fault is a moving red
   hatch over the whole line (round 080 group C, R1749): no gold as a
   signal, and the two read by shape. The truce and a stage-1 seaquake are
   schedules; a war economy, a settlement and a dropped socket are not, so
   `#truce.bad` and every `#link` take the hatch (the rule above draws
   it). */
#truce.bad, #link { height: 3px; background-color: transparent; }
/* The fill is the clip box of the moving hatch (the rule near the top). */
#truce.bad .fill, #link .fill { transform: none; background: none; box-shadow: none; border-radius: inherit; }
#truce.bad .tab, #link .tab { color: var(--bad); }
/* Under the AUTO look the timer stands in the time cell of the readout
   line, so the tab under the line is not drawn (R1749). A look that draws
   the timer itself (R824) keeps its tab. */
#ui.theme-notices-drain #topbar.readout :is(#truce, #link) .tab { display: none; }

/* The keyboard reference (plan §5.1): ⌨ KEYS or '?' opens it, esc or ✕
   closes. The panel is an ordinary pointer-driven overlay — the keyboard
   it documents is desktop sugar, never the only way to anything. */
#keys {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
  width: min(var(--w-modal), calc(100vw / var(--ui-scale, 1) - 24px));
  /* The sheet scrolls inside its own box: the small viewport height keeps
     its foot over the toolbar of a telephone browser (R2050). */
  max-height: calc(78vh / var(--ui-scale, 1));
  max-height: calc(78dvh / var(--ui-scale, 1));
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 12px 16px 10px;
  z-index: 80;
}
/* A reference sheet is opaque (R2050, ui-map-interface.md §2.3 "The
   stacking rule"): the sheet ink at full cover and no blur, so no chat
   line and no legend reads through it. The scroll cue: while more rows
   wait under the foot, an accent hairline and a tint stand at the foot of
   the box (the `scroll` layer); at the end of the list the cover of the
   `local` layer hides both. Two ids, because `#ui .panel` sets the glass. */
#ui #keys {
  background:
    linear-gradient(rgb(var(--sheet-rgb)), rgb(var(--sheet-rgb))) center bottom / 100% 28px no-repeat local,
    linear-gradient(0deg, rgb(var(--accent-rgb) / 0.5) 0 1px, rgb(var(--accent-rgb) / 0.12) 1px, rgb(var(--accent-rgb) / 0)) center bottom / 100% 28px no-repeat scroll,
    rgb(var(--sheet-rgb));
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
#keys.on { display: block; }
/* The head stays in view while the rows scroll, so ✕ is always in reach.
   It spans the padding of the box and wears the same opaque ground. */
#keys .title {
  position: sticky;
  top: 0;
  z-index: 1;
  margin: -12px -16px 0;
  padding: 12px 16px 2px;
  background: rgb(var(--sheet-rgb));
  color: var(--accent);
  letter-spacing: 0.08em;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#keys .group { color: var(--dim); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); margin: 10px 0 3px; }
/* A row is the key in a fixed column and its sentence left-aligned next
   to it (R2184): `#ui .row` spreads its two cells to the edges, and the
   reference does not. */
#keys .row { display: flex; justify-content: flex-start; gap: 10px; padding: 1px 0; }
#keys .key { flex: 0 0 92px; color: var(--text); }
#keys .does { flex: 1; min-width: 0; color: var(--dim); text-align: left; }
/* The heat maps fold under their head (R2184): a native fold whose head
   is the group head with its key count and a caret. */
#keys .kfold > summary { display: flex; align-items: center; gap: var(--s-2); min-height: var(--target-mouse); cursor: pointer; list-style: none; }
#keys .kfold > summary::-webkit-details-marker { display: none; }
#keys .kfold > summary::before { content: "▸"; color: var(--dim); }
#keys .kfold[open] > summary::before { content: "▾"; }
#keys .kfold > summary i { font-style: normal; text-transform: none; letter-spacing: 0; }
#keys .foot { margin-top: 10px; color: var(--dim); font-size: var(--t-small-size); }

/* The two live regions of the game page (R2052, ui-map-interface.md §15):
   a screen reader reads them, and the page never paints them. The host
   stands outside #ui, so the chrome veil never hides it. */
#live {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
/* The toasts stand beside the dock (R430), not on the bar's centre line:
   the centre is the map a player came to watch, and the band left of the
   dock is free. They slide in from the right and stack down.

   **One lane** (round 083 card 16, R1819): `right` is the measured width
   of the dock column plus one edge margin of air (`--lane-r`, R1765), the
   top of the lane (`--lane-t`); the hint line that stood over them moved
   to the context slot (R2164). A line is at most a card wide (`--w-card`). */
#notices {
  position: absolute;
  right: var(--lane-r);
  top: var(--lane-t);
  --rest: translateX(0);
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  pointer-events: none;
}
/* The mirrored desktop (the MIRRORED LAYOUT setting, R2883): the lane of
   the notices stands at the top left and its lines pack to the left. The
   rule stands before the notices looks, so a look that places the lane
   itself keeps its own place. */
#ui.mirror #notices {
  left: var(--pad);
  right: auto;
  align-items: flex-start;
  --out: translateX(calc(-100% - var(--pad) - 16px));
}
/* The length of the fade is NOT stated here: the event table says how long
   a line stays, and `ui/notices.ts` writes that one number to `--life`
   beside the removal timer, so the fade and the removal cannot drift apart.
   Naming a duration here would give the fade a second, silent opinion.

   The length is a PROPERTY and not an inline `animation-duration`, because
   a notices look names an animation of its own (R824) and an inline
   duration would stand over every one of them. */
#notices .notice {
  padding: 4px 10px 4px 9px;
  font-size: var(--t-small-size);
  max-width: var(--w-card);
  border-left: 2px solid var(--accent);
  border-radius: 0 6px 6px 0;
  animation: toast var(--life) forwards;
}
#notices .notice.error {
  color: var(--bad);
  border-color: rgb(var(--bad-rgb) / 0.35);
  border-left-color: var(--bad);
}
/* The alarm screen (R1753, card 16 of round 082): the AUTO look keeps two
   lines, and the older one stands faded, so the newest reads first. The
   fade is a filter and not an opacity, because the life of a line runs
   its opacity as an animation. */
#ui.theme-notices-drain #notices .notice:not(:last-child) { filter: opacity(0.35); }
/* The notice of the lane (round 083 card 16, R1819): a plate of the card
   ground with the edge, and a mark at its head whose SHAPE is the tone, so
   the line reads in greyscale: a ring with a tick for news, a diamond for
   a refusal. The ground is the card's, because text never shows through
   text (§2.3). */
#ui.theme-notices-drain #notices .notice {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  min-height: 32px;
  box-sizing: border-box;
  padding: var(--s-2) var(--s-4) var(--s-2) var(--s-3);
  background: var(--g-card);
  border: 1px solid var(--edge);
  border-radius: var(--r-button);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  color: var(--text);
}
#ui.theme-notices-drain #notices .notice::before {
  content: "";
  flex: none;
  width: 10px;
  height: 5px;
  margin: 0 4px 3px;
  border: solid var(--good);
  border-width: 0 0 2px 2px;
  transform: rotate(-45deg);
  box-shadow: 0 0 0 4px var(--g-card), 0 0 0 5px rgb(var(--good-rgb) / 0.6);
  border-radius: 1px;
}
#ui.theme-notices-drain #notices .notice.error { border-color: rgb(var(--bad-rgb) / 0.5); color: var(--text); }
#ui.theme-notices-drain #notices .notice.error::before {
  width: 9px;
  height: 9px;
  margin: 0 4px;
  border: 1.5px solid var(--bad);
  border-radius: var(--r-bar);
  transform: rotate(45deg);
  box-shadow: inset 0 0 0 2px var(--g-card), inset 0 0 0 9px rgb(var(--bad-rgb) / 0.5);
}
/* A line with a place (R2370, §15 "The toast"): the line takes the pointer
   that the column does not, and a press takes the map to the cell of its
   event. The tell `.go-tell` stands at the end of the line under every
   look, in the tone of the line; the two grid looks give it a column. A
   line with no place keeps `pointer-events: none` from the column. */
#notices .notice.go { pointer-events: auto; cursor: pointer; }
#notices .notice .go-tell {
  flex: none;
  margin-left: var(--s-2);
  color: var(--accent);
  font-weight: 600;
  letter-spacing: 0.06em;
  white-space: nowrap;
}
#notices .notice.error .go-tell { color: var(--bad); }
/* The alert weights (round 088 card 17, R1753, R2637,
   `[presentation.alerts]`). Weight 1 is a plain line: the press still
   takes the map to the place, and the GO TO word stays away. Weight 2 is
   a GO TO in the dark face of the card kit: a ground darker than the
   line, a faint accent edge and the wide tracking. Weight 3 is the solid
   light press of the siege row alone, so no notice takes it. */
#notices .notice.w1 .go-tell { display: none; }
#notices .notice.w2 .go-tell {
  padding: 1px var(--s-2);
  background: rgb(var(--deep-rgb) / 0.88);
  border: 1px solid rgb(var(--accent-rgb) / 0.34);
  border-radius: var(--r-card);
  letter-spacing: 0.14em;
}
#notices .notice.w2.error .go-tell { border-color: rgb(var(--bad-rgb) / 0.5); }
#ui.theme-notices-ledger #notices .notice.go { grid-template-columns: 52px 2px 1fr auto; }
#ui.theme-notices-under-clock #notices .notice.go { grid-template-columns: 16px 1fr auto; }

/* --- the unlock card, the stamp (achievements.md §4, R936, R962) --------
   One card per reached grade. It LANDS in the top third of the map at
   `--unlock-scale` with a ring flash, settles, holds, then TRAVELS into
   the notices column and contracts into one line there, so the ceremony
   and the receipt end on one edge. It is mockup round forty-four card 10.

   Four rules bind it.

   **A tap minimizes the card** (R1442). `ui/unlock.ts` starts the travel
   on a tap and stops the tap at the card. A card that travels takes no
   pointer, so a second tap reaches the map.

   **Every length is a PROPERTY.** `ui/unlock.ts` writes `--unlock-ms`,
   `--unlock-land-ms` and `--unlock-travel-ms`, and this names the
   animations; the rule `#notices` already keeps with `--life`. No rule
   below states a duration.

   **The travel's end is measured, never stated here.** The notices column
   moves with the form factor, with a notices look and with the dock.
   `ui/unlock.ts` measures it ONE time at the start of the travel and
   writes `--unlock-dx` and `--unlock-dy`; the keyframe reads them.

   **Reduced motion keeps the landed card and drops the travel.** `.still`
   is the class `ui/unlock.ts` writes, and the media query below is the
   backstop for a viewer whose switch turned after the card was built. Both
   swap the animation NAME and leave every length where it is. */
#unlock {
  position: absolute;
  /* Centred across the MAP and not across the viewport: the dock owns the
     right of the screen, and a stamp under it is a stamp nobody reads.
     `--dock-w` is the dock's measured width from the right edge (R556).
     The card's centre stands at one quarter of the height, so the whole
     card stays in the top third and clear of the fight in the middle
     (R1442). */
  left: calc(50% - var(--dock-w, 0px) / 2);
  top: 25%;
  display: flex;
  align-items: center;
  /* Every length of the card is a phone length times `--unlock-size`,
     which `ui/unlock.ts` writes from `unlock_desktop_size` on the desktop
     and holds at 1 in the sheet (R963). The badge bakes at the same
     factor, so a desktop card is not a scaled-up phone card. */
  --unlock-size: 1;
  gap: calc(11px * var(--unlock-size));
  width: max-content;
  max-width: min(calc(400px * var(--unlock-size)), calc(70vw / var(--ui-scale, 1)));
  padding: calc(8px * var(--unlock-size)) calc(14px * var(--unlock-size)) calc(8px * var(--unlock-size)) calc(9px * var(--unlock-size));
  border-left: calc(2px * var(--unlock-size)) solid var(--accent);
  border-radius: 0 calc(8px * var(--unlock-size)) calc(8px * var(--unlock-size)) 0;
  cursor: pointer;
  transform: translate(-50%, -50%);
  animation: unlock-land var(--unlock-land-ms) cubic-bezier(0.16, 0.9, 0.3, 1) forwards;
}
/* The ring flash of the landing: ONE pseudo-element, no canvas and no
   second node. It is out of the flex flow, so it takes no lane of the
   card, and it dies with the landing it belongs to. */
#unlock::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: calc(180px * var(--unlock-size));
  height: calc(180px * var(--unlock-size));
  border: calc(2px * var(--unlock-size)) solid var(--accent);
  border-radius: 50%;
  pointer-events: none;
  opacity: 0;
  animation: unlock-flash var(--unlock-land-ms) ease-out forwards;
}
#unlock canvas { flex: 0 0 auto; display: block; }
#unlock .body { min-width: 0; }
#unlock .eyebrow {
  color: var(--dim);
  font-size: calc(var(--t-cap-size) * var(--unlock-size));
  letter-spacing: 0.1em;
}
#unlock .name {
  color: var(--text);
  font-size: calc(var(--t-title-size) * var(--unlock-size));
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-top: calc(1px * var(--unlock-size));
}
/* The description, the figures and the bar (R1232). The description is
   one short sentence and may wrap; the figures are numbers and use tabular
   digits so two cards line their figures up. */
#unlock .desc { color: var(--dim); font-size: calc(var(--t-small-size) * var(--unlock-size)); line-height: 1.3; margin-top: calc(2px * var(--unlock-size)); }
#unlock .grade { color: var(--accent); font-size: calc(var(--t-small-size) * var(--unlock-size)); margin-top: calc(4px * var(--unlock-size)); }
#unlock .figures { color: var(--text); font-size: calc(var(--t-small-size) * var(--unlock-size)); font-variant-numeric: tabular-nums; margin-top: calc(2px * var(--unlock-size)); }
#unlock .bar {
  position: relative;
  height: calc(3px * var(--unlock-size));
  margin-top: calc(4px * var(--unlock-size));
  background: var(--edge);
  border-radius: calc(2px * var(--unlock-size));
  overflow: hidden;
}
#unlock .bar::before {
  content: '';
  position: absolute;
  inset: 0 auto 0 0;
  width: calc(var(--fill, 0) * 100%);
  background: var(--accent);
}
#unlock .next { color: var(--dim); font-size: calc(var(--t-small-size) * var(--unlock-size)); font-variant-numeric: tabular-nums; margin-top: calc(3px * var(--unlock-size)); }

/* The sheet form factor: the stamp lands at one quarter of the map, which
   is the screen above the sheet, so it stands in the top third and clear
   of the thumb and of the sheet's mission row (R1442). The map takes the whole
   width there, so the dock's width is not taken off, and the card keeps
   the phone size: `--unlock-size` stays 1. */
#unlock.sheet {
  left: 50%;
  top: calc((100% - var(--dock-h, 0px)) / 4);
  max-width: min(330px, calc(100vw / var(--ui-scale, 1) - 32px));
}
#unlock.sheet::after { width: 150px; height: 150px; }

/* The travel: the card contracts and goes to the corner `ui/unlock.ts`
   measured. It lands as far below 1x as it arrived above it, so one value
   states both ends of the ceremony. */
#unlock.travel {
  animation: unlock-travel var(--unlock-travel-ms) cubic-bezier(0.5, 0, 0.7, 1) forwards;
}
#unlock.travel::after { animation: none; opacity: 0; }
/* `#ui .panel` gives every panel the pointer, so the travel takes it back
   with the same weight. */
#ui #unlock.travel { pointer-events: none; }

/* Reduced motion: the card stands where it landed and fades. Nothing
   scales, nothing travels and the flash never plays. */
#unlock.still { animation-name: unlock-hold; }
#unlock.still::after { animation: none; opacity: 0; }
#unlock.still.travel { animation: unlock-fade var(--unlock-travel-ms) forwards; }
@media (prefers-reduced-motion: reduce) {
  #unlock, #unlock.sheet { animation-name: unlock-hold; }
  #unlock::after { animation: none; opacity: 0; }
  #unlock.travel { animation-name: unlock-fade; }
}

/* The landing: the stamp falls to its own size and the ring flash opens
   out of it. */
@keyframes unlock-land {
  0% { opacity: 0; transform: translate(-50%, -50%) scale(var(--unlock-scale, 1.5)); }
  100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
}
@keyframes unlock-flash {
  0% { opacity: 0.55; transform: translate(-50%, -50%) scale(0.35); }
  100% { opacity: 0; transform: translate(-50%, -50%) scale(2.2); }
}
@keyframes unlock-travel {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform:
      translate(calc(-50% + var(--unlock-dx, 0px)), calc(-50% + var(--unlock-dy, 0px)))
      scale(calc(1 / var(--unlock-scale, 1.5)));
  }
}
@keyframes unlock-hold {
  0% { opacity: 0; transform: translate(-50%, -50%) scale(1); }
  100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
}
@keyframes unlock-fade {
  0% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  100% { opacity: 0; transform: translate(-50%, -50%) scale(1); }
}

/* --- the theme preview's own frame (R806, R824) -------------------------
   The preview builds the REAL chrome modules inside a small frame, so it
   has to place them for that frame. The placement is a rule and never an
   inline style: an inline style stands over every `#ui.theme-notices-<id>`
   block below, and the whole point of the frame is to show what a value
   does. `preview/frame.ts` writes `preview-<focus>` on the frame's chrome
   root, so the dock focus can stand the column beside its own dock panel.

   These rules come FIRST, because a per-value block below carries the same
   specificity and must win on source order. */
.theme-preview #ui #notices {
  right: 12px;
  top: 48px;
}
.theme-preview #ui.preview-dock #notices { right: calc(min(380px, 44%) + 24px); }
/* The dock panel narrows to the frame and never passes its own width. */
.theme-preview #ui #dock { width: min(380px, 44%); }
.theme-preview #ui.preview-ui #dock { padding: 8px 10px; }
/* The frame has no dock column until it builds its own dock panel, so the
   readout line centres on the frame (R2043). `preview/frame.ts` writes the
   width of its dock panel inline, and that inline figure wins over this
   rule. The line stays one edge margin inside the frame, and a long world
   name ends in an ellipsis and keeps its first letters. */
.theme-preview #ui { --dock-w: 0px; }
.theme-preview #ui #topbar { max-width: calc(100% - 2 * var(--pad)); }
.theme-preview #ui #topbar > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* A chart card is one peek wide, and a MODDING frame is narrower than
   that: the card stays one edge margin inside the frame, left of its dock
   column, and its title ends in an ellipsis (R2043). */
.theme-preview #ui #furniture .chart-card { max-width: calc(100% - 2 * var(--pad) - var(--dock-w)); }
/* The stacked order (R2043): where the line is wider than the map left of
   the frame's dock panel, `preview/frame.ts` writes `preview-stacked`. The
   line then centres on the frame, the dock panel stands under it, and no
   chart card shows, as a telephone keeps no card of the stack. */
.theme-preview #ui.preview-stacked #topbar { left: 50%; }
.theme-preview #ui.preview-stacked #dock { top: calc(var(--topbar-h) + var(--pad)); }
.theme-preview #ui.preview-stacked #furniture .chart-card { display: none; }

/* --- the five alternative notices looks (R824, themes.md §3.4) ----------
   `notices` is a field of the World body, and `wearChromeLook` puts
   `theme-notices-<id>` on `#ui`. One block below is one value of the field,
   ported from its card of mockup round twenty-four; `drain` is card 02 and
   has no block, because card 02 is what ships.

   Four rules bind every block.

   A block states `--out` on `#notices` and NEVER a bare `transform`: the
   chrome dock-in multiplies `--rest` by `--out`, and a panel that writes
   `transform` loses its layout at the first frame of the arrival.

   A block names a colour as a token, so a UI theme repaints the notices
   with the rest of the chrome.

   A block keeps both tones — the hero ink for a schedule, red for a
   fault, never gold (R1798) — and it
   keeps the claim order, because those are §8's rules and not a look's.

   The blocks stand ABOVE the dock-in heading below, because `#truce` and
   `#link` must not appear under it: they are children of the bar and they
   travel with it. */

/* ---- ledger (card 03) --------------------------------------------------
   News is a log, so it is written as one: top left, under the stats, each
   line stamped with the world clock it arrived at and led by a coloured
   rule on a plate that fades away to the right. A ledger stands off the
   bar's centre line, so it holds six lines and holds each one longer
   (presentation.toml, `ledger_lines` and `ledger_notice_ms`). The timer
   keeps the centre and splits into the name of the clock and its figure. */
#ui.theme-notices-ledger #notices {
  left: var(--pad);
  right: auto;
  /* Under the round unit of a desktop (R2879). */
  top: max(62px, var(--unit-t, 0px));
  width: 470px;
  max-width: calc(100vw / var(--ui-scale, 1) - 24px);
  align-items: stretch;
  gap: 2px;
  --out: translateX(calc(-100% - 24px));
}
/* The mirrored desktop stands the round unit at the top right (R2883), so
   the ledger at the left keeps its own top. */
#ui.mirror.theme-notices-ledger #notices { top: 62px; }
#ui.theme-notices-ledger #notices .notice {
  display: grid;
  grid-template-columns: 52px 2px 1fr;
  gap: 8px;
  align-items: baseline;
  max-width: none;
  padding: 2px 8px 2px 4px;
  white-space: nowrap;
  border: 0;
  border-radius: 0;
  background: linear-gradient(90deg, rgb(var(--deep-rgb) / 0.78), rgb(var(--deep-rgb) / 0));
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  animation: toast-left var(--life) linear forwards;
}
#ui.theme-notices-ledger #notices .notice .ts { color: var(--dim); font-size: var(--t-small-size); }
#ui.theme-notices-ledger #notices .notice .rule {
  align-self: stretch;
  background: var(--accent);
  border-radius: 1px;
}
#ui.theme-notices-ledger #notices .notice.error .rule { background: var(--bad); }
/* The pill under the bar. The 2 px rule along the bar's foot is gone: this
   look states the figure and no quantity, so `.fill` has nothing to draw. */
#ui.theme-notices-ledger :is(#truce, #link) {
  left: 0;
  right: 0;
  bottom: auto;
  top: calc(100% + 5px);
  width: max-content;
  margin-inline: auto;
  height: auto;
  background: none;
  border-radius: 0;
}
#ui.theme-notices-ledger :is(#truce, #link) .fill { display: none; }
#ui.theme-notices-ledger :is(#truce, #link) .tab {
  position: static;
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 0;
  padding: 3px 14px 4px;
  font-size: var(--t-small-size);
  line-height: 1.35;
  letter-spacing: 0;
  color: var(--text);
  background: var(--panel);
  border: 1px solid rgb(var(--hero-ink-rgb) / 0.45);
  border-radius: 8px;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  text-shadow: none;
}
#ui.theme-notices-ledger :is(#truce, #link) .tab small {
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
  text-transform: uppercase;
}
#ui.theme-notices-ledger :is(#truce, #link) .tab b {
  font-size: var(--t-title-size);
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--hero-ink);
}
#ui.theme-notices-ledger :is(#truce, #link) .tab .tail { font-size: var(--t-small-size); color: var(--dim); }
#ui.theme-notices-ledger :is(#truce.bad, #link) .tab { border-color: rgb(var(--bad-rgb) / 0.45); }
#ui.theme-notices-ledger :is(#truce.bad, #link) .tab b { color: var(--bad); }

/* ---- split-lane (card 04) ----------------------------------------------
   One strip under the bar with two cells: the timer at its left, a divider,
   and the latest line at its right, rolling up when the next one arrives.
   The older lines are a count and not a stack, and the strip is gone when
   it holds neither a timer nor a line. */
#ui.theme-notices-split-lane #notices {
  /* The centring is `left: 0; right: 0` and an auto margin, and NOT a
     `translateX(-50%)` in `--rest`. A shrink-to-fit absolute box resolves a
     percentage translate against a width it does not have yet, so the
     column stood half its width to the right of the centre. The auto margin
     needs no width and no transform, and it leaves `--rest` to the dock-in
     alone. */
  left: 0;
  right: 0;
  top: 38px;
  width: max-content;
  margin-inline: auto;
  flex-direction: row;
  align-items: center;
  gap: 0;
  height: 24px;
  padding: 0 12px;
  max-width: calc(100vw / var(--ui-scale, 1) - 24px);
  font-size: var(--t-small-size);
  white-space: nowrap;
  background: var(--panel);
  border: 1px solid var(--edge);
  border-radius: 8px;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  --out: translateY(calc(-100% - 44px));
}
#ui.theme-notices-split-lane #notices.empty { display: none; }
#ui.theme-notices-split-lane #notices .hide { display: none; }
#ui.theme-notices-split-lane #notices .div {
  width: 1px;
  height: 12px;
  margin: 0 12px;
  background: rgb(var(--accent-rgb) / 0.35);
}
#ui.theme-notices-split-lane #notices .nt {
  position: relative;
  display: flex;
  align-items: center;
  height: 24px;
  min-width: 0;
  overflow: hidden;
}
#ui.theme-notices-split-lane #notices .more {
  margin-left: 10px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
}
#ui.theme-notices-split-lane #notices .notice {
  position: relative;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  animation: toast-roll 400ms both;
}
#ui.theme-notices-split-lane #notices .notice.error { color: var(--bad); }
/* The two timer elements stand in the lane's own cell here, so they lose
   the rule along the bar's foot and take the lane's own type. */
#ui.theme-notices-split-lane :is(#truce, #link) {
  position: static;
  height: auto;
  letter-spacing: 0.08em;
  background: none;
  border-radius: 0;
}
#ui.theme-notices-split-lane :is(#truce, #link) .fill { display: none; }
#ui.theme-notices-split-lane :is(#truce, #link) .tab {
  position: static;
  margin: 0;
  font-size: var(--t-small-size);
  line-height: 1.35;
  letter-spacing: 0.09em;
  color: var(--hero-ink);
  text-shadow: none;
}
#ui.theme-notices-split-lane :is(#truce.bad, #link) .tab { color: var(--bad); }

/* ---- under-clock (card 05) ---------------------------------------------
   A countdown belongs with the clock it counts on, so the tab hangs under
   the bar's right end in the bar's own glass — a second row on the right
   and not a banner across the middle. The lines keep the centre as cards
   with a 16 px mark column, and a hairline along the foot of each one
   drains over its life, so a reader sees how long it has left. */
#ui.theme-notices-under-clock #notices {
  /* The centring is `left: 0; right: 0` and an auto margin, and NOT a
     `translateX(-50%)` in `--rest`. A shrink-to-fit absolute box resolves a
     percentage translate against a width it does not have yet, so the
     column stood half its width to the right of the centre. The auto margin
     needs no width and no transform, and it leaves `--rest` to the dock-in
     alone. */
  left: 0;
  right: 0;
  /* The card puts the cards at 44 px. The column starts at 84 px, under
     the readout line and the band the card left for its caption (R824). */
  top: 84px;
  align-items: center;
  --out: translateY(calc(-100% - 90px));
}
#ui.theme-notices-under-clock #notices .notice {
  position: relative;
  display: grid;
  grid-template-columns: 16px 1fr;
  gap: 8px;
  align-items: center;
  padding: 5px 11px 6px;
  border: 1px solid var(--edge);
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
  animation: toast-fade var(--life) forwards;
}
#ui.theme-notices-under-clock #notices .notice .g { color: var(--accent); text-align: center; }
#ui.theme-notices-under-clock #notices .notice.error {
  color: var(--bad);
  border-color: rgb(var(--bad-rgb) / 0.35);
}
#ui.theme-notices-under-clock #notices .notice.error .g { color: var(--bad); }
#ui.theme-notices-under-clock #notices .notice .life {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: var(--accent);
  transform-origin: left;
  animation: toast-life var(--life) linear forwards;
}
#ui.theme-notices-under-clock #notices .notice.error .life { background: var(--bad); }
#ui.theme-notices-under-clock :is(#truce, #link) {
  left: auto;
  right: 18px;
  bottom: auto;
  top: 100%;
  width: max-content;
  height: auto;
  background: none;
  border-radius: 0;
}
#ui.theme-notices-under-clock :is(#truce, #link) .fill { display: none; }
#ui.theme-notices-under-clock :is(#truce, #link) .tab {
  position: static;
  margin: -1px 0 0;
  padding: 2px 9px 3px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  line-height: 1.35;
  letter-spacing: var(--t-cap-track);
  color: var(--hero-ink);
  background: var(--panel);
  border: 1px solid rgb(var(--hero-ink-rgb) / 0.45);
  border-top: 0;
  border-radius: 0 0 6px 6px;
  text-shadow: none;
}
#ui.theme-notices-under-clock :is(#truce, #link) .tab .d {
  margin-left: 6px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
}
#ui.theme-notices-under-clock :is(#truce.bad, #link) .tab {
  color: var(--bad);
  border-color: rgb(var(--bad-rgb) / 0.45);
}

/* ---- ribbon (card 08) --------------------------------------------------
   A full-width strip of the bar's glass hangs under the bar from edge to
   edge: the latest line types in at the left, the clock stands at the
   right, and the bar's centre stays empty. One line at a time, so a burst
   of news reads as a ticker and never as a stack, and the rest is a count
   that names the inbox. The strip slides away when it holds nothing.

   This is the one look that moves another panel: the dock and the stats
   drop to clear the strip, and the bar stands over it (R824). */
#ui.theme-notices-ribbon #notices {
  left: 0;
  right: 0;
  top: 34px;
  height: 22px;
  flex-direction: row;
  align-items: center;
  gap: 0;
  font-size: var(--t-small-size);
  letter-spacing: 0.08em;
  background: rgb(var(--panel-rgb) / 0.62);
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.14);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  transition: transform 260ms cubic-bezier(0.215, 0.61, 0.355, 1), opacity 200ms;
  --out: translateY(-100%);
}
#ui.theme-notices-ribbon #notices.empty { --rest: translateY(-100%); opacity: 0; }
#ui.theme-notices-ribbon #notices .hide { display: none; }
#ui.theme-notices-ribbon #notices .div { display: none; }
#ui.theme-notices-ribbon #notices .nt {
  position: absolute;
  left: 16px;
  top: 0;
  display: flex;
  align-items: center;
  height: 22px;
  max-width: calc(100% - 320px);
  overflow: hidden;
}
#ui.theme-notices-ribbon #notices .more {
  position: absolute;
  left: 16px;
  top: 100%;
  margin-top: 5px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
}
#ui.theme-notices-ribbon #notices .notice {
  display: flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  animation: toast-type var(--life) forwards;
}
#ui.theme-notices-ribbon #notices .notice .g { color: var(--accent); }
#ui.theme-notices-ribbon #notices .notice.error { color: var(--bad); }
#ui.theme-notices-ribbon #notices .notice.error .g { color: var(--bad); }
/* The timer cell stands at the right end of the strip. */
#ui.theme-notices-ribbon #notices .tm {
  position: absolute;
  right: 16px;
  top: 0;
  display: flex;
  align-items: center;
  height: 22px;
  white-space: nowrap;
}
#ui.theme-notices-ribbon :is(#truce, #link) {
  position: static;
  height: auto;
  background: none;
  border-radius: 0;
}
#ui.theme-notices-ribbon :is(#truce, #link) .fill { display: none; }
#ui.theme-notices-ribbon :is(#truce, #link) .tab {
  position: static;
  margin: 0;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  line-height: 1.35;
  letter-spacing: var(--t-cap-track);
  color: var(--hero-ink);
  text-shadow: none;
}
#ui.theme-notices-ribbon :is(#truce, #link) .tab .sm { display: none; }
#ui.theme-notices-ribbon :is(#truce, #link) .tab .d {
  margin-left: 8px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
}
#ui.theme-notices-ribbon :is(#truce.bad, #link) .tab { color: var(--bad); }
#ui.theme-notices-ribbon #topbar { z-index: 51; }
#ui.theme-notices-ribbon #dock { top: 58px; }
/* The strip spans the screen, so it crosses the second row of the dev
   readout as well. That readout stands under the strip AND under the count
   line that hangs below the strip's left end. */
#ui.theme-notices-ribbon #stats { top: 84px; }

/* ---- bare-type (card 10) -----------------------------------------------
   Set like a caption on a film. Nothing is boxed, so the lane never reads
   as a panel a player could press: the timer is one line of small capitals
   in the tone of the claim with a hairline under it, and the lines are
   plain sentences with a dot. It stands on the text shadow to stay
   readable over a bright site (R824). */
#ui.theme-notices-bare-type #notices {
  /* The centring is `left: 0; right: 0` and an auto margin, and NOT a
     `translateX(-50%)` in `--rest`. A shrink-to-fit absolute box resolves a
     percentage translate against a width it does not have yet, so the
     column stood half its width to the right of the centre. The auto margin
     needs no width and no transform, and it leaves `--rest` to the dock-in
     alone. */
  left: 0;
  right: 0;
  /* The card puts the lines at 66 px, under a caption at 42 px. The
     column starts at 88 px, so the lines stand under the caption band
     (R824). */
  top: 88px;
  align-items: center;
  gap: 3px;
  --out: translateY(calc(-100% - 94px));
}
#ui.theme-notices-bare-type #notices .notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  white-space: nowrap;
  text-shadow: 0 1px 3px rgb(var(--deep-rgb)), 0 0 6px rgb(var(--deep-rgb) / 0.95);
  animation: toast-fade var(--life) forwards;
}
#ui.theme-notices-bare-type #notices .notice .dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--accent);
}
#ui.theme-notices-bare-type #notices .notice.error .dot { background: var(--bad); }
#ui.theme-notices-bare-type :is(#truce, #link) {
  left: 0;
  right: 0;
  bottom: auto;
  top: calc(100% + 9px);
  width: max-content;
  margin-inline: auto;
  height: auto;
  background: none;
  border-radius: 0;
}
#ui.theme-notices-bare-type :is(#truce, #link) .fill { display: none; }
/* `--tone` is the one property a notices renderer writes on a tab
   (`ui/notices.ts`): the hairline under the line takes the tone of the
   claim, and a gradient cannot read a class. */
#ui.theme-notices-bare-type :is(#truce, #link) .tab {
  position: relative;
  display: block;
  margin: 0;
  padding-bottom: 4px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  line-height: 1.35;
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
  color: var(--tone, var(--hero-ink));
  text-shadow: 0 1px 3px rgb(var(--deep-rgb)), 0 0 8px rgb(var(--deep-rgb) / 0.95);
}
#ui.theme-notices-bare-type :is(#truce, #link) .tab::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--tone, var(--hero-ink)), transparent);
}
#ui.theme-notices-bare-type :is(#truce, #link) .tab b {
  font-weight: 600;
  color: var(--tone, var(--hero-ink));
}
#ui.theme-notices-bare-type :is(#truce, #link) .tab .d { color: var(--dim); }


/* The top-bar core card (R1458). A press on the Data Core cell opens it
   under the cell, where the explainer card stands, and the overlay places
   it from the cell's box. It is the commit card's frame: one question,
   the trade, the line that says how a core is won, and two buttons. */
#corecard {
  position: absolute;
  width: min(280px, calc(100vw / var(--ui-scale, 1) - 8px));
  box-sizing: border-box;
  padding: 8px 10px;
  font-size: var(--t-small-size);
  line-height: 1.45;
  border-left: 2px solid var(--core);
  border-radius: 0 6px 6px 0;
  z-index: 42;
}
#corecard .ask { color: var(--text); }
#corecard .how { margin-top: 4px; color: var(--dim); }
#corecard .acts {
  display: flex;
  gap: 6px;
  margin-top: 8px;
  justify-content: flex-end;
}
#corecard .acts button { min-height: 36px; }

/* --- the squad on the map (R1571; mockup round 075, cards 16 to 19) ---

   The squad chip stands in the dock head after the name (R1749): the
   reader's squad mark, then SQUAD 3 · 6 COMMANDERS. A pickup squad wears
   a dashed rim, so it never reads as a clan squad. The chip states its
   own button face, because the base button and the coarse 40 px floor
   would make it a box. The pulse of a squad change is one run of
   `squad-pulse`: the chip states the length and a negative delay inline,
   because the head rewrites its markup on a change and a rewrite must
   not start the pulse again. */
#dockhead button.sq {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 1px 8px 1px 6px;
  border: 1px solid var(--edge);
  border-radius: 10px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--text);
  background: rgb(var(--accent-rgb) / 0.06);
}
@media (hover: hover) {
  #dockhead button.sq:hover:not(:disabled) { background: rgb(var(--accent-rgb) / 0.14); color: var(--text); }
}
#dockhead button.sq img { display: block; }
#dockhead button.sq b { color: var(--accent); font-weight: 500; }
#dockhead button.sq.pick { border-style: dashed; }
#dockhead button.sq.flash { animation-name: squad-pulse; animation-timing-function: ease-out; animation-fill-mode: both; }
@keyframes squad-pulse {
  from { box-shadow: 0 0 0 0 rgb(var(--accent-rgb) / 0.45); background: rgb(var(--accent-rgb) / 0.22); }
  to { box-shadow: 0 0 0 6px rgb(var(--accent-rgb) / 0); background: rgb(var(--accent-rgb) / 0.06); }
}
@media (prefers-reduced-motion: reduce) {
  #dockhead button.sq.flash { animation: none; }
}

/* The roster card under the chip (card 16): the squad and the clan, one
   row a member with the reader first, then MARKS KEY and OPEN CLAN. The
   overlay places it under the chip, the way the core card stands. */
#squadcard {
  position: absolute;
  width: min(282px, calc(100vw / var(--ui-scale, 1) - 8px));
  box-sizing: border-box;
  padding: 9px 11px 10px;
  font-size: var(--t-small-size);
  z-index: 42;
}
/* A popover on a panel is opaque (R2050, ui-map-interface.md §2.3 "The
   stacking rule"): the card stands over BUILD and the dock head, so it
   takes the sheet ink at full cover and no blur, and no row of the menu
   under it reads through its names. Two ids, because `#ui .panel` sets
   the glass. */
#ui #squadcard {
  background: rgb(var(--sheet-rgb));
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
#squadcard .sqhead {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 4px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
}
#squadcard .sqname { color: var(--accent); }
#squadcard .sqclan { color: var(--dim); }
#squadcard .sqrow {
  display: flex;
  gap: 8px;
  padding: 3px 0;
  border-top: 1px solid rgb(var(--accent-rgb) / 0.07);
}
#squadcard .sqrow .nm { color: var(--text); }
#squadcard .sqrow.you .nm { color: var(--accent); }
#squadcard .sqrow .st { margin-left: auto; color: var(--dim); }
#squadcard .acts { display: flex; gap: 6px; margin-top: 8px; }
#squadcard .acts .primary { margin-left: auto; }
/* The window line and RALLY (the game critique of 2026-10-14): the window
   of the reader over the rows, then the one primary of the card. Each row
   leads with three readiness pips, the held ones filled, so the state
   reads by shape: near the target, a hull in view, online, offline. */
#squadcard .sqwin {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 4px 0 2px;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}
#squadcard .sqwin .sw-t { flex: 1; min-width: 0; }
#squadcard .sqwin .sw-c { flex: none; color: var(--hero-ink); font-weight: 500; }
#squadcard .sqwin.none { color: var(--dim); }
#squadcard .acts.sqrally { margin: 2px 0 6px; }
#squadcard .acts.sqrally .primary { flex: 1; margin-left: 0; }
#squadcard .sqrow { align-items: center; }
#squadcard .rdy { display: inline-flex; flex: none; gap: 2px; }
#squadcard .rdy i { width: 5px; height: 5px; border-radius: 50%; box-shadow: inset 0 0 0 1px var(--dim); }
#squadcard .rdy i.on { background: var(--accent); box-shadow: none; }
#squadcard .rdy.r-near i.on { background: var(--good); }
@media (pointer: coarse) { #squadcard .acts button { min-height: var(--target-finger); } }

/* The marks key (card 17): the three degrees of R185, the hull and its
   words on the left and the hold and its words on the right, at map
   scale, and a foot with the other hull value. It stands over the map at
   the left under the bar and under the round unit of a desktop
   (`--unit-t`, R2879); the sheet block makes it a sheet at the bottom. In
   the CLAN tab the same markup heads the roster (`.intab`). */
#squadkey {
  position: absolute;
  left: var(--pad);
  top: max(calc(64px + var(--safe-t)), var(--unit-t, 0px));
  width: min(360px, calc(100vw / var(--ui-scale, 1) - 24px));
  box-sizing: border-box;
  padding: 8px 10px 7px;
  border-radius: 8px;
  z-index: 42;
}
.markskey .khead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding-bottom: 6px;
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.15);
}
.markskey .kt { color: var(--accent); font-size: var(--t-cap-size); font-weight: 500; letter-spacing: var(--t-cap-track); }
.markskey .ks { color: var(--dim); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); }
.markskey .krow {
  display: grid;
  grid-template-columns: 44px 1fr 44px 1fr;
  align-items: center;
  min-height: 44px;
}
.markskey .km { display: flex; align-items: center; justify-content: center; }
.markskey .km img { display: block; }
.markskey .kw { display: flex; flex-direction: column; gap: 2px; padding-left: 6px; }
.markskey .kw b { color: var(--accent); font-size: var(--t-cap-size); font-weight: 500; letter-spacing: var(--t-cap-track); }
.markskey .k-own .kw b { color: var(--hover-ink); }
.markskey .kw i { color: var(--dim); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); font-style: normal; }
.markskey .kfoot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
  padding-top: 6px;
  border-top: 1px solid rgb(var(--accent-rgb) / 0.12);
  color: var(--dim);
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
}
.markskey.intab { margin: 6px 0 10px; }

/* The report card (deployment.md §7.6, R1323) is a modal (round 083 card
   16, R1819): centred over the scrim on a desktop, `--w-modal` wide. On a
   telephone it stands under the readout line, because a keyboard rises
   from the bottom and must not cover the note box. */
#reportcard {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(var(--w-modal), calc(100vw / var(--ui-scale, 1) - 32px));
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: var(--t-small-size);
  border-left: 2px solid var(--bad);
  border-radius: 0 6px 6px 0;
  z-index: 80;
}
#reportcard .ask { color: var(--text); letter-spacing: 0.08em; word-break: break-word; }
#reportcard .hint { margin-top: 6px; color: var(--dim); line-height: 1.4; }
/* The reason is the select box of the choice kit (R2011). */
#reportcard .reasons { margin-top: 8px; }
#reportcard input.repin {
  width: 100%;
  box-sizing: border-box;
  margin-top: 8px;
  min-height: 36px;
  font-size: var(--t-figure-size);
}
#reportcard .err { margin-top: 6px; color: var(--bad); }
#reportcard .acts {
  display: flex;
  gap: 6px;
  margin-top: 8px;
  justify-content: flex-end;
}
#reportcard .acts button { min-height: 40px; min-width: 72px; }

/* The full-screen stop (R69): the connection is permanently down and only
   a reload helps, so everything else is covered over. */
#fatal {
  position: fixed;
  inset: 0;
  z-index: 90;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(var(--deep-rgb) / 0.88);
  pointer-events: auto;
}
#fatal .panel {
  padding: 20px 26px;
  max-width: min(440px, calc(100vw / var(--ui-scale, 1) - 32px));
  text-align: center;
  border-color: rgb(var(--bad-rgb) / 0.35);
}
#fatal .title { color: var(--bad); letter-spacing: 0.08em; margin-bottom: 8px; }

/* The idle sea view (R2865, ui-map-interface.md §13 "SEA VIEW"): the frame
   of the sea view over the whole map, on `document.body`, on the top step
   of the modal rung, so `#fatal` on the cover rung still covers it. It
   loads at opacity 0 and takes no pointer; `ui/seaidle.ts` fades it on
   its opacity with the curve and the durations of
   `[presentation.seaview_idle]`. During the tour the shield takes every
   pointer and hides the cursor; in the free sea view the frame takes the
   input. */
#seaidle {
  position: fixed;
  inset: 0;
  z-index: 89;
  opacity: 0;
  pointer-events: none;
  transition-property: opacity;
  background: transparent;
}
#seaidle iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  pointer-events: none;
}
#seaidle .shield { position: absolute; inset: 0; display: none; cursor: none; }
#seaidle.shield .shield { display: block; pointer-events: auto; }
#seaidle.free iframe { pointer-events: auto; }
#fatal .line { color: var(--dim); margin-bottom: 6px; }
#fatal button { margin-top: 8px; }

/* The maintenance cover (the release manager, deployment.md §6.1;
   ui/maintenance.ts). It stands over EVERYTHING, `#fatal` included, at
   the rung above it (cover + 1, R1797): a world that closed for a window may have set the version
   stop off on the way out, and the window is the fact that explains both.

   It mounts on `document.body` and not inside `#ui`, because `#ui` is a
   stacking context of its own and the hub and the landing screen carry no
   `#ui` at all.

   The cover takes NO press, so nothing here is a control and the plate
   carries no cursor. `pointer-events: auto` still stands, because the
   cover must swallow a press that would otherwise reach the map under it.

   The canvas is the Sonar Bloom, loaded from `/bloom.js` on demand. It is
   behind the plate and it is decoration: a cover whose bloom did not load
   shows a dark ground and every word. */
#maintenance {
  position: fixed;
  inset: 0;
  z-index: 91;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(var(--deep-rgb));
  pointer-events: auto;
}
#maintenance canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}
#maintenance .plate {
  position: relative;
  padding: 22px 26px;
  max-width: min(480px, calc(100vw - 32px));
  text-align: center;
  background: rgb(var(--panel-rgb) / 0.88);
  border: 1px solid rgb(var(--amber-rgb) / 0.35);
}
#maintenance .title {
  color: var(--amber);
  letter-spacing: 0.17em;
  margin-bottom: 10px;
}
#maintenance .note { color: var(--text); margin-bottom: 8px; }
#maintenance .left { color: var(--dim); }
#maintenance .count {
  color: var(--dim);
  font-size: var(--t-display-size);
  font-variant-numeric: tabular-nums;
}
#maintenance .count:empty { display: none; }

/* The season summary card (ui-map-interface.md §3.4, R1518, R1519, R2089;
   ui/seasonsummary.ts): card 10 of mockup round 066, led by YOU CARRY and
   the place in the sea since R2089. It covers the map from the lock of
   the scores until the player puts it away or the season rolls. z-index
   48 stands it over the replay film at 42 and the season banner at 45,
   and under the dev panel at 50, so an operator can still turn the world
   under it.

   The head is the Abyss look of the season banner (§3.3) at about one
   third of its size: the hero, the line of the mode and the world, and
   the clock. The body holds YOU CARRY, the place in the sea, the
   sections in columns and the timelapse, and it scrolls inside the card
   when it is taller than the screen. The header and the footer do not
   scroll, so the footer buttons are fixed chrome and act on the press
   (§16.8). Every text of the card takes 12 px at least (the body step),
   and a figure of 0 takes Dim, never Faint (R2089). The sheet form
   factor has its own rules in the sheet block below. */
#seasonsummary {
  position: fixed;
  inset: 0;
  z-index: 48;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgb(var(--deep-rgb) / 0.82);
  pointer-events: auto;
  touch-action: none;
}
#seasonsummary .card {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: min(1120px, 100%);
  max-height: calc(88vh / var(--ui-scale, 1));
  padding: 16px 18px 12px;
  font-size: var(--t-body-size);
  line-height: 1.5;
  border-color: rgb(var(--gold-rgb) / 0.35);
}
/* The small banner: the #banner Abyss rules at a third of their size. It
   arrives the way the banner arrives (the tracking opens, the rule draws
   out from the centre, the kicker and the foot fade in), once, and then
   stands. `still` is reduced motion, as on #banner. The head is a reprise
   of the loading screen art, so it keeps the kicker, the hero, the glow
   rule and the clock line of card 10 (R2111). */
#seasonsummary .bn {
  flex: none;
  padding: 4px 0 2px;
  text-align: center;
  text-transform: uppercase;
  contain: layout paint;
}
#seasonsummary .bn .kick {
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: 0.42em;
  margin-right: -0.42em;
  color: var(--dim);
  animation: banner-fade 500ms linear both;
}
#seasonsummary .bn .hero {
  font-size: 32px;
  font-weight: 300;
  line-height: 1.05;
  /* The banner hero's own white, as #banner .hero. */
  color: var(--hero-ink);
  white-space: nowrap;
  margin: 7px -0.26em 7px 0;
  letter-spacing: 0.26em;
  animation: summary-track 1100ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#seasonsummary .bn .rule {
  height: 1px;
  width: min(46%, 360px);
  margin: 0 auto;
  background: linear-gradient(90deg, transparent, rgb(var(--accent-rgb) / 0.85), transparent);
  animation: banner-rule 620ms cubic-bezier(0.215, 0.61, 0.355, 1) 190ms both;
}
#seasonsummary .bn .foot {
  font-size: var(--t-small-size);
  letter-spacing: 0.34em;
  margin-right: -0.34em;
  margin-top: 8px;
  color: var(--dim);
  font-variant-numeric: tabular-nums;
  animation: banner-fade 500ms linear both;
}
#seasonsummary .bn .foot b { color: var(--accent); font-weight: 500; }
#seasonsummary.held .bn .foot { color: var(--bad); }
#seasonsummary.still .bn .kick, #seasonsummary.still .bn .hero,
#seasonsummary.still .bn .rule, #seasonsummary.still .bn .foot { animation: none; }
@keyframes summary-track {
  from { letter-spacing: 0.16em; margin-right: -0.16em; opacity: 0; }
  to   { letter-spacing: 0.26em; margin-right: -0.26em; opacity: 1; }
}
#seasonsummary .body {
  margin-top: 12px;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  touch-action: pan-y;
}
#seasonsummary section { min-width: 0; }
#seasonsummary h3 {
  color: var(--gold);
  letter-spacing: 0.08em;
  margin: 0 0 6px;
  padding-bottom: 3px;
  border-bottom: 1px solid var(--edge);
  font-size: var(--t-body-size);
  font-weight: normal;
  text-transform: uppercase;
}
#seasonsummary h3.next { margin-top: 12px; }
#seasonsummary .num { font-variant-numeric: tabular-nums; text-align: right; white-space: nowrap; }
#seasonsummary .dl { color: var(--dim); font-variant-numeric: tabular-nums; }
#seasonsummary .lab {
  font-size: var(--t-body-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
  text-transform: uppercase;
}
#seasonsummary .you-tag {
  color: var(--accent);
  border: 1px solid rgb(var(--accent-rgb) / 0.5);
  border-radius: 3px;
  padding: 0 3px;
  margin-left: 5px;
  letter-spacing: 0.06em;
}
#seasonsummary .empty { color: var(--dim); }
/* YOU CARRY (R2089): what crosses the reset. The Honour at the figure
   step beside the captains that cross; a guest the roll deletes reads the
   guest sentence on the guest card's amber edge (§3.5). */
#seasonsummary .carry { margin-bottom: 14px; }
#seasonsummary .carry .cy {
  display: grid;
  grid-template-columns: minmax(14ch, auto) 1fr;
  gap: 8px 24px;
  align-items: start;
}
#seasonsummary .carry .hon { display: flex; flex-direction: column; gap: 2px; }
#seasonsummary .carry .hon .fig {
  font-size: var(--t-figure-size);
  font-weight: var(--t-figure-weight);
  color: var(--gold);
  font-variant-numeric: tabular-nums;
}
#seasonsummary .carry .hon .sub { color: var(--dim); font-variant-numeric: tabular-nums; }
#seasonsummary .carry .caps { min-width: 0; display: flex; flex-direction: column; gap: 2px; }
#seasonsummary .carry ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(26ch, 1fr));
  gap: 1px 20px;
}
#seasonsummary .carry li { display: flex; gap: 8px; align-items: baseline; min-width: 0; }
#seasonsummary .carry li .nm { color: var(--text); min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
#seasonsummary .carry li .ph { color: var(--dim); white-space: nowrap; }
#seasonsummary .carry li .risk { color: var(--amber); white-space: nowrap; }
#seasonsummary .carry .lost { color: var(--dim); margin-top: 2px; }
#seasonsummary .carry .lost.some { color: var(--text); }
#seasonsummary .carry.guest h3 { color: var(--amber); border-color: rgb(var(--amber-rgb) / 0.45); letter-spacing: 0.18em; }
#seasonsummary .carry.guest p { margin: 0; color: var(--text); max-width: 72ch; }
/* YOUR PLACE IN THE SEA (R2089): the kind, the name, the place and the
   score of the reader's faction, clan and own row. */
#seasonsummary .place { margin-bottom: 4px; }
#seasonsummary .pl {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  gap: 2px 14px;
  align-items: baseline;
  /* A reading width: the place stands near its name on a wide card. */
  max-width: 72ch;
}
#seasonsummary .pr { display: contents; }
#seasonsummary .pr .pk { color: var(--dim); letter-spacing: var(--t-cap-track); }
#seasonsummary .pr .pn { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
#seasonsummary .pr .pp { color: var(--hero-ink); white-space: nowrap; font-variant-numeric: tabular-nums; }
#seasonsummary .pr .num { color: var(--text); }
#seasonsummary .bond { color: var(--text); margin-top: 8px; }
/* The hex mark of the top three: filled, ringed, open. The rank reads by
   shape and weight, never by colour alone. */
#seasonsummary svg.medal { display: inline-block; vertical-align: middle; flex: none; }
#seasonsummary .r-top { font-weight: 700; color: var(--hero-ink); }
/* The duel: YOU on the left, the row you meet on the right. It stands
   only when that row sails in another faction (R2089). */
#seasonsummary .duel {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 6px 14px;
  align-items: center;
  margin-top: 12px;
}
#seasonsummary .who { display: flex; flex-direction: column; gap: 1px; }
#seasonsummary .who.w { text-align: right; align-items: flex-end; }
#seasonsummary .who .lab { letter-spacing: 0.22em; }
#seasonsummary .who .nm { font-size: var(--t-figure-size); font-weight: var(--t-figure-weight); color: var(--fc); }
#seasonsummary .who .rk { font-size: 32px; font-weight: 300; line-height: 1; color: var(--fc); }
#seasonsummary .vs {
  font-family: var(--summary-fell, Georgia, serif);
  font-style: italic;
  font-size: var(--t-display-size); font-weight: var(--t-display-weight);
  color: var(--dim);
}
/* The mirrored bars: your figure, your bar that grows to the left, the
   label and the gap, the winner's bar that grows to the right, the
   winner's figure. A pair of 0 against 0 draws no bar (R2089). */
#seasonsummary .mx {
  display: grid;
  grid-template-columns: 8ch 1fr 110px 1fr 8ch;
  gap: 5px 10px;
  margin: 12px 0 4px;
  align-items: center;
}
#seasonsummary .mx > .num { color: var(--hero-ink); }
#seasonsummary .mx > .num.yv { color: var(--accent); }
#seasonsummary .mx > .num.wv { text-align: left; }
#seasonsummary .bar { height: 12px; position: relative; }
#seasonsummary .bar i { position: absolute; top: 0; bottom: 0; border-radius: 1px; }
#seasonsummary .bar.y i { right: 0; background: var(--accent); }
#seasonsummary .bar.w i {
  left: 0;
  background: rgb(var(--amber-rgb) / 0.75);
  background-image: repeating-linear-gradient(45deg, rgb(var(--deep-rgb) / 0.35) 0 2px, transparent 2px 5px);
}
#seasonsummary .mx .mid {
  text-align: center;
  font-size: var(--t-body-size); font-weight: var(--t-cap-weight);
  letter-spacing: 0.06em;
  color: var(--dim);
  line-height: 1.25;
}
#seasonsummary .mx .mid b {
  display: block;
  color: var(--text);
  font-weight: normal;
  letter-spacing: 0;
  font-variant-numeric: tabular-nums;
}
#seasonsummary .gapline { text-align: center; color: var(--dim); margin-top: 4px; }
#seasonsummary .gapline b { color: var(--hero-ink); font-weight: normal; }
/* The sections in four columns, in every mode (R1519): the rankings with
   the clan ranking under them, YOUR SEASON, the score terms, and the
   grades alone. */
#seasonsummary .cols {
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1fr;
  gap: 12px 20px;
  margin-top: 14px;
  align-items: start;
}
#seasonsummary .col { min-width: 0; }
/* A ranking row: the rank or its mark, the name, the score. The own row
   stands on the accent wash with an inset, and its rank takes the Text
   ink, so it keeps 4.5:1 on the wash (R2089). */
#seasonsummary .r { display: flex; gap: 8px; padding: 2px 0; align-items: baseline; }
#seasonsummary .r .rk { min-width: 3.2ch; text-align: right; color: var(--dim); }
#seasonsummary .r .nm { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
#seasonsummary .r.own {
  background: rgb(var(--accent-rgb) / 0.08);
  color: var(--accent);
  padding: 2px 6px;
  margin: 0 -6px;
  border-radius: 3px;
}
#seasonsummary .r.own .rk { color: var(--text); }
#seasonsummary .r.gap { border-top: 1px dashed var(--edge); margin-top: 5px; padding-top: 4px; }
/* A label and a figure: YOUR SEASON, the score terms, the grades. */
#seasonsummary .r2 { display: flex; justify-content: space-between; gap: 8px; padding: 1.5px 0; }
#seasonsummary .r2 span:first-child { color: var(--dim); }
#seasonsummary .r2.zero .num { color: var(--dim); }
/* The grade pips: filled to the grade, out of six. */
#seasonsummary .gp { letter-spacing: var(--t-cap-track); font-weight: var(--t-cap-weight); color: var(--accent); }
#seasonsummary .gp i { font-style: normal; color: var(--dim); }
/* The count of the grades and of the captains the card cut (R1519). */
#seasonsummary .more { color: var(--dim); padding-top: 3px; letter-spacing: 0.08em; }
/* The footer states no clock: the head states it once (R2089). REGISTER
   of a swept guest takes the amber edge of the guest card. */
#seasonsummary footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  flex: none;
}
#seasonsummary footer button { min-height: 36px; min-width: 96px; }
#seasonsummary footer button.reg { margin-right: auto; color: var(--amber); border-color: rgb(var(--amber-rgb) / 0.55); }
#seasonsummary footer button[hidden] { display: none; }

/* The season timelapse players (ui-map-interface.md §3.6, R1620,
   ui/timelapse/): card 07 on the summary card, card 09 in WAR ·
   SOVEREIGNTY and card 10 in the public reader of mockup round 076. The
   small map, the legend, the transport and the day marks are one look in
   the three places. The reader stands in #hub and the other two in #ui,
   so each rule names both roots: an id outranks the base button rules of
   either sheet. The white of the legend mark is the season banner's hero
   white, as on the summary card. */
:is(#ui, #hub) .tlb { display: flex; gap: 12px; align-items: stretch; }
:is(#ui, #hub) .tlmap {
  flex: none;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid rgb(var(--accent-rgb) / 0.14);
  background: rgb(var(--deep-rgb));
}
:is(#ui, #hub) .tlmap canvas { display: block; width: 100%; height: auto; aspect-ratio: 1; }
:is(#ui, #hub) .tlside { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 5px; }
:is(#ui, #hub) .tlx { display: flex; align-items: center; gap: 7px; }
:is(#ui, #hub) .tlx button {
  flex: none;
  min-height: 0;
  letter-spacing: 0;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  padding: 2px 6px;
}
:is(#ui, #hub) .tlx button.tlp {
  width: 34px;
  height: 30px;
  padding: 0;
  font-size: var(--t-body-size);
  color: var(--accent);
  border-color: rgb(var(--accent-rgb) / 0.5);
}
:is(#ui, #hub) .tlx .tlday {
  flex: none;
  min-width: 13ch;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--hero-ink);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
:is(#ui, #hub) .tlx input.tlr {
  flex: 1;
  min-width: 60px;
  width: auto;
  height: 28px;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  accent-color: var(--accent);
}
:is(#ui, #hub) .tlleg {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 1px 7px;
  font-size: var(--t-small-size);
  align-items: center;
}
:is(#ui, #hub) .tlleg .sw { display: block; width: 8px; height: 8px; border-radius: 1px; }
/* The reader's own faction, or the volume commander's: the white outline
   of the YOUR CELLS swatch of the mockup, on the faction row (R1620). */
:is(#ui, #hub) .tlleg .sw.me { outline: 1px solid var(--hero-ink); outline-offset: 1px; }
:is(#ui, #hub) .tlleg .n { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--dim); }
:is(#ui, #hub) .tlleg .n.me { color: var(--hero-ink); }
:is(#ui, #hub) .tlleg .c { text-align: right; color: var(--hero-ink); font-variant-numeric: tabular-nums; }
:is(#ui, #hub) .tlticks {
  display: flex;
  justify-content: space-between;
  padding: 0 2px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
}
@media (pointer: coarse) {
  :is(#ui, #hub) .tlx button.tlp { width: 44px; height: 40px; }
  :is(#ui, #hub) .tlx button.tlsp { min-height: 40px; min-width: 40px; }
  :is(#ui, #hub) .tlx input.tlr { height: 40px; }
}
/* Card 07: the section under the duel. The map stands beside the legend,
   the transport and the day marks; the sheet block below stacks them. */
#seasonsummary .tlsum { margin-top: 14px; }
#seasonsummary .tlsum h3 { display: flex; gap: 8px; }
#seasonsummary .tlsum h3 .sp { flex: 1; }
#seasonsummary .tlsum h3 .m { color: var(--dim); letter-spacing: var(--t-cap-track); }
#seasonsummary .tlsum .tlmap { width: 210px; }
/* On the card the side column stands at the top of the map and takes
   its content height, so no empty band stands under the transport, and
   every text takes the 12 px floor; the transport targets are 36 px for
   a mouse and 44 px under a finger (R2089). */
#seasonsummary .tlsum .tlside { align-self: flex-start; gap: 8px; }
#seasonsummary .tlsum .tllh { color: var(--dim); letter-spacing: var(--t-cap-track); }
#seasonsummary .tlsum .tlleg,
#seasonsummary .tlsum .tlx .tlday,
#seasonsummary .tlsum .tlticks,
#seasonsummary .tlsum .tlx button { font-size: var(--t-body-size); }
#seasonsummary .tlsum .tlx button.tlp { width: 36px; height: 36px; }
#seasonsummary .tlsum .tlx button.tlsp { min-width: 44px; min-height: 36px; }
#seasonsummary .tlsum .tlx input.tlr { height: 36px; }
@media (pointer: coarse) {
  #seasonsummary .tlsum .tlx button.tlp { width: 44px; height: 44px; }
  #seasonsummary .tlsum .tlx button.tlsp { min-width: 44px; min-height: 44px; }
  #seasonsummary .tlsum .tlx input.tlr { height: 44px; }
}

/* The drain banner (R2094, ui/settlement.ts, ui-map-interface.md §3.4.1).
   One band at the top of the map while the drain of the settlement takes
   the board, in the seaquake's fault tone: the cap in the Bad ink, the
   line in the text ink with the clock to the season summary card, and a
   drain line of the share left. It stands at the left edge of the map at
   the top of the notice lane, so the notices at the right of the lane
   stay clear, and it takes no pointer, so the map stays live under it. It
   stands under the guest warning, the season banner and the season
   summary. Reduced motion (`.still`) drops the entrance. */
#settlement {
  position: absolute;
  top: var(--lane-t);
  left: calc(var(--safe-l) + var(--pad));
  z-index: 43;
  width: min(460px, calc(100% - 2 * var(--pad) - var(--safe-l) - var(--safe-r)));
  padding: var(--s-3) var(--s-4) 0;
  border-color: rgb(var(--bad-rgb) / 0.5);
  border-left: 3px solid var(--bad);
  pointer-events: none;
  animation: settlement-in 420ms ease-out both;
}
#settlement.still { animation: none; }
#settlement .sb-kick {
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--bad);
}
#settlement .sb-line {
  margin-top: var(--s-2);
  font-size: var(--t-body-size);
  line-height: 1.45;
  color: var(--text);
  font-variant-numeric: tabular-nums;
}
#settlement .sb-drain {
  height: 3px;
  margin: var(--s-3) calc(-1 * var(--s-4)) 0;
  background: rgb(var(--bad-rgb) / 0.2);
}
#settlement .sb-drain i {
  display: block;
  height: 100%;
  background: var(--bad);
  transform-origin: left center;
}
@keyframes settlement-in {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: none; }
}
/* A telephone: the dock is the sheet at the foot, so the band spans the
   screen inside the edge pad. */
@media (max-width: 900px) {
  #settlement { right: calc(var(--safe-r) + var(--pad)); width: auto; }
}

/* The guest warning (R1565, ui/guestwarn.ts, deployment.md §10.3). One
   card near the top of the map, from seaquake stage 1 in a Conquest
   world, for a guest that the season roll deletes. It is centred across
   the map and clear of the dock (`--dock-w`, R556). z-index 44 stands it
   under the season banner at 45 and the season summary at 48. Its two
   buttons are fixed chrome and act on the press (§16.8). On a touch
   screen each button takes half the row at the thumb height. */
#guestwarn {
  position: absolute;
  top: calc(64px + var(--safe-t));
  left: calc(50% - var(--dock-w, 0px) / 2);
  transform: translateX(-50%);
  z-index: 44;
  width: min(380px, calc(100% - 32px));
  padding: 12px 14px 10px;
  font-size: var(--t-body-size);
  line-height: 1.5;
  border-color: rgb(var(--amber-rgb) / 0.45);
}
/* It yields while the explainer card under the top bar stands, because
   both take the top of the map (R2139). */
#guestwarn[hidden] { display: none; }
#guestwarn .head { color: var(--amber); letter-spacing: 0.18em; font-weight: 600; }
#guestwarn p { margin: 6px 0 0; color: var(--text); }
#guestwarn footer { display: flex; justify-content: flex-end; gap: 8px; margin-top: 10px; }
#guestwarn footer button { min-height: 36px; min-width: 96px; }
@media (pointer: coarse) {
  #guestwarn footer button { flex: 1; min-height: 44px; }
}

/* The chrome behind the season summary (R1519, ui/seasonover.ts). While a
   summary stands, the map and the card are the whole screen: every child
   of #ui fades out over --veil-fade and then takes no space in the hit
   test. The card, its reopen button, the dev panel (#admin) and #fatal
   stay. The readout line holds no control since R1749, so its figures
   fade and its panel goes transparent; the dev panel stays the backtick's
   (R94). The minimap canvas is not in #ui, so it wears the class itself. `veilnow`
   stops every transition for one reflow: a page load hides at once.
   After VIEW MAP `#ui` wears `seasonmap` too, and the top bar comes back
   with its figures and the timer claim NEW SEASON (R2094); while the card
   is open, the card states the clock. */
#ui.seasonover > :not(#seasonsummary):not(#ssreopen):not(#admin):not(#topbar):not(#fatal):not(#photobar):not(#photohint):not(#photosaved),
#ui.seasonover:not(.seasonmap) #topbar > *,
#fast-minimap.seasonover {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity var(--veil-fade) ease-out, visibility 0s linear var(--veil-fade);
}
#ui.seasonover:not(.seasonmap) #topbar {
  background-color: transparent;
  /* The ground of the line is a gradient (R1770), and a gradient is an
     image that a transparent colour does not hide. */
  background-image: none;
  border-color: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  pointer-events: none;
  transition: background-color var(--veil-fade) ease-out, border-color var(--veil-fade) ease-out;
}
#ui.seasonover #topbar { pointer-events: none; }
/* The bar on the map after VIEW MAP: it fades in over the veil's fade, and
   it holds no control while the veil stands. Reduced motion shows it at
   once. */
#ui.seasonover.seasonmap > #topbar { animation: seasonmap-in var(--veil-fade) ease-out both; }
@keyframes seasonmap-in { from { opacity: 0; } }
@media (prefers-reduced-motion: reduce) {
  #ui.seasonover.seasonmap > #topbar { animation: none; }
}
#ui.veilnow, #ui.veilnow *, #fast-minimap.veilnow { transition: none !important; }
/* SEASON SUMMARY on the map: it opens the card again after VIEW MAP. It
   stands under the card's z-index 48, and it is fixed chrome and acts on
   the press (§16.8). On a desktop the compass rose stands at the bottom
   centre, so the button stands at the bottom right, where the veil leaves
   the dock column empty (R2089); the sheet block puts it at the bottom
   centre, in the thumb zone of a phone. */
#ui #ssreopen {
  position: absolute;
  right: calc(16px + var(--safe-r));
  bottom: calc(16px + var(--safe-b));
  z-index: 47;
  min-height: 44px;
  padding: 0 18px;
  letter-spacing: 0.18em;
  color: var(--accent);
  background: var(--panel);
  border: 1px solid rgb(var(--accent-rgb) / 0.45);
  border-radius: 8px;
  pointer-events: auto;
}
#ui #ssreopen[hidden] { display: none; }

/* --- photo mode (R1623, ui-map-interface.md §13.1, round 077 card 06) ---
   The veil's second cause. Under `photomode` the season summary, its
   reopen button, the dev panel and the whole top bar go too, so the map
   and the slim bar are the screen. The bar, its hint and the SAVED line
   stand only in photo mode; the seasonover rule above leaves them alone. */
#ui.photomode > #seasonsummary,
#ui.photomode > #ssreopen,
#ui.photomode > #admin,
#ui.photomode > #topbar {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity var(--veil-fade) ease-out, visibility 0s linear var(--veil-fade);
}
#ui #photobar, #ui #photohint, #ui #photosaved { display: none; }
#ui.photomode #photobar { display: flex; }
#ui.photomode #photohint { display: block; }
#ui.photomode #photosaved.on { display: block; }
#ui #photobar {
  position: absolute;
  left: 50%;
  bottom: calc(14px + var(--safe-b));
  transform: translateX(-50%);
  z-index: 49;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  font-size: var(--t-small-size);
  white-space: nowrap;
}
#ui.photomode #photobar.away { display: none; }
#ui #photobar button { min-height: 32px; white-space: nowrap; }
#ui #photobar .zr { display: flex; align-items: center; gap: 5px; color: var(--dim); font-size: var(--t-small-size); }
#ui #photobar .zr input { accent-color: var(--accent); width: 150px; }
#ui #photobar .zv { color: var(--hero-ink); font-variant-numeric: tabular-nums; min-width: 4ch; }
/* A switch is a button that wears a track and a knob (card 06). */
#ui #photobar button.sw {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 4px;
  background: none;
  border: 0;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--text);
}
#ui #photobar .sw i {
  position: relative;
  display: inline-block;
  width: 26px;
  height: 14px;
  border-radius: 8px;
  background: rgb(var(--accent-rgb) / 0.2);
}
#ui #photobar .sw i::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--faint);
}
#ui #photobar .sw.on i { background: rgb(var(--accent-rgb) / 0.55); }
#ui #photobar .sw.on i::after { left: 14px; background: var(--hero-ink); }
#ui #photohint {
  position: absolute;
  left: 50%;
  top: calc(10px + var(--safe-t));
  transform: translateX(-50%);
  z-index: 49;
  padding: 3px 10px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
  pointer-events: none;
}
#ui #photosaved {
  position: absolute;
  right: 14px;
  top: calc(14px + var(--safe-t));
  z-index: 49;
  padding: 5px 12px;
  font-size: var(--t-small-size);
  border-left: 2px solid var(--good);
  border-radius: 0 6px 6px 0;
  pointer-events: none;
}
#ui #photosaved b { color: var(--good); font-weight: 400; }
#ui #photosaved.bad { border-left-color: var(--bad); }
#ui #photosaved.bad b { color: var(--bad); }
/* The telephone's photo bar is in the sheet form factor block below. */

/* --- the REPORT sheet (R1626, fault-reports.md §4.4, round 077 cards 08
   and 09) ---
   A card of the OPTIONS geometry over the dimmed map. The scrim is the
   first child of #ui, so it dims the map and stands under every panel of
   the chrome; it takes the presses of the map while the sheet stands. The
   telephone's sheet rises from the foot: see the sheet form factor block. */
#ui #reportscrim {
  position: absolute;
  inset: 0;
  background: var(--g-modal);
  pointer-events: auto;
}
#ui #reportscrim[hidden], #ui #reportsheet[hidden] { display: none; }
#ui #reportsheet {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(380px, calc(100vw / var(--ui-scale, 1) - 24px));
  max-height: calc(100vh / var(--ui-scale, 1) - 96px);
  overflow-y: auto;
  z-index: 82;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 14px 11px;
  font-size: var(--t-small-size);
  touch-action: pan-y;
}
#reportsheet .rh { display: flex; align-items: center; gap: 8px; }
#reportsheet .rt { flex: 1; color: var(--accent); letter-spacing: 0.08em; font-size: var(--t-body-size); }
#ui #reportsheet .rx { min-width: 0; }
#reportsheet .rl { color: var(--dim); font-size: var(--t-small-size); line-height: 1.45; }
#reportsheet .rl b { color: var(--hero-ink); font-weight: 400; }
#reportsheet .rk { margin-top: 2px; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }
#reportsheet .rtext { position: relative; }
#reportsheet textarea {
  display: block;
  width: 100%;
  min-height: 58px;
  box-sizing: border-box;
  resize: vertical;
  padding: 6px 8px 14px;
  font: inherit;
  font-size: var(--t-small-size);
  color: var(--text);
  background: rgb(var(--accent-rgb) / 0.04);
  border: 1px solid var(--edge);
  border-radius: 4px;
  user-select: text;
}
#reportsheet .cnt { position: absolute; right: 6px; bottom: 5px; font-size: var(--t-small-size); color: var(--dim); pointer-events: none; }
#reportsheet .chk {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 0;
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.06);
  cursor: pointer;
}
#reportsheet .chk.off, #reportsheet .chk.fix { cursor: default; }
#reportsheet .chk.off .ct { opacity: 0.55; }
#reportsheet .chk input {
  position: relative;
  flex: none;
  width: 13px;
  height: 13px;
  margin: 0;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid var(--text);
  border-radius: 2px;
}
#reportsheet .chk input:checked { background: var(--accent); border-color: var(--accent); }
#reportsheet .chk input:checked::after {
  content: "";
  position: absolute;
  left: 3.5px;
  top: 0.5px;
  width: 3px;
  height: 7px;
  border: solid rgb(var(--panel-rgb));
  border-width: 0 1.6px 1.6px 0;
  transform: rotate(45deg);
}
#reportsheet .chk input:disabled { border-style: dashed; border-color: var(--faint); }
/* The fixed line: what always goes. Its box is dashed and holds a dash. */
#reportsheet .chk .cb {
  position: relative;
  flex: none;
  width: 13px;
  height: 13px;
  border: 1px dashed var(--faint);
  border-radius: 2px;
}
#reportsheet .chk .cb::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 5px;
  width: 5px;
  height: 1px;
  background: var(--faint);
}
#reportsheet .ct { flex: 1; min-width: 0; }
#reportsheet .ct b { font-weight: 400; color: var(--text); }
#reportsheet .ct small { display: block; color: var(--dim); font-size: var(--t-small-size); overflow-wrap: anywhere; }
#reportsheet .thumb { flex: none; overflow: hidden; border: 1px solid var(--edge); border-radius: 3px; }
#reportsheet .thumb img { display: block; object-fit: cover; }
#reportsheet .rerr { color: var(--bad); font-size: var(--t-small-size); }
#reportsheet .rf { display: flex; justify-content: flex-end; align-items: center; gap: 8px; margin-top: 3px; }
#reportsheet .rf .fine { margin-right: auto; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }
/* Card 09: the answer. */
#reportsheet .okh { font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: 0.3em; color: var(--good); }
#reportsheet .badh { font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: 0.3em; color: var(--amber); }
#reportsheet .ref {
  margin: 2px 0;
  font-size: var(--t-display-size); font-weight: var(--t-display-weight);
  letter-spacing: 0.2em;
  color: var(--hero-ink);
  font-variant-numeric: tabular-nums;
  user-select: text;
}

/* A toast arrives from the right edge of its own lane (R430), because that
   is the edge it stands against. */
@keyframes toast {
  0% { opacity: 0; transform: translateX(14px); }
  8% { opacity: 1; transform: none; }
  80% { opacity: 1; }
  100% { opacity: 0; }
}
/* The arrivals the five alternative notices looks take (R824, mockup round
   twenty-four). Each one carries its own stops, so a look changes how a
   line arrives and never how long it stands. */
@keyframes toast-fade {
  0% { opacity: 0; transform: translateY(-4px); }
  8% { opacity: 1; transform: none; }
  80% { opacity: 1; }
  100% { opacity: 0; }
}
@keyframes toast-left {
  0% { opacity: 0; transform: translateX(-14px); }
  6% { opacity: 1; transform: none; }
  84% { opacity: 1; }
  100% { opacity: 0; }
}
@keyframes toast-roll {
  0% { opacity: 0; transform: translateY(110%); }
  100% { opacity: 1; transform: none; }
}
@keyframes toast-type {
  0% { opacity: 1; clip-path: inset(0 100% 0 0); }
  5% { clip-path: inset(0 0 0 0); }
  84% { opacity: 1; }
  100% { opacity: 0; }
}
@keyframes toast-life {
  0% { transform: scaleX(1); }
  100% { transform: scaleX(0); }
}

/* The statistics line stands only while the dev stats switch of OPTIONS ·
   HELP is on (R1746): `on` is the overlay's one class for it. A line that
   is not on the glass takes no room. The round unit of a desktop stands
   one pad under the foot of the line while it shows, else under the
   readout line and the group bar (`topFoot` of `ui/layout.ts`, R2879). */
#stats {
  position: absolute;
  left: var(--pad);
  /* Under the readout line, whose left end can reach over the corner on a
     narrow desktop (R1749). */
  top: calc(var(--topbar-h, 44px) + 8px);
  display: none;
  color: var(--dim);
  font-size: var(--t-small-size);
  line-height: 1.5;
  pointer-events: none;
  /* The dev line is two rows: main.ts separates them with a newline. */
  white-space: pre-line;
}
#stats.on { display: block; }
#stats .brand { color: var(--accent); font-size: var(--t-body-size); letter-spacing: 0.17em; display: block; }

/* A chat line carrying a probe scan: ▤ REPORT opens the report in the
   selection anchor, ⌖ SHOW jumps the camera to the pinged cell. The two
   read as a pair, so they share one rule. */
#chatlog button.report {
  background: none;
  border: 1px solid var(--edge);
  border-radius: 3px;
  padding: 0 4px;
  font-size: var(--t-body-size);
  color: var(--accent);
}
@media (hover: hover) {
  #chatlog button.report:hover { background: rgb(var(--accent-rgb) / 0.15); }
}
/* The ⋯ of a chat line of another player, and the row it opens under the
   line: REPORT, and BLOCK on the CLAN tab (deployment.md §7.6, R1323). The
   ⋯ stays dim until it is open, so a busy log does not read as a column
   of controls. */
#chatlog button.report.more { color: var(--dim); border-color: transparent; }
#chatlog button.report.more.on { color: var(--accent); border-color: var(--edge); }
@media (hover: hover) {
  #chatlog button.report.more:hover { color: var(--accent); border-color: var(--edge); }
}
#chatlog button.report.bad { color: var(--bad); }
#chatlog .linemenu { margin: 1px 0 4px 12px; }
/* A quick line (R1607, mockup round 077, card 04): the ◆ before the name
   says "a fixed line", the line stands in the bright ink (the reader's own
   line in the hover ink), and the position is a ⌖ pill that moves the
   camera there, the idiom of the scan line's SHOW. */
#chatlog .line.q .qm { color: var(--accent); margin-right: 3px; }
#chatlog .line.q .qt { color: var(--hero-ink); }
#chatlog .line.q.own .qt { color: var(--hover-ink); }
#chatlog button.qpos {
  display: inline-block;
  margin-left: 5px;
  padding: 0 5px;
  background: none;
  border: 1px solid var(--edge);
  border-radius: 3px;
  font-size: var(--t-body-size);
  color: var(--accent);
  white-space: nowrap;
}
@media (hover: hover) {
  #chatlog button.qpos:hover { background: rgb(var(--accent-rgb) / 0.15); }
}
@media (pointer: coarse) {
  #chatlog button.report.more { min-width: 36px; min-height: 28px; }
  #chatlog .linemenu button { min-width: 72px; min-height: 36px; }
  /* The pill is a 32 px target under a finger (card 04). */
  #chatlog button.qpos { min-height: 32px; }
}

/* The ⚑ REPORT mark beside the name of another commander and beside a
   hull name of the faction (R1323): a bare glyph, like the ✎ RENAME mark,
   so a standings row and a roster row keep their width. A coarse pointer
   keeps a hit area a thumb can find. REPORTED is the mark after a report,
   and it is no control. */
#ui button.rep {
  flex: none;
  min-width: 22px;
  min-height: 22px;
  margin-left: 2px;
  padding: 0 2px;
  font-size: var(--t-body-size);
  letter-spacing: 0;
  background: none;
  border: none;
  box-shadow: none;
  color: var(--dim);
}
#ui button.rep.primary { background: none; color: var(--bad); }
@media (hover: hover) {
  #ui button.rep:hover { background: none; color: var(--bad); }
}
#ui .repd { margin-left: 4px; font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }
@media (pointer: coarse) {
  #ui button.rep { min-width: 36px; min-height: 36px; }
}

/* --- dev admin panel (R50): centred card over the map --- */

/* The dev panel is centred like every other explainer card (R238), and it
   stands over all of them. It hung from `top: 60px` while they were
   centred, which read as a different kind of thing at a different anchor.
   It is the panel an operator opens to change the world underneath a
   running game, so nothing in the shell may cover it — z-index 50 is over
   the panels at 20, the chat at 30 and the season banner at 45. `#fatal` alone stands higher, on the cover rung (R1797): a version mismatch or a
   refused ticket must never be hidden behind a tuning card. */
#admin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* The panel is as wide as the OPTIONS popup (760px) until the screen is
     not: every centred modal keeps itself inside the glass and scrolls
     rather than overflow it. */
  width: min(760px, calc(100vw / var(--ui-scale, 1) - 48px));
  display: none;
  z-index: 81;
}
#admin.on { display: block; }
/* The frame of the OPTIONS popup (R1774): the kit of
   `ui/options/options.css` draws the popup, the head and the rows, and
   the panel takes its height from its rows up to the height of the
   OPTIONS popup. */
#ui #admin .o-devpop {
  position: static;
  width: auto;
  height: auto;
  max-height: min(560px, calc(100vh / var(--ui-scale, 1) - 44px));
}

/* --- the ☸ OPTIONS menu (R124, R1731, ui-map-interface.md §13) ---
   `#settings` is the cover of the menu. The kit of
   `ui/options/options.css` draws what stands in it: on a desktop the
   dimmed map and the popup of one fixed size over the whole screen; on a
   telephone the screen from the top edge down to the tab bar, which stays
   in view and in reach under it (R1754). The overlay picks the shell with
   `isSheet()` and writes it as the class `phone`, so the cover carries no
   breakpoint of its own. `--tabs-h` is the measured height of the tab bar
   (`ui/layout.ts`). */

#settings {
  position: absolute;
  inset: 0;
  display: none;
  z-index: 80;
}
#settings.on { display: block; }
#ui #settings.phone { bottom: var(--tabs-h); }

/* --- the media player (ui-map-interface.md §15), centred like the other cards ---
   Everything with words in it is DOM, never canvas (§1). */

#audio {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(var(--w-modal), calc(100vw / var(--ui-scale, 1) - 24px));
  max-height: calc(100vh / var(--ui-scale, 1) - 96px);
  overflow-y: auto;
  padding: 10px 14px 12px;
  display: none;
  z-index: 80;
}
#audio.on { display: block; }

/* The scrim of a modal (round 083 card 16, R1819): the deep ink at the
   modal ground `--g-modal` over the whole screen, under KEYS, the media
   player and the report card (DESIGN.md "Elevation & Depth": a modal card
   stands on Deep at 82 to 88 %, R2050). The arcade match takes it under
   its key sheet and its gesture card. A press on it closes the modal.
   OPTIONS draws its own scrim in the kit. */
#scrim {
  position: absolute;
  inset: 0;
  display: none;
  background: var(--g-modal);
  pointer-events: auto;
  z-index: 70;
}
#scrim.on { display: block; }
#audio .ihead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
#audio .ititle { color: var(--accent); letter-spacing: 0.08em; }
#audio .isub, #ui #settings .mplayer .isub { color: var(--dim); font-size: var(--t-small-size); margin: 2px 0 6px; }
/* One track is the whole tap target, past the 40px guideline. */
#audio .mrow, #ui #settings .mplayer .mrow {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 40px;
  padding: 4px 6px;
  text-align: left;
  background: none;
  border: 0;
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.07);
  color: var(--text);
}
#audio .mrow:last-of-type, #ui #settings .mplayer .mrow:last-of-type { border-bottom: 0; }
#audio .mrow.active, #ui #settings .mplayer .mrow.active { color: var(--accent); background: rgb(var(--accent-rgb) / 0.1); }
#audio .mn, #ui #settings .mplayer .mn { flex: 0 0 22px; color: var(--dim); font-size: var(--t-small-size); }
#audio .mt, #ui #settings .mplayer .mt { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
#audio .mtrans, #ui #settings .mplayer .mtrans { display: flex; gap: 6px; margin-top: 8px; }
#audio .mtrans button, #ui #settings .mplayer .mtrans button { flex: 1; min-height: 44px; font-size: var(--t-title-size); font-weight: var(--t-title-weight); }
#audio .mtime, #ui #settings .mplayer .mtime {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  color: var(--dim);
  font-size: var(--t-small-size);
}
#audio .mbar, #ui #settings .mplayer .mbar {
  height: 6px;
  margin-top: 3px;
  border: 1px solid var(--edge);
  border-radius: 2px;
  overflow: hidden;
}
#audio .mfill, #ui #settings .mplayer .mfill { display: block; height: 100%; background: var(--accent); }
#audio .foot, #ui #settings .mplayer .foot { margin-top: 8px; color: var(--dim); font-size: var(--t-small-size); }

/* --- the heat legend of a telephone (round 086 card 11 b, R1806) ---
   The field itself is canvas; everything with words in it is DOM (§1). The
   heat modes live in the VIEW panel and a desktop reads the HEAT section of
   the legend card, so this is the one heat surface of its own: a thin ramp
   along the right edge of the clear map, the mode word over it and the two
   end words beside its ends. It takes no press and no ground. */

#heatramp {
  position: absolute;
  right: var(--pad);
  top: calc(var(--topbar-h, 46px) + 120px);
  width: 10px;
  height: min(260px, calc(100vh / var(--ui-scale, 1) - var(--topbar-h, 46px) - 120px - var(--mapbtns-t, 120px) - var(--s-6) * 2));
  display: none;
  pointer-events: none;
}
#heatramp.on { display: block; }
#heatramp .hr-bar {
  position: absolute;
  inset: 0;
  border: 1px solid rgb(var(--text-rgb) / 0.4);
  border-radius: var(--r-bar);
}
#heatramp .hr-mode,
#heatramp .hr-hi,
#heatramp .hr-lo {
  position: absolute;
  right: 0;
  white-space: nowrap;
  color: var(--text);
  text-shadow: 0 0 3px rgb(var(--deep-rgb));
}
#heatramp .hr-mode {
  bottom: calc(100% + var(--s-2));
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
}
#heatramp .hr-hi,
#heatramp .hr-lo { right: calc(100% + var(--s-2)); font-size: var(--t-small-size); }
#heatramp .hr-hi { top: 0; }
#heatramp .hr-lo { bottom: 0; }

/* --- chat (game-design §10: global / faction / clan / squad) --- */

/* --- the chat, a state of the dock (R1799, ui-map-interface.md §12.0
   "The chat", cards 15, 16 and 19 of round 085, card 05 b of round 087) ---
   The floating chat box is gone. On a desktop the chat is the chat pane at
   the foot of the dock column, over the queue strip: `chatpane` stands it
   at its own height (R1870), `chatcol` gives it the whole column, and the
   line stop shows the chat line alone. The sheet block below makes it the chat
   band of a telephone. The chat line stands over the queue line while the
   chat rests. */
#chat {
  order: 2;
  flex-shrink: 0;
  display: none;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: 0 var(--s-3) var(--s-3);
  border-top: 1px solid var(--edge);
  background: rgb(var(--sheet-rgb) / 0.97);
}
#dock.chatpane #chat, #dock.chatcol #chat, #dock.chatdrag #chat { display: flex; }
/* The pane takes the height of its last drag, `--chat-pane-h` from the
   setting `chatPanePx` (R1870). It shrinks to the column when the window
   is lower, and the setting keeps its height for a taller window. */
#dock.chatpane #chat { height: var(--chat-pane-h, 280px); flex-shrink: 1; }
/* The whole column: the menu body gives up its room to the pane. */
#dock.chatcol #chat { flex: 1 1 auto; }
#dock.chatcol #tabbody { display: none; }
/* A drag of the grip states the height inline; the body takes the rest. */
#dock.chatdrag #chat { max-height: none; flex: none; }
#dock.chatdrag #tabbody { display: block; flex: 1 1 0; min-height: 0; }
#chathead { display: flex; align-items: center; gap: var(--s-3); height: 30px; flex: none; }
#chathead .cic { color: var(--accent); flex: none; }
#chathead .cw { color: var(--accent); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); }
/* The grip of the desktop pane: a drag sets the height of the pane
   freely (`ui/chatdock.ts releasePane`, R1870). */
#chathead .cgrip {
  flex: 1;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ns-resize;
  touch-action: none;
}
#chathead .cgrip i { width: 34px; height: 4px; border-radius: 2px; background: rgb(var(--text-rgb) / 0.3); }
/* The square press (R1856, `ui/arrowpress.ts`): every arrow press of the
   chrome and the – of the chat box wear the face of the minimize control
   of the chart card frame (R1804, `.cc-min` below): 24 px painted, a faint
   edge, the button radius, and a 44 px target under a finger. A button
   wears it itself; a larger target (the fold of the peek line, the caret
   of the queue line) holds it as a span. The arrow is a solid triangle in
   a 12 px box: the owner's middle ground between the 10 px ▴ of before and
   the 16 px box of R1856 (R1857). */
#ui .sqp {
  position: relative;
  flex: none;
  display: inline-grid;
  place-items: center;
  box-sizing: border-box;
  width: var(--s-6);
  height: var(--s-6);
  min-height: 0;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 1px solid rgb(var(--text-rgb) / 0.22);
  border-radius: var(--r-button);
  background: none;
  color: var(--dim);
  cursor: pointer;
}
#ui button.sqp::after {
  content: "";
  position: absolute;
  inset: calc((var(--s-6) - var(--target-finger)) / 2);
}
/* The triangle stands in its 12 px box wherever it stands: in the face
   of a square press, on ▴ and ▾ of a sheet, and at the end of a strip. */
#ui svg.ag { display: inline-block; flex: none; width: var(--s-4); height: var(--s-4); vertical-align: middle; }
#ui .sqp .ag { display: block; }
@media (hover: hover) {
  #ui button.sqp:hover:not(:disabled), #ui .sqp:hover, #ui button:hover > .sqp {
    color: var(--accent); border-color: var(--accent); background: none;
  }
}
/* The four channel tabs in the order of the game (R1800, card 19 of round
   085): the tab strip of the choice kit (R2011), which draws the box, the
   dividers and the accent foot of the open tab. The strip takes the width
   of the chat and its tabs share it; a tab that holds unread lines carries
   one light count. No gold. */
#chattabs { display: flex; flex: none; }
#ui #chattabs > .ch-ts { flex: 1; display: flex; }
#ui #chattabs button.ch-tab { flex: 1 1 0; }
/* A channel the seat cannot read: the CLAN tab of a commander in no clan.
   The strip is built once, so the tab is hidden and never removed. */
#ui #chattabs button.hidden { display: none; }
#chatlog {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--s-2) 0;
  font-size: var(--t-body-size);
  line-height: 1.45;
  scrollbar-width: thin;
}
/* The input row (card 18 of round 085): the QUICK press opens the quick
   wheel, the field, and SEND in the dark face of a card primary. */
#chatin { display: flex; gap: 6px; align-items: center; flex: none; padding-top: var(--s-2); }
#ui #chatin .cquick {
  flex: none;
  width: 34px;
  height: 30px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
}
#ui #chatin .csend {
  flex: none;
  height: 30px;
  padding: 0 var(--s-4);
  color: var(--accent);
  background: rgb(var(--deep-rgb) / 0.6);
  border-color: rgb(var(--accent-rgb) / 0.45);
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
}
/* The chat line (R1799, card 16 of round 085): one row of the dock. A new
   line shows its channel, the sender in the owner ink and the words; then
   the quiet row with the count and the channels that hold unread lines.
   The peek of the closed chat box `#chatpeek` wears the same line (R2057). */
#chatline { order: 2; flex-shrink: 0; }
#chatline:empty { display: none; }
#ui :is(#chatline, #chatpeek) .cl {
  display: flex;
  align-items: center;
  gap: 7px;
  width: calc(100% - 2 * var(--s-2));
  height: 36px;
  margin: var(--s-2) var(--s-2) 0;
  padding: 0 10px 0 var(--s-3);
  box-sizing: border-box;
  border: 1px solid rgb(var(--accent-rgb) / 0.14);
  border-radius: var(--r-card);
  background: rgb(var(--deep-rgb) / 0.4);
  color: var(--text);
  font-size: var(--t-small-size);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
}
#ui :is(#chatline, #chatpeek) .cic { flex: none; color: var(--accent); }
#ui :is(#chatline, #chatpeek) .cl > .cic:last-child { color: var(--dim); }
#ui :is(#chatline, #chatpeek) .ch { flex: none; color: var(--dim); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); }
#ui :is(#chatline, #chatpeek) .w { flex: none; font-weight: 500; }
#ui :is(#chatline, #chatpeek) .tx { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; }
#ui :is(#chatline, #chatpeek) .tx.q { color: var(--hero-ink); }
#ui :is(#chatline, #chatpeek) .cl.quiet .tx { color: var(--dim); }
#ui :is(#chatline, #chatpeek) .lcount { flex: none; box-shadow: none; }
#chatlog::-webkit-scrollbar { width: 6px; }
#chatlog::-webkit-scrollbar-thumb { background: var(--edge); border-radius: 3px; }
#chatlog .line { margin: 1px 0; word-break: break-word; }
#chatlog .who { color: var(--accent); }
#chatlog .sys { color: var(--hero-ink); }
/* The chat time stamp `[HH:MM]` in front of a line (R1791): muted, and
   tabular, so the senders of a column of lines start at one edge. */
#chatlog .ts { color: var(--dim); font-variant-numeric: tabular-nums; }
/* The clan tab carries no faction colour, because the meta server hosts no
   world (R225). Own lines are marked instead. */
#chatlog .who.own { color: var(--hover-ink); }
/* The → DISCORD line stands at the top of the CLAN tab while the chat
   relay of the clan is on (player-reach.md §3.10, R1641). The log scrolls
   under it, so it takes the panel colour without the alpha. */
#chatlog .line.relaymark {
  position: sticky;
  top: 0;
  z-index: 1;
  color: var(--accent);
  background: rgb(var(--panel-rgb));
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
}
#chatinput {
  flex: 1;
  min-width: 0;
  height: 30px;
  font: inherit;
  font-size: var(--t-body-size);
  box-sizing: border-box;
  color: var(--text);
  /* The deep ink of `.td-inp` of round 082 (R1770). */
  background: rgb(var(--deep-rgb) / 0.6);
  border: 1px solid rgb(var(--accent-rgb) / 0.3);
  border-radius: var(--r-button);
  padding: 0 10px;
  outline: none;
}
/* The focus of the chat field (R1693): the same 1 px outline of the
   accent at 50 % stands inside the box, so the clip of the dock cannot
   cut it. */#ui #chatinput:focus { outline: 1px solid rgb(var(--accent-rgb) / 0.5); outline-offset: -1px; }
/* Dim and not Faint: a placeholder must read at 4.5:1 on the field (the
   Dim Read Rule, R2050). */
#chatinput::placeholder { color: var(--dim); }

/* --- the chat box of SMALL and LARGE (R1838, ui-map-interface.md §12.0
   "The chat") ---
   A desktop whose chat setting is SMALL or LARGE floats the chat at the
   bottom-left of the map as a unit of the console: `ui/layout.ts` packs
   it alone (the round unit stands top left, R2879), publishes its slot as `--chat-x` and
   `--chat-b`; VIEW stands on the chart strip at the other corner
   (R2904). The sizes are outer
   sizes from `[presentation.layout] chat_box_*` (R1841). It stands on the
   console rung (R1822), so the context card over the console stands over
   it (R1818). `#ui` takes no press, and the box stands in the root of the
   chrome and not in the dock, so it turns its presses back on itself
   (R1841). The – closes it to its peek line (R2057). The head shows
   the size press and DOCK on the box, and UNDOCK on the pane. DOCK and
   UNDOCK are square presses with a glyph (R1866), so the presses of a
   head wear one face. */
#chathead .csize, #chathead .cdock { display: none; }
#ui #chat.box #chathead .cdock:not(.cundock),
#ui #dock #chathead .cundock { display: inline-grid; }
#ui #chat.box #chathead .csize { display: inline-grid; }
#ui #chat.box #chathead .cgrip { visibility: hidden; cursor: default; }
#ui #chat.box {
  position: absolute;
  left: var(--chat-x, var(--pad));
  bottom: var(--chat-b, var(--pad));
  z-index: 20;
  display: flex;
  box-sizing: border-box;
  width: 512px;
  height: 320px;
  pointer-events: auto;
  border: 1px solid var(--edge);
  border-radius: var(--r-card);
  background: rgb(var(--sheet-rgb) / 0.94);
  transform-origin: var(--chat-ox, 24px) var(--chat-oy, 100%);
  transform: var(--rest, translateX(0));
  transition:
    transform var(--dock-ms) var(--dock-ease) var(--dock-delay, 0ms),
    opacity 140ms linear,
    visibility 0s linear 140ms;
}
#ui #chat.box.big { width: 800px; height: min(calc(62vh / var(--ui-scale, 1)), 500px); }
#ui #chat.box.off { opacity: 0; visibility: hidden; pointer-events: none; }
@media (max-width: 900px) {
  #ui #chat.box { width: 280px; height: 240px; }
  #ui #chat.box.big { width: 400px; height: min(calc(62vh / var(--ui-scale, 1)), 320px); }
}
@media (prefers-reduced-motion: reduce) {
  #ui #chat.box { transition: opacity 320ms linear, visibility 0s linear 320ms; }
  #ui #chat.box.off { transition: opacity 120ms linear, visibility 0s linear 120ms; }
}
/* The peek of the chat box (R2057): a closed box of SMALL and LARGE rests
   as one chat line at the width of SMALL, the model of the telephone's
   chat line. The line is the only child it shows, and a press on it opens
   the box. The CHAT tile turns the chat off, and this shape fades out
   (`off`, R2369). The rules
   stand after the size rules, so the peek wins over LARGE. */
#chatpeek { display: none; }
#ui #chat.box.peek { height: auto; }
#ui #chat.box.big.peek { width: 512px; }
#ui #chat.box.peek > :not(#chatpeek) { display: none; }
#ui #chat.box.peek > #chatpeek { display: block; flex: 1; min-width: 0; }
#ui #chatpeek .cl { width: 100%; margin: 0; border: 0; background: none; }
@media (max-width: 900px) {
  #ui #chat.box.big.peek { width: 280px; }
}


/* --- the console and the map buttons (R218, R1747) -------------------------

   The open console units stand on one floor with their bottom edges flush
   and pack from the left, wrapping to a row above where the next one would
   not fit. No row of toggles stands under them any more: the map buttons
   stand beside them (card 08 of mockup round 082). On a telephone the VIEW
   button stands at the right edge, over the sheet's bar and the chat band;
   on a desktop it stands on top of the chart strip at the strip's outer
   edge (R2904), and an arcade desktop stands it in the lower-left corner
   (R1935). The hold plate that stood over it
   on a telephone is gone: the rose press below is the way home (R1758).
   Every figure below comes from `ui/layout.ts`, which is the one place that knows how big each
   unit is and where the floor and the map buttons stand. Nothing here
   states a distance that belongs to another panel.

   The minimize is animation A: 140 ms on cubic-bezier(.4, 0, .2, 1),
   transform and opacity only, onto the VIEW button. It rides the separate
   `scale` property rather than `transform`, so a unit that travels in the
   chrome dock-in composes the two instead of fighting for one
   declaration. The chart cannot be a
   CSS transition at all and samples the same curve in TypeScript
   (render/minimap.ts). */

#mapbtns {
  position: absolute;
  left: var(--mapbtns-x, 12px);
  bottom: var(--mapbtns-b, 12px);
  width: var(--view-px, 48px);
  /* The box takes no press: the button in it does. */
  pointer-events: none;
}
/* A map button is round glass over the map. It states its own size, which
   `ui/layout.ts` publishes for the pointer, so the coarse floor of
   `#ui button` gives way here: both sizes hold the 40 px target. */
#mapbtns button.mb {
  pointer-events: auto;
  position: relative;
  min-height: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border-radius: 50%;
  border: 1px solid rgb(var(--accent-rgb) / 0.3);
  background: rgb(var(--deep-rgb) / 0.86);
  color: var(--accent);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
#mapbtns button.view {
  width: var(--view-px, 48px);
  height: var(--view-px, 48px);
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  line-height: 1;
}
/* The icon of card 08: 17 px on a desktop VIEW button and 19 px for a
   finger (the coarse block). */
#mapbtns .mic { display: block; flex: none; width: 17px; height: 17px; }
@media (hover: hover) {
  #mapbtns button.mb:hover { border-color: rgb(var(--accent-rgb) / 0.6); color: var(--hover-ink); }
}
/* The open VIEW panel lights the plate and puts an accent bar on its
   bottom edge, so the state reads by shape as well as by colour. No gold:
   a heatmap mode names itself in the HEAT tile. */
#mapbtns button.view.on {
  background: rgb(var(--accent-rgb) / 0.22);
  border-color: rgb(var(--accent-rgb) / 0.6);
  color: var(--hero-ink);
}
#mapbtns button.view.on::after {
  content: '';
  position: absolute;
  left: 32%;
  right: 32%;
  bottom: -1px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: var(--accent);
}
/* The light count: the unread chat lines, a capsule of the hero ink on the
   top right edge of the VIEW button and in the CHAT tile. */
#ui .lcnt {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--hero-ink);
  color: rgb(var(--deep-rgb));
  font-size: var(--t-cap-size);
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
#mapbtns .lcnt {
  position: absolute;
  top: -5px;
  right: -5px;
  box-shadow: 0 0 0 2px rgb(var(--deep-rgb) / 0.92);
}

/* The VIEW panel (R1747): the four tiles of what stands over the map, in
   the look of the QUICK row of ☸ OPTIONS (`ui/options/options.css`, the
   `.o-qt` tile). It stands over the column of the map buttons. A short
   screen over the chat band can leave it less room than its tiles
   need, so it scrolls inside the room it has, and the overlay then acts on
   the release (§16.8). */
#viewpanel {
  position: absolute;
  left: var(--mapbtns-x, 12px);
  bottom: calc(var(--mapbtns-t, 60px) + var(--mapbtns-gap, 10px));
  /* The card rung, over the context card and the peek (R1990): the card
     slot of an arcade desktop stands one gap over VIEW, and a game card
     can reach the panel's column, so a panel on the console rung opened
     under the card and its ✕. */
  z-index: 42;
  display: none;
  box-sizing: border-box;
  width: 352px;
  max-height: min(450px, calc(100vh / var(--ui-scale, 1) - var(--mapbtns-t, 60px) - var(--mapbtns-gap, 10px) - var(--topbar-h, 46px) - 8px));
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 2px 10px 10px;
  border-radius: 12px;
  border: 1px solid rgb(var(--accent-rgb) / 0.3);
  background: rgb(var(--sheet-rgb) / 0.97);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
#viewpanel.on { display: block; }
/* The arcade's mirrored desktop (R2883): VIEW stands in the lower-right
   corner of the map, so the panel stands over it from its right edge. */
#ui.mirror #viewpanel { left: auto; right: var(--mapbtns-r, 12px); }
/* The desktop VIEW of the game stands on the chart strip (R2904): at the
   right edge of the map, so the panel stands over it from its right edge,
   and at the left edge of a mirrored desktop, so the panel stands from its
   left edge there. The arcade keeps VIEW in the lower-left corner (R1935). */
#ui:not(.arcade) #viewpanel { left: auto; right: var(--mapbtns-r, 12px); }
#ui.mirror:not(.arcade) #viewpanel { left: var(--mapbtns-x, 12px); right: auto; }
#viewpanel .vp-h { display: flex; align-items: center; gap: 10px; height: 32px; padding: 0 2px; }
#viewpanel .vp-h b { font-weight: 500; font-size: var(--t-cap-size); letter-spacing: 0.18em; color: var(--accent); }
#viewpanel .vp-h i { font-style: normal; font-size: var(--t-small-size); color: var(--dim); }
/* Two ids: the kit's own tile rule carries one id and two classes. */
#ui #viewpanel .o-qt { min-height: 64px; justify-content: flex-start; gap: 2px; }
#ui #viewpanel .o-qtop { min-height: 18px; margin-bottom: 3px; }
/* A tile with no line under its name (the LAYERS tiles of the map) is
   short, so SEA VIEW HERE stands in the panel of a desktop with no scroll
   (R2564). The arcade tiles keep their line and their height. */
#ui #viewpanel .o-qt.bare { min-height: 0; }
#viewpanel .vp-sub {
  font-style: normal;
  font-size: var(--t-small-size);
  line-height: 1.2;
  color: var(--dim);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* The GO TO THE HOLD row under the tiles (R1758). It acts once and holds
   no state, so it is a row on the ground of a tile with no pill. It stands
   in every chart setting, and it is the way home while the chart is off and
   no compass rose draws. Two ids: `#ui button` carries one. The row is
   `view_row_px` of [presentation.layout] high (R2832). */
#ui #viewpanel .vp-home {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 34px;
  margin-top: 8px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid var(--edge);
  background: rgb(var(--accent-rgb) / 0.05);
  color: var(--accent);
  text-align: left;
}
#viewpanel .vp-home .mic { display: block; flex: none; width: 17px; height: 17px; }
#viewpanel .vp-home b { flex: 1; font-weight: 500; font-size: var(--t-small-size); letter-spacing: 0.12em; color: var(--text); }
#viewpanel .vp-home .vp-key { font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: 0.04em; color: var(--dim); }
@media (hover: hover) {
  #ui #viewpanel .vp-home:hover { background: rgb(var(--accent-rgb) / 0.1); }
}
/* Under a finger the lower row keeps the finger target (R2832): the press
   reaches half the difference past the painted row above and below, and
   the gap over each row is the whole difference, so two targets never
   lie on each other. */
@media (pointer: coarse) {
  #ui #viewpanel .vp-home { margin-top: calc(var(--target-finger) - 34px); }
  #ui #viewpanel .vp-home::after {
    content: '';
    position: absolute;
    inset: calc((34px - var(--target-finger)) / 2) 0;
  }
}

/* The VIEW panel grown (round 086 cards 10 and 15, R1806): the section
   heads, the line icons of the tiles, the HEAT row and the heat page. */
#viewpanel .vp-sh {
  display: flex;
  align-items: baseline;
  gap: var(--s-3);
  margin: var(--s-3) 2px var(--s-2);
}
#viewpanel .vp-sh b { font-weight: 500; font-size: var(--t-cap-size); letter-spacing: var(--t-cap-track); color: var(--dim); }
#viewpanel .vp-sh i { font-style: normal; font-size: var(--t-small-size); color: var(--dim); }
#ui #viewpanel .o-qt svg.g { display: block; flex: none; width: 18px; height: 18px; color: var(--dim); }
#ui #viewpanel .o-qt.on svg.g { color: var(--accent); }
#ui #viewpanel .vp-row,
#ui #viewpanel .vp-back {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: var(--target-mouse);
  padding: 0 var(--s-4);
  border-radius: var(--r-button);
  border: 1px solid rgb(var(--accent-rgb) / 0.25);
  background: none;
  color: var(--text);
  text-align: left;
}
#ui #viewpanel .vp-row { width: 100%; margin-top: var(--s-3); }
#viewpanel .vp-row b { flex: 1; font-weight: 500; font-size: var(--t-cap-size); letter-spacing: var(--t-cap-track); }
#viewpanel .vp-row .mic, #viewpanel .vp-back .mic { display: block; flex: none; width: 16px; height: 16px; }
#ui #viewpanel .vp-back { padding: 0 var(--s-2); border-color: transparent; color: var(--accent); }
/* The CHART reading and the CHART PIECES (round 086 card 15, R1812): the
   compact pill group of the choice kit across the panel, and the three
   groups of pieces as ticked pills that share the row (R2011). */
#ui #viewpanel .ch-pg { display: grid; width: 100%; }
#ui #viewpanel .vp-pieces > .ch-pm { display: flex; width: 100%; }
#ui #viewpanel .vp-pieces > .ch-pm > button.ch-pl { flex: 1 1 0; }
/* The heat page (round 086 card 10): the modes as the compact preview
   tiles of the choice kit, two to a row (R2011). The picture of a tile is
   the swatch of the ramp, and on a desktop the keycap of the alt digit. */
#viewpanel .vp-tp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s-2);
  min-height: 26px;
  padding: 0 var(--s-3);
}
#viewpanel .vp-sw {
  flex: 1;
  max-width: 64px;
  height: 8px;
  border-radius: var(--r-bar);
  border: 1px solid rgb(var(--text-rgb) / 0.25);
}
#viewpanel .vp-sw.x {
  border-color: rgb(var(--text-rgb) / 0.5);
  background: linear-gradient(to top right, transparent 45%, rgb(var(--text-rgb) / 0.7) 47%, rgb(var(--text-rgb) / 0.7) 53%, transparent 55%);
}
#viewpanel .vp-kc {
  flex: none;
  /* One width for every keycap, alt-1 to alt-0 (R1869). The width fits
     the longest label on one line. */
  width: 6.5ch;
  white-space: nowrap;
  box-sizing: content-box;
  padding: 0 var(--s-1);
  border-radius: var(--r-bar);
  border: 1px solid var(--edge);
  font-size: var(--t-cap-size);
  letter-spacing: 0;
  color: var(--dim);
  text-align: center;
}
/* The line under the heat tiles keeps one height in every mode (R1850):
   one line of words, cut with an ellipsis where a narrow panel cannot
   hold it, and an empty ramp under OFF. */
#viewpanel .vp-what {
  margin-top: var(--s-3);
  font-size: var(--t-small-size);
  color: var(--dim);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#viewpanel .vp-ramp.none { visibility: hidden; }
#viewpanel .vp-what b { font-weight: 500; font-size: var(--t-cap-size); letter-spacing: var(--t-cap-track); color: var(--accent); }
#viewpanel .vp-ramp {
  height: 8px;
  margin-top: var(--s-2);
  border-radius: var(--r-bar);
  border: 1px solid rgb(var(--text-rgb) / 0.3);
}
#viewpanel .vp-ends {
  display: flex;
  justify-content: space-between;
  margin-top: var(--s-1);
  font-size: var(--t-small-size);
  color: var(--dim);
}
/* The faction key section of a telephone (round 086 card 09 b): the rows
   of the legend card, as images painted once. Its head row is the fold
   control (R1859): the section folds to it by default, so the main page
   stands inside the room over the VIEW button. Two ids: `#ui button`
   carries one. */
#ui #viewpanel .vp-fold {
  align-items: center;
  width: 100%;
  min-height: var(--target-finger);
  margin: var(--s-2) 0 0;
  padding: 0 2px;
  border: 0;
  border-radius: var(--r-button);
  background: none;
  color: var(--dim);
  text-align: left;
}
#viewpanel .vp-fold .mic { display: block; flex: none; width: 12px; height: 12px; }
@media (hover: hover) {
  #ui #viewpanel .vp-fold:hover { background: rgb(var(--accent-rgb) / 0.06); }
}
#viewpanel .vp-key-rows .fk-row {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  min-height: 34px;
  font-size: var(--t-small-size);
}
#viewpanel .vp-key-rows .fk-ink { flex: none; width: 8px; height: 8px; border-radius: var(--r-bar); }
#viewpanel .vp-key-rows .fk-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
#viewpanel .vp-key-rows img { display: block; flex: none; }
/* The heat pip (round 086 card 11): the heat icon on VIEW, in the hue of
   the mode that paints, also while the legend is minimized. */
#mapbtns .vw-pip {
  position: absolute;
  bottom: -5px;
  left: -5px;
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgb(var(--deep-rgb) / 0.92);
  box-shadow: 0 0 0 1px var(--edge);
}
#mapbtns .vw-pip .pic { width: 12px; height: 12px; }

/* The chart's minimize control. The chart is a picture on the canvas, so
   the button is a DOM element over the top-right corner of the round
   unit's slot, outside the disc and the rim (§1, R1801). It does not
   travel in the chrome dock-in: it waits, out of sight, and is there when
   the chart it belongs to lands. It takes the one look of card 17 of
   mockup round 086: 24 px painted, a target of 44 px round it. */
#mapchrome {
  position: absolute;
  left: calc(var(--rose-x, 12px) + var(--rose-w, 168px));
  bottom: calc(var(--rose-b, 12px) + var(--rose-h, 168px));
  transform: translate(-100%, 100%);
  pointer-events: auto;
}
#ui #mapchrome button.min {
  position: relative;
  display: grid;
  place-items: center;
  width: var(--s-6);
  height: var(--s-6);
  min-width: 0;
  min-height: 0;
  padding: 0;
  font-size: var(--t-body-size);
  line-height: 1;
  color: var(--dim);
  border: 1px solid rgb(var(--text-rgb) / 0.22);
  border-radius: var(--r-button);
  background: rgb(var(--deep-rgb) / 0.8);
}
/* The finger target: 44 px round the painted 24 px square. */
#ui #mapchrome button.min::after {
  content: "";
  position: absolute;
  inset: calc((var(--s-6) - var(--target-finger)) / 2);
}
@media (hover: hover) {
  #ui #mapchrome button.min:hover { color: var(--accent); }
}
/* The HEAT chip (R1849, card 17 a of mockup round 086). While a heat mode
   paints, the round minimap shows the heat surface alone, and this chip
   says so: the heat icon and HEAT in the on look, at the top-left corner
   of the round unit's slot, as the minimize control stands at the
   top-right corner. It only reads, so it takes no press. */
#heatchip {
  position: absolute;
  left: var(--rose-x, 12px);
  bottom: calc(var(--rose-b, 12px) + var(--rose-h, 168px));
  transform: translateY(100%);
  pointer-events: none;
  display: none;
}
#heatchip.on { display: block; }
/* The mirrored desktop (R2883): the round unit stands at the top right, so
   the minimize control takes its top-left corner and the HEAT chip its
   top-right corner, and the rose peek opens to the left of the unit. */
#ui.mirror #mapchrome { left: var(--rose-x, 12px); transform: translate(0, 100%); }
#ui.mirror #heatchip { left: calc(var(--rose-x, 12px) + var(--rose-w, 168px)); transform: translate(-100%, 100%); }
#heatchip .hchip {
  display: inline-flex;
  align-items: center;
  gap: var(--s-2);
  height: calc(var(--s-5) + var(--s-2));
  padding: 0 6px;
  border: 1px solid rgb(var(--accent-rgb) / 0.5);
  border-radius: var(--r-button);
  background: linear-gradient(rgb(var(--accent-rgb) / 0.1), rgb(var(--accent-rgb) / 0.1)), rgb(var(--deep-rgb) / 0.88);
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--accent);
  white-space: nowrap;
}
#heatchip .pic { display: block; width: 12px; height: 12px; }

/* The rose press (R1758). The compass rose is a picture on the canvas, so
   the press that centres the map on the hold is a DOM button over the
   rose's slot (§1), as the chart's minimize control stands over the chart.
   It stands on the slot `ui/layout.ts` publishes, and only while the rose
   draws (`.on`). It draws nothing: the rose answers a press on its rim. It
   acts on the press, as fixed chrome does (§16.8), and a drag that starts
   on the map never reaches it, because the canvas holds the pointer. Two
   ids: `#ui button` carries one, and its hover must not paint the slot. */
#ui #rosepress {
  position: absolute;
  left: var(--rose-x, 12px);
  bottom: var(--rose-b, 12px);
  width: var(--rose-w, 168px);
  height: var(--rose-h, 168px);
  display: none;
  min-height: 0;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: transparent;
  pointer-events: auto;
  /* The disc of the round minimap is the canvas's (R1801): the slot less
     the disc, an even-odd path that ui/layout.ts publishes. */
  clip-path: var(--rose-clip, none);
}
#ui #rosepress.on { display: block; }
/* The rose peek (R1802, card 16 of mockup round 086): the home icon, HOME
   and the key of `home`, beside the round unit, while a pointer that can
   hover stands on the rose press. It is the press's next sibling, so the
   hover shows it without a class. */
#ui #rosepeek {
  position: absolute;
  left: calc(var(--rose-x, 12px) + var(--rose-w, 168px) + var(--s-3));
  bottom: calc(var(--rose-b, 12px) + var(--rose-h, 168px) / 2);
  transform: translateY(50%);
  display: none;
  align-items: center;
  gap: var(--s-2);
  padding: var(--s-2) var(--s-3);
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: 0.12em;
  color: var(--text);
  white-space: nowrap;
  border: 1px solid var(--edge);
  border-radius: var(--r-button);
  background: rgb(var(--deep-rgb) / 0.88);
  pointer-events: none;
}
#ui #rosepeek .mic {
  width: var(--s-5);
  height: var(--s-5);
  fill: none;
  stroke: var(--accent);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
#ui #rosepeek b { font-weight: inherit; }
#ui #rosepeek .rp-key {
  padding: 0 var(--s-2);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--dim);
  border: 1px solid rgb(var(--text-rgb) / 0.22);
  border-radius: var(--r-bar);
}
@media (hover: hover) {
  #ui #rosepress.on:hover + #rosepeek { display: flex; }
}
#ui.mirror #rosepeek { left: auto; right: calc(var(--rose-right, 12px) + var(--rose-w, 168px) + var(--s-3)); }
/* The telephone scale bar (R1801, card 05 of mockup round 086): whole
   cells next to the round unit, on its floor. ui/scalebar.ts writes the
   cells and the width, and `.on` while it stands. */
#ui #scalebar {
  position: absolute;
  left: calc(var(--rose-x, 12px) + var(--rose-w, 112px) + var(--s-3));
  bottom: var(--rose-b, 12px);
  display: none;
  align-items: center;
  gap: var(--s-2);
  height: var(--s-6);
  padding: 0 var(--s-3);
  font-size: var(--t-cap-size);
  color: var(--text);
  white-space: nowrap;
  border: 1px solid var(--edge);
  border-radius: var(--r-button);
  background: rgb(var(--deep-rgb) / 0.88);
  pointer-events: none;
}
#ui #scalebar.on { display: flex; }
#ui #scalebar.historical { font-family: var(--serif); font-style: italic; }
#ui #scalebar .sb-bar { display: flex; height: var(--s-2); }
#ui #scalebar .sb-bar i { flex: 1 1 0; background: var(--text); opacity: 0.7; }
#ui #scalebar .sb-bar i:nth-child(even) { opacity: 0.25; }

/* Animation A itself is stated at the end of the chrome dock-in block near
   the end of this file, and not here: `transition` is one property, and
   the last declaration wins. */

#ui input {
  font: inherit;
  font-size: var(--t-small-size);
  color: var(--text);
  background: rgb(var(--accent-rgb) / 0.08);
  border: 1px solid var(--edge);
  border-radius: 4px;
  padding: 2px 6px;
  margin-right: 4px;
}
/* The 90px belongs to the clan fields, which is where it was written. As a
   blanket rule on `input` it also hit #chatinput, leaving a 90px target in
   a 360px box — you could see the chat line you were trying to click and
   miss it. */
#clanname { width: 90px; }
#ui input:focus { outline: 1px solid rgb(var(--accent-rgb) / 0.5); }
/* Keyboard focus has to be visible now that the dock can be driven from the
   keyboard (R106). :focus-visible, not :focus — a mouse press must not leave
   a ring behind on every button it touches. */
#ui button:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}
/* A link and an element that a page makes focusable (the cup mark) wear
   the same ring, and a select and a textarea are fields (R1693). This
   reaches the arcade too: the lobby, the match chrome and the replay
   viewer all stand in `#ui.arcade`. */
#ui a[href]:focus-visible,
#ui [tabindex="0"]:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}
#ui select:focus-visible,
#ui textarea:focus-visible { outline: 1px solid rgb(var(--accent-rgb) / 0.5); }

/* An unread chat tab (R1798, R1800): no gold as a signal. The word takes
   the text ink and the tab carries one light count, the count of round
   080 group C (`#ui .lcount`). */
#ui #chattabs button.unread { color: var(--text); }

/* --- WAR · SOVEREIGNTY / STRUCTURES / INTEL (plan §4, R83; R95) --- */

/* A faction chip: identity is never colour alone — the chip always sits
   beside the faction's name (or a labelled figure). */
#ui .fchip {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 5px;
  vertical-align: baseline;
}

/* The window head of WAR (ui-map-interface.md §12.1, ui/siegewindow.ts):
   one block above the pills, no box of its own. Line 1 is the target and
   the countdown in the figure step, line 2 the role in the cap step and
   the two hours, line 3 the two sides near the target. A window that
   concerns the reader takes the hero ink on its figure; the window of the
   sea stays Dim and says how a window becomes the reader's. */
#ui .wh {
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
  padding: var(--s-2) 0 var(--s-3);
  margin-bottom: var(--s-2);
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.12);
}
#ui .wh-l1 { display: flex; align-items: baseline; gap: var(--s-3); min-width: 0; }
#ui .wh-t { flex: 1; min-width: 0; color: var(--text); font: var(--t-title); overflow-wrap: anywhere; }
#ui .wh-c { flex: none; color: var(--dim); font: var(--t-figure); font-variant-numeric: tabular-nums; }
#ui .wh.mine .wh-c { color: var(--hero-ink); }
#ui .wh-l2, #ui .wh-l3 {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--s-1) var(--s-3);
  color: var(--dim);
  font-size: var(--t-small-size);
  font-variant-numeric: tabular-nums;
}
#ui .wh-r, #ui .wh-l3 i {
  font-style: normal;
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
}
#ui .wh.mine .wh-r { color: var(--accent); }
#ui .wh.open .wh-r { color: var(--bad); }
#ui .wh-l3 > span { color: var(--text); }
#ui .wh-l3 i { color: var(--dim); margin-right: var(--s-1); }
#ui .wh-note { margin: 0; color: var(--dim); font-size: var(--t-small-size); max-width: 65ch; }
#ui .wh.none .wh-note { padding: 0; }
#ui .wh-acts { display: flex; gap: var(--s-2); margin-top: var(--s-1); }
#ui .wh-acts .ck-b, #ui .trs-acts .ck-b {
  display: inline-flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: var(--target-mouse);
  padding: 0 var(--s-3);
  border-radius: var(--r-button);
  color: var(--accent);
  font: var(--t-body);
  letter-spacing: 0.04em;
  background: transparent;
  border: 1px solid rgb(var(--accent-rgb) / 0.2);
}
#ui .wh-acts .ck-b.dk, #ui .trs-acts .ck-b.dk {
  flex: 1.6 1 0;
  background: rgb(var(--deep-rgb) / 0.88);
  border-color: rgb(var(--accent-rgb) / 0.34);
  font-weight: 500;
  letter-spacing: 0.1em;
}
#ui .wh-acts .ck-b:disabled { color: var(--dim); border-color: rgb(var(--text-rgb) / 0.16); cursor: default; }
@media (pointer: coarse) { #ui .wh-acts .ck-b, #ui .trs-acts .ck-b { min-height: var(--target-finger); } }
/* The SEARCH and VIEW pair of a row of WRECKS WITH CARGO (R2843, R2860):
   the presses of the SHOW and RALLY pair above, SEARCH bright and VIEW
   dark, over the cost and the press columns of the build row. Line 1
   states the take of a SEARCH after the class, in the form of a build
   price. */
#ui .row.spec.wreck .costcol { display: none; }
#ui .row.spec .trs-acts {
  grid-column: 3 / 5;
  grid-row: 1 / 3;
  display: flex;
  gap: var(--s-2);
  justify-content: flex-end;
}
#ui .row.spec .ident .take { margin-left: var(--s-2); font-size: var(--t-small-size); }
/* Donut + legend, side by side; wraps on its own at sheet width. */
#ui .sovcharts {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: center;
  padding: 4px 0;
}
#ui .sovpie { width: 116px; height: 116px; flex-shrink: 0; }
#ui .sovlegend { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
#ui .sovlegend .line { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-left: 2px; margin-left: -2px; }

/* The season line chart scales with the sheet; never wider than it. It has
 * no legend of its own (R95) — the donut's legend above keys the colours. */
#ui .sovline { width: 100%; height: auto; display: block; }
#ui .sovline + .sovaxis { padding-bottom: 6px; }
/* ECONOMY · PRODUCTION: one block per resource. The name row keeps no
 * rule of its own, and the rule stands between two blocks (R1570). */
#ui .prodgraph > .row { border-bottom: 0; }
#ui .prodgraph + .prodgraph { border-top: 1px solid rgb(var(--accent-rgb) / 0.07); }
#ui .sovaxis {
  display: flex;
  justify-content: space-between;
  color: var(--dim);
  font-size: var(--t-small-size);
  padding-bottom: 2px;
}
/* The season timelapse of WAR · SOVEREIGNTY (card 09 of mockup round 076,
   R1620, ui/timelapse/war.ts). The series wears the playhead, the part of
   the series right of it goes dark, and the transport stands under the
   axis. The legend marks the reader's own faction with the white outline
   of the timelapse legend. */
#ui h3.tlhd { display: flex; align-items: baseline; gap: 8px; }
#ui h3.tlhd .tltag { margin-left: auto; color: var(--dim); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); }
#ui .sovline .tlfuture { fill: rgb(var(--deep-rgb) / 0.55); }
#ui .sovline .tlhead { stroke: var(--hero-ink); stroke-width: 1.4; }
#ui .fchip.me { outline: 1px solid var(--hero-ink); outline-offset: 1px; }
#ui .sovlegend .line.me { color: var(--hero-ink); }
#ui .tlwar { display: flex; flex-direction: column; gap: 4px; padding: 2px 0 8px; }
#ui .tlwar:empty { display: none; }
/* The note under the transport is a sentence, so it takes the small step
   and no capitals tracking (the game critique of 2026-10-14). */
#ui .tlwar .tlnote { font-size: var(--t-small-size); color: var(--dim); }
/* The band over the map while the scrubber stands on a frame, in the
   accent of an "on" state (R1798; it was gold): it
   names the frame, and LIVE gives the map back. It stands under the top
   bar, centred over the map and clear of the dock, under the guest
   warning at 44. LIVE is fixed chrome and acts on the press (§16.8). */
#tlband {
  position: absolute;
  top: calc(var(--topbar-h, 44px) + 8px);
  left: calc(50% - var(--dock-w, 0px) / 2);
  transform: translateX(-50%);
  z-index: 43;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 4px 6px 4px 12px;
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--accent);
  border-color: rgb(var(--accent-rgb) / 0.45);
  white-space: nowrap;
  pointer-events: auto;
}
#tlband[hidden] { display: none; }
#tlband b { color: var(--hero-ink); font-weight: 400; font-variant-numeric: tabular-nums; }
#ui #tlband button {
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  padding: 1px 8px;
  color: var(--accent);
  border-color: rgb(var(--accent-rgb) / 0.45);
}
@media (pointer: coarse) {
  #ui #tlband button { min-height: 32px; min-width: 56px; }
}

/* Ledger tables: fixed numeric columns so the rows march. */
#ui .sovwho {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#ui .sovnum { width: 52px; text-align: right; flex-shrink: 0; }
#ui .row.sovhead { color: var(--dim); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); text-transform: uppercase; letter-spacing: var(--t-cap-track); }
#ui .row.sovhead span:first-child { flex: 1; }

/* The battle report's fleet table (R795, ui-map-interface.md §12). A card
   names every fleet that stood at the window, so the row is wider than the
   two-column ledger above. The table scrolls inside its own container: a
   wide row must never make the panel scroll sideways (§10). */
#ui .battletable { overflow-x: auto; }
#ui .battletable .row { min-width: 280px; }
#ui .bfleet { flex: 1; min-width: 96px; }
#ui .bwho {
  width: 76px;
  flex-shrink: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#ui .bnum { width: 44px; text-align: right; flex-shrink: 0; }
#ui .row.battlehead { color: var(--dim); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); text-transform: uppercase; letter-spacing: var(--t-cap-track); }

/* A hull class whose slot holds an installed print builds to that pattern
   rather than the default, and every BUILD spends one of its runs — so the
   row is marked. Light green is the resource palette's biomass hue
   (ui-map-interface.md §2), reused here because it is the one accent the
   map layers never claim. */
.row.spec.printed .ident .name,
.row.spec.printed > .ident > button.info { color: var(--good); }
.sub.printed { color: var(--good); opacity: 0.85; }

/* The keystone fold of the TECH tab (R2160, which supersedes the head of
   R708): the HOW IT WORKS row look under the next block, closed by
   default; open, the note and one card a branch, one of them the
   season's. The rule down the left edge groups the cards without a box
   around them. */
#ui .ksf { margin: var(--s-3) 0 var(--s-2); border-top: 1px solid rgb(var(--accent-rgb) / 0.14); }
#ui .ksf-row {
  display: flex;
  align-items: center;
  gap: var(--s-3);
  width: 100%;
  min-height: var(--target-finger);
  margin: 0;
  padding: 0;
  background: none;
  border: 0;
  color: var(--dim);
  font: var(--t-cap);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
  text-align: left;
  cursor: pointer;
}
#ui .ksf-row b { font-weight: 500; color: var(--text); }
#ui .ksf-row .ksf-n { margin-left: auto; font: var(--t-small); font-style: normal; text-transform: none; letter-spacing: 0; }
#ui .ksf .ksn { padding-top: 0; }
#ui .row.spec.keystone { border-left: 2px solid var(--faint); padding-left: 6px; }

/* --- the inbox (v12) --- */

#ui .unreaddot { color: var(--hero-ink); font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); vertical-align: 2px; }

/* ===================================================================
   Form factors. Every media query in this file lives here, in three
   blocks, because a layout you have to reassemble from five places is a
   layout nobody can check.
   =================================================================== */

/* --- narrow desktop (<=900px): a mouse, but not the room for the wide
   right column. The dock narrows and the panels beside it move. --- */

@media (max-width: 900px) {
  #dock { width: 300px; }
  /* Six menus at 11px/1px tracking still overflow a 300px dock; tighten
     the strip rather than let the row clip. The ⤢ cell left the desktop
     tab bar (R233) and gave the row 30px back, which is not enough for
     CAPTAIN at the wider tracking. The sub-menu row is the same control
     and carries the longest labels in the dock (SOVEREIGNTY,
     RECRUITMENT), so it tightens with it (R258). */
  #tabs button, #ui .subrow .sub { font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: 0; }
}

/* --- sheet form factor — keep in sync with SHEET_MQ in ui/layout.ts ---
   A phone, or a finger on a screen too short for a right-hand column.
   The dock becomes a bottom sheet, the top bar wraps edge to edge, and
   every panel that used to sit beside them stacks or centres instead.
   The two bars are measured by installLayoutVars(), which publishes
   --topbar-h and --dock-h: what a panel has to clear is not a constant
   here, because the bar wraps and the sheet expands. */

@media (max-width: 760px), ((pointer: coarse) and (max-height: 520px)) {
  /* Photo mode on the telephone (R1623, card 06): the bar spans the foot
     and wraps to two rows, the slider on a row of its own, with 44 px
     buttons. The ✕ stands alone and the hint goes. */
  #ui #photobar {
    left: var(--pad);
    right: var(--pad);
    bottom: calc(var(--pad) + var(--safe-b));
    transform: none;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  #ui #photobar button { min-height: 44px; }
  #ui #photobar .zr { flex-basis: 100%; order: -1; }
  #ui #photobar .zr input { flex: 1; width: auto; height: 30px; }
  #ui #photobar .lw { display: none; }
  #ui.photomode #photohint { display: none; }
  #ui #photosaved { left: var(--pad); right: var(--pad); }
  /* The REPORT sheet on the telephone (R1626, card 08): a sheet from the
     foot, with CANCEL and SEND at the thumb, and no fine line. It spans
     the screen from edge to edge, so its content pads the side insets: on
     a telephone on its side the island stands at a side (R1830). Beside
     the rail the sheet takes the form of the desktop card instead (round
     090 card 11 B, R1848). */
  #ui:not(.rail) #reportsheet {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    max-height: calc(100vh / var(--ui-scale, 1) - 40px);
    transform: none;
    border-bottom: 0;
    border-radius: 12px 12px 0 0;
    padding: 10px calc(14px + var(--safe-r)) calc(11px + var(--safe-b)) calc(14px + var(--safe-l));
  }
  #ui.reporting > :not(#topbar):not(#reportsheet):not(#reportscrim):not(#fatal),
  #fast-minimap.reporting { visibility: hidden; }
  #ui #reportsheet .rf button { flex: 1; min-height: 44px; }
  #reportsheet .rf .fine { display: none; }
  /* The season summary card (R1518, R1519, R2089) takes the whole
     screen, and the card fits the dynamic viewport with the bottom safe
     area, so the footer never runs under the home bar. The places, the
     duel and the bars stay side by side at a smaller size, the sections
     stack in one column, and the body scrolls under the finger. The
     footer stays on the bottom edge, in the thumb zone. A value takes the
     title step, 14 px, and a label the body step, 12 px. */
  #seasonsummary { padding: 0; align-items: stretch; }
  #seasonsummary .card {
    width: 100%;
    height: calc(100dvh / var(--ui-scale, 1));
    max-height: none;
    border-radius: 0;
    padding: calc(12px + var(--safe-t)) 16px calc(10px + var(--safe-b));
    font-size: var(--t-title-size);
  }
  #seasonsummary .bn .hero { font-size: 24px; }
  #seasonsummary .bn .kick { font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: 0.3em; margin-right: -0.3em; }
  #seasonsummary .bn .foot { font-size: var(--t-cap-size); font-weight: var(--t-cap-weight); letter-spacing: 0.22em; margin-right: -0.22em; }
  #seasonsummary .body { flex: 1; }
  #seasonsummary h3, #seasonsummary .lab, #seasonsummary .you-tag,
  #seasonsummary .pr .pk, #seasonsummary .mx .mid, #seasonsummary .more,
  #seasonsummary .gp, #seasonsummary .dl { font-size: var(--t-body-size); }
  #seasonsummary .carry .cy { grid-template-columns: 1fr; gap: 8px; }
  #seasonsummary .carry .hon { flex-direction: row; flex-wrap: wrap; align-items: baseline; gap: 4px 10px; }
  #seasonsummary .carry ul { grid-template-columns: 1fr; }
  #seasonsummary .pl { gap: 4px 10px; }
  #seasonsummary .who .nm { font-size: var(--t-title-size); }
  #seasonsummary .who .rk { font-size: 26px; }
  #seasonsummary .mx {
    grid-template-columns: auto 1fr 104px 1fr auto;
    gap: 4px 5px;
  }
  #seasonsummary .cols { grid-template-columns: 1fr; }
  /* The season timelapse (R1620): the map takes the width, the transport
     stands under it in the thumb's reach, the legend under that. */
  #seasonsummary .tlsum .tlb { flex-direction: column; gap: 6px; }
  #seasonsummary .tlsum .tlside { align-self: stretch; }
  #seasonsummary .tlsum .tlmap { width: min(100%, 300px); align-self: center; }
  #seasonsummary .tlsum .tlx { order: -1; }
  #seasonsummary .tlsum .tlticks, #seasonsummary .tlsum h3 .m { display: none; }
  /* SEASON SUMMARY on the map: the bottom centre, in the thumb zone; the
     rose of a phone stands at the left. */
  #ui #ssreopen { right: auto; left: 50%; transform: translateX(-50%); }
  /* WAR · SOVEREIGNTY: while the scrubber stands on a frame, the donut
     stands out of the way of the series and the transport (R1620). */
  #ui .sovcharts.tlframe { display: none; }
  /* The frame band and the guest warning centre on the screen: the sheet
     spans the whole width, so `--dock-w` is the screen and names no map
     beside it. A card that centres on `50% - --dock-w / 2` here centres on
     x = 0, half off the screen (R2114); the unlock card takes the same
     answer from `#unlock.sheet`, and `sheetrules.test.ts` holds every such
     card to one. */
  #tlband, #guestwarn { left: 50%; }
  #seasonsummary footer { padding-top: 8px; border-top: 1px solid var(--edge); }
  #seasonsummary footer button { flex: 1; min-width: 0; min-height: 44px; }
  #seasonsummary footer button.reg { margin-right: 0; }
  /* The thumb dock (R1749, card 01 of round 082): a bottom sheet with
     round top corners and an accent rule on its top edge. It keeps the
     panel ground and its blur at the closed height and at the rest stop,
     so the map keeps showing through (§12, R1748). */
  #dock {
    left: 0;
    right: 0;
    top: auto;
    bottom: 0;
    /* `auto` and not `100vw`: the box is `content-box`, so `100vw` put the
       1 px border past the right edge of the glass, and the sheet lost its
       right border on a telephone. `left: 0; right: 0` fill the screen with
       the border inside it, as they do for the top bar. */
    width: auto;
    max-height: calc(52vh / var(--ui-scale, 1));
    border-width: 1px 0 0;
    border-color: rgb(var(--accent-rgb) / 0.24);
    border-radius: 22px 22px 0 0;
    /* No drop shadow (DESIGN.md "The No Drop Shadow Rule", R2050): the
       accent hairline of the top edge separates the sheet from the map,
       and the inner light line stays. */
    box-shadow: inset 0 1px 0 rgb(var(--hero-ink-rgb) / 0.07);
    /* The caps and the tabs of 44 px are what the bar is measured by, so
       the dock is a size container: under 360 px of chrome width the caps
       drop their words (card 12 of round 082). */
    container-type: inline-size;
  }
  /* The sheet ground is the sheet ink of `.td-dock` of round 082
     (R1770), denser at the foot. Two ids, because `#ui .panel` sets the
     panel ground. The full sheet below keeps its own alpha. */
  #ui #dock { background: linear-gradient(180deg, rgb(var(--sheet-rgb) / 0.96), rgb(var(--sheet-rgb) / 0.99)); }
  /* The expansion is vertical only. Neither state moves an edge: the
     sheet is already `left: 0; right: 0`, and only `top` and `max-height`
     change. */
  #dock.expanded { top: var(--topbar-h, 45px); max-height: none; }
  /* The closed sheet clips nothing. Its top edge stands 4 px over the tab
     bar, and the count of the INBOX cap stands 6 px over the cap, so a
     clipping dock cut the top of the count until a focus scrolled the dock
     by the 2 px. The closed sheet holds no body that scrolls (R1748). */
  #dock.collapsed { top: auto; max-height: none; overflow: visible; }
  /* **The full sheet draws no blur** (R1748). A backdrop blur is a live
     blur of the map under it, and the browser computes it again on every
     frame the map moves, so a blur over most of the screen costs battery.
     The sheet and every panel inside it (the queue strip is a panel with a
     blur of its own) take none at the full height, and the ground covers
     the map at `[presentation.thumb_dock] full_sheet_alpha` in place of
     the panel alpha, so the map still shows through faintly and the rows
     stay legible. **No stop of the sheet draws a blur** (R1772): the
     sheet ink of R1770 covers 96 to 99 % of the map at the closed sheet
     and the rest stop as well, so the blur showed almost nothing and cost
     a live blur on every frame; `.td-dock` of round 082 draws none. The
     `#ui.sheet` outranks the blur of a dock-in look. */
  #ui.sheet #dock,
  #ui.sheet #dock .panel {
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
  #ui.sheet #dock.expanded { background: rgb(var(--sheet-rgb) / 0.9); }
  /* While a finger is on the grip the height is the drag's, and a sheet
     the finger left away from every stop keeps that height afterwards
     (R570). The two are one rule at two moments: both read `--sheet-h`,
     which ui/overlay.ts writes. `expanded`, `collapsed` and `free` are
     three answers to one question, so only one of them ever stands on the
     element — each states a `max-height` of its own. */
  #dock.dragging, #dock.free { max-height: var(--sheet-h, calc(52vh / var(--ui-scale, 1))); }
  /* **The grip stands under the setting of three heights alone** (R1748).
     The default sheet has two heights, closed and open, and a press on a
     tab is the whole of the gesture, so a grip would be a control that
     does nothing. `sheet-three` is the overlay's class for the setting. */
  #ui.sheet-three #dockgrip { display: block; }
  /* The dock head is the desktop's (R1749). A telephone stands the
     commander row in the OPTIONS menu, and the tab bar's two caps hold
     INBOX and MENU. */
  #dockhead { display: none; }
  /* The rows of the telephone dock take the desktop's order (R1749,
     R1763): the body, the peek line or the siege row, the queue strip and
     the tab bar, so the head line of the queue stands directly over the
     tab bar at every stop. */
  /* **The closed sheet keeps the queue line** (R1763, the owner's order of
     2026-10-07). §12 rules that the queue never hides. The closed sheet
     keeps the head line of the strip, QUEUE n/m with the wait and the
     jobs, or the idle words, and hides the jobs under it. The line is
     30 px at every stop, so the sheet's bar has one height (R237); the
     strip's own rules frame it. */
  #dock.collapsed #queuestrip > :not(.qline) { display: none; }
  #dock #queuestrip .qline { min-height: 30px; padding-top: 0; padding-bottom: 0; }
  /* **The strip is a box of the tab bar's width** (R1767, card 01 of round
     082). It stands 8 px in from each edge of the sheet, the inset of the
     tab bar and of the siege row, so the three rows share one width, and
     it draws its rim on all four sides on the dark ground of `.td-q`. The
     peek line draws no rule of its own here, so the strip keeps the top
     rule that a desktop gives up under the peek line; three ids outrank
     that rule. */
  #ui #dock #queuestrip {
    margin: 0 8px;
    border: 1px solid var(--edge);
    /* The box keeps the 10 px corners of `.td-q` (R1769): the square
       corners of R1767 are the desktop band's alone. */
    border-radius: 10px;
    background: rgb(var(--deep-rgb) / 0.4);
  }
  /* **The peek line stays on the closed sheet** (R1555, R1749). It is ONE
     line of 40 px over the queue line: the sea trials while they run, else
     the advisor line (the overlay draws one of the two). The line takes no
     rule of its own here, because the sheet's own edge and the queue
     strip frame it. The open rows of the sea trials stand over the line,
     so the line keeps its place, and the closed sheet hides them: a press
     on the caret opens the sheet with them. The closing line states the
     count and not the sentence here. */
  #peekline { border-top: 0; display: flex; flex-direction: column-reverse; }
  #peekline .advrow { border-bottom: 0; }
  #peekline .advice { min-height: 40px; padding: 4px 10px; }
  /* The pill takes more room inside its rim on a telephone (R1769): the
     pill of `.td-advl` sets the normal line height, and the 1 of the
     desktop pill made it tight round the word. */
  #peekline .advice .atag { padding: 4px 8px; }
  #dock.collapsed #peekline > :not(.advrow) { display: none; }
  #peekline .closing .long { display: none; }
  #peekline .closing .short { display: inline; }
  /* **The slot over the queue line** (R1753, R1763, card 16 of round 082).
     While a siege warning holds, the siege row stands where the peek line
     stands, and the peek line yields; the row stays on the closed sheet.
     While the alarm list stands, it takes the same slot and the overlay
     closes the sheet, so the list, the queue line and the tab bar are the
     dock. */
  #siegerow, #alarmlist { order: 2; }
  #dock.has-siege #peekline, #dock.has-alarms #peekline { display: none; }
  #siegerow { height: 48px; margin: 6px 8px 0; padding: 0 4px 0 2px; }
  #ui #siegerow .sg-go { height: 40px; }
  #alarmlist {
    max-height: calc(60vh / var(--ui-scale, 1));
    border-bottom: 0;
    touch-action: pan-y;
  }
  #ui #alarmlist .alb { height: 40px; }
  /* The welcome card takes the width of the screen. It stands on its
     foot, 8 px over the advisor line (R1572), and grows up to the top bar
     with its content alone (R2120): the folded card is short, so its two
     buttons stay in the thumb zone. Its body scrolls inside it. */
  #welcome {
    left: 8px; right: 8px; width: auto; top: auto; bottom: var(--welcome-b, 132px);
    max-height: calc(100vh / var(--ui-scale, 1) - var(--topbar-h, 56px) - 6px - var(--welcome-b, 132px));
    overflow: hidden; flex-direction: column;
  }
  #welcome.on { display: flex; }
  #welcome .body { flex: 1; min-height: 0; overflow: auto; }
  #welcome .lists { grid-template-columns: 1fr; }
  #welcome .foot button { flex: 1; min-height: var(--target-finger); }
  /* The sheet sizes to its content under a max-height, so a percentage
     cap on the strip resolves to nothing. Each stop therefore states the
     cap as the same share of the height it stands at (R1202). */
  #queuestrip { max-height: calc(52vh / var(--ui-scale, 1) * 0.5); }
  #dock.expanded #queuestrip { max-height: calc((100vh / var(--ui-scale, 1) - var(--topbar-h, 45px)) * 0.5); }
  #dock.dragging #queuestrip, #dock.free #queuestrip { max-height: calc(var(--sheet-h, calc(52vh / var(--ui-scale, 1))) * 0.5); }
  /* **The tab bar of the thumb dock** (R1749, card 01 of round 082): a row
     of 44 px, the INBOX cap at the left end, the six tabs with their short
     words, and the MENU cap at the right end. It is the thumb zone and the
     last thing on the glass, so it clears the home indicator and never
     sits under it. A tab is a plate with a faint rim; the open tab is lit.
     The `#dock` in the selectors outranks the coarse block's 48 px. */
  #tabs { gap: 3px; padding: 4px 8px calc(4px + var(--safe-b)); }
  #dock #tabs button {
    flex: 1;
    min-width: 0;
    min-height: 44px;
    height: 44px;
    padding: 0;
    font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
    letter-spacing: 0.04em;
    border-radius: 9px;
    border-color: rgb(var(--accent-rgb) / 0.14);
    background: rgb(var(--accent-rgb) / 0.05);
    color: var(--text);
  }
  #dock #tabs button.active {
    background: rgb(var(--accent-rgb) / 0.2);
    border-color: rgb(var(--accent-rgb) / 0.42);
    color: var(--accent);
  }
  /* A tab word never touches its plate (R2206): the six tabs share the bar
     evenly while each word fits with 3 px on each side, and a longer word
     (ZEICHN, FLOTTE) takes its room from the shorter ones. 4 px overfills
     the bar of German on a 375 px telephone. */
  #dock #tabs button:not(.cap) { flex: 1 1 0; min-width: max-content; padding: 0 3px; }
  /* The glyphs of the telephone bar (R2214, R2215): under GLYPH, the
     default, each tab shows its glyph alone. Under GLYPH + WORD the glyph
     stands over the short word at the cap size, and `fitTabs` gives the
     tab with the longest word the class `g` while the bar does not fit
     (round 102 card 17). No tab word takes a smaller size (R231). */
  #dock #tabs button.gt { flex-direction: column; gap: 3px; }
  #dock #tabs button.gt.g { min-width: 0; }
  #dock #tabs button.gt .tgl { width: 18px; height: 18px; }
  #dock #tabs button.gt.g .tgl { width: 22px; height: 22px; }
  /* Under GLYPH the INBOX and MENU caps keep their icon and drop their
     word at every width, 40 px wide, so the bar is one family. */
  #dock #tabs.tg-glyph button.cap { flex-basis: 40px; gap: 0; }
  #tabs.tg-glyph .cap .cw { display: none; }
  /* The two caps wear the dark ink of LEAVE TO THE HUB (R1740): no ground
     of their own, a faint accent edge and the accent words, the icon over
     the word. A cap whose panel stands is lit, with an accent bar on its
     top edge, so OPEN reads by shape as well as by ink. */
  #dock #tabs button.cap {
    position: relative;
    flex: 0 0 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border-radius: 12px;
    border-color: rgb(var(--accent-rgb) / 0.24);
    background: transparent;
    color: var(--accent);
    font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
    line-height: 1;
    letter-spacing: var(--t-cap-track);
  }
  #dock #tabs button.cap:first-child { margin-right: 3px; }
  #dock #tabs button.cap:last-child { margin-left: 3px; }
  #dock #tabs button.cap.on {
    background: rgb(var(--accent-rgb) / 0.22);
    border-color: rgb(var(--accent-rgb) / 0.55);
    color: var(--hero-ink);
  }
  #dock #tabs button.cap.on::before {
    content: '';
    position: absolute;
    left: 13px;
    right: 13px;
    top: -1px;
    height: 3px;
    border-radius: 0 0 3px 3px;
    background: var(--accent);
  }
  /* **Under the OPTIONS menu the sheet draws no box** (R1769, the owner's
     eye test of 2026-10-07, cards 02 and 13 of round 082): the menu meets
     the tab bar on one flat surface. The sheet drops its rim, its round
     top corners and its shadow, and it clips nothing, so the count of the
     INBOX cap shows whole, as on the closed sheet (R1748). The tabs and
     the caps keep their own rims. */
  #dock.menu-over {
    border-color: transparent;
    border-radius: 0;
    box-shadow: none;
    overflow: visible;
  }
  /* The menu ends at the measured top of the tab bar (`--tabs-h`) and
     stands over the dock, so it covered the 2 px of the INBOX count that
     stand over the bar. Under the menu the bar takes 4 px more at its top
     (R1772): the count stands inside the bar, and the menu ends 4 px
     higher. The buttons keep their place, because the bar stands on the
     bottom edge. */
  #dock.menu-over #tabs { padding-top: 8px; }
  /* **The sub-menu buttons take the height of the tabs** (R1769): the sub-menu row
     of a menu and the tab bar are the same control one level apart, so
     both rows stand 44 px high. Two ids outrank the coarse block's 48 px. */
  #ui #tabbody .subrow .sub { min-height: 44px; height: 44px; }
  #tabs .cap .lcount { position: absolute; top: -6px; right: -5px; }
  #tabs .cap .ldot { position: absolute; top: 6px; right: 9px; }
  #tabs .cap .ctag { position: absolute; top: -8px; left: -4px; margin: 0; }
  /* On a narrow chrome (a small telephone, or a UI scale of 120 % and
     more) the caps keep their icons and their counts and drop their words,
     and narrow to 40 px, so the six tab words still fit (card 12). */
  @container (max-width: 359px) {
    #dock #tabs button.cap { flex-basis: 40px; gap: 0; }
    #tabs .cap .cw { display: none; }
    #dock #tabs button { letter-spacing: 0; }
    /* A tab word keeps 2 px on each side here (R2206): 3 px overfills the
       bar of German at 120 % on a 390 px telephone. */
    #dock #tabs button:not(.cap) { padding: 0 2px; }
    /* The name of a build row takes the cost column on line 1 (R2205): the
       cost and its time stand side by side at the end of line 2, so a
       German name keeps its letters and the row keeps its two lines. A
       row whose cost column holds a stock bar or a field keeps its shape,
       and so does a row that wraps its name or its reason (R2160, R2061). */
    #ui .row.spec:not(.obj, .rwrap, .nwrap):not(:has(> .costcol :is(.sbar, input))) > .ident { grid-column: 2 / 4; }
    #ui .row.spec:not(.obj, .rwrap, .nwrap):not(:has(> .costcol :is(.sbar, input))) > .costcol {
      grid-row: 2;
      flex-direction: row;
      justify-content: flex-end;
      align-items: baseline;
      gap: var(--s-2);
    }
  }
  /* At a UI scale of 140 % on a telephone the chrome is under 300 px wide
     (R2205): the caps narrow to 32 px (45 px on the glass) and the bar
     takes 2 px gaps, so the six German words fit on one line. */
  @container (max-width: 299px) {
    #tabs { gap: 2px; padding-left: 6px; padding-right: 6px; }
    #dock #tabs button.cap { flex-basis: 32px; }
    #dock #tabs button.cap:first-child { margin-right: 0; }
    #dock #tabs button.cap:last-child { margin-left: 0; }
    #dock #tabs.tg-glyph button.cap { flex-basis: 32px; }
    #dock #tabs button.gt.g .tgl { width: 18px; height: 18px; }
  }
  /* Under 320 px of chrome width (120 % on a 375 px telephone, 140 % on a
     390 px one) the bar takes 2 px gaps (R2206). The caps keep 40 px down
     to 300 px, so they stay a touch target. A tab word keeps the cap size:
     under GLYPH + WORD a word that does not fit leaves its tab to the
     glyph (R2215). */
  @container (max-width: 319px) {
    #tabs { gap: 2px; }
  }

  /* **The anchored sub-menu row keeps to one line here**, and R258 is
     what holds it there. The row no longer scrolls away, so its height is
     paid for the whole time the menu is open, and a sheet at 52vh of a
     360 px telephone has about 320 px of body under the grip, the queue
     strip and the tab bar. Two lines of buttons took 94 px of that.

     The sub-menu button is the tab bar's button now: `flex: 1`, and 2 px of
     horizontal padding. The row is therefore already at its narrowest and
     it divides the width it is given, exactly as the tab bar above it
     does. The four buttons of CAPTAIN and the four of WAR measure one line
     on a 360 px screen at the 10 px tracking-free type this width also
     takes. The rounded pill's 12 px of coarse padding, which is what made
     them wrap to two lines, went with the rounded pill, so this block
     states no padding of its own any more. Height is what a finger needs,
     and the coarse floor below is the one rule that states it. */

  /* **The readout line spans the screen in ONE row of 44 px** (R1749,
     card 01 of mockup round 082). It holds the five commodities with their
     gauges, the Data Core and the time cell, and no control besides: the
     identity left the telephone chrome for the session block of the
     OPTIONS menu, and INBOX and MENU stand on the caps of the tab bar. The
     cells spread across the width, the rates hide, and the time cell
     stacks the most urgent timer under the clock. The line starts at the
     top edge and pads the safe area: iOS 26 blurs the top edge of a
     home-screen web app unless a fixed box covers it, so the line must not
     start under the inset (R1728). The line is a size container, so a
     narrow chrome (a UI scale of 120 % and more) drops the clock glyph and
     the timer's word and keeps the timer's own glyph and its figure (card
     12). */
  #topbar {
    left: 0;
    right: 0;
    --rest: translateX(0);
    height: auto;
    justify-content: space-evenly;
    padding: var(--safe-t) 8px 0;
    container-type: inline-size;
  }
  /* The ground of `.td-top.td-ph` of round 082 (R1770), with the page
     ink at the top edge (R1772): iOS paints the status band in the page
     ink (`theme-color`, R1730), and the deep ink of the mockup stood
     darker than the band at the owner's eye test. The line runs from the
     solid ink at the top edge to the panel ink at the foot, over the map. */
  #ui #topbar {
    border-width: 0 0 1px;
    border-radius: 0;
    background: linear-gradient(180deg, rgb(var(--ink-rgb)), rgb(var(--panel-rgb) / 0.97));
  }
  #topbar svg.ri { width: 12px; height: 12px; }
  /* The cells and the clock are siblings of one row, so the free width falls
     in equal gaps between all of them and at both ends. */
  #topbar .rl-res { display: contents; }
  #topbar .rl-dv,
  #topbar .wide,
  #topbar .res .rate { display: none; }
  #topbar .narrow { display: inline; }
  #ui #topbar button.res {
    min-width: 30px;
    padding: 0;
    justify-content: center;
    gap: 3px;
    font-size: var(--t-readout-phone-size);
  }
  #topbar .res .gauge { left: 15px; right: 0; }
  #ui #topbar button.clock {
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 4px;
    padding: 0;
    font-size: var(--t-readout-phone-size);
  }
  #topbar .clock.two .rl-ck { font-size: var(--t-small-size); }
  #topbar .clock .rl-ck { gap: 4px; }
  #topbar .tline {
    gap: 4px;
    padding-left: 0;
    border-left: 0;
    font-size: var(--t-readout-timer-phone-size);
    line-height: 1;
    letter-spacing: 0.044em;
  }
  #topbar .tline b { font-size: var(--t-readout-timer-phone-size); letter-spacing: 0.044em; }
  @container (max-width: 339px) {
    #topbar .clock .cg, #topbar .tline .tw { display: none; }
    #topbar .tline .tg { display: inline; }
  }
  /* The marks key is a sheet at the bottom here (round 075 card 17), over
     the dock, one edge margin off the edges (R1765). */
  #squadkey {
    left: var(--pad);
    right: var(--pad);
    top: auto;
    bottom: calc(var(--pad) + var(--safe-b));
    width: auto;
  }
  /* The roster card has no chip here: it stands over the tab bar, one
     edge margin off the edges, so MENU and the tabs stay in reach (R2448). */
  #squadcard {
    left: var(--pad);
    right: var(--pad);
    bottom: calc(var(--tabs-h) + var(--pad));
    width: auto;
  }

  /* **The chat band** (R1799, card 05 b of round 087). A press on the chat
     line or on the CHAT tile of VIEW opens the chat at one fixed height
     over the tab bar, sized to its parts: the head with ▾, the channel
     tabs, `chat_band_lines` lines of the log and the input. It is no stop
     of the sheet and nothing drags it, so the grip of the desktop pane
     stands hidden. The map stays above it, and the queue line stays under
     it (R1763). While the keyboard stands, the band sits on the keyboard
     with `chat_band_keyboard_lines` lines and the input; `--kb-b` is the
     keyboard's height, which the overlay reads off the visual viewport. */
  #chat { padding: var(--s-2) var(--s-3) 0; border-top: 0; background: none; }
  #dock.chatband #chat { display: flex; }
  #dock.chatband #peekline, #dock.chatband #chatline, #dock.chatband #alarmlist { display: none; }
  #dock.chatband #chatlog { flex: none; height: calc(var(--chat-lines, 6) * 1lh); }
  #chathead { height: 36px; }
  #chathead .cgrip { visibility: hidden; cursor: default; }
  /* The band of a telephone takes no desktop chat setting (R1838). */
  #ui #dock #chathead .cundock { display: none; }
  #ui #chatin .cquick { width: var(--target-finger); height: var(--target-finger); }
  #ui #chatin .csend { height: var(--target-finger); }
  #chatinput { height: var(--target-finger); }
  #dock.kb { bottom: var(--kb-b, 0px); }
  #dock.kb #tabs, #dock.kb #chathead, #dock.kb #queuestrip, #dock.kb #siegerow { display: none; }
  #dock.kb #chatin { padding-bottom: var(--s-3); }
  /* The chat line takes the slot of the peek line (R1799): 40 px over the
     queue line, in the inset of the tab bar. */
  #ui #chatline .cl { height: 40px; margin: var(--s-2) var(--s-3) 0; width: calc(100% - 2 * var(--s-3)); }
  /* The words of the line take two lines of the 40 px (R2061): one line
     hid 209 px of a FACTION line at 390 px. A chat line is free text, so
     a longer one loses its tail at the end of the second line. */
  #chatline .tx {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    overflow-wrap: break-word;
    line-height: 1.3;
  }
  #dock.has-siege #chatline, #dock.has-alarms #chatline { display: none; }
  /* The stacking of the bottom corner (R237, R1822). The console holds one
     place for the whole of a session and the sheet is drawn over it: the
     console rung stands under the dock rung, so a raised sheet covers the
     console, and the context sheet on the card rung stands over both. The
     notices on the lane rung stand over the open sheet, so a refusal (a
     missing requirement) stays in view while the BUILD list fills the
     screen; the explainer cards and the OPTIONS menu still stand over
     them (R1753). The ladder states it once, outside this block. */
  /* The VIEW button stands at the right edge (R1747). The panel stands
     over it, right-aligned to it, and takes the width of card 08. */
  /* The bound of `view_panel_max_px` is a desktop figure: on a telephone
     the panel takes the room over the VIEW button, so the main page with
     the folded key section does not scroll (R1859). */
  #viewpanel {
    left: auto;
    right: var(--mapbtns-r, 12px);
    width: min(270px, 100vw / var(--ui-scale, 1) - 24px);
    max-height: calc(100vh / var(--ui-scale, 1) - var(--mapbtns-t, 60px) - var(--mapbtns-gap, 10px) - var(--topbar-h, 46px) - 8px);
  }
  /* The chart furniture's cards stand behind all of the chrome on a phone
     (owner, 2026-10-04): the faction key is five rows tall, and it once
     covered the map buttons, the chart and the chat. A card is decoration,
     so every control wins the glass; the furniture rung of the ladder
     states it on both form factors (R1822). */

  /* **The context sheet** (§12.0, R1818, round 083 card 13, round 087
     card 01). The card of a thing stands over the sheet's bar (the tab
     bar, the queue line and the siege row while one holds), `--ctx-l` in
     from each side and over the bar, so the tab bar stays in view under
     it. `ui/layout.ts` publishes the anchor, and the console stands on the
     closed sheet. The raised sheet takes at most 45 vh for a
     map object and 55 vh for a catalogue card (round 083
     open point 3), and it stands over the console. The fleet window of
     R836 is gone: a fleet takes the same sheet as every other thing. */
  #ui .ctxcard {
    left: var(--ctx-l);
    right: var(--ctx-l);
    width: auto;
    bottom: var(--ctx-b);
    --ctx-maxh: calc(45vh / var(--ui-scale, 1));
  }
  #ui .ctxcard.cat { --ctx-maxh: calc(55vh / var(--ui-scale, 1)); }
  #ui .ctxcard > .ck {
    border-radius: var(--r-sheet) var(--r-sheet) var(--r-card) var(--r-card);
  }
  /* The bar of the grab handle (R2008): the sheet follows a drag on the
     handle, the line or the head, and commits at `ctx_swipe_px`. */
  #ui .ctxcard > .ck::before {
    content: "";
    display: block;
    flex: none;
    width: 38px;
    height: 4px;
    margin: 6px auto 0;
    border-radius: var(--r-bar);
    background: rgb(var(--text-rgb) / 0.3);
  }
  /* The keyboard of a telephone rises over the foot of the screen, so the
     rename card stands on it while its box holds the focus. */
  #ui #renamecard { bottom: max(var(--ctx-b), calc(var(--kb-b, 0px) + var(--ctx-l))); }
  /* While the context sheet stands over the bar, the peek line and the
     chat line yield their slot to it; the siege row keeps it, and the
     sheet stands on the siege row (R1753). Beside the rail a card at the
     right edge leaves the slot line in place (`ctx-beside`, round 090
     card 04 B, R1848). */
  #ui.ctx-on:not(.ctx-beside) #peekline, #ui.ctx-on:not(.ctx-beside) #chatline { display: none; }
  /* The head of a menu sheet while a selection stands (087 card 01): the
     selection chip under TWO, the fold under THREE at the rest stop. */
  #ui.sheet #selhead:not(:empty) {
    display: flex;
    align-items: center;
    gap: var(--s-3);
    flex-shrink: 0;
    order: 0;
    padding: var(--s-2) var(--s-3) 0;
  }
  #ui #selhead > .ck.cs-fold { flex: 1; min-width: 0; }

  /* The drain runs the whole width of the bar here as well (R430): 8 px is
     the bar's own padding in this form factor, so the line keeps to it. The
     two need no `--topbar-h`, because they ride inside the bar.

     The toasts keep the right edge, under the tab, and the readouts under
     the bar follow the bar's measured height — it is two or three rows
     tall here. */
  #truce, #link { left: 0; right: 0; }
  /* The notices of the alarm screen (R1753, card 16 of round 082): two
     lines at most, at the right directly under the readout line, the
     older one faded. The timer stands in the time cell, so no tab hangs
     under the line. The lane stands one gap under the readout line
     (`--lane-t`, round 083 card 16, R1819). */
  /* The report card keeps the top of the screen here, under the readout
     line, so the keyboard that rises from the bottom leaves its note box
     in view (R1323, R1819). */
  #reportcard { top: var(--lane-t); transform: translateX(-50%); }
  #notices {
    right: var(--pad);
    top: var(--lane-t);
    max-width: calc(100vw / var(--ui-scale, 1) - 2 * var(--pad));
  }
  #stats { top: calc(var(--topbar-h, 56px) + 6px); }

  /* The five alternative notices looks in the sheet form factor (R824,
     mockup round twenty-four, the phone 390 stages). Every placement under
     the bar follows the bar's own measured height, because the bar is two
     or three rows tall here. The two looks that keep a WIDE CENTRED timer
     — `ledger` and `bare-type` — cover the dev stats line at 390 px, so
     they move that line to the foot of the screen. The owner's eye test
     rules on that placement. */
  #ui.theme-notices-ledger #notices {
    left: var(--pad);
    right: auto;
    width: calc(100vw / var(--ui-scale, 1) - 2 * var(--pad));
    max-width: calc(100vw / var(--ui-scale, 1) - 2 * var(--pad));
    top: calc(var(--topbar-h, 56px) + 36px);
  }
  #ui.theme-notices-ledger #stats { top: auto; bottom: var(--pad); }
  #ui.theme-notices-split-lane #notices {
    left: var(--pad);
    right: var(--pad);
    top: calc(var(--topbar-h, 56px) + 4px);
    padding: 0 8px;
    width: auto;
    max-width: none;
    margin-inline: 0;
  }
  #ui.theme-notices-split-lane #notices .nt { flex: 1; }
  /* The strip spans the screen here, so the cell has a width to truncate
     against. On a desktop the strip is `width: max-content` and a cap on
     the line would collapse the cell it is measured from. */
  #ui.theme-notices-split-lane #notices .notice {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #ui.theme-notices-split-lane #stats { top: calc(var(--topbar-h, 56px) + 34px); }
  #ui.theme-notices-under-clock :is(#truce, #link) { left: auto; right: 8px; }
  #ui.theme-notices-under-clock #notices {
    top: calc(var(--topbar-h, 56px) + 26px);
    max-width: calc(100vw / var(--ui-scale, 1) - 16px);
  }
  /* The ribbon keeps the short name of the clock, drops the reason and
     truncates the line; the stats stand under it. The three panels it
     moves on a desktop keep the sheet placement they have here, so each
     one is restated. */
  #ui.theme-notices-ribbon #notices {
    top: var(--topbar-h, 56px);
    max-width: none;
  }
  #ui.theme-notices-ribbon #notices .nt { left: 8px; max-width: calc(100% - 130px); }
  #ui.theme-notices-ribbon #notices .more { left: 8px; }
  #ui.theme-notices-ribbon #notices .tm { right: 8px; }
  #ui.theme-notices-ribbon :is(#truce, #link) .tab .lg { display: none; }
  #ui.theme-notices-ribbon :is(#truce, #link) .tab .sm { display: inline; }
  #ui.theme-notices-ribbon :is(#truce, #link) .tab .d { display: none; }
  #ui.theme-notices-ribbon #stats { top: calc(var(--topbar-h, 56px) + 44px); }
  #ui.theme-notices-ribbon #dock { top: auto; }
  #ui.theme-notices-ribbon #dock.expanded { top: var(--topbar-h, 56px); }
  #ui.theme-notices-ribbon #dock.collapsed { top: auto; }
  #ui.theme-notices-bare-type #notices {
    top: calc(var(--topbar-h, 56px) + 54px);
    max-width: calc(100vw / var(--ui-scale, 1) - 16px);
  }
  #ui.theme-notices-bare-type :is(#truce, #link) { max-width: calc(100vw / var(--ui-scale, 1) - 16px); }
  #ui.theme-notices-bare-type :is(#truce, #link) .tab {
    white-space: normal;
    text-align: center;
  }
  #ui.theme-notices-bare-type #stats { top: auto; bottom: var(--pad); }
  /* Nothing in the chrome may be wider than the screen (R233). The legend
     is the one panel with a literal width that the sheet block never
     overrode, and the cap under it answers for every panel at once. */
  #ui .panel { max-width: calc(100vw / var(--ui-scale, 1)); }
  #admin .arow { flex-wrap: wrap; }
}

/* The hover of each press whose rest rule outranks the hover of `#ui
   button` (R2011, ui-map-interface.md §18.4): every press shows a change
   under a mouse. A press that paints a light ground at rest takes a
   brighter edge or a brighter ground. */
@media (hover: hover) {
  #ui #siegerow .sg-open:hover { background: rgb(var(--hero-ink-rgb) / 0.08); }
  #ui #alarmlist .alx:hover { background: rgb(var(--accent-rgb) / 0.14); color: var(--hover-ink); }
  #ui #dockhead .dh-chip:hover, #ui #dockhead button.sq:hover { border-color: rgb(var(--accent-rgb) / 0.5); background: rgb(var(--accent-rgb) / 0.14); }
  #ui:not(.alarm-on) #dockhead .dh-rst:hover { background: var(--hover-ink); }
  #ui.alarm-on #dockhead .dh-rst:hover { background: rgb(var(--accent-rgb) / 0.14); }
  #ui :is(#chatline, #chatpeek) .cl:hover { border-color: rgb(var(--accent-rgb) / 0.4); background: rgb(var(--accent-rgb) / 0.1); }
  #ui #viewpanel .vp-row:hover, #ui #viewpanel .vp-back:hover { background: rgb(var(--accent-rgb) / 0.1); color: var(--hover-ink); }
  #ui .row.spec .bp:hover:not(:disabled) { border-color: rgb(var(--accent-rgb) / 0.7); }
  #ui .row.spec .rmore:hover:not(.on) { background: rgb(var(--accent-rgb) / 0.1); }
  #ui .ctxcard > .cs-grab:hover { background: rgb(var(--accent-rgb) / 0.06); }
  #peekline .tcount:hover { color: var(--hover-ink); }
}

/* --- coarse pointer: a finger, at any size. Targets only — nothing here
   moves a position, so a touch laptop keeps the desktop layout and gets
   the bigger controls (mobile is a target platform). --- */

@media (pointer: coarse) {
  #ui button { min-height: 40px; }
  #tabs button { min-height: 48px; }
  /* **The readout line is the one exception to the floor above** (R233,
     R1749). Its cells and its clock are 44 px tall by their own rule, and a
     floor of the button would only stretch the line. */
  #topbar button.res, #topbar button.clock { min-height: 0; }
  /* The squad chip keeps the pill of the dock head (R1571, R1749). */
  #dockhead button.sq { min-height: 0; }
  #ui #chattabs button { min-height: 40px; }
  /* The sub-menu row takes the tab bar's target, because R258 made it the
     tab bar's control. The old rule asked for 36 px and never got it: at
     one class more than `#ui button` it lost to that rule's 40 px, so the
     row has stood at 40 px for as long as both rules have. The id in this
     selector is what makes the figure the one that applies. */
  #ui .subrow .sub { min-height: 48px; }
  #queuestrip .qline { min-height: 40px; }
  /* The name of a spec row is a button, so the floor above makes it 40 px
     tall. A row of 44 px holds the name line to 28 px and the text stands
     8 px over line 2. A LOCKED row (`rwrap`) grows to its content, so the
     name line took the whole 40 px and line 2 stood 14 px under the name.
     The margin gives 6 px back over and under the name, so the LOCKED row
     reads with the spacing of a BUILD row, and the name keeps its 40 px
     target (the owner, 2026-10-14, R2161). A keystone card wraps its
     name (`nwrap`) and keeps its own spacing. */
  #ui .row.spec.rwrap:not(.nwrap) .ident { margin-block: -6px; }
  /* The fold caret of the advisor line takes a thumb's width (R1423). */
  #peekline .afold { min-width: 40px; }
  /* The count of the sea trials takes a finger's square (R2131). */
  #peekline .tcount { min-width: 44px; min-height: 44px; }
  /* The peek line is a row with a control of its own, and on the closed
     sheet it is the one control over the tab bar, so it takes the 40 px
     touch floor (R257, R1555, R1749). It takes them at every stop, so the
     sheet's bar has one height and the console does not move. */
  #peekline .advice { min-height: 40px; }
  /* A term button keeps the height of its line, and a transparent box
     takes the finger: the 40 px floor, up and down only (R1557). */
  #ui button.term::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 40px;
    transform: translateY(-50%);
  }

  /* --- the console's own targets (R218) ---
     The VIEW button states its own size (R1747): `viewPx()` in
     ui/layout.ts gives it 52 px for a finger, so it needs no floor above.
     The rose press is the rose's slot, 90 px on the sheet (R1758). The
     icon of the larger VIEW button grows with it. */
  #mapbtns button.view .mic { width: 19px; height: 19px; }
}
/* --- the landing screen (ui/landing.ts; mockup round fifteen A, "Twin
   Consoles"; R229) ---

   It lives outside `#ui`, because it is up before the canvas and the dock
   exist. The palette and the type are the dock's (ui-map-interface.md §2).

   The layout is one column of three parts: a brand bar, the stage, and the
   footer. The stage is a grid. On a wide screen it is two consoles and the
   account rail; on a telephone the same three blocks stack, and the rail
   becomes the sheet at the foot of the page. Nothing is positioned
   absolutely, so the page grows with its own content and scrolls when it
   has to. --- */

#landing {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-family: var(--mono);
  font-size: var(--t-body-size);
  line-height: 1.5;
  color: var(--text);
  background:
    radial-gradient(120% 90% at 50% 0%, rgb(var(--accent-rgb) / 0.1), transparent 60%),
    rgb(var(--ink-rgb));
  -webkit-text-size-adjust: 100%;

  /* The type floor of the hub (R1739, R2150), on the landing too. Each
     Cap size of this block reads `max(var(--type-floor), …)`. At rest the
     floor is under the Cap step, so a mouse sees no change; the
     `(pointer: coarse)` block after the telephone block raises it to
     11 px. */
  --type-floor: 9px;
}

#landing * { box-sizing: border-box; }

/* --- the desktop frame (R229) -----------------------------------------
   The landing stops growing on a wide screen for the reason the hub does:
   two consoles stretched over a 27-inch monitor put the account rail an
   arm away from them. It caps at 1280x900, centres, and keeps a gutter.
   A telephone keeps the full bleed. */
@media (min-width: 901px) {
  #landing {
    margin: auto;
    max-width: min(1280px, calc(100vw / var(--ui-scale, 1) - 48px));
    max-height: min(var(--wide-px), calc(100vh / var(--ui-scale, 1) - 48px));
    border: 1px solid var(--edge);
    border-radius: 12px;
  }
}

/* The surround of a framed menu. It is one step deeper than the sheet, so
   the gutter reads as room and not as an unpainted edge. `:has` scopes it
   to the two screens that frame themselves; the game itself keeps the
   plain ground, because the canvas covers it. It reads `--deep-rgb`, so a
   theme recolours it with the sheet. */
@media (min-width: 901px) {
  body:has(> #landing),
  body:has(> #hub) { background: rgb(var(--deep-rgb)); }
}

/* --- the brand bar --- */

#landing .bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: none;
  padding: 14px 22px;
}
/* The sign and the name are the header lockup (brand.md §2, R1645; mockup
   round 079, card 16). Every length is a fraction of the sign box
   `--lockup-h`: the name has a cap height of `cap` of the box, stands
   `gap` of the box after it, and carries no tracking after its last
   letter. With a line height of 1, the face's own metrics put the middle
   of the cap height on the middle of the box. The tag line hangs under
   the name, out of the flow, so it does not move the name off that line;
   it keeps its own type. */
#landing .mark {
  --lockup-h: 22px;
  display: flex;
  align-items: center;
  gap: calc(var(--lockup-h) * 0.25);
}
#landing .glyph { width: var(--lockup-h); height: var(--lockup-h); flex: none; }
#landing .words { position: relative; }
#landing .name {
  font: 500 calc(var(--lockup-h) * 0.6027) / 1 "Aqua Lockup", var(--mono);
  letter-spacing: 0.3em;
  margin-right: -0.3em;
  color: var(--game-bright);
  white-space: nowrap;
}
#landing .tag {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 3px;
  font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight);
  line-height: 1.2;
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
  white-space: nowrap;
}
#landing .rt { display: flex; gap: 16px; font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }

/* --- the stage --- */

#landing .stage {
  /* `flex: 1 1 auto` and a `min-content` floor, not `flex: 1` with a zero
     one. The shorthand's 0% basis and a zero floor together let the grid
     shrink under its own consoles, and a grid whose overflow is visible
     then paints them straight over the footer instead of scrolling. The
     screen carries `overflow-y: auto` for exactly this case. */
  flex: 1 1 auto;
  display: grid;
  gap: 16px;
  padding: 0 22px 18px;
  grid-template-columns: 1fr 1fr 292px;
  align-items: stretch;
  /* `min-content` and not 0. A zero floor is what lets the grid shrink
     under the consoles; the stage still grows to fill a tall screen. */
  min-height: min-content;
}

/* --- a console --- */

#landing .console {
  display: flex;
  flex-direction: column;
  min-height: 340px;
  overflow: hidden;
  border: 1px solid var(--edge);
  border-radius: 10px;
  background: var(--console-ground);
  cursor: pointer;
  transition: border-color 180ms ease;
}
#landing .console.shut { cursor: default; }
#landing .console .screen { position: relative; flex: 1; min-height: 160px; overflow: hidden; }
/* The mode reel fills the screen and crops to it (R1535). */
#landing .console .screen video.reel {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  pointer-events: none;
}
#landing .console .scrim {
  position: absolute;
  inset: 0;
  z-index: 2;
  background: linear-gradient(180deg,
    rgb(var(--deep-rgb) / 0.9) 0%, rgb(var(--deep-rgb) / 0.62) 22%, rgb(var(--deep-rgb) / 0.06) 46%,
    rgb(var(--deep-rgb) / 0) 72%, rgb(var(--deep-rgb) / 0.3) 100%);
}
/* The diagonal of round fourteen survives as the cut across each screen,
   and nowhere else on the page. */
#landing .console .cut {
  position: absolute;
  left: -10%;
  top: 52%;
  width: 120%;
  height: 1px;
  z-index: 2;
  transform-origin: 50% 50%;
}
#landing .console.arc .cut { transform: rotate(-3deg); background: linear-gradient(90deg, transparent, rgb(var(--amber-rgb) / 0.5), transparent); }
#landing .console.con .cut { transform: rotate(3deg); background: linear-gradient(90deg, transparent, rgb(var(--accent-rgb) / 0.5), transparent); }

#landing .console .head { position: relative; z-index: 3; padding: 14px 16px 0; }
#landing .console .kick { font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }
#landing .console .nm { margin: 3px 0 5px; font-size: 30px; letter-spacing: 0.27em; }
#landing .console .bl { max-width: 42ch; font-size: var(--t-small-size); line-height: 1.55; color: var(--dim); }

#landing .console .deck {
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px 14px;
  border-top: 1px solid rgb(var(--accent-rgb) / 0.14);
  background: rgb(var(--ink-rgb) / var(--panel-alpha));
}
#landing .console .reads { display: flex; }
#landing .console .reads .r { flex: 1; min-width: 0; display: flex; flex-direction: column; padding-right: 10px; border-right: 1px solid rgb(var(--accent-rgb) / 0.12); }
#landing .console .reads .r:last-child { border-right: 0; padding-right: 0; }
#landing .console .reads .r + .r { padding-left: 8px; }
#landing .console .reads .k { font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }
/* A wrapped label pushes no value down: each value stands at the foot of its cell. */
#landing .console .reads .v { margin-top: auto; padding-top: 2px; font-size: var(--t-title-size); font-weight: var(--t-title-weight); letter-spacing: 0.07em; font-variant-numeric: tabular-nums; }

#landing .console .cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 46px;
  font: inherit;
  font-size: var(--t-body-size);
  letter-spacing: 0.33em;
  border-radius: 4px;
  cursor: pointer;
}
#landing .console .cta:disabled { opacity: 0.45; cursor: not-allowed; }

#landing .console.arc { border-color: rgb(var(--amber-rgb) / 0.3); }
#landing .console.arc .nm, #landing .console.arc .reads .v { color: var(--amber); }
#landing .console.arc .cta { color: var(--amber); border: 1px solid rgb(var(--amber-rgb) / 0.5); background: rgb(var(--amber-rgb) / 0.14); }
@media (hover: hover) {
  #landing .console.arc:hover:not(.shut) { border-color: rgb(var(--amber-rgb) / 0.6); }
}
#landing .console.con .nm, #landing .console.con .reads .v { color: var(--accent); }
#landing .console.con .cta { color: var(--accent); border: 1px solid rgb(var(--accent-rgb) / 0.5); background: rgb(var(--accent-rgb) / 0.14); }
@media (hover: hover) {
  #landing .console.con:hover { border-color: rgb(var(--accent-rgb) / 0.6); }
}

/* --- the account rail --- */

#landing .rail {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px 16px;
  border: 1px solid var(--edge);
  border-radius: 10px;
  background: var(--panel);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  align-self: start;
}
#landing .rail h3 { margin: 0; font-size: max(var(--type-floor), var(--t-cap-size)); letter-spacing: var(--t-cap-track); color: var(--dim); font-weight: 400; }
#landing .oauth { display: flex; flex-direction: column; gap: 10px; }
/* The sign-in fields live in a real <form> for the password managers; it
   stacks the way the rail itself does. */
#landing .rail form { display: flex; flex-direction: column; gap: 10px; }
#landing .rail .oa {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 0 12px;
  font: inherit;
  font-size: var(--t-small-size);
  letter-spacing: 0.09em;
  color: var(--text);
  border: 1px solid var(--edge);
  border-radius: 4px;
  background: rgb(var(--accent-rgb) / 0.06);
  cursor: pointer;
}
#landing .rail .oa .g { width: 16px; text-align: center; }
#landing .rail .oa.ap .g { color: var(--apple-glyph); }
#landing .rail .oa.go .g { color: var(--amber); }
#landing .rail .or { display: flex; align-items: center; gap: 8px; font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); color: var(--dim); }
#landing .rail .or::before, #landing .rail .or::after { content: ""; flex: 1; height: 1px; background: var(--edge); }
#landing .rail input {
  min-height: 44px;
  padding: 0 10px;
  font: inherit;
  font-size: var(--t-small-size);
  letter-spacing: 0.09em;
  color: var(--text);
  background: rgb(var(--ink-rgb) / 0.7);
  border: 1px solid var(--edge);
  border-radius: 4px;
}
/* Dim and not Faint: a placeholder must read at 4.5:1 on the field (R2047). */
#landing .rail input::placeholder { color: var(--dim); letter-spacing: 0.17em; }
#landing .rail .cont {
  min-height: 44px;
  font: inherit;
  font-size: var(--t-small-size);
  letter-spacing: 0.27em;
  color: var(--accent);
  border: 1px solid rgb(var(--accent-rgb) / 0.4);
  border-radius: 4px;
  background: rgb(var(--accent-rgb) / 0.14);
  cursor: pointer;
}
#landing .rail .cont:disabled { opacity: 0.45; cursor: wait; }
/* FORGOT PASSWORD? (R624). It stands inside the form under the password
   box, right-aligned and quiet: it is a way out of a sign-in that failed
   and never a second CONTINUE. It keeps a 38 px target on a telephone,
   which is the floor for a control that is not the primary one, and the
   negative margins take back most of the form's own 10 px gap so the
   password box and CONTINUE stay one pair. */
#landing .rail .forgot {
  align-self: flex-end;
  min-height: 38px;
  margin: -6px 0 -8px;
  padding: 0 2px;
  font: inherit;
  font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
  background: none;
  border: 0;
  cursor: pointer;
}
@media (hover: hover) {
  #landing .rail .forgot:hover { color: var(--accent); }
}
#landing .rail .forgot:disabled { opacity: 0.45; cursor: wait; }
#landing .rail .hint { font-size: var(--t-small-size); line-height: 1.45; color: var(--dim); }
#landing .rail .hint b { color: var(--dim); font-weight: 400; }
#landing .rail .line { font-size: var(--t-small-size); line-height: 1.45; color: var(--dim); }
#landing .rail .err {
  padding: 8px 10px;
  border: 1px solid rgb(var(--bad-rgb) / 0.4);
  border-radius: 4px;
  font-size: var(--t-small-size);
  line-height: 1.45;
  color: var(--bad);
}
#landing .chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid var(--edge);
  border-radius: 17px;
  font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
  background: rgb(var(--panel-rgb) / 0.7);
}
#landing button.quiet {
  min-height: 44px;
  padding: 0;
  font: inherit;
  font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--dim);
  background: none;
  border: 0;
  cursor: pointer;
}
@media (hover: hover) {
  #landing button.quiet:hover { color: var(--bad); }
}

/* --- the footer: six links, and three of them are the legal ones --- */

#landing .foot {
  flex: none;
  padding: 14px 22px calc(14px + env(safe-area-inset-bottom));
  border-top: 1px solid rgb(var(--accent-rgb) / 0.1);
  background: rgb(var(--deep-rgb) / 0.55);
}
#landing .foot .links { display: flex; flex-wrap: wrap; gap: 6px 20px; font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); }
#landing .foot a { color: var(--dim); text-decoration: none; }
#landing .foot a.legal { color: var(--dim); }
@media (hover: hover) {
  #landing .foot a:hover { color: var(--accent); }
}
/* The privacy notice and the terms have a long name and a short one
   (R732). The narrow block below swaps them for PRIVACY and TERMS. */
#landing .foot .narrow { display: none; }
#landing .foot .rule { height: 1px; margin: 10px 0; background: rgb(var(--accent-rgb) / 0.1); }
#landing .foot .fine { max-width: 100ch; font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track); line-height: 1.6; color: var(--dim); }

/* --- keyboard focus (R1693, ui-map-interface.md §8) ---
   The landing stands outside `#ui`, so it states the two focus looks of
   the chrome itself: the ring of `#ui button:focus-visible` on a control,
   and the outline of `#ui input:focus` on a field. */
#landing button:focus-visible,
#landing a[href]:focus-visible,
#landing [tabindex="0"]:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}
#landing input:focus-visible,
#landing select:focus-visible,
#landing textarea:focus-visible { outline: 1px solid rgb(var(--accent-rgb) / 0.5); }

/* --- a telephone: the same three blocks, stacked --- */

@media (max-width: 900px) {
  #landing .bar { padding: 12px 14px; }
  #landing .rt { display: none; }
  #landing .stage { grid-template-columns: 1fr; padding: 0 12px 14px; gap: 12px; }
  #landing .console { min-height: 296px; }
  #landing .console .nm { font-size: 24px; letter-spacing: 0.25em; }
  #landing .console .cut { top: 44%; }
  /* The head covers most of a telephone's reel, and the scrim of a wide
     screen let the blurb stand on the bare reel. Here the scrim holds the
     ground of the text down to the foot of the blurb, and each glyph
     takes a halo of the deep ink. The reel plays on under both (R2208). */
  #landing .console .scrim {
    background: linear-gradient(180deg,
      rgb(var(--deep-rgb) / 0.9) 0%, rgb(var(--deep-rgb) / 0.8) 24%,
      rgb(var(--deep-rgb) / 0.8) 90%, rgb(var(--deep-rgb) / 0.3) 100%);
  }
  #landing .console .head { text-shadow: 0 0 3px rgb(var(--deep-rgb)), 0 0 1px rgb(var(--deep-rgb)); }
  /* Each readout is one row: the label at the start and its value at the
     end, so a label that wraps stays with its own value (R2208). */
  #landing .console .reads { flex-direction: column; gap: 4px; }
  #landing .console .reads .r {
    flex: none;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    padding: 0 0 4px;
    border-right: 0;
    border-bottom: 1px solid rgb(var(--accent-rgb) / 0.12);
  }
  #landing .console .reads .r + .r { padding-left: 0; }
  #landing .console .reads .r:last-child { padding-bottom: 0; border-bottom: 0; }
  #landing .console .reads .k { min-width: 0; }
  #landing .console .reads .v { flex: none; margin-top: 0; padding-top: 0; text-align: end; }
  /* The rail is the sheet at the foot of the page, and the two provider
     buttons sit side by side as chips so the form stays in reach. */
  #landing .rail { border-radius: 12px; padding: 14px; gap: 9px; }
  #landing .oauth { flex-direction: row; }
  #landing .oauth .oa { flex: 1; justify-content: center; }
  #landing .foot { padding: 12px 14px calc(12px + env(safe-area-inset-bottom)); }
  /* The row is 362 px wide at 390 px, and a character of the system mono
     at 10 px with its tracking is 8.18 px. A gap of 14 px keeps the seven
     links on two lines in both languages: the longest German line is 355
     px, where a gap of 20 px takes PRESSEMAPPE to a third line. */
  #landing .foot .links { column-gap: 14px; }
  #landing .foot .wide { display: none; }
  #landing .foot .narrow { display: inline; }
}

/* --- a finger: the type floor (R1739, R2150) ---
   A coarse pointer raises the floor to 11 px, as on the hub, so the tag
   line, the rail heads, FORGOT, the legal row and the fine print read
   11 px. A sentence in mixed case takes the 12 px Body type (the Sentence
   Rule). The legal row gives way in tracking first, so it keeps its two
   lines at 390 px. The targets do not change (R1739). */
@media (pointer: coarse) {
  #landing { --type-floor: 11px; }
  #landing :is(.console .bl, .rail .hint, .rail .line, .rail .err) { font-size: var(--t-body-size); }
  #landing .foot .links { letter-spacing: 0.06em; }
}

/* The `?` press of a landing console (R2445): it opens the HOW IT PLAYS
   card on the page of its mode. It stands at the top right of the head,
   over the reel, and takes a finger's target through `::after`. */
#landing .console .head { padding-right: 52px; }
#landing .console .how {
  position: absolute; top: 10px; right: 12px;
  width: 30px; height: 30px; padding: 0;
  border: 1px solid var(--edge); border-radius: 50%;
  background: rgb(var(--deep-rgb) / 0.72); color: var(--text);
  font: var(--t-body); cursor: pointer;
}
#landing .console .how::after { content: ''; position: absolute; inset: -7px; }
#landing .console.arc .how { border-color: rgb(var(--amber-rgb) / 0.5); color: var(--amber); }
#landing .console.con .how { border-color: rgb(var(--accent-rgb) / 0.5); color: var(--accent); }
@media (hover: hover) {
  #landing .console .how:hover { background: rgb(var(--accent-rgb) / 0.18); }
}

/* --- the HOW IT PLAYS card (player-reach.md §8.7, R2445) ---------------
   One card with one page for each mode, on `document.body` under its own
   root, because it opens over the landing, the hub and the game page. A
   wide screen centres it over a shade; a telephone draws it as a bottom
   sheet whose body scrolls, with the press of the drills in the thumb
   zone. Every size reads a type step, and the shade takes a press. */
#howplays {
  position: fixed; inset: 0; z-index: 88;
  display: flex; align-items: center; justify-content: center;
  font-family: var(--mono); font-size: var(--t-body-size); line-height: 1.45; color: var(--text);
  font-synthesis-weight: none; font-variant-numeric: tabular-nums;
  user-select: none; -webkit-user-select: none; -webkit-touch-callout: none;
  /* The UI scale zooms the card as it zooms `#landing` (R1556). */
  zoom: var(--ui-scale, 1);
  --type-floor: 9px;
}
#howplays * { box-sizing: border-box; }
#howplays .hp-shade { position: absolute; inset: 0; background: var(--g-modal); }
#howplays .hp-card {
  position: relative; display: flex; flex-direction: column;
  width: min(560px, calc(100vw / var(--ui-scale, 1) - 32px));
  max-height: calc(100vh / var(--ui-scale, 1) - 48px);
  border: 1px solid var(--edge); border-radius: 10px;
  background: var(--console-ground);
}
#howplays .hp-head { display: flex; align-items: center; gap: var(--s-3); padding: 12px 12px 6px 16px; }
#howplays h2 { flex: 1; margin: 0; font-size: var(--t-title-size); font-weight: 500; letter-spacing: 0.21em; color: var(--accent); }
#howplays button {
  appearance: none; -webkit-appearance: none; margin: 0; font: inherit; color: inherit; cursor: pointer;
  background: none; border: 1px solid var(--edge); border-radius: 4px;
}
#howplays .hp-x { flex: none; width: 36px; height: 36px; padding: 0; color: var(--dim); }
/* Four presses, one for each mode (R3178). On a narrow telephone a long
   mode name in a long language moves the last press to a second row,
   and every press keeps its whole word. */
#howplays .hp-switch { display: flex; flex-wrap: wrap; gap: 2px; margin: 0 16px 4px; }
#howplays .hp-tab {
  flex: 1 1 auto; min-height: 36px; padding: 0 var(--s-3); white-space: nowrap;
  font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track);
  color: var(--dim);
}
#howplays .hp-tab.on { background: rgb(var(--accent-rgb) / 0.22); color: var(--accent); }
#howplays .hp-card.arcade .hp-tab.on { background: rgb(var(--amber-rgb) / 0.18); color: var(--amber); border-color: rgb(var(--amber-rgb) / 0.5); }
#howplays .hp-card.event .hp-tab.on { background: rgb(var(--violet-rgb) / 0.18); color: var(--violet); border-color: rgb(var(--violet-rgb) / 0.5); }
#howplays .hp-card.clanwar .hp-tab.on { background: rgb(var(--bad-rgb) / 0.18); color: var(--bad); border-color: rgb(var(--bad-rgb) / 0.5); }
#howplays .hp-body { flex: 1; min-height: 0; overflow-y: auto; padding: 4px 16px 0; }
#howplays .hp-row { padding: 9px 0; border-bottom: 1px solid rgb(var(--accent-rgb) / 0.1); }
#howplays .hp-row:last-child { border-bottom: 0; }
#howplays h3 {
  margin: 0 0 3px; font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track); color: var(--dim);
}
#howplays p { margin: 0; font: var(--t-body); color: var(--text); }
#howplays .hp-foot {
  display: flex; flex-direction: column; gap: 6px;
  padding: 10px 16px 14px; border-top: 1px solid rgb(var(--accent-rgb) / 0.14);
}
#howplays .hp-foot p { color: var(--dim); }
#howplays .hp-go {
  align-self: flex-end; min-height: 40px; padding: 0 14px;
  border-color: rgb(var(--amber-rgb) / 0.5); background: rgb(var(--amber-rgb) / 0.12); color: var(--amber);
  font-size: max(var(--type-floor), var(--t-cap-size)); font-weight: var(--t-cap-weight); letter-spacing: var(--t-cap-track);
}
#howplays button:focus-visible { outline: 2px solid var(--accent); outline-offset: 1px; }
@media (hover: hover) {
  #howplays .hp-x:hover, #howplays .hp-tab:hover { background: rgb(var(--accent-rgb) / 0.12); color: var(--text); }
  #howplays .hp-go:hover { background: rgb(var(--amber-rgb) / 0.22); }
}
@media (max-width: 900px) {
  #howplays { align-items: flex-end; }
  #howplays .hp-card {
    width: 100%; max-height: calc(100vh / var(--ui-scale, 1) - 40px);
    border-radius: 12px 12px 0 0; border-bottom: 0;
  }
  /* The card is zoomed by the UI scale, so the inset is divided by it. */
  #howplays .hp-foot { padding-bottom: calc(14px + env(safe-area-inset-bottom, 0px) / var(--ui-scale, 1)); }
  #howplays .hp-go { align-self: stretch; }
}
@media (pointer: coarse) {
  #howplays { --type-floor: 11px; }
  #howplays :is(.hp-x, .hp-tab, .hp-go) { min-height: var(--target-finger); }
  #howplays .hp-x { width: var(--target-finger); height: var(--target-finger); }
}
/* --- the chrome dock-in (R182, mockup round ten, "Magnet Snap") ---------
   The screen is black until the map spawn starts, and the chrome sits
   outside the viewport all through the spawn. When the spawn ends, every
   panel travels home inside one second. Under the AUTO value the curve
   carries a panel past its dock line and lets it settle back, and each
   bordered panel flashes as it lands.

   Two custom properties carry the travel itself. `--rest` is the
   transform a panel's layout already needed — the centring of the top bar,
   the centring of a card — and `--out` is the
   translate that takes it off its own edge. They are multiplied in one
   place. A panel that writes `transform` for its layout instead of `--rest`
   loses that layout at the first frame of the arrival.

   `ui/dockin.ts` owns the classes below and samples the same curve for the
   minimap, which is drawn on the canvas and cannot be a CSS transition.
   Both sides read the curve from the data layer, so neither states it.

   Which panels travel: the eight that are on screen when a session starts.
   The chat travels inside the dock (R1799). The key sheet, the tooltip and the explainer cards are `display: none`
   until something asks for them, so they have no arrival to take part in.
   The two timers are not here either (R430): they are children of `#topbar`
   now, and they travel with the bar.

   **The clocks are data, not CSS** (R826). The World body's `dock` field
   picks one of five arrivals, `ui/chromelook.ts` writes `theme-dock-<id>`
   on `#ui`, and the block of that class sets `--dock-ms`, `--dock-ease`
   and, per panel, `--dock-delay`. Every rule below reads the three
   properties and states no duration and no curve of its own, so the
   stylesheet and `ui/dockin.ts` cannot name different figures. The blocks
   are RENDERED from `[presentation.dockin.<id>]`: a new value costs one
   TOML table and no hand-written CSS. */

#ui {
  --dock-ms: 1000ms;
  --dock-ease: cubic-bezier(.34, 1.42, .64, 1);
}

#ui.theme-dock-magnet {
  --dock-ms: 1000ms;
  --dock-ease: cubic-bezier(.34, 1.42, .64, 1);
}
#ui.theme-dock-hard-dock {
  --dock-ms: 1000ms;
  --dock-ease: cubic-bezier(.22, .61, .36, 1);
}
#ui.theme-dock-cascade {
  --dock-ms: 760ms;
  --dock-ease: cubic-bezier(.22, .61, .36, 1);
}
#ui.theme-dock-cascade #notices { --dock-delay: 60ms; }
#ui.theme-dock-cascade #dock { --dock-delay: 80ms; }
#ui.theme-dock-cascade #infocard { --dock-delay: 160ms; }
#ui.theme-dock-cascade #hint { --dock-delay: 60ms; }
#ui.theme-dock-cascade #mapbtns { --dock-delay: 160ms; }
#ui.theme-dock-cascade #selection { --dock-delay: 160ms; }
#ui.theme-dock-pressure-rise {
  --dock-ms: 1000ms;
  --dock-ease: cubic-bezier(.16, 1, .3, 1);
  --dock-fade-ms: 700ms;
  --dock-offset: 22px;
  --dock-scale: 0.96;
  --dock-blur: 3px;
}
#ui.theme-dock-surface-wake {
  --dock-ms: 1000ms;
  --dock-ease: cubic-bezier(.22, .61, .36, 1);
}

#topbar, #stats, #notices, #groupbar,
#dock, #infocard, #hint,
#mapbtns, #selection {
  transform: var(--rest, translateX(0));
  transition: transform var(--dock-ms) var(--dock-ease) var(--dock-delay, 0ms);
}

#ui.docking #topbar, #ui.docking #stats, #ui.docking #notices, #ui.docking #groupbar,
#ui.docking #dock, #ui.docking #infocard, #ui.docking #hint,
#ui.docking #mapbtns, #ui.docking #selection {
  transform: var(--rest, translateX(0)) var(--out, translateX(0));
  will-change: transform;
}

/* The VIEW button is hidden until the arrival starts, then enters from the
   left edge with the rest of the chrome. */
#mapbtns {
  transition:
    transform var(--dock-ms) var(--dock-ease) var(--dock-delay, 0ms),
    opacity 240ms linear var(--dock-delay, 0ms);
}
#ui.docking #mapbtns { opacity: 0; }

/* The travel of each panel, read off the layout above it. A distance is
   `100%` of the panel plus whatever inset holds it off its edge. */
#topbar    { --out: translateY(calc(-100% - 12px)); }
#stats     { --out: translateY(calc(-100% - var(--topbar-h, 44px) - 16px)); }   /* under the readout line */
#groupbar  { --out: translateY(calc(-100% - var(--topbar-h, 44px) - 16px)); }   /* under the readout line */
#notices   { --out: translateX(calc(100% + var(--lane-r) + 16px)); }
#dock      { --out: translateX(calc(100% + var(--pad) + 4px)); }
#infocard  { --out: translateY(calc(100% + var(--ctx-b) + 24px)); }
#hint      { --out: translateY(calc(100% + var(--ctx-b) + 24px)); }
#mapbtns   { --out: translateX(calc(-100% - var(--mapbtns-x, 12px) - 4px)); }
#selection { --out: translateY(calc(100% + var(--ctx-b) + 24px)); }
/* The arcade's mirrored desktop (R2883): VIEW travels in from the right
   edge. */
#ui.mirror #mapbtns { --out: translateX(calc(100% + var(--mapbtns-r, 12px) + 4px)); }
/* The desktop VIEW of the game stands on the chart strip (R2904): it
   travels in from the right edge, and from the left edge on a mirrored
   desktop. The sheet block states the telephone travel again. */
#ui:not(.arcade) #mapbtns { --out: translateX(calc(100% + var(--mapbtns-r, 12px) + 4px)); }
#ui.mirror:not(.arcade) #mapbtns { --out: translateX(calc(-100% - var(--mapbtns-x, 12px) - 4px)); }

/* The flash of contact. Only the bordered panels carry it: the readouts
   have no border for it to light up. `will-change` lives on `docking` and
   `snapping` rather than on the panels, so a session pays for the
   compositor layers during the arrival alone (ui-map-interface.md §10).
   The layers exist from `docking` on, so the browser rasters the panels
   outside the viewport during the spawn. A layer made at `snapping`
   rasters all eight panels in one frame and stops the spawn for up to
   400 ms (R2891). */
#ui.snapping #topbar,
#ui.snapping #dock, #ui.snapping #infocard,
#ui.snapping #selection {
  animation: dock-snap var(--dock-ms) linear var(--dock-delay, 0ms) 1;
}
#ui.snapping #topbar, #ui.snapping #stats, #ui.snapping #notices,
#ui.snapping #dock, #ui.snapping #infocard, #ui.snapping #hint,
#ui.snapping #mapbtns, #ui.snapping #selection {
  will-change: transform;
}

@keyframes dock-snap {
  0%, 62% { border-color: var(--edge); box-shadow: none; }
  72%     { border-color: rgb(var(--accent-rgb) / 0.85); box-shadow: 0 0 6px rgb(var(--accent-rgb) / 0.35); }
  100%    { border-color: var(--edge); box-shadow: none; }
}

/* Only the AUTO value flashes. Every other value lands without it, and
   says so in its own `flash` figure, so the rule below is rendered from
   the TOML and never counted by hand. */

#ui.theme-dock-hard-dock.snapping #topbar,
#ui.theme-dock-hard-dock.snapping #dock, #ui.theme-dock-hard-dock.snapping #infocard,
#ui.theme-dock-hard-dock.snapping #selection,
#ui.theme-dock-hard-dock.snapping #chat.box {
  animation: none;
}

#ui.theme-dock-cascade.snapping #topbar,
#ui.theme-dock-cascade.snapping #dock, #ui.theme-dock-cascade.snapping #infocard,
#ui.theme-dock-cascade.snapping #selection,
#ui.theme-dock-cascade.snapping #chat.box {
  animation: none;
}

#ui.theme-dock-pressure-rise.snapping #topbar,
#ui.theme-dock-pressure-rise.snapping #dock, #ui.theme-dock-pressure-rise.snapping #infocard,
#ui.theme-dock-pressure-rise.snapping #selection,
#ui.theme-dock-pressure-rise.snapping #chat.box {
  animation: none;
}

#ui.theme-dock-surface-wake.snapping #topbar,
#ui.theme-dock-surface-wake.snapping #dock, #ui.theme-dock-surface-wake.snapping #infocard,
#ui.theme-dock-surface-wake.snapping #selection,
#ui.theme-dock-surface-wake.snapping #chat.box {
  animation: none;
}

/* --- Pressure Rise (round ten, card 04) --------------------------------

   Nothing crosses the map. Each panel starts `--dock-offset` outside its
   own dock line at `--dock-scale`, and rises into place while it fades up
   over `--dock-fade-ms`. The direction of the offset is the direction the
   panel travels in the AUTO value, so the three bands keep their sides. */

#ui.theme-dock-pressure-rise #topbar,
#ui.theme-dock-pressure-rise #stats {
  --out: translateY(calc(-1 * var(--dock-offset))) scale(var(--dock-scale));
}
#ui.theme-dock-pressure-rise #notices,
#ui.theme-dock-pressure-rise #dock {
  --out: translateX(var(--dock-offset)) scale(var(--dock-scale));
}
#ui.theme-dock-pressure-rise #selection,
#ui.theme-dock-pressure-rise #hint,
#ui.theme-dock-pressure-rise #infocard {
  --out: translateY(var(--dock-offset)) scale(var(--dock-scale));
}
#ui.theme-dock-pressure-rise #mapbtns {
  --out: translateX(calc(-1 * var(--dock-offset))) scale(var(--dock-scale));
}

#ui.theme-dock-pressure-rise #topbar, #ui.theme-dock-pressure-rise #stats,
#ui.theme-dock-pressure-rise #notices, #ui.theme-dock-pressure-rise #dock,
#ui.theme-dock-pressure-rise #infocard, #ui.theme-dock-pressure-rise #hint,
#ui.theme-dock-pressure-rise #mapbtns, #ui.theme-dock-pressure-rise #selection {
  transition:
    transform var(--dock-ms) var(--dock-ease) var(--dock-delay, 0ms),
    opacity var(--dock-fade-ms) ease-out var(--dock-delay, 0ms);
}
#ui.theme-dock-pressure-rise.docking #topbar,
#ui.theme-dock-pressure-rise.docking #stats,
#ui.theme-dock-pressure-rise.docking #notices,
#ui.theme-dock-pressure-rise.docking #dock,
#ui.theme-dock-pressure-rise.docking #infocard,
#ui.theme-dock-pressure-rise.docking #hint,
#ui.theme-dock-pressure-rise.docking #mapbtns,
#ui.theme-dock-pressure-rise.docking #selection {
  opacity: 0;
}

/* The blur is a TWO-STEP and not a ramp (§10). `backdrop-filter` is a
   live blur of the map under the panel, and a ramp re-blurs the sea under
   eight panels on every frame of the arrival. The panels therefore wear
   no blur while the travel runs, and the value's own `--dock-blur` the
   moment they land. The card ramps it; the shipped step does not. */
#ui.theme-dock-pressure-rise #topbar, #ui.theme-dock-pressure-rise #stats,
#ui.theme-dock-pressure-rise #notices, #ui.theme-dock-pressure-rise #dock,
#ui.theme-dock-pressure-rise #infocard, #ui.theme-dock-pressure-rise #hint,
#ui.theme-dock-pressure-rise #mapbtns,
#ui.theme-dock-pressure-rise #selection {
  backdrop-filter: blur(var(--dock-blur));
  -webkit-backdrop-filter: blur(var(--dock-blur));
}
#ui.theme-dock-pressure-rise.snapping #topbar,
#ui.theme-dock-pressure-rise.snapping #stats,
#ui.theme-dock-pressure-rise.snapping #notices,
#ui.theme-dock-pressure-rise.snapping #dock,
#ui.theme-dock-pressure-rise.snapping #infocard,
#ui.theme-dock-pressure-rise.snapping #hint,
#ui.theme-dock-pressure-rise.snapping #mapbtns,
#ui.theme-dock-pressure-rise.snapping #selection {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

/* --- Surface Wake (round ten, card 05) ---------------------------------

   Hard Dock, plus the map's own vocabulary: each panel drags a one-pixel
   leading edge of the accent that dies as the panel lands, the way a wake
   dies behind a hull. The edge is a `::before` of the panel and stands
   INSIDE the panel's own edge, because `#dock` clips what passes its
   border. `::after` is taken on `#topbar`.

   The edge sits on the side the panel arrives across: the bottom edge for
   the two that come down from the top, the left edge for the panels that
   come in from the right band, and the top edge for the panels that rise
   from the bottom (the hint host with them, R2164). The chart is on the
   canvas and takes a ring instead (`fast/minimap.ts`,
   ui-map-interface.md §3.2).

   The card blurs the bar by half a pixel. The shipped edge does not: a
   filter would put each of the eight bars on a compositor layer of its
   own, and an opacity animation on a 1 px bar needs none. */

#ui.theme-dock-surface-wake #topbar::before,
#ui.theme-dock-surface-wake #stats::before,
#ui.theme-dock-surface-wake #notices::before,
#ui.theme-dock-surface-wake #dock::before,
#ui.theme-dock-surface-wake #infocard::before,
#ui.theme-dock-surface-wake #hint::before,
#ui.theme-dock-surface-wake #mapbtns::before,
#ui.theme-dock-surface-wake #selection::before {
  content: '';
  position: absolute;
  background: var(--accent);
  opacity: 0;
  pointer-events: none;
}
#ui.theme-dock-surface-wake #topbar::before,
#ui.theme-dock-surface-wake #stats::before {
  left: 0; right: 0; bottom: 0; height: 1px;
}
#ui.theme-dock-surface-wake #notices::before,
#ui.theme-dock-surface-wake #dock::before {
  top: 0; bottom: 0; left: 0; width: 1px;
}
#ui.theme-dock-surface-wake #mapbtns::before,
#ui.theme-dock-surface-wake #selection::before,
#ui.theme-dock-surface-wake #hint::before,
#ui.theme-dock-surface-wake #infocard::before {
  left: 0; right: 0; top: 0; height: 1px;
}
#ui.theme-dock-surface-wake.snapping #topbar::before,
#ui.theme-dock-surface-wake.snapping #stats::before,
#ui.theme-dock-surface-wake.snapping #notices::before,
#ui.theme-dock-surface-wake.snapping #dock::before,
#ui.theme-dock-surface-wake.snapping #infocard::before,
#ui.theme-dock-surface-wake.snapping #hint::before,
#ui.theme-dock-surface-wake.snapping #mapbtns::before,
#ui.theme-dock-surface-wake.snapping #selection::before {
  animation: dock-wake var(--dock-ms) ease-out var(--dock-delay, 0ms) 1;
}

@keyframes dock-wake {
  0%   { opacity: 0.9; }
  70%  { opacity: 0.55; }
  100% { opacity: 0; }
}

/* One frame with no travel: the snap out under the black, and the jump home
   when a player skips the arrival. */
#ui.nodock #topbar, #ui.nodock #stats, #ui.nodock #notices,
#ui.nodock #dock, #ui.nodock #infocard, #ui.nodock #hint,
#ui.nodock #mapbtns, #ui.nodock #selection {
  transition: none !important;
  animation: none !important;
}

/* The black. `index.html` paints it before any script runs, so a direct
   entry is black from the first frame; the landing screen is z-index 50 and
   stands over it, unchanged. The black is an image over the ink, so iOS
   Safari takes the ink for its status bar band (R1724).

   The ink is `--boot-ink` first: the ink of the theme worn last, which
   `/entrycover.js` writes before the first paint (R1917). The built page
   links this sheet after the head's own rules, so this rule wins there,
   and the token ink is the Abyssal Compact until a theme applies (R1956). */
#blackout {
  position: fixed;
  inset: 0;
  z-index: 40;
  background: var(--boot-ink, rgb(var(--ink-rgb))) linear-gradient(var(--film-black), var(--film-black));
  pointer-events: none;
  transition: opacity 220ms linear;
}

/* A menu entry: the cover is the ink, the ground of the landing and the
   hub, until a world comes next (R1773). */
html.menu-entry #blackout {
  background: var(--boot-ink, rgb(var(--ink-rgb)));
}

/* Reduced motion: nothing travels. The panels fade in place, and the
   minimap follows a straight line, so the two still land together. */
@media (prefers-reduced-motion: reduce) {
  #topbar, #stats, #notices,
  #dock, #infocard, #hint,
  #mapbtns, #selection {
    transition: opacity 320ms linear;
  }
  #ui.docking #topbar, #ui.docking #stats, #ui.docking #notices,
  #ui.docking #dock, #ui.docking #infocard, #ui.docking #hint,
  #ui.docking #mapbtns, #ui.docking #selection {
    transform: var(--rest, translateX(0));
    opacity: 0;
  }
  #ui.snapping #topbar,
  #ui.snapping #dock, #ui.snapping #infocard,
  #ui.snapping #selection {
    animation: none;
  }
  /* The leading edge of Surface Wake is motion too, and the rule names no
     value: a panel under any other value generates no `::before` box, so
     the selector costs nothing there (R826). */
  #ui.snapping #topbar::before, #ui.snapping #stats::before,
  #ui.snapping #notices::before, #ui.snapping #dock::before,
  #ui.snapping #infocard::before, #ui.snapping #hint::before,
  #ui.snapping #mapbtns::before,
  #ui.snapping #selection::before {
    animation: none;
    opacity: 0;
  }
}

/* --- animation A, the collapse onto the VIEW button (R218, R1747) ---------

   The chat box took part until R1799; the chat is a state of the dock
   now and travels with the dock. The heat legend took part until R1806;
   it is a section of the legend card now. The chart's control alone
   remains, and it fades.

   The collapse rides `scale`, the separate transform property, so the panel
   can shrink onto the VIEW button. `visibility` is delayed by the whole duration: a closing panel is
   drawn all the way down and leaves the pointer path the moment it is gone.

   The chart is drawn on the canvas and cannot be a transition at all.
   `fast/minimap.ts` samples the same curve — the reason animation A
   was chosen over the two clip-path styles is that this needs no mask. */

#mapchrome {
  transition: opacity 140ms linear, visibility 0s linear 140ms;
}
/* The chart's control waits out the arrival rather than travelling with the
   chart, which is on the canvas and not a panel. It is stated here, below
   the flash rule, so `dockin.test.ts` still finds the flash rule first. */
#ui.docking #mapchrome, #ui.snapping #mapchrome,
#ui.docking #heatchip, #ui.snapping #heatchip { opacity: 0; }
/* The rose press waits out the arrival too: the spawn veil covers the rose
   on the canvas, so no press may land on it (R1758). */
#ui.docking #rosepress, #ui.docking #scalebar { visibility: hidden; }
/* The chart furniture's cards wait out the spawn too (R1545). The spawn
   veil covers every canvas piece, but the DOM host stands over the canvas,
   so it hides until the panels leave and fades in over their travel. The
   keyframes state no end, so the fade lands on the host's own opacity. */
#ui.docking #furniture { visibility: hidden; }
#ui.snapping #furniture { animation: furniture-in var(--dock-ms) linear 1; }
@keyframes furniture-in { from { opacity: 0; } }
/* The brand and statistics line waits out the spawn the same way (R1548).
   Its travel is its own height, so a layout that sets it lower leaves it
   in view over the spawn; the fade keeps the delay of its slide. */
#ui.docking #stats { visibility: hidden; }
#ui.snapping #stats { animation: furniture-in var(--dock-ms) linear var(--dock-delay, 0ms) 1 backwards; }
/* The chat box of SMALL and LARGE (R1838) travels in from the left edge on
   the curve of the other panels and flashes as it lands. It states `--out`
   and never a bare `transform`, like the nine panels. Reduced motion keeps
   the old bargain: it waits out the arrival and fades in. */
#ui #chat.box { --out: translateX(calc(-100% - var(--chat-x, var(--pad)) - 16px)); }
/* The mirrored desktop (R2883): the chat box stands next to the dock, so
   the Magnet Snap brings it in from the right edge. */
#ui.mirror #chat.box { --out: translateX(calc(100% + var(--chat-right, var(--pad)) + 16px)); }
#ui.docking #chat.box { transform: var(--rest, translateX(0)) var(--out, translateX(0)); }
#ui.snapping #chat.box { animation: dock-snap var(--dock-ms) linear var(--dock-delay, 0ms) 1; will-change: transform; }
#ui.theme-dock-pressure-rise #chat.box { --out: translateX(calc(-1 * var(--dock-offset))) scale(var(--dock-scale)); }
#ui.theme-dock-pressure-rise.docking #chat.box { opacity: 0; }
#ui.theme-dock-pressure-rise.snapping #chat.box {
  transition:
    transform var(--dock-ms) var(--dock-ease) var(--dock-delay, 0ms),
    opacity var(--dock-fade-ms) ease-out var(--dock-delay, 0ms);
}
@media (prefers-reduced-motion: reduce) {
  #ui.docking #chat.box { transform: none; visibility: hidden; }
  #ui.snapping #chat.box { animation: furniture-in var(--dock-ms) linear var(--dock-delay, 0ms) 1 backwards; will-change: auto; }
}
/* The chart's own control is 22px of button with no shrink worth watching:
   it fades with the picture it belongs to. */
#mapchrome.min { opacity: 0; visibility: hidden; pointer-events: none; }

/* The same bargain §3.2 makes: no travel, a plain fade.

   Two fades, though, and they are not the same length. The arrival keeps the
   dock-in's 320 ms, because §3.2's whole reduced-motion rule is that the
   panels and the chart still *land together* — a legend that faded in at
   120 ms would arrive ahead of the chart, which moves at a constant rate over
   the full second. The collapse is the round's own 120 ms.

   One `transition` cannot say both, so the duration is taken from the
   after-change style: the base rule governs opening, `.min` governs closing. */
@media (prefers-reduced-motion: reduce) {
  #mapchrome {
    transition: opacity 320ms linear, visibility 0s linear 320ms;
  }
  #mapchrome.min {
    transition: opacity 120ms linear, visibility 0s linear 120ms;
  }
}

/* The sheet form factor. The dock is a bottom sheet, so it arrives from the
   bottom and not from the right, and the top bar spans the screen and has
   no centring left to keep. The build card is a page of the sheet there
   (R1826), so `#infocard` never stands. */
@media (max-width: 760px), ((pointer: coarse) and (max-height: 520px)) {
  #topbar    { --out: translateY(calc(-100% - 4px)); }
  #stats     { --out: translateY(calc(-100% - var(--topbar-h, 56px) - 10px)); }
  #notices   { --out: translateX(calc(100% + var(--pad) + 4px)); }
  #dock      { --out: translateY(calc(100% + 16px)); }
  #mapbtns, #ui:not(.arcade) #mapbtns { --out: translateX(calc(-100% - var(--mapbtns-x, 12px) - 4px)); }
  #selection { --out: translateY(calc(100% + var(--ctx-b) + 16px)); }
  #infocard  { --out: translateY(calc(100% + var(--ctx-b) + 16px)); }
  /* Pressure Rise on the sheet form factor (R826). The dock is a bottom
     sheet here, so it rises with the bottom band. The other six keep the
     sides the desktop rules gave them. */
  #ui.theme-dock-pressure-rise #dock { --out: translateY(var(--dock-offset)) scale(var(--dock-scale)); }
  /* Surface Wake on the sheet form factor: the leading edge follows the
     side the panel arrives across here. The dock rises, so its edge is on
     the top. */
  #ui.theme-dock-surface-wake #dock::before {
    top: 0; bottom: auto; left: 0; right: 0; width: auto; height: 1px;
  }
}

/* --- the safe-area probe (R1828) ---
   A script cannot read `env()`. The probe is a hidden box in `#ui`: its
   width is the left inset, its height the bottom inset, and its right and
   top borders the right and the top inset, all in chrome px, so
   `ui/layout.ts` reads the four from its client and border boxes. */
#safeprobe {
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: content-box;
  width: var(--safe-l);
  height: var(--safe-b);
  border-style: solid;
  border-color: transparent;
  border-width: var(--safe-t) var(--safe-r) 0 0;
  visibility: hidden;
  pointer-events: none;
}

/* --- the landscape rail (§12.0 "The landscape rail", R1828, round 083
   card 15) ---
   A telephone on its side. `ui/layout.ts` writes the class `rail` on
   `#ui` where the eight cells of the rail keep the finger target, so these
   rules stand on the class and outside the media blocks; every rule of the
   sheet block still holds under them. The tab bar is a rail of
   64 px at the left edge, inside the safe area; the sheet opens
   beside it, 340 px wide; the context card stands at the right
   edge; the map keeps the rest. */
#ui.rail { --rail-w: calc(64px + var(--safe-l)); }
#ui.rail #dock {
  left: var(--rail-w);
  right: auto;
  width: 340px;
  padding-bottom: var(--safe-b);
  border-width: 1px 1px 0 0;
  border-radius: 0 var(--r-sheet) 0 0;
  /* The rail is a child of the dock and stands left of it. */
  overflow: visible;
}
#ui.rail #dock.expanded { top: 0; border-width: 0 1px 0 0; border-radius: 0; }
/* The rail: INBOX at its head, the six tabs, MENU at its foot. The cells
   stand with no gap, so each one keeps the finger target. */
#ui.rail #dock #tabs {
  position: absolute;
  left: calc(-1 * var(--rail-w));
  bottom: 0;
  width: var(--rail-w);
  height: calc(100vh / var(--ui-scale, 1));
  box-sizing: border-box;
  flex-direction: column;
  gap: 0;
  padding: 4px 0 calc(4px + var(--safe-b)) var(--safe-l);
  background: rgb(var(--sheet-rgb) / 0.97);
  border-right: 1px solid rgb(var(--accent-rgb) / 0.24);
}
/* **The rail is one ruled plate** (round 090 card 08 C, R1848): no corner
   and no ground per cell, a 1 px rule between two cells, and the lit tab
   with a 3 px accent bar on its map side. The INBOX and MENU caps keep
   their cap face, the accent words on no ground. The finger target is a
   length on the glass, so a cell is the target divided by the UI scale in
   chrome px (card 09 C). */
#ui.rail #dock #tabs button {
  flex: 1 1 0;
  width: 100%;
  min-width: 0;
  height: auto;
  min-height: calc(var(--target-finger) / var(--ui-scale, 1));
  margin: 0;
  border-radius: 0;
  border-width: 1px 0 0;
  border-color: rgb(var(--accent-rgb) / 0.14);
  background: none;
}
#ui.rail #dock #tabs button:first-child { border-top-width: 0; }
#ui.rail #dock #tabs button.active,
#ui.rail #dock #tabs button.cap.on {
  border-color: rgb(var(--accent-rgb) / 0.14);
  background: rgb(var(--accent-rgb) / 0.16);
  box-shadow: inset -3px 0 0 var(--accent);
}
#ui.rail #dock #tabs button.cap.on::before { display: none; }
#ui.rail:not(.rail-short) #tabs .cap .cw { display: inline; }
/* A cell under `rail_word_px` shows the icon of a cap alone (card 09 C). */
#ui.rail-short #tabs .cap .cw { display: none; }
#ui.rail-short #dock #tabs button.cap { gap: 0; }
/* The glyphs of the rail (R2214, R2215): under GLYPH a cell shows its
   glyph alone; under GLYPH + WORD the glyph over the short word, and a
   cell under `rail_word_px` shows the glyph alone. The hold bubble stands
   beside the cell, over the map. */
#ui.rail #dock #tabs button.gt { flex-direction: column; gap: 3px; letter-spacing: 0; }
#ui.rail #dock #tabs button.gt.g .tgl { width: 20px; height: 20px; }
#ui.rail-short #tabs button.gt .tw { display: none; }
#ui.rail #tabs button.gt.bub::after,
#ui.rail #tabs button.gt:focus-visible::after { bottom: auto; top: 50%; left: calc(100% + 9px); transform: translateY(-50%); }
#ui.rail #tabs button.gt.bub::before,
#ui.rail #tabs button.gt:focus-visible::before {
  bottom: auto;
  top: 50%;
  left: calc(100% - 1px);
  margin: -5px 0 0;
  border-top-color: transparent;
  border-right-color: var(--hero-ink);
}
/* The readout line is a strip right of the rail, and right of the open
   sheet and of the chat band, which takes the column (round 090 card
   02 B). */
#ui.rail #topbar { left: var(--rail-w); padding: 0 calc(8px + var(--safe-r)) 0 8px; }
#ui.rail:has(> #dock.expanded) #topbar,
#ui.rail:has(> #dock.chatband:not(.kb)) #topbar { left: calc(var(--rail-w) + 340px + 1px); }
/* **The chat band takes the column** beside the rail (round 090 card
   02 B, R1848): from the top edge to the bar, and the log fills it, so
   `chat_band_lines` does not hold here. With the keyboard up the band
   keeps the form of R1799 on the keyboard. */
#ui.rail #dock.chatband:not(.kb) { top: 0; max-height: none; border-width: 0 1px 0 0; border-radius: 0; }
#ui.rail #dock.chatband:not(.kb) #chat { flex: 1 1 auto; }
#ui.rail #dock.chatband:not(.kb) #chatlog { flex: 1 1 0; height: auto; }
/* The round unit stands right of the column where it does not fit over
   the bar, and the scale bar goes where it has no room (card 09 C). */
#ui.scalebar-off #scalebar.on { display: none; }
#ui.rail #topbar button.res, #ui.rail #topbar button.clock { height: 36px; }
/* The context card stands at the right edge, a card wide (`railCtxSlot`),
   and the raised card takes the height under the readout line. */
#ui.rail .ctxcard,
#ui.rail .ctxcard.cat {
  right: auto;
  width: var(--ctx-w);
  --ctx-maxh: calc(100vh / var(--ui-scale, 1) - var(--topbar-h) - var(--ctx-b) - var(--pad));
}
#ui.rail #renamecard { bottom: max(var(--ctx-b), calc(var(--kb-b, 0px) + var(--pad))); }
/* The REPORT sheet takes the form of the desktop card (round 090 card
   11 B, R1848): 380 px wide, centred in the safe area, from the readout strip
   to the home indicator. */
#ui.rail #reportsheet {
  top: calc(var(--topbar-h, 37px) + 8px);
  bottom: calc(var(--safe-b) + 8px);
  left: var(--safe-l);
  right: var(--safe-r);
  margin: 0 auto;
  max-height: none;
  transform: none;
}
/* OPTIONS takes the form of a rail and a pane (round 090 card 11 B): it
   stands right of the rail, which stays in view and in reach. */
#ui.rail #settings.side { left: var(--rail-w); }
/* The panels that span the sheet's width stand right of the rail. */
#ui.rail #settings.phone { left: var(--rail-w); bottom: 0; }
/* OPTIONS beside the rail (R1830): `--rail-w` counts the left inset, so
   the menu pads none, and no tab bar stands under its foot, so the menu
   pads the home indicator. */
#ui.rail #settings.phone .o-full { padding-left: 0; padding-bottom: var(--safe-b); }
#ui.rail #squadkey { left: calc(var(--rail-w) + var(--pad)); }
/* The welcome card stands in the place of the context card (round 090
   card 10 C, R1848): at the right edge, a card wide, from the readout
   strip to the home indicator, with no dim. */
#ui.rail #welcome {
  left: auto;
  right: calc(var(--pad) + var(--safe-r));
  width: var(--w-card);
  top: calc(var(--topbar-h, 37px) + var(--pad));
  bottom: calc(var(--safe-b) + var(--pad));
  max-height: none;
}
#ui.rail #welcomedim.on { display: none; }
#ui.rail #notices { right: calc(var(--pad) + var(--safe-r)); }
/* The notice lane steps left of a card at the right edge (round 090 card
   06 B, R1848), so the card keeps its height and the lane stays one lane. */
#ui.ctx-beside.ctx-on #notices { right: calc(2 * var(--pad) + var(--safe-r) + var(--ctx-w)); }
#ui.rail #heatramp { right: calc(var(--pad) + var(--safe-r)); }

/* --- the season banner (mockup round eleven, card 04 "Abyss Title Card") ---

   The title card: which world, which season, how long is left. It goes up
   on the same frame the chrome dock-in starts — the map has spawned, the
   panels are still outside the viewport — and it is gone four and a half
   seconds later. `ui/banner.ts` raises it on a `login` and on a season
   roll, and on nothing else.

   The card is a film title and not a sign: thin caps, wide tracking that
   keeps opening for the banner's whole life, a hairline that draws itself
   out from the centre, and a quiet exit. Nothing here is bigger than it has
   to be, because the thing under it is a map the player has just arrived to
   see.

   One animation carries each moving part, and `banner-life` carries the
   whole life: the module adds one class, waits for that animation to end,
   and takes the card away. **Every banner style keeps `banner-life` on
   `#banner.on`**, because that name is what ends a card. The life and its
   two phase edges are rendered from `[presentation.banner]` (R825), so a
   keyframe added here cannot drift away from the clock `bannerStop` counts,
   and `banner.test.ts` reads them back off this file as well.

   **`letter-spacing` is a layout property**, and animating one is a
   deliberate exception to the performance rules (ui-map-interface.md §10):
   the tracking that never stops opening *is* card 04. `contain: layout
   paint` is what makes it affordable — the reflow each frame of the
   tracking forces stops at the banner's own box, so it can never reach the
   panels arriving behind it. The compensating `margin-right` in the same
   keyframes is the trailing gap the tracking adds after the last letter:
   without it the hero drifts to the right of centre as the tracking opens.

   Reduced motion is a class and not a media query here (`still`). The
   client asks the OS in exactly one place — `reducedMotion()` in
   render/spawn.ts — and the module that raises the card is the one that
   knows. */

#banner {
  position: absolute;
  inset: 0;
  z-index: 45;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-transform: uppercase;
  /* For its whole life. The card sits over a black-to-map transition that
     already needed a watchdog; it must never be able to eat a click. */
  pointer-events: none;
  contain: layout paint;
}

#banner.on {
  display: flex;
  animation: banner-life 4500ms linear both;
}

#banner .kick {
  font-size: clamp(10px, 1.9vw, 24px);
  letter-spacing: 0.42em;
  color: var(--dim);
  animation: banner-fade 500ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}

#banner .hero {
  font-size: clamp(26px, 6.4vw, 96px);
  font-weight: 300;
  line-height: 1.05;
  color: var(--hero-ink);
  white-space: nowrap;
  margin: clamp(8px, 1.4vw, 20px) 0 clamp(7px, 1.2vw, 18px);
  animation: banner-track 4500ms linear both;
}

#banner .rule {
  height: 1px;
  width: min(38vw, 520px);
  background: linear-gradient(90deg, transparent, rgb(var(--accent-rgb) / 0.85), transparent);
  transform: scaleX(0);
  animation: banner-rule 620ms cubic-bezier(0.215, 0.61, 0.355, 1) 190ms both;
}

#banner .foot {
  font-size: clamp(11px, 2.2vw, 26px);
  letter-spacing: 0.34em;
  color: var(--dim);
  margin-top: clamp(8px, 1.4vw, 20px);
  animation: banner-fade 380ms linear 540ms both;
}

/* The life: in on an ease-out, hold, out on the mockup's own `1 - u²`. */
@keyframes banner-life {
  0%       { opacity: 0; animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  22.222%  { opacity: 1; animation-timing-function: linear; }
  80%      { opacity: 1; animation-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53); }
  100%     { opacity: 0; }
}

/* The tracking, which never stops opening: 0.16em at the first frame,
   0.26em when the arrival ends, 0.36em when the hold ends, 0.42em as the
   card goes. The negative margin is half the trailing gap, twice over. */
@keyframes banner-track {
  0%       { letter-spacing: 0.16em; margin-right: -0.16em;
             animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
  22.222%  { letter-spacing: 0.26em; margin-right: -0.26em;
             animation-timing-function: linear; }
  80%      { letter-spacing: 0.36em; margin-right: -0.36em; }
  100%     { letter-spacing: 0.42em; margin-right: -0.42em; }
}

@keyframes banner-fade {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes banner-rule {
  from { transform: scaleX(0); }
  to   { transform: scaleX(1); }
}

/* Reduced motion: the card fades in, holds and fades out, and nothing
   travels. The hero keeps the tracking the arrival would have settled on,
   the rule is simply drawn, and the stagger goes — a stagger is motion. */
#banner.still .hero {
  animation: none;
  letter-spacing: 0.26em;
  margin-right: -0.26em;
}
#banner.still .rule { animation: none; transform: scaleX(1); }
#banner.still .kick, #banner.still .foot { animation: none; }

/* --- the five other banner styles of the World theme (R825, §3.3) ---

   `wearChromeLook` writes `theme-banner-<id>` on `#ui` and `bannerMarkup`
   writes the parts each style needs, so one block below is one whole look.
   Three rules hold for all five.

    - **`banner-life` stays.** None of these blocks touches
      `#banner.on { animation: … }`: the module ends a card on that name
      alone, and a style that replaced it would leave the card on the glass
      until the belt fired.
    - **A whole-life keyframe states both phase edges**, rendered from
      `[presentation.banner]`; an arrival-only keyframe lasts the arrival
      and states no edge.
    - **`cqw` became `clamp()`.** The mockup sized every card against its
      own container. The banner fills the viewport, so each figure is
      `clamp(min, N vw, max)` — the same translation card 04 took.

   Each style also answers `still`, because reduced motion is a class here
   and not a media query: the sweep is done, the gauge is in place, the
   bands are closed, the echoes are gone, and the bar is filled. */

/* Card 01 "Sonar Type". The hero is written twice: `.base` is the type the
   instrument has not reached, `.lit` is the type behind the sweep. The
   mask is 260% of the box and slides from right to left, so its opaque
   head crosses the letters from left to right and leaves them lit. */
#ui.theme-banner-sonar-type #banner .hero {
  position: relative;
  display: inline-block;
  font-weight: 700;
  font-size: clamp(26px, 8.4vw, 104px);
  letter-spacing: 0.1em;
  margin: clamp(8px, 1.2vw, 18px) 0 clamp(7px, 1.1vw, 16px);
  animation: none;
}
#ui.theme-banner-sonar-type #banner .hero .base {
  color: rgb(var(--accent-rgb) / 0.3);
}
#ui.theme-banner-sonar-type #banner .hero .lit {
  position: absolute;
  left: 0;
  top: 0;
  text-shadow: 0 0 clamp(6px, 2vw, 26px) rgb(var(--accent-rgb) / 0.55);
  -webkit-mask-image: linear-gradient(100deg, var(--film-black) 0%, var(--film-black) 34%, rgb(var(--film-black-rgb) / 0) 52%);
  mask-image: linear-gradient(100deg, var(--film-black) 0%, var(--film-black) 34%, rgb(var(--film-black-rgb) / 0) 52%);
  -webkit-mask-size: 260% 100%;
  mask-size: 260% 100%;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  animation: banner-sonar-sweep 1000ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
@keyframes banner-sonar-sweep {
  from { -webkit-mask-position: 100% 0; mask-position: 100% 0; }
  to   { -webkit-mask-position: 0% 0; mask-position: 0% 0; }
}
#ui.theme-banner-sonar-type #banner.still .hero {
  letter-spacing: 0.1em;
  margin-right: 0;
}
#ui.theme-banner-sonar-type #banner.still .hero .lit {
  animation: none;
  -webkit-mask-image: none;
  mask-image: none;
}

/* Card 02 "Depth Gauge". An instrument and not a title: a ruled frame that
   opens from half its width, a tick rule over it, and two figures that
   roll into place inside boxes that clip them. */
#ui.theme-banner-depth-gauge #banner .frame {
  position: relative;
  width: min(56vw, 760px);
  padding: clamp(9px, 1.6vw, 22px) 0;
  border-top: 1px solid rgb(var(--accent-rgb) / 0.5);
  border-bottom: 1px solid rgb(var(--accent-rgb) / 0.5);
  animation: banner-gauge-frame 4500ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-depth-gauge #banner .ticks {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(-1 * clamp(3px, 0.5vw, 7px));
  display: flex;
  justify-content: space-between;
}
#ui.theme-banner-depth-gauge #banner .ticks .t {
  width: 1px;
  height: clamp(3px, 0.5vw, 7px);
  background: rgb(var(--accent-rgb) / 0.3);
}
#ui.theme-banner-depth-gauge #banner .ticks .t.tall {
  height: clamp(6px, 1vw, 14px);
  background: rgb(var(--accent-rgb) / 0.6);
}
#ui.theme-banner-depth-gauge #banner .kick {
  font-size: clamp(9px, 1.7vw, 21px);
  margin-bottom: clamp(4px, 0.6vw, 8px);
}
#ui.theme-banner-depth-gauge #banner .gauge {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: clamp(6px, 1.2vw, 17px);
  overflow: hidden;
}
#ui.theme-banner-depth-gauge #banner .gauge .word {
  font-size: clamp(11px, 2.2vw, 28px);
  letter-spacing: 0.3em;
  color: var(--dim);
}
#ui.theme-banner-depth-gauge #banner .gauge .roll {
  display: inline-block;
  font-size: clamp(34px, 8vw, 108px);
  font-weight: 700;
  line-height: 1.05;
  color: var(--hero-ink);
  animation: banner-gauge-roll 1000ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-depth-gauge #banner .foot {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: clamp(5px, 1vw, 14px);
  margin-top: clamp(4px, 0.6vw, 8px);
  overflow: hidden;
  letter-spacing: normal;
  color: var(--dim);
}
#ui.theme-banner-depth-gauge #banner .foot .time {
  display: inline-block;
  font-size: clamp(15px, 3vw, 40px);
  letter-spacing: 0.16em;
  color: var(--accent);
  animation: banner-gauge-rise 1000ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-depth-gauge #banner .foot small {
  font-size: clamp(8px, 1.6vw, 20px);
  letter-spacing: 0.24em;
}
@keyframes banner-gauge-frame {
  0%                   { transform: scaleX(0.5); }
  22.222%    { transform: scaleX(1); }
  80%  { transform: scaleX(1); }
  100%                 { transform: scaleX(0.88); }
}
@keyframes banner-gauge-roll {
  0%, 14% { transform: translateY(-1.6em); opacity: 0; }
  100%    { transform: translateY(0); opacity: 1; }
}
@keyframes banner-gauge-rise {
  0%, 40% { transform: translateY(1.2em); opacity: 0; }
  100%    { transform: translateY(0); opacity: 1; }
}
#ui.theme-banner-depth-gauge #banner.still .frame { animation: none; transform: scaleX(1); }
#ui.theme-banner-depth-gauge #banner.still .gauge .roll,
#ui.theme-banner-depth-gauge #banner.still .foot .time {
  animation: none;
  transform: none;
  opacity: 1;
}

/* Card 08 "Horizon Split". Two letterbox bands close over the map and the
   words are revealed between them. `--band-dir` is the edge each band
   comes from, so one keyframe carries both. The bands are the one place a
   banner darkens the map on purpose. */
#ui.theme-banner-horizon-split #banner .band {
  position: absolute;
  left: 0;
  right: 0;
  height: 34%;
  border-style: solid;
  border-color: rgb(var(--accent-rgb) / 0.35);
  animation: banner-split-band 4500ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-horizon-split #banner .band.top {
  --band-dir: -1;
  top: 0;
  border-width: 0 0 1px;
  background: linear-gradient(180deg, rgb(var(--deep-rgb) / 0.94), rgb(var(--deep-rgb) / 0.72));
}
#ui.theme-banner-horizon-split #banner .band.bot {
  --band-dir: 1;
  bottom: 0;
  border-width: 1px 0 0;
  background: linear-gradient(0deg, rgb(var(--deep-rgb) / 0.94), rgb(var(--deep-rgb) / 0.72));
}
#ui.theme-banner-horizon-split #banner .mid {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(3px, 0.5vw, 7px);
  animation: banner-split-reveal 4500ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-horizon-split #banner .kick {
  font-size: clamp(9px, 1.8vw, 22px);
  animation: none;
}
#ui.theme-banner-horizon-split #banner .hero {
  margin: 0;
  font-weight: 700;
  font-size: clamp(26px, 6.6vw, 92px);
  letter-spacing: 0.1em;
  animation: none;
}
#ui.theme-banner-horizon-split #banner .foot {
  margin-top: 0;
  animation: none;
}
@keyframes banner-split-band {
  0%                   { transform: translateY(calc(var(--band-dir, -1) * 100%)); }
  22.222%    { transform: translateY(0); }
  80%  { transform: translateY(0); }
  100%                 { transform: translateY(calc(var(--band-dir, -1) * 100%)); }
}
@keyframes banner-split-reveal {
  0%                   { clip-path: inset(50% 0 50% 0); opacity: 0; }
  22.222%    { clip-path: inset(0 0 0 0); opacity: 1; }
  80%  { clip-path: inset(0 0 0 0); opacity: 1; }
  100%                 { clip-path: inset(50% 0 50% 0); opacity: 0; }
}
#ui.theme-banner-horizon-split #banner.still .band {
  animation: none;
  transform: translateY(0);
}
#ui.theme-banner-horizon-split #banner.still .mid {
  animation: none;
  clip-path: inset(0 0 0 0);
  opacity: 1;
}

/* Card 09 "Echo Count". The season stamps, and two fainter copies expand
   out of it and die. `--echo-spread` is how far one echo grows and the
   delay is when it leaves, both from `[presentation.banner]`. */
#ui.theme-banner-echo-count #banner .echoes {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: clamp(48px, 12vw, 150px);
}
#ui.theme-banner-echo-count #banner .echoes .hero {
  position: absolute;
  margin: 0;
  font-weight: 700;
  font-size: clamp(30px, 8.6vw, 104px);
  letter-spacing: 0.1em;
  animation: none;
}
/* The three copies keep `.echoes .hero` in the selector. The rule above
   takes the AUTO tracking off them with `animation: none`, and a selector
   one class shorter would lose to it and leave all three still. */
#ui.theme-banner-echo-count #banner .echoes .e0 {
  text-shadow: 0 0 clamp(6px, 2vw, 26px) rgb(var(--accent-rgb) / 0.5);
  animation: banner-echo-stamp 1000ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-echo-count #banner .echoes .e1,
#ui.theme-banner-echo-count #banner .echoes .e2 {
  color: var(--accent);
  animation: banner-echo 1000ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-echo-count #banner .echoes .e1 {
  --echo-spread: 0.35;
  animation-delay: 180ms;
}
#ui.theme-banner-echo-count #banner .echoes .e2 {
  --echo-spread: 0.75;
  animation-delay: 340ms;
  color: rgb(var(--accent-rgb) / 0.75);
}
@keyframes banner-echo-stamp {
  from { transform: scale(1.35); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}
@keyframes banner-echo {
  from { transform: scale(1); opacity: 0.55; }
  to   { transform: scale(calc(1 + var(--echo-spread, 0.35))); opacity: 0; }
}
#ui.theme-banner-echo-count #banner.still .echoes .e0 {
  animation: none;
  transform: none;
  opacity: 1;
}
#ui.theme-banner-echo-count #banner.still .echoes .e1,
#ui.theme-banner-echo-count #banner.still .echoes .e2 {
  animation: none;
  opacity: 0;
}

/* Card 10 "Season Bar". The countdown as a picture: a bar the width of the
   season, filled to the day the season has reached. `--season-frac` comes
   off the card's own two figures, so the fill, the head and the mark all
   read one number. `--bar-w` is stated here, so the head travels on a
   transform and never on `left`. */
/* How far the mark stands over the track. The hero takes the same gap
   under it, so the two can never print on one another. */
#ui.theme-banner-season-bar #banner {
  --mark-up: clamp(26px, 4vw, 48px);
}
#ui.theme-banner-season-bar #banner .hero {
  margin: clamp(6px, 1vw, 14px) 0 calc(var(--mark-up) + clamp(6px, 1vw, 12px));
  font-weight: 700;
  font-size: clamp(28px, 7.2vw, 96px);
  letter-spacing: 0.1em;
  animation: none;
}
#ui.theme-banner-season-bar #banner .bar {
  --bar-w: min(52vw, 700px);
  position: relative;
  width: var(--bar-w);
}
#ui.theme-banner-season-bar #banner .track {
  height: 2px;
  background: rgb(var(--faint-rgb) / 0.35);
}
#ui.theme-banner-season-bar #banner .fill {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 2px;
  background: var(--accent);
  box-shadow: 0 0 clamp(4px, 1.2vw, 16px) rgb(var(--accent-rgb) / 0.55);
  transform: scaleX(0);
  transform-origin: left center;
  animation: banner-bar-fill 4500ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-season-bar #banner .head {
  position: absolute;
  left: 0;
  top: calc(-1 * clamp(2px, 0.5vw, 7px));
  width: clamp(2px, 0.35vw, 5px);
  height: clamp(7px, 1.4vw, 19px);
  background: var(--hero-ink);
  animation: banner-bar-head 4500ms cubic-bezier(0.215, 0.61, 0.355, 1) both;
}
#ui.theme-banner-season-bar #banner .days {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: clamp(5px, 0.9vw, 12px);
  font-size: clamp(8px, 1.5vw, 18px);
  letter-spacing: 0.2em;
  color: var(--dim);
}
/* The mark stands over the head, above the track. In the label row it
   would print on top of `day 1` through the first days of a season. */
#ui.theme-banner-season-bar #banner .bar .mark {
  position: absolute;
  top: calc(-1 * var(--mark-up));
  left: calc(var(--season-frac, 0) * 100%);
  font-size: clamp(8px, 1.5vw, 18px);
  letter-spacing: 0.2em;
  color: var(--accent);
  transform: translateX(-50%);
  animation: banner-fade 300ms linear 1000ms both;
}
#ui.theme-banner-season-bar #banner .foot {
  margin-top: clamp(10px, 1.8vw, 24px);
}
@keyframes banner-bar-fill {
  0%                   { transform: scaleX(0); }
  22.222%    { transform: scaleX(var(--season-frac, 0)); }
  80%  { transform: scaleX(var(--season-frac, 0)); }
  100%                 { transform: scaleX(var(--season-frac, 0)); }
}
@keyframes banner-bar-head {
  0%                   { transform: translateX(0); opacity: 0; }
  22.222%    { transform: translateX(calc(var(--season-frac, 0) * var(--bar-w))); opacity: 1; }
  80%  { transform: translateX(calc(var(--season-frac, 0) * var(--bar-w))); opacity: 1; }
  100%                 { transform: translateX(calc(var(--season-frac, 0) * var(--bar-w))); opacity: 1; }
}
#ui.theme-banner-season-bar #banner.still .fill {
  animation: none;
  transform: scaleX(var(--season-frac, 0));
}
#ui.theme-banner-season-bar #banner.still .head {
  animation: none;
  transform: translateX(calc(var(--season-frac, 0) * var(--bar-w)));
  opacity: 1;
}
#ui.theme-banner-season-bar #banner.still .bar .mark {
  animation: none;
  opacity: 1;
}

/* --- the chart furniture's DOM host (R548, §17) ---
   The cards of words of the chart mount here: the cartouche plate and the
   legend card. §1's canvas/DOM split says words are DOM, so they
   mount here rather than in the atlas.

   The host lies over the whole map and takes NO pointer: it must never
   stand between the pointer and the canvas. A card that wants a press sets
   `pointer-events: auto` on itself.

   It takes the furniture rung of the stacking ladder inside `#ui`, under
   every panel of the chrome (§2.3, R1822): the furniture is chart
   decoration and a panel is a control, so the console, the dock, the
   context card and the VIEW panel always win the glass. `ui/chart/stack.ts`
   places the cards from the published layout properties, so nothing here
   states a height.

   The whole host fades on a reading change: the controller writes one
   `opacity` on this element, not one per card. */

#furniture {
  position: absolute;
  inset: 0;
  z-index: 10;
  pointer-events: none;
  font-family: var(--mono);
  color: var(--text);
  contain: layout paint;
}

/* The one chart card frame (round 086 card 04). One width (the peek
   width), one pad, one head row and one minimize control in the top-right
   corner. The modern frame is the plain panel of the peek ground; the
   historical frame is the inset double rule with the small radius, and
   every word in the Fell steps of §17.4. */
#ui #furniture .chart-card {
  position: absolute;
  box-sizing: border-box;
  width: var(--w-peek);
  padding: var(--s-4);
  background: var(--g-peek);
  border: 1px solid var(--edge);
  border-radius: var(--r-card);
  font: var(--t-small);
  color: var(--text);
  pointer-events: none;
}
#ui #furniture .chart-card.historical {
  border-color: rgb(var(--text-rgb) / 0.45);
  border-radius: var(--r-bar);
  box-shadow: inset 0 0 0 3px rgb(var(--panel-rgb) / 0.94), inset 0 0 0 4px rgb(var(--text-rgb) / 0.35);
  font-family: var(--serif);
  font-style: italic;
}

/* The head row: the title at the name step, and the minimize control. The
   historical head stands centred between two fleurons. */
#ui #furniture .chart-card .cc-head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s-3);
  min-height: var(--s-6);
  margin: calc(-1 * var(--s-2)) 0 var(--s-2);
  color: var(--accent);
}
#ui #furniture .chart-card .cc-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#ui #furniture .chart-card.historical .cc-head {
  justify-content: center;
  padding: 0 var(--s-6);
  color: var(--text);
}
#ui #furniture .chart-card.historical .cc-title::before { content: "❧ "; }
#ui #furniture .chart-card.historical .cc-title::after { content: " ❧"; }

/* The minimize control: 24 px painted, and a 44 px target under a finger
   (round 086 card 04). The same corner on every card. */
#ui #furniture .chart-card .cc-min {
  position: relative;
  flex: none;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  width: var(--s-6);
  height: var(--s-6);
  min-height: 0;
  padding: 0;
  border: 1px solid rgb(var(--text-rgb) / 0.22);
  border-radius: var(--r-button);
  background: none;
  color: var(--dim);
  pointer-events: auto;
  cursor: pointer;
}
#ui #furniture .chart-card .cc-min::after {
  content: "";
  position: absolute;
  inset: calc((var(--s-6) - var(--target-finger)) / 2);
}
#ui #furniture .chart-card.historical .cc-min {
  position: absolute;
  right: 0;
  top: 0;
}
@media (hover: hover) {
  #ui #furniture .chart-card .cc-min:hover { color: var(--accent); border-color: var(--accent); }
}

/* The four chart text steps of a card (§17.4, round 086 card 04). The
   modern reading takes the chrome ramp: a head and a note in the cap
   step, a line in the small step. The historical reading takes the Fell
   steps. The case rule of card 03: a modern head is in upper case, and a
   note keeps the case of its sentence. */
#ui #furniture .chart-card .cs-note { font-size: var(--t-cap-size); letter-spacing: 0.04em; color: var(--dim); }
#ui #furniture .chart-card .cs-label { font-size: var(--t-small-size); }
#ui #furniture .chart-card .cs-name {
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
}
#ui #furniture .chart-card .cs-feature { font-size: var(--t-title-size); }
#ui #furniture .chart-card.historical .cs-note { font-size: var(--t-fell-note-size); letter-spacing: 0; color: var(--text); }
#ui #furniture .chart-card.historical .cs-label { font-size: var(--t-fell-label-size); }
#ui #furniture .chart-card.historical .cs-name {
  font-size: var(--t-fell-name-size);
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
}
#ui #furniture .chart-card.historical .cs-feature { font-size: var(--t-fell-feature-size); }

/* The cartouche plate (card 06, round 086 card 05 a): the season banner's
   resting form, with the scale bar. The imprint is ink in the margin of
   the map and no part of the plate (R1852). */
#ui #furniture .chart-card.cartouche .ct-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--s-1);
  text-align: center;
}
/* The season and the day stand in the centre of the plate, under the
   title, as the plate centres every line (R1871, the owner's word of
   2026-10-09, after R1852 had set them at the left edge). */
/* The scale row is always one line (R589). The row does not wrap and the
   words do not break: the piece sheds cells from the bar until the bar,
   the zero and the words go into the row together. */
#ui #furniture .chart-card.cartouche .ct-scale {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: var(--s-1) var(--s-2);
  width: 100%;
  justify-content: center;
}
#ui #furniture .chart-card.cartouche .ct-len { white-space: nowrap; }
#ui #furniture .chart-card.cartouche .ct-bar {
  display: flex;
  overflow: hidden;
  max-width: 100%;
}
#ui #furniture .chart-card.cartouche .ct-bar i {
  flex: 1 1 0;
  background: var(--text);
  opacity: 0.7;
}
#ui #furniture .chart-card.cartouche .ct-bar i:nth-child(even) { opacity: 0.25; }

/* The faction key (card 67, R1568): one row per faction, the ink, the
   charge badge, the name and the border dash. The columns and the row
   height come from `chart.toml` through the piece. */
#ui #furniture .chart-card.faction-key .fk-row {
  display: grid;
  align-items: center;
}
#ui #furniture .chart-card.faction-key .fk-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#ui #furniture .chart-card.faction-key canvas { display: block; }

/* The legend card (round 086 card 13, R1805): the FACTIONS and the HEAT
   section, each under a head row that folds it. A minimized card is a
   44 px chip with the five dashes and the heat swatch. */
#ui #furniture .chart-card.legend .lg-sec + .lg-sec {
  margin-top: var(--s-2);
  border-top: 1px solid rgb(var(--accent-rgb) / 0.12);
}
#ui #furniture .chart-card.legend.historical .lg-sec + .lg-sec { border-top-color: rgb(var(--text-rgb) / 0.25); }
#ui #furniture .chart-card.legend .lg-sh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: var(--target-mouse);
  padding: 0;
  color: var(--dim);
}
#ui #furniture .chart-card.legend.historical .lg-sh { color: var(--text); }
/* The heat section keeps the chrome face in both readings (round 086 open
   point 2): the heat field is a map filter, not chart furniture. */
#ui #furniture .chart-card.legend .chrome-face { font-family: var(--mono); font-style: normal; }
#ui #furniture .chart-card.legend .chrome-face .cs-name {
  font-size: var(--t-cap-size);
  font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
}
#ui #furniture .chart-card.legend .chrome-face .cs-note { font-size: var(--t-cap-size); letter-spacing: 0.04em; color: var(--dim); }
#ui #furniture .chart-card.legend .lg-ramp {
  height: 8px;
  border-radius: var(--r-bar);
  border: 1px solid rgb(var(--text-rgb) / 0.3);
}
#ui #furniture .chart-card.legend .lg-ends { display: flex; justify-content: space-between; margin-top: var(--s-1); }
/* The DEPTH and the CURRENT sections of v2 phase 2 (round 088 cards 04
   and 07, R2616, `ui/chart/deep-legend.ts`). The legend card of a desktop
   and the VIEW panel of a telephone write the same markup. A swatch is the
   deep ink at the alpha of its band over the water; the piece writes the
   ground inline, because the alpha is a figure of `chart.toml`. */
#ui .dl-bands { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 3px; margin: 2px 0 var(--s-1); }
#ui .dl-band { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
#ui .dl-band i {
  display: flex;
  align-items: center;
  height: 16px;
  padding: 0 var(--s-1);
  border: 1px solid rgb(var(--text-rgb) / 0.28);
  border-radius: var(--r-bar);
}
#ui .dl-band em { font-style: normal; font-size: var(--t-cap-size); color: var(--dim); }
#ui .dl-band b { font-weight: 500; font-size: var(--t-cap-size); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
#ui .dl-row { display: flex; align-items: center; gap: var(--s-2); min-height: 22px; }
#ui .dl-row > span { min-width: 0; }
#ui .dl-streak path { fill: none; stroke: rgb(var(--text-rgb) / 0.75); stroke-width: 1.2; stroke-linecap: round; }
#ui .dl-streak { flex: none; }
/* The bar of the tide cycle: one cell a step, the shade by the strength
   of the step, the steps that turn the flow round in the text ink, and
   the step now under the hero ink. */
#ui .dl-cycle { display: flex; gap: 1px; height: 10px; margin: var(--s-1) 0 2px; }
#ui .dl-cycle i { flex: 1 1 0; border-radius: 1px; }
#ui .dl-cycle i.pos { background: rgb(var(--accent-rgb) / var(--k)); }
#ui .dl-cycle i.neg { background: rgb(var(--text-rgb) / var(--k)); }
#ui .dl-cycle i.now { outline: 2px solid var(--hero-ink); outline-offset: 0; }
#ui .dl-ends { display: flex; justify-content: space-between; gap: var(--s-2); font-size: var(--t-cap-size); color: var(--dim); }
/* The fold body of the telephone VIEW panel (R2616). */
#viewpanel .vp-deep { padding: 0 2px var(--s-2); font-size: var(--t-small-size); }
#ui #furniture .chart-card.legend.chip {
  width: auto;
  padding: 0;
  border-radius: var(--r-button);
}
#ui #furniture .chart-card.legend .lg-chip {
  display: flex;
  align-items: center;
  gap: var(--s-2);
  min-height: var(--target-finger);
  padding: 0 var(--s-4);
  border: 0;
  background: none;
  color: var(--accent);
  pointer-events: auto;
  cursor: pointer;
}
#ui #furniture .chart-card.legend .lg-chip img { display: block; }
/* The chip's open control is the square press of the folded cartouche
   plate (`.cc-min`), in the flow of the chip in both readings. */
#ui #furniture .chart-card.legend .lg-chip .cc-min { position: relative; }
@media (hover: hover) {
  #ui #furniture .chart-card.legend .lg-chip:hover .cc-min { color: var(--accent); border-color: var(--accent); }
}
#ui #furniture .chart-card.legend .lg-swatch {
  width: 22px;
  height: 8px;
  border-radius: var(--r-bar);
  border: 1px solid rgb(var(--text-rgb) / 0.3);
}
/* A card folded to its head row: the plate under its minimize control,
   the legend while the stack would reach the notice band (card 08). The
   rule stands after every rule of a card body: `.ct-body` sets its display
   at the same specificity, and while this rule stood before it, the plate's
   minimize press folded nothing (R1852). `sheetrules.test.ts` holds the
   order. */
#ui #furniture .chart-card.folded > :not(.cc-head) { display: none; }
#ui #furniture .chart-card.folded .cc-head { margin-bottom: calc(-1 * var(--s-2)); }
/* The strip at the dock's left edge (R2181): the legend stands directly on
   the cartouche plate (`ui/chart/stack.ts`), so the two frames are one.
   The seam is the faint rule of a section, the outer corners keep their
   radius, and a minimized legend is a full-width row of the strip. The rules
   stand after the chip rule, which states the chip's own width. */
#ui #furniture .chart-card.cc-join-up {
  border-bottom-color: rgb(var(--accent-rgb) / 0.12);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
#ui #furniture .chart-card.cc-join-dn {
  border-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
#ui #furniture .chart-card.legend.chip.cc-join-up { width: var(--w-peek); }
#ui #furniture .chart-card.legend.chip.cc-join-up .lg-chip { width: 100%; }
#ui #furniture .chart-card.legend.chip.cc-join-up .lg-up { margin-left: auto; }
/* The two NPC rows, NPC MONSTERS and NPC PIRATES (R2831), in the columns
   of a faction row: a square of the NPC ink, the side mark centred in a
   cell as wide as the badge column (R2698), the name, and the five marks
   at the right end of the row, in the place of the border dash. */
#ui .fk-npc .fk-ink.npc-sq { background: var(--npc); }
#ui .fk-npc .npc-cell { display: flex; justify-content: center; align-items: center; flex: none; overflow: visible; }
#ui .fk-npc .npc-set { display: flex; justify-content: flex-end; align-items: center; flex: none; justify-self: end; }
#ui .fk-npc .npc-set img { display: block; }
#ui .npc-mark .npc-fill { fill: var(--npc); stroke: var(--npc-edge); stroke-width: 0.9; stroke-linejoin: round; }
/* The inverse hull of a pirate (R2874, round 134 card 01): the deep body,
   the rim and the eye in the NPC ink. */
#ui .npc-mark .npc-body { fill: rgb(var(--deep-rgb)); stroke: var(--npc); stroke-width: 1.4; stroke-linejoin: round; }
#ui .npc-mark .npc-eye { fill: var(--npc); }
#ui .npc-mark .npc-line { fill: none; stroke: var(--npc); stroke-width: 1.4; stroke-linecap: round; }
#ui .npc-mark .npc-ring { fill: var(--npc-edge); stroke: var(--npc); stroke-width: 1.2; }
/* The still mark of a monster kind (round 109, R2719, render/monster-marks.ts):
   capsules and rings in the NPC ink and its deep edge, discs filled. A
   filled part is the inverse hull (R2874): the NPC ink round the deep
   body. */
#ui .npc-mark .mm-l, #ui .npc-mark .mm-d { fill: none; stroke-linecap: round; }
#ui .npc-mark .mm-l { stroke: var(--npc); }
#ui .npc-mark .mm-d { stroke: var(--npc-edge); }
#ui .npc-mark .mm-lf { fill: var(--npc); }
#ui .npc-mark .mm-df { fill: var(--npc-edge); }

/* The harbour plan in the historical reading (R1824, round 086 card 07
   b): the section of the own hold card takes the Fell steps, as the chart
   cards do. The head is the name step, a lane the label step and the hull
   list the note step; the modern section keeps the card's chrome face
   (`ui/cards/cardkit.css`). */
#ui .ck .ck-plan.hist { font-family: var(--serif); font-style: italic; }
#ui .ck .ck-plan.hist .ck-sh > .ck-cap {
  font-family: inherit;
  font-size: var(--t-fell-name-size);
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  color: var(--text);
}
#ui .ck .ck-plan.hist .ck-shr,
#ui .ck .ck-plan.hist .ck-ll,
#ui .ck .ck-plan.hist .ck-lf {
  font-family: inherit;
  font-size: var(--t-fell-label-size);
  letter-spacing: 0;
  text-transform: none;
}
#ui .ck .ck-plan.hist .ck-lhulls { font-family: inherit; font-size: var(--t-fell-note-size); }
#ui .ck .ck-plan.hist .ck-berths > i { border-radius: 50%; }

/* --- the replay film (R531, R542) ---
   THE replay. The picture is the MAP: the film plays on the live WebGL2
   engine, and every layer of sovereignty and sonar is hidden while it runs
   (`fast/film.ts`). The holds and the faction installations stay on the
   picture. What is here is the chrome around that picture — the letterbox bars with their sprocket holes, the grain,
   the REPLAY tag, the timecode, the transport and the damage report.

   It lives inside `#ui` for the stacking the banner uses: `#ui` is
   z-index 10, so a film can never stand over `#blackout` (40) or over the
   way in (`#landing`, 50). Inside `#ui` it takes 42 — over every panel,
   under the season banner (45) and `#fatal` (the cover rung, R1797), because a connection
   that has died says so over any ceremony.

   Reduced motion is a class and not a media query (`still`), the same rule
   the banner keeps: the client asks the OS in one place. */

#film {
  position: fixed;
  inset: 0;
  z-index: 42;
  display: none;
  pointer-events: auto;
  font: var(--t-body);
  color: var(--text);
  contain: layout paint;
}

#film.on { display: block; }

/* The two letterbox bars. They are the film's own frame, so they carry the
   ink of deep water rather than a panel's translucency. */
#film .fbar {
  position: absolute;
  left: 0;
  right: 0;
  height: 10vh;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  background: rgb(var(--ink-rgb) / 0.94);
  box-sizing: border-box;
}
#film .fbar.top { top: 0; border-bottom: 1px solid var(--edge); }
#film .fbar.bot { bottom: 0; border-top: 1px solid var(--edge); }

/* The sprocket holes: one repeating strip along the outer edge of each
   bar. It is a gradient and not a row of elements, so the strip costs one
   paint whatever the width of the screen. */
#film .fbar .holes {
  position: absolute;
  left: 0;
  right: 0;
  height: 7px;
  background: repeating-linear-gradient(
    90deg,
    rgb(var(--text-rgb) / 0.16) 0 10px,
    transparent 10px 22px);
}
#film .fbar.top .holes { top: 4px; }
#film .fbar.bot .holes { bottom: 4px; }

/* The tag: a blinking dot, the word, then the film's own title. */
#film .tag { display: flex; align-items: center; gap: 8px; min-width: 0; }
#film .tag .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--bad);
  animation: film-blink 1400ms steps(1, end) infinite;
}
#film .tag .word { color: var(--bad); letter-spacing: 0.3em; font-weight: 600; }
/* The hold's countdown (R535). It stands beside the tag and it is empty
   while the film runs, so it takes no room until the loop holds. */
#film .fhold {
  color: var(--accent);
  letter-spacing: 0.18em;
  white-space: nowrap;
}
#film .ftitle {
  color: var(--dim);
  letter-spacing: 0.12em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#film .meta { margin-left: auto; display: flex; align-items: center; gap: 14px; }
#film .fclock { color: var(--text); white-space: nowrap; }
#film .floop { color: var(--dim); letter-spacing: 0.2em; white-space: nowrap; }

/* The transport, along the foot of the lower bar. */
#film .ctl { display: flex; align-items: center; gap: 8px; width: 100%; }
#film .ctl .scrub { flex: 1; accent-color: var(--accent); min-width: 60px; }
#film button {
  pointer-events: auto;
  min-width: 34px;
  min-height: 32px;
  padding: 4px 8px;
  background: rgb(var(--accent-rgb) / 0.10);
  border: 1px solid var(--edge);
  border-radius: 4px;
  color: var(--text);
  font: var(--t-body-weight) var(--t-body-size)/1 var(--mono);
  cursor: pointer;
}
#film button.wide { letter-spacing: 0.16em; }
@media (hover: hover) {
  #film button:hover { background: rgb(var(--accent-rgb) / 0.18); color: var(--accent); }
}

/* The damage report (R527, R531, R534): one row per SOURCE, worded by the
   server and counted by the film. It stands between the bars on the right,
   and it drops to the foot on a narrow screen, where there is no room
   beside the fight. */
#film .report {
  position: absolute;
  top: calc(10vh + 12px);
  right: 12px;
  width: min(760px, 58vw);
  padding: 8px 10px;
  background: rgb(var(--sheet-rgb) / 0.82);
  border: 1px solid var(--edge);
  border-radius: 5px;
  contain: layout paint;
}
#film.noreport .report { display: none; }
#film .report .rhead {
  color: var(--accent);
  letter-spacing: 0.18em;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--edge);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* The table. The column heads and the rows are two grids of ONE track
   list, in `ch` of the mono face, so a head stands over its column
   without a table element and without a measurement. The source column
   takes what is left. Nine columns since R535: the source, the commander
   and the faction stand apart. */
#film .report .rcols,
#film .report .rrow {
  display: grid;
  grid-template-columns:
    8ch minmax(0, 9ch) minmax(0, 1fr) minmax(0, 12ch) minmax(0, 15ch)
    3ch 5ch 8ch 8ch;
  gap: 0 6px;
}
#film .report .rcols {
  color: var(--dim);
  letter-spacing: 0.08em;
  padding: 4px 0 2px;
}
#film .report .rrows {
  /* The panel holds this many rows and then scrolls. The row height is
     typography and belongs to the sheet; the count is the data layer's. */
  line-height: 1.5;
  max-height: calc(14 * 1.5em);
  overflow-y: auto;
  overflow-x: hidden;
}
#film .report .rrow {
  padding: 1px 0;
  color: var(--dim);
}
/* Every cell is one line: a long hull name is cut, never wrapped, so a
   row is one row and the columns of the table stand. */
#film .report .rcols span,
#film .report .rrow span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* The counted cells read right, the way a figure is read. The four of
   them stand after the faction column (R535). */
#film .report .rcols span:nth-child(n + 6),
#film .report .rrow span:nth-child(n + 6) { text-align: right; }
/* A row that lands while the film runs is lit whole, and a row that moved
   lights the cells that moved. A row rebuilt after a seek is old news and
   takes no class, so nothing flashes when a player drags the scrubber. */
#film .report .rrow.lit,
#film .report .rrow span.lit { animation: film-row 900ms ease-out 1; }

/* The grain and the scanlines. Both are one full-viewport paint under the
   bars, and the grain is an SVG turbulence carried as a data URI so the
   sheet needs no asset. */
#film .grain {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.055;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/></filter><rect width='140' height='140' filter='url(%23n)'/></svg>");
  animation: film-grain 1000ms steps(1, end) infinite;
}
#film .scan {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    repeating-linear-gradient(0deg,
      rgb(var(--film-black-rgb) / 0.14) 0 1px, transparent 1px 3px),
    radial-gradient(ellipse at center,
      transparent 55%, rgb(var(--film-black-rgb) / 0.45) 100%);
}

/* The grain moves in whole steps: film grain is a flicker and never a
   drift. The cycle length is the data layer's grain rate. */
@keyframes film-grain {
  0%   { background-position: 0 0; }
  12.5%{ background-position: -30px 12px; }
  25%  { background-position: 18px -24px; }
  37.5%{ background-position: -14px -8px; }
  50%  { background-position: 26px 18px; }
  62.5%{ background-position: -22px 26px; }
  75%  { background-position: 10px -18px; }
  87.5%{ background-position: -8px 8px; }
}

@keyframes film-blink {
  0%, 49%   { opacity: 1; }
  50%, 100% { opacity: 0.15; }
}

@keyframes film-row {
  from { background: rgb(var(--accent-rgb) / 0.28); color: var(--text); }
  to   { background: transparent; }
}

/* Reduced motion: the grain holds still and the tag stops blinking. The
   film itself is the motion the player asked for, so it keeps running. */
#film.still .grain { animation: none; }
#film.still .tag .dot { animation: none; }

/* The chrome leaves while a film runs. It travels on the arrival's own
   `--out` distances, so the panels go the way they came and nothing new
   has to be measured. */
#ui.film #topbar, #ui.film #stats, #ui.film #notices,
#ui.film #dock, #ui.film #infocard, #ui.film #hint,
#ui.film #mapbtns, #ui.film #selection {
  transform: var(--rest, translateX(0)) var(--out, translateX(0));
}
/* A film covers the map, and a group slot that recalls a fleet has
   nothing to do there (R1817). */
#ui.film #mapchrome, #ui.film #heatchip, #ui.film #tooltip, #ui.film #peeklead, #ui.film #bartip,
#ui.film #corecard, #ui.film #groupbar, #ui.film #grouprow, #ui.film #grptoast, #ui.film #viewpanel,
#ui.film #rosepress, #ui.film #chat.box { display: none; }
/* Every other piece of chrome that states the game of today goes too
   (R2403): the three asks of the context slot, the WAR timelapse band, an
   undocked casino pane and the heat ramp. Each one comes back as it was
   when the film closes. */
#ui.film #commitcard, #ui.film #pickcard, #ui.film #renamecard,
#ui.film #tlband, #ui.film #casinopane, #ui.film #heatramp { display: none; }
/* The guest warning and the unlock stamp stand over the glass, so they
   go too (R2404): REGISTER would leave the world from inside a film, and
   a stamp that stood when the film opened plays out hidden. The settlement
   drain stays, because it ends the season. */
#ui.film #guestwarn, #ui.film #unlock { display: none; }

/* A telephone has no room beside the fight, so the report stands on the
   control strip instead of beside the water.

   One entry takes TWO lines there (R581). Nine columns on a 390 px screen
   cut half of every cell with an ellipsis, and the owner asked for the
   content and not for narrower columns. So the entry becomes a sub-table:
   the first line carries TIME, KIND and SOURCE, and the second line
   carries COMMANDER, FACTION and the four counted cells. The head row
   takes the SAME areas, so a head still stands over its own column.

   The cells are plain spans in column order, so the grid places them by
   `nth-child`. A change to `REPORT_COLUMNS` in `fast/film.ts` must change
   these areas with it. */
@media (max-width: 900px) {
  #film .report {
    top: auto;
    bottom: calc(10vh + 12px);
    /* The whole width of the glass, less the margin the strip keeps. Both
       edges are anchored, because the sheet measures a width as content
       and a panel of `100vw` would then stand over the right margin.

       The second line carries six cells, and the two widest of them are a
       commander and a banner. The longest of each is fifteen characters,
       and the two fit at this width and at this size and at no smaller
       one. */
    left: 12px;
    right: 12px;
    width: auto;
    padding: 8px;
    font-size: var(--t-cap-size);
  }
  #film .report .rcols,
  #film .report .rrow {
    grid-template-columns:
      minmax(0, 1fr) minmax(0, 1fr) 2.5ch 5ch 8ch 8ch;
    grid-template-areas:
      "tm kd sr sr sr sr"
      "cm fc hi dm sh hu";
    gap: 0 4px;
  }
  #film .report .rcols span:nth-child(1),
  #film .report .rrow span:nth-child(1) { grid-area: tm; }
  #film .report .rcols span:nth-child(2),
  #film .report .rrow span:nth-child(2) { grid-area: kd; }
  #film .report .rcols span:nth-child(3),
  #film .report .rrow span:nth-child(3) { grid-area: sr; }
  #film .report .rcols span:nth-child(4),
  #film .report .rrow span:nth-child(4) { grid-area: cm; }
  #film .report .rcols span:nth-child(5),
  #film .report .rrow span:nth-child(5) { grid-area: fc; }
  #film .report .rcols span:nth-child(6),
  #film .report .rrow span:nth-child(6) { grid-area: hi; }
  #film .report .rcols span:nth-child(7),
  #film .report .rrow span:nth-child(7) { grid-area: dm; }
  #film .report .rcols span:nth-child(8),
  #film .report .rrow span:nth-child(8) { grid-area: sh; }
  #film .report .rcols span:nth-child(9),
  #film .report .rrow span:nth-child(9) { grid-area: hu; }
  /* The COUNT halves and the cap in em holds (R581). An entry is two lines
     here, so the same 14 lines of glass hold half as many
     entries. The panel keeps the height it had on the desktop, which is
     what leaves the fight its own glass at the foot of a telephone. */
  #film .report .rrows {
    max-height: calc(14 * 1.5em);
  }
  /* Two lines for one entry read as two entries with no banding, so every
     other entry takes a wash. It is a paint and adds no height. */
  #film .report .rrow:nth-of-type(even) {
    background: rgb(var(--accent-rgb) / 0.06);
  }
}

/* --- the impersonation strip (deployment.md, the impersonation section) ---

   An operator who answers a support ticket signs in as the account and is
   then that player everywhere. The strip is what says so. It is amber,
   the verdict that waits (R1798): gold is never a signal.

   It is a FOURTH root, beside `#ui`, `#landing` and `#hub`. Those three
   each leave the body when their screen resolves, so a strip that lived
   inside any of them would leave with it. `ui/impbar.ts` appends this one
   to the body itself and no screen owns it.

   z-index 60 is over `#hub` and `#landing` at 50 and over the whole chrome
   at 10. `#fatal` alone stands higher, on the cover rung (R1797): a version mismatch must
   never be hidden behind the strip.

   **It never takes a pointer.** `pointer-events: none` holds for the band
   and `auto` for the STOP button alone, so nothing under the band loses a
   press. The band still covers the top of the glass, so the three roots
   that start at the top edge move down by exactly its height.
   `--impbar-h` is that height, declared on the body while the strip is up
   and read by the band and by the three roots together: one figure, and no
   way for the band and the gap under it to disagree.

   The module toggles ONE class, `on`, the way the drain line does. The
   `:has` selector is what turns that class into the offset above, and the
   sheet already scopes the framed menus with the same selector. */

body:has(> #impbar.on) {
  --impbar-h: calc(20px + env(safe-area-inset-top, 0px));
}
body:has(> #impbar.on) #topbar,
body:has(> #impbar.on) > #landing,
body:has(> #impbar.on) > #hub { top: var(--impbar-h); }
/* The desktop dock column starts at the top too, under its head (R1749).
   `#ui:not(.sheet)` keeps the rule off the telephone sheet, which stands
   on the bottom edge. */
body:has(> #impbar.on) #ui:not(.sheet) #dock:not(.collapsed) { top: calc(var(--impbar-h) + 8px); }

#impbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--impbar-h, 20px);
  box-sizing: border-box;
  padding: env(safe-area-inset-top, 0px) 10px 0;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 60;
  font-family: var(--mono);
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  text-transform: uppercase;
  white-space: nowrap;
  color: var(--amber);
  background: rgb(var(--amber-rgb) / 0.18);
  border-bottom: 1px solid rgb(var(--amber-rgb) / 0.45);
  pointer-events: none;
}
#impbar.on { display: flex; }
/* The player's name comes from the meta server and can be long. It gives
   way before the button does, so a narrow telephone still shows STOP. */
#impbar .who {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
#impbar .stop {
  pointer-events: auto;
  flex: none;
  min-height: 16px;
  padding: 0 8px;
  border: 1px solid rgb(var(--amber-rgb) / 0.5);
  border-radius: 4px;
  background: rgb(var(--amber-rgb) / 0.1);
  color: var(--amber);
  font: inherit;
  letter-spacing: 0.1em;
  cursor: pointer;
}
@media (hover: hover) {
  #impbar .stop:hover { background: rgb(var(--amber-rgb) / 0.22); }
}
/* The press is in flight. The button goes quiet rather than away, so the
   band does not change width under the finger that pressed it. */
#impbar.stopping .stop { opacity: 0.5; pointer-events: none; }

/* A telephone. The button is a touch control, so it takes the 40 px of
   §12 like every other one, and the band grows to hold it. An operator
   session is rare and short, and a band that is hard to press would cost
   more than the glass it takes. */
@media (pointer: coarse) {
  body:has(> #impbar.on) {
    --impbar-h: calc(46px + env(safe-area-inset-top, 0px));
  }
  #impbar .stop { min-height: 40px; padding: 0 14px; }
}

/* The touch log (ui-map-interface.md §8 "Touch log", R1497;
   fast/touchlog.ts). It exists only while `?touchlog=1` turned it on. It
   mounts on the body, because the hub, the landing screen and the world
   each own a different root, and the log must stay up through all three.

   The chip stands on the right edge, at 38 % of the height. That keeps it
   off the minimap (the top-left corner on a desktop, R2879, and the
   console of a telephone, R1801), off the top bar and off the dock. z-index 55 is over `#hub`
   and `#landing` at 50 and under `#impbar` at 60.

   The menu opens to the left of the chip. `manual` shows the text field,
   which holds the log when the browser gave no clipboard. */
#touchlog {
  position: fixed;
  right: env(safe-area-inset-right, 0px);
  top: 38%;
  z-index: 55;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  gap: 6px;
  font-family: var(--mono);
  font-size: var(--t-cap-size); font-weight: var(--t-cap-weight);
  letter-spacing: var(--t-cap-track);
  color: var(--amber);
}
#touchlog button {
  min-height: 28px;
  padding: 0 8px;
  border: 1px solid rgb(var(--amber-rgb) / 0.5);
  border-radius: 4px;
  background: rgb(var(--deep-rgb) / 0.85);
  color: var(--amber);
  font: inherit;
  letter-spacing: inherit;
  white-space: nowrap;
  cursor: pointer;
}
#touchlog .chip { border-right: none; border-radius: 4px 0 0 4px; }
#touchlog .menu {
  display: none;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  padding: 6px;
  border: 1px solid rgb(var(--amber-rgb) / 0.35);
  border-radius: 4px;
  background: rgb(var(--deep-rgb) / 0.92);
}
#touchlog.open .menu { display: flex; }
#touchlog .status:empty { display: none; }
#touchlog textarea {
  display: none;
  width: min(260px, calc(100vw - 120px));
  height: 120px;
  font: inherit;
  font-size: var(--t-small-size);
  color: var(--dim);
  background: rgb(var(--deep-rgb) / 0.95);
  border: 1px solid rgb(var(--amber-rgb) / 0.35);
}
#touchlog.manual textarea { display: block; }

/* A telephone. Each button is a touch control, so it takes the 40 px of
   §12. */
@media (pointer: coarse) {
  #touchlog button { min-height: 40px; padding: 0 12px; }
}
